(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  // node_modules/alpinejs/dist/module.esm.js
  var flushPending = false;
  var flushing = false;
  var queue = [];
  function scheduler(callback) {
    queueJob(callback);
  }
  function queueJob(job) {
    if (!queue.includes(job))
      queue.push(job);
    queueFlush();
  }
  function dequeueJob(job) {
    let index = queue.indexOf(job);
    if (index !== -1)
      queue.splice(index, 1);
  }
  function queueFlush() {
    if (!flushing && !flushPending) {
      flushPending = true;
      queueMicrotask(flushJobs);
    }
  }
  function flushJobs() {
    flushPending = false;
    flushing = true;
    for (let i4 = 0; i4 < queue.length; i4++) {
      queue[i4]();
    }
    queue.length = 0;
    flushing = false;
  }
  var reactive;
  var effect;
  var release;
  var raw;
  var shouldSchedule = true;
  function disableEffectScheduling(callback) {
    shouldSchedule = false;
    callback();
    shouldSchedule = true;
  }
  function setReactivityEngine(engine) {
    reactive = engine.reactive;
    release = engine.release;
    effect = (callback) => engine.effect(callback, { scheduler: (task) => {
      if (shouldSchedule) {
        scheduler(task);
      } else {
        task();
      }
    } });
    raw = engine.raw;
  }
  function overrideEffect(override) {
    effect = override;
  }
  function elementBoundEffect(el) {
    let cleanup2 = () => {
    };
    let wrappedEffect = (callback) => {
      let effectReference = effect(callback);
      if (!el._x_effects) {
        el._x_effects = /* @__PURE__ */ new Set();
        el._x_runEffects = () => {
          el._x_effects.forEach((i4) => i4());
        };
      }
      el._x_effects.add(effectReference);
      cleanup2 = () => {
        if (effectReference === void 0)
          return;
        el._x_effects.delete(effectReference);
        release(effectReference);
      };
      return effectReference;
    };
    return [wrappedEffect, () => {
      cleanup2();
    }];
  }
  var onAttributeAddeds = [];
  var onElRemoveds = [];
  var onElAddeds = [];
  function onElAdded(callback) {
    onElAddeds.push(callback);
  }
  function onElRemoved(el, callback) {
    if (typeof callback === "function") {
      if (!el._x_cleanups)
        el._x_cleanups = [];
      el._x_cleanups.push(callback);
    } else {
      callback = el;
      onElRemoveds.push(callback);
    }
  }
  function onAttributesAdded(callback) {
    onAttributeAddeds.push(callback);
  }
  function onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups)
      el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name])
      el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
  }
  function cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups)
      return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value]) => {
      if (names === void 0 || names.includes(name)) {
        value.forEach((i4) => i4());
        delete el._x_attributeCleanups[name];
      }
    });
  }
  var observer = new MutationObserver(onMutate);
  var currentlyObserving = false;
  function startObservingMutations() {
    observer.observe(document, { subtree: true, childList: true, attributes: true, attributeOldValue: true });
    currentlyObserving = true;
  }
  function stopObservingMutations() {
    flushObserver();
    observer.disconnect();
    currentlyObserving = false;
  }
  var recordQueue = [];
  var willProcessRecordQueue = false;
  function flushObserver() {
    recordQueue = recordQueue.concat(observer.takeRecords());
    if (recordQueue.length && !willProcessRecordQueue) {
      willProcessRecordQueue = true;
      queueMicrotask(() => {
        processRecordQueue();
        willProcessRecordQueue = false;
      });
    }
  }
  function processRecordQueue() {
    onMutate(recordQueue);
    recordQueue.length = 0;
  }
  function mutateDom(callback) {
    if (!currentlyObserving)
      return callback();
    stopObservingMutations();
    let result = callback();
    startObservingMutations();
    return result;
  }
  var isCollecting = false;
  var deferredMutations = [];
  function deferMutations() {
    isCollecting = true;
  }
  function flushAndStopDeferringMutations() {
    isCollecting = false;
    onMutate(deferredMutations);
    deferredMutations = [];
  }
  function onMutate(mutations) {
    if (isCollecting) {
      deferredMutations = deferredMutations.concat(mutations);
      return;
    }
    let addedNodes = [];
    let removedNodes = [];
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for (let i4 = 0; i4 < mutations.length; i4++) {
      if (mutations[i4].target._x_ignoreMutationObserver)
        continue;
      if (mutations[i4].type === "childList") {
        mutations[i4].addedNodes.forEach((node) => node.nodeType === 1 && addedNodes.push(node));
        mutations[i4].removedNodes.forEach((node) => node.nodeType === 1 && removedNodes.push(node));
      }
      if (mutations[i4].type === "attributes") {
        let el = mutations[i4].target;
        let name = mutations[i4].attributeName;
        let oldValue = mutations[i4].oldValue;
        let add2 = () => {
          if (!addedAttributes.has(el))
            addedAttributes.set(el, []);
          addedAttributes.get(el).push({ name, value: el.getAttribute(name) });
        };
        let remove = () => {
          if (!removedAttributes.has(el))
            removedAttributes.set(el, []);
          removedAttributes.get(el).push(name);
        };
        if (el.hasAttribute(name) && oldValue === null) {
          add2();
        } else if (el.hasAttribute(name)) {
          remove();
          add2();
        } else {
          remove();
        }
      }
    }
    removedAttributes.forEach((attrs, el) => {
      cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el) => {
      onAttributeAddeds.forEach((i4) => i4(el, attrs));
    });
    for (let node of removedNodes) {
      if (addedNodes.includes(node))
        continue;
      onElRemoveds.forEach((i4) => i4(node));
      if (node._x_cleanups) {
        while (node._x_cleanups.length)
          node._x_cleanups.pop()();
      }
    }
    addedNodes.forEach((node) => {
      node._x_ignoreSelf = true;
      node._x_ignore = true;
    });
    for (let node of addedNodes) {
      if (removedNodes.includes(node))
        continue;
      if (!node.isConnected)
        continue;
      delete node._x_ignoreSelf;
      delete node._x_ignore;
      onElAddeds.forEach((i4) => i4(node));
      node._x_ignore = true;
      node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node) => {
      delete node._x_ignoreSelf;
      delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
  }
  function scope(node) {
    return mergeProxies(closestDataStack(node));
  }
  function addScopeToNode(node, data22, referenceNode) {
    node._x_dataStack = [data22, ...closestDataStack(referenceNode || node)];
    return () => {
      node._x_dataStack = node._x_dataStack.filter((i4) => i4 !== data22);
    };
  }
  function refreshScope(element, scope2) {
    let existingScope = element._x_dataStack[0];
    Object.entries(scope2).forEach(([key, value]) => {
      existingScope[key] = value;
    });
  }
  function closestDataStack(node) {
    if (node._x_dataStack)
      return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) {
      return closestDataStack(node.host);
    }
    if (!node.parentNode) {
      return [];
    }
    return closestDataStack(node.parentNode);
  }
  function mergeProxies(objects) {
    let thisProxy = new Proxy({}, {
      ownKeys: () => {
        return Array.from(new Set(objects.flatMap((i4) => Object.keys(i4))));
      },
      has: (target, name) => {
        return objects.some((obj) => obj.hasOwnProperty(name));
      },
      get: (target, name) => {
        return (objects.find((obj) => {
          if (obj.hasOwnProperty(name)) {
            let descriptor = Object.getOwnPropertyDescriptor(obj, name);
            if (descriptor.get && descriptor.get._x_alreadyBound || descriptor.set && descriptor.set._x_alreadyBound) {
              return true;
            }
            if ((descriptor.get || descriptor.set) && descriptor.enumerable) {
              let getter = descriptor.get;
              let setter = descriptor.set;
              let property = descriptor;
              getter = getter && getter.bind(thisProxy);
              setter = setter && setter.bind(thisProxy);
              if (getter)
                getter._x_alreadyBound = true;
              if (setter)
                setter._x_alreadyBound = true;
              Object.defineProperty(obj, name, {
                ...property,
                get: getter,
                set: setter
              });
            }
            return true;
          }
          return false;
        }) || {})[name];
      },
      set: (target, name, value) => {
        let closestObjectWithKey = objects.find((obj) => obj.hasOwnProperty(name));
        if (closestObjectWithKey) {
          closestObjectWithKey[name] = value;
        } else {
          objects[objects.length - 1][name] = value;
        }
        return true;
      }
    });
    return thisProxy;
  }
  function initInterceptors(data22) {
    let isObject2 = (val) => typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "") => {
      Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value, enumerable }]) => {
        if (enumerable === false || value === void 0)
          return;
        let path = basePath === "" ? key : `${basePath}.${key}`;
        if (typeof value === "object" && value !== null && value._x_interceptor) {
          obj[key] = value.initialize(data22, path, key);
        } else {
          if (isObject2(value) && value !== obj && !(value instanceof Element)) {
            recurse(value, path);
          }
        }
      });
    };
    return recurse(data22);
  }
  function interceptor(callback, mutateObj = () => {
  }) {
    let obj = {
      initialValue: void 0,
      _x_interceptor: true,
      initialize(data22, path, key) {
        return callback(this.initialValue, () => get(data22, path), (value) => set(data22, path, value), path, key);
      }
    };
    mutateObj(obj);
    return (initialValue) => {
      if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
        let initialize = obj.initialize.bind(obj);
        obj.initialize = (data22, path, key) => {
          let innerValue = initialValue.initialize(data22, path, key);
          obj.initialValue = innerValue;
          return initialize(data22, path, key);
        };
      } else {
        obj.initialValue = initialValue;
      }
      return obj;
    };
  }
  function get(obj, path) {
    return path.split(".").reduce((carry, segment) => carry[segment], obj);
  }
  function set(obj, path, value) {
    if (typeof path === "string")
      path = path.split(".");
    if (path.length === 1)
      obj[path[0]] = value;
    else if (path.length === 0)
      throw error;
    else {
      if (obj[path[0]])
        return set(obj[path[0]], path.slice(1), value);
      else {
        obj[path[0]] = {};
        return set(obj[path[0]], path.slice(1), value);
      }
    }
  }
  var magics = {};
  function magic(name, callback) {
    magics[name] = callback;
  }
  function injectMagics(obj, el) {
    Object.entries(magics).forEach(([name, callback]) => {
      Object.defineProperty(obj, `$${name}`, {
        get() {
          let [utilities, cleanup2] = getElementBoundUtilities(el);
          utilities = { interceptor, ...utilities };
          onElRemoved(el, cleanup2);
          return callback(el, utilities);
        },
        enumerable: false
      });
    });
    return obj;
  }
  function tryCatch(el, expression, callback, ...args) {
    try {
      return callback(...args);
    } catch (e4) {
      handleError(e4, el, expression);
    }
  }
  function handleError(error2, el, expression = void 0) {
    Object.assign(error2, { el, expression });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(() => {
      throw error2;
    }, 0);
  }
  var shouldAutoEvaluateFunctions = true;
  function dontAutoEvaluateFunctions(callback) {
    let cache = shouldAutoEvaluateFunctions;
    shouldAutoEvaluateFunctions = false;
    callback();
    shouldAutoEvaluateFunctions = cache;
  }
  function evaluate(el, expression, extras = {}) {
    let result;
    evaluateLater(el, expression)((value) => result = value, extras);
    return result;
  }
  function evaluateLater(...args) {
    return theEvaluatorFunction(...args);
  }
  var theEvaluatorFunction = normalEvaluator;
  function setEvaluator(newEvaluator) {
    theEvaluatorFunction = newEvaluator;
  }
  function normalEvaluator(el, expression) {
    let overriddenMagics = {};
    injectMagics(overriddenMagics, el);
    let dataStack = [overriddenMagics, ...closestDataStack(el)];
    if (typeof expression === "function") {
      return generateEvaluatorFromFunction(dataStack, expression);
    }
    let evaluator = generateEvaluatorFromString(dataStack, expression, el);
    return tryCatch.bind(null, el, expression, evaluator);
  }
  function generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = () => {
    }, { scope: scope2 = {}, params = [] } = {}) => {
      let result = func.apply(mergeProxies([scope2, ...dataStack]), params);
      runIfTypeOfFunction(receiver, result);
    };
  }
  var evaluatorMemo = {};
  function generateFunctionFromString(expression, el) {
    if (evaluatorMemo[expression]) {
      return evaluatorMemo[expression];
    }
    let AsyncFunction = Object.getPrototypeOf(async function() {
    }).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression) || /^(let|const)\s/.test(expression) ? `(() => { ${expression} })()` : expression;
    const safeAsyncFunction = () => {
      try {
        return new AsyncFunction(["__self", "scope"], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
      } catch (error2) {
        handleError(error2, el, expression);
        return Promise.resolve();
      }
    };
    let func = safeAsyncFunction();
    evaluatorMemo[expression] = func;
    return func;
  }
  function generateEvaluatorFromString(dataStack, expression, el) {
    let func = generateFunctionFromString(expression, el);
    return (receiver = () => {
    }, { scope: scope2 = {}, params = [] } = {}) => {
      func.result = void 0;
      func.finished = false;
      let completeScope = mergeProxies([scope2, ...dataStack]);
      if (typeof func === "function") {
        let promise = func(func, completeScope).catch((error2) => handleError(error2, el, expression));
        if (func.finished) {
          runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
          func.result = void 0;
        } else {
          promise.then((result) => {
            runIfTypeOfFunction(receiver, result, completeScope, params, el);
          }).catch((error2) => handleError(error2, el, expression)).finally(() => func.result = void 0);
        }
      }
    };
  }
  function runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if (shouldAutoEvaluateFunctions && typeof value === "function") {
      let result = value.apply(scope2, params);
      if (result instanceof Promise) {
        result.then((i4) => runIfTypeOfFunction(receiver, i4, scope2, params)).catch((error2) => handleError(error2, el, value));
      } else {
        receiver(result);
      }
    } else {
      receiver(value);
    }
  }
  var prefixAsString = "x-";
  function prefix(subject = "") {
    return prefixAsString + subject;
  }
  function setPrefix(newPrefix) {
    prefixAsString = newPrefix;
  }
  var directiveHandlers = {};
  function directive(name, callback) {
    directiveHandlers[name] = callback;
  }
  function directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
      let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value]) => ({ name, value }));
      let staticAttributes = attributesOnly(vAttributes);
      vAttributes = vAttributes.map((attribute) => {
        if (staticAttributes.find((attr) => attr.name === attribute.name)) {
          return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
          };
        }
        return attribute;
      });
      attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map(toTransformedAttributes((newName, oldName) => transformedAttributeMap[newName] = oldName)).filter(outNonAlpineAttributes).map(toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort(byPriority);
    return directives2.map((directive2) => {
      return getDirectiveHandler(el, directive2);
    });
  }
  function attributesOnly(attributes) {
    return Array.from(attributes).map(toTransformedAttributes()).filter((attr) => !outNonAlpineAttributes(attr));
  }
  var isDeferringHandlers = false;
  var directiveHandlerStacks = /* @__PURE__ */ new Map();
  var currentHandlerStackKey = Symbol();
  function deferHandlingDirectives(callback) {
    isDeferringHandlers = true;
    let key = Symbol();
    currentHandlerStackKey = key;
    directiveHandlerStacks.set(key, []);
    let flushHandlers = () => {
      while (directiveHandlerStacks.get(key).length)
        directiveHandlerStacks.get(key).shift()();
      directiveHandlerStacks.delete(key);
    };
    let stopDeferring = () => {
      isDeferringHandlers = false;
      flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
  }
  function getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback) => cleanups.push(callback);
    let [effect3, cleanupEffect] = elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
      Alpine: alpine_default,
      effect: effect3,
      cleanup: cleanup2,
      evaluateLater: evaluateLater.bind(evaluateLater, el),
      evaluate: evaluate.bind(evaluate, el)
    };
    let doCleanup = () => cleanups.forEach((i4) => i4());
    return [utilities, doCleanup];
  }
  function getDirectiveHandler(el, directive2) {
    let noop2 = () => {
    };
    let handler3 = directiveHandlers[directive2.type] || noop2;
    let [utilities, cleanup2] = getElementBoundUtilities(el);
    onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = () => {
      if (el._x_ignore || el._x_ignoreSelf)
        return;
      handler3.inline && handler3.inline(el, directive2, utilities);
      handler3 = handler3.bind(handler3, el, directive2, utilities);
      isDeferringHandlers ? directiveHandlerStacks.get(currentHandlerStackKey).push(handler3) : handler3();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
  }
  var startingWith = (subject, replacement) => ({ name, value }) => {
    if (name.startsWith(subject))
      name = name.replace(subject, replacement);
    return { name, value };
  };
  var into = (i4) => i4;
  function toTransformedAttributes(callback = () => {
  }) {
    return ({ name, value }) => {
      let { name: newName, value: newValue } = attributeTransformers.reduce((carry, transform) => {
        return transform(carry);
      }, { name, value });
      if (newName !== name)
        callback(newName, name);
      return { name: newName, value: newValue };
    };
  }
  var attributeTransformers = [];
  function mapAttributes(callback) {
    attributeTransformers.push(callback);
  }
  function outNonAlpineAttributes({ name }) {
    return alpineAttributeRegex().test(name);
  }
  var alpineAttributeRegex = () => new RegExp(`^${prefixAsString}([^:^.]+)\\b`);
  function toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name, value }) => {
      let typeMatch = name.match(alpineAttributeRegex());
      let valueMatch = name.match(/:([a-zA-Z0-9\-:]+)/);
      let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
      let original = originalAttributeOverride || transformedAttributeMap[name] || name;
      return {
        type: typeMatch ? typeMatch[1] : null,
        value: valueMatch ? valueMatch[1] : null,
        modifiers: modifiers.map((i4) => i4.replace(".", "")),
        expression: value,
        original
      };
    };
  }
  var DEFAULT = "DEFAULT";
  var directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "radio",
    "tabs",
    "switch",
    "disclosure",
    "menu",
    "listbox",
    "list",
    "item",
    "combobox",
    "bind",
    "init",
    "for",
    "mask",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    DEFAULT,
    "teleport"
  ];
  function byPriority(a4, b4) {
    let typeA = directiveOrder.indexOf(a4.type) === -1 ? DEFAULT : a4.type;
    let typeB = directiveOrder.indexOf(b4.type) === -1 ? DEFAULT : b4.type;
    return directiveOrder.indexOf(typeA) - directiveOrder.indexOf(typeB);
  }
  function dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
      detail,
      bubbles: true,
      composed: true,
      cancelable: true
    }));
  }
  var tickStack = [];
  var isHolding = false;
  function nextTick(callback = () => {
  }) {
    queueMicrotask(() => {
      isHolding || setTimeout(() => {
        releaseNextTicks();
      });
    });
    return new Promise((res) => {
      tickStack.push(() => {
        callback();
        res();
      });
    });
  }
  function releaseNextTicks() {
    isHolding = false;
    while (tickStack.length)
      tickStack.shift()();
  }
  function holdNextTicks() {
    isHolding = true;
  }
  function walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
      Array.from(el.children).forEach((el2) => walk(el2, callback));
      return;
    }
    let skip = false;
    callback(el, () => skip = true);
    if (skip)
      return;
    let node = el.firstElementChild;
    while (node) {
      walk(node, callback, false);
      node = node.nextElementSibling;
    }
  }
  function warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
  }
  function start() {
    if (!document.body)
      warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    dispatch(document, "alpine:init");
    dispatch(document, "alpine:initializing");
    startObservingMutations();
    onElAdded((el) => initTree(el, walk));
    onElRemoved((el) => destroyTree(el));
    onAttributesAdded((el, attrs) => {
      directives(el, attrs).forEach((handle) => handle());
    });
    let outNestedComponents = (el) => !closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll(allSelectors())).filter(outNestedComponents).forEach((el) => {
      initTree(el);
    });
    dispatch(document, "alpine:initialized");
  }
  var rootSelectorCallbacks = [];
  var initSelectorCallbacks = [];
  function rootSelectors() {
    return rootSelectorCallbacks.map((fn) => fn());
  }
  function allSelectors() {
    return rootSelectorCallbacks.concat(initSelectorCallbacks).map((fn) => fn());
  }
  function addRootSelector(selectorCallback) {
    rootSelectorCallbacks.push(selectorCallback);
  }
  function addInitSelector(selectorCallback) {
    initSelectorCallbacks.push(selectorCallback);
  }
  function closestRoot(el, includeInitSelectors = false) {
    return findClosest(el, (element) => {
      const selectors = includeInitSelectors ? allSelectors() : rootSelectors();
      if (selectors.some((selector) => element.matches(selector)))
        return true;
    });
  }
  function findClosest(el, callback) {
    if (!el)
      return;
    if (callback(el))
      return el;
    if (el._x_teleportBack)
      el = el._x_teleportBack;
    if (!el.parentElement)
      return;
    return findClosest(el.parentElement, callback);
  }
  function isRoot(el) {
    return rootSelectors().some((selector) => el.matches(selector));
  }
  function initTree(el, walker = walk) {
    deferHandlingDirectives(() => {
      walker(el, (el2, skip) => {
        directives(el2, el2.attributes).forEach((handle) => handle());
        el2._x_ignore && skip();
      });
    });
  }
  function destroyTree(root) {
    walk(root, (el) => cleanupAttributes(el));
  }
  function setClasses(el, value) {
    if (Array.isArray(value)) {
      return setClassesFromString(el, value.join(" "));
    } else if (typeof value === "object" && value !== null) {
      return setClassesFromObject(el, value);
    } else if (typeof value === "function") {
      return setClasses(el, value());
    }
    return setClassesFromString(el, value);
  }
  function setClassesFromString(el, classString) {
    let split = (classString2) => classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2) => classString2.split(" ").filter((i4) => !el.classList.contains(i4)).filter(Boolean);
    let addClassesAndReturnUndo = (classes) => {
      el.classList.add(...classes);
      return () => {
        el.classList.remove(...classes);
      };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
  }
  function setClassesFromObject(el, classObject) {
    let split = (classString) => classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool]) => bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool]) => !bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i4) => {
      if (el.classList.contains(i4)) {
        el.classList.remove(i4);
        removed.push(i4);
      }
    });
    forAdd.forEach((i4) => {
      if (!el.classList.contains(i4)) {
        el.classList.add(i4);
        added.push(i4);
      }
    });
    return () => {
      removed.forEach((i4) => el.classList.add(i4));
      added.forEach((i4) => el.classList.remove(i4));
    };
  }
  function setStyles(el, value) {
    if (typeof value === "object" && value !== null) {
      return setStylesFromObject(el, value);
    }
    return setStylesFromString(el, value);
  }
  function setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2]) => {
      previousStyles[key] = el.style[key];
      if (!key.startsWith("--")) {
        key = kebabCase(key);
      }
      el.style.setProperty(key, value2);
    });
    setTimeout(() => {
      if (el.style.length === 0) {
        el.removeAttribute("style");
      }
    });
    return () => {
      setStyles(el, previousStyles);
    };
  }
  function setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return () => {
      el.setAttribute("style", cache || "");
    };
  }
  function kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
  }
  function once(callback, fallback = () => {
  }) {
    let called = false;
    return function() {
      if (!called) {
        called = true;
        callback.apply(this, arguments);
      } else {
        fallback.apply(this, arguments);
      }
    };
  }
  directive("transition", (el, { value, modifiers, expression }, { evaluate: evaluate2 }) => {
    if (typeof expression === "function")
      expression = evaluate2(expression);
    if (!expression) {
      registerTransitionsFromHelper(el, modifiers, value);
    } else {
      registerTransitionsFromClassString(el, expression, value);
    }
  });
  function registerTransitionsFromClassString(el, classString, stage) {
    registerTransitionObject(el, setClasses, "");
    let directiveStorageMap = {
      enter: (classes) => {
        el._x_transition.enter.during = classes;
      },
      "enter-start": (classes) => {
        el._x_transition.enter.start = classes;
      },
      "enter-end": (classes) => {
        el._x_transition.enter.end = classes;
      },
      leave: (classes) => {
        el._x_transition.leave.during = classes;
      },
      "leave-start": (classes) => {
        el._x_transition.leave.start = classes;
      },
      "leave-end": (classes) => {
        el._x_transition.leave.end = classes;
      }
    };
    directiveStorageMap[stage](classString);
  }
  function registerTransitionsFromHelper(el, modifiers, stage) {
    registerTransitionObject(el, setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || ["enter"].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || ["leave"].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) {
      modifiers = modifiers.filter((i4, index) => index < modifiers.indexOf("out"));
    }
    if (modifiers.includes("out") && !doesntSpecify) {
      modifiers = modifiers.filter((i4, index) => index > modifiers.indexOf("out"));
    }
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = modifierValue(modifiers, "delay", 0);
    let origin = modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
      el._x_transition.enter.during = {
        transformOrigin: origin,
        transitionDelay: delay,
        transitionProperty: property,
        transitionDuration: `${durationIn}s`,
        transitionTimingFunction: easing
      };
      el._x_transition.enter.start = {
        opacity: opacityValue,
        transform: `scale(${scaleValue})`
      };
      el._x_transition.enter.end = {
        opacity: 1,
        transform: `scale(1)`
      };
    }
    if (transitioningOut) {
      el._x_transition.leave.during = {
        transformOrigin: origin,
        transitionDelay: delay,
        transitionProperty: property,
        transitionDuration: `${durationOut}s`,
        transitionTimingFunction: easing
      };
      el._x_transition.leave.start = {
        opacity: 1,
        transform: `scale(1)`
      };
      el._x_transition.leave.end = {
        opacity: opacityValue,
        transform: `scale(${scaleValue})`
      };
    }
  }
  function registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition)
      el._x_transition = {
        enter: { during: defaultValue, start: defaultValue, end: defaultValue },
        leave: { during: defaultValue, start: defaultValue, end: defaultValue },
        in(before = () => {
        }, after = () => {
        }) {
          transition(el, setFunction, {
            during: this.enter.during,
            start: this.enter.start,
            end: this.enter.end
          }, before, after);
        },
        out(before = () => {
        }, after = () => {
        }) {
          transition(el, setFunction, {
            during: this.leave.during,
            start: this.leave.start,
            end: this.leave.end
          }, before, after);
        }
      };
  }
  window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = () => nextTick2(show);
    if (value) {
      if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) {
        el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
      } else {
        el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
      }
      return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject) => {
      el._x_transition.out(() => {
      }, () => resolve(hide));
      el._x_transitioning.beforeCancel(() => reject({ isFromCancelledTransition: true }));
    }) : Promise.resolve(hide);
    queueMicrotask(() => {
      let closest = closestHide(el);
      if (closest) {
        if (!closest._x_hideChildren)
          closest._x_hideChildren = [];
        closest._x_hideChildren.push(el);
      } else {
        nextTick2(() => {
          let hideAfterChildren = (el2) => {
            let carry = Promise.all([
              el2._x_hidePromise,
              ...(el2._x_hideChildren || []).map(hideAfterChildren)
            ]).then(([i4]) => i4());
            delete el2._x_hidePromise;
            delete el2._x_hideChildren;
            return carry;
          };
          hideAfterChildren(el).catch((e4) => {
            if (!e4.isFromCancelledTransition)
              throw e4;
          });
        });
      }
    });
  };
  function closestHide(el) {
    let parent = el.parentNode;
    if (!parent)
      return;
    return parent._x_hidePromise ? parent : closestHide(parent);
  }
  function transition(el, setFunction, { during, start: start2, end } = {}, before = () => {
  }, after = () => {
  }) {
    if (el._x_transitioning)
      el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
      before();
      after();
      return;
    }
    let undoStart, undoDuring, undoEnd;
    performTransition(el, {
      start() {
        undoStart = setFunction(el, start2);
      },
      during() {
        undoDuring = setFunction(el, during);
      },
      before,
      end() {
        undoStart();
        undoEnd = setFunction(el, end);
      },
      after,
      cleanup() {
        undoDuring();
        undoEnd();
      }
    });
  }
  function performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = once(() => {
      mutateDom(() => {
        interrupted = true;
        if (!reachedBefore)
          stages.before();
        if (!reachedEnd) {
          stages.end();
          releaseNextTicks();
        }
        stages.after();
        if (el.isConnected)
          stages.cleanup();
        delete el._x_transitioning;
      });
    });
    el._x_transitioning = {
      beforeCancels: [],
      beforeCancel(callback) {
        this.beforeCancels.push(callback);
      },
      cancel: once(function() {
        while (this.beforeCancels.length) {
          this.beforeCancels.shift()();
        }
        ;
        finish();
      }),
      finish
    };
    mutateDom(() => {
      stages.start();
      stages.during();
    });
    holdNextTicks();
    requestAnimationFrame(() => {
      if (interrupted)
        return;
      let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
      let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
      if (duration === 0)
        duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
      mutateDom(() => {
        stages.before();
      });
      reachedBefore = true;
      requestAnimationFrame(() => {
        if (interrupted)
          return;
        mutateDom(() => {
          stages.end();
        });
        releaseNextTicks();
        setTimeout(el._x_transitioning.finish, duration + delay);
        reachedEnd = true;
      });
    });
  }
  function modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1)
      return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue)
      return fallback;
    if (key === "scale") {
      if (isNaN(rawValue))
        return fallback;
    }
    if (key === "duration") {
      let match2 = rawValue.match(/([0-9]+)ms/);
      if (match2)
        return match2[1];
    }
    if (key === "origin") {
      if (["top", "right", "left", "center", "bottom"].includes(modifiers[modifiers.indexOf(key) + 2])) {
        return [rawValue, modifiers[modifiers.indexOf(key) + 2]].join(" ");
      }
    }
    return rawValue;
  }
  var isCloning = false;
  function skipDuringClone(callback, fallback = () => {
  }) {
    return (...args) => isCloning ? fallback(...args) : callback(...args);
  }
  function clone(oldEl, newEl) {
    if (!newEl._x_dataStack)
      newEl._x_dataStack = oldEl._x_dataStack;
    isCloning = true;
    dontRegisterReactiveSideEffects(() => {
      cloneTree(newEl);
    });
    isCloning = false;
  }
  function cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback) => {
      walk(el2, (el3, skip) => {
        if (hasRunThroughFirstEl && isRoot(el3))
          return skip();
        hasRunThroughFirstEl = true;
        callback(el3, skip);
      });
    };
    initTree(el, shallowWalker);
  }
  function dontRegisterReactiveSideEffects(callback) {
    let cache = effect;
    overrideEffect((callback2, el) => {
      let storedEffect = cache(callback2);
      release(storedEffect);
      return () => {
      };
    });
    callback();
    overrideEffect(cache);
  }
  function bind(el, name, value, modifiers = []) {
    if (!el._x_bindings)
      el._x_bindings = reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? camelCase(name) : name;
    switch (name) {
      case "value":
        bindInputValue(el, value);
        break;
      case "style":
        bindStyles(el, value);
        break;
      case "class":
        bindClasses(el, value);
        break;
      default:
        bindAttribute(el, name, value);
        break;
    }
  }
  function bindInputValue(el, value) {
    if (el.type === "radio") {
      if (el.attributes.value === void 0) {
        el.value = value;
      }
      if (window.fromModel) {
        el.checked = checkedAttrLooseCompare(el.value, value);
      }
    } else if (el.type === "checkbox") {
      if (Number.isInteger(value)) {
        el.value = value;
      } else if (!Number.isInteger(value) && !Array.isArray(value) && typeof value !== "boolean" && ![null, void 0].includes(value)) {
        el.value = String(value);
      } else {
        if (Array.isArray(value)) {
          el.checked = value.some((val) => checkedAttrLooseCompare(val, el.value));
        } else {
          el.checked = !!value;
        }
      }
    } else if (el.tagName === "SELECT") {
      updateSelect(el, value);
    } else {
      if (el.value === value)
        return;
      el.value = value;
    }
  }
  function bindClasses(el, value) {
    if (el._x_undoAddedClasses)
      el._x_undoAddedClasses();
    el._x_undoAddedClasses = setClasses(el, value);
  }
  function bindStyles(el, value) {
    if (el._x_undoAddedStyles)
      el._x_undoAddedStyles();
    el._x_undoAddedStyles = setStyles(el, value);
  }
  function bindAttribute(el, name, value) {
    if ([null, void 0, false].includes(value) && attributeShouldntBePreservedIfFalsy(name)) {
      el.removeAttribute(name);
    } else {
      if (isBooleanAttr(name))
        value = name;
      setIfChanged(el, name, value);
    }
  }
  function setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) {
      el.setAttribute(attrName, value);
    }
  }
  function updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2) => {
      return value2 + "";
    });
    Array.from(el.options).forEach((option) => {
      option.selected = arrayWrappedValue.includes(option.value);
    });
  }
  function camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match2, char) => char.toUpperCase());
  }
  function checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
  }
  function isBooleanAttr(attrName) {
    const booleanAttributes = [
      "disabled",
      "checked",
      "required",
      "readonly",
      "hidden",
      "open",
      "selected",
      "autofocus",
      "itemscope",
      "multiple",
      "novalidate",
      "allowfullscreen",
      "allowpaymentrequest",
      "formnovalidate",
      "autoplay",
      "controls",
      "loop",
      "muted",
      "playsinline",
      "default",
      "ismap",
      "reversed",
      "async",
      "defer",
      "nomodule"
    ];
    return booleanAttributes.includes(attrName);
  }
  function attributeShouldntBePreservedIfFalsy(name) {
    return !["aria-pressed", "aria-checked", "aria-expanded", "aria-selected"].includes(name);
  }
  function getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0)
      return el._x_bindings[name];
    let attr = el.getAttribute(name);
    if (attr === null)
      return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "")
      return true;
    if (isBooleanAttr(name)) {
      return !![name, "true"].includes(attr);
    }
    return attr;
  }
  function debounce(func, wait) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        func.apply(context, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  function throttle(func, limit) {
    let inThrottle;
    return function() {
      let context = this, args = arguments;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
  function plugin(callback) {
    callback(alpine_default);
  }
  var stores = {};
  var isReactive = false;
  function store(name, value) {
    if (!isReactive) {
      stores = reactive(stores);
      isReactive = true;
    }
    if (value === void 0) {
      return stores[name];
    }
    stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") {
      stores[name].init();
    }
    initInterceptors(stores[name]);
  }
  function getStores() {
    return stores;
  }
  var binds = {};
  function bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? () => bindings : bindings;
    if (name instanceof Element) {
      applyBindingsObject(name, getBindings());
    } else {
      binds[name] = getBindings;
    }
  }
  function injectBindingProviders(obj) {
    Object.entries(binds).forEach(([name, callback]) => {
      Object.defineProperty(obj, name, {
        get() {
          return (...args) => {
            return callback(...args);
          };
        }
      });
    });
    return obj;
  }
  function applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while (cleanupRunners.length)
      cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value]) => ({ name, value }));
    let staticAttributes = attributesOnly(attributes);
    attributes = attributes.map((attribute) => {
      if (staticAttributes.find((attr) => attr.name === attribute.name)) {
        return {
          name: `x-bind:${attribute.name}`,
          value: `"${attribute.value}"`
        };
      }
      return attribute;
    });
    directives(el, attributes, original).map((handle) => {
      cleanupRunners.push(handle.runCleanups);
      handle();
    });
  }
  var datas = {};
  function data(name, callback) {
    datas[name] = callback;
  }
  function injectDataProviders(obj, context) {
    Object.entries(datas).forEach(([name, callback]) => {
      Object.defineProperty(obj, name, {
        get() {
          return (...args) => {
            return callback.bind(context)(...args);
          };
        },
        enumerable: false
      });
    });
    return obj;
  }
  var Alpine2 = {
    get reactive() {
      return reactive;
    },
    get release() {
      return release;
    },
    get effect() {
      return effect;
    },
    get raw() {
      return raw;
    },
    version: "3.10.5",
    flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions,
    disableEffectScheduling,
    setReactivityEngine,
    closestDataStack,
    skipDuringClone,
    addRootSelector,
    addInitSelector,
    addScopeToNode,
    deferMutations,
    mapAttributes,
    evaluateLater,
    setEvaluator,
    mergeProxies,
    findClosest,
    closestRoot,
    interceptor,
    transition,
    setStyles,
    mutateDom,
    directive,
    throttle,
    debounce,
    evaluate,
    initTree,
    nextTick,
    prefixed: prefix,
    prefix: setPrefix,
    plugin,
    magic,
    store,
    start,
    clone,
    bound: getBinding,
    $data: scope,
    data,
    bind: bind2
  };
  var alpine_default = Alpine2;
  function makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for (let i4 = 0; i4 < list.length; i4++) {
      map[list[i4]] = true;
    }
    return expectsLowerCase ? (val) => !!map[val.toLowerCase()] : (val) => !!map[val];
  }
  var specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
  var isBooleanAttr2 = /* @__PURE__ */ makeMap(specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
  var EMPTY_OBJ = true ? Object.freeze({}) : {};
  var EMPTY_ARR = true ? Object.freeze([]) : [];
  var extend = Object.assign;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var hasOwn = (val, key) => hasOwnProperty.call(val, key);
  var isArray = Array.isArray;
  var isMap = (val) => toTypeString(val) === "[object Map]";
  var isString = (val) => typeof val === "string";
  var isSymbol = (val) => typeof val === "symbol";
  var isObject = (val) => val !== null && typeof val === "object";
  var objectToString = Object.prototype.toString;
  var toTypeString = (value) => objectToString.call(value);
  var toRawType = (value) => {
    return toTypeString(value).slice(8, -1);
  };
  var isIntegerKey = (key) => isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
  var cacheStringFunction = (fn) => {
    const cache = /* @__PURE__ */ Object.create(null);
    return (str) => {
      const hit = cache[str];
      return hit || (cache[str] = fn(str));
    };
  };
  var camelizeRE = /-(\w)/g;
  var camelize = cacheStringFunction((str) => {
    return str.replace(camelizeRE, (_2, c4) => c4 ? c4.toUpperCase() : "");
  });
  var hyphenateRE = /\B([A-Z])/g;
  var hyphenate = cacheStringFunction((str) => str.replace(hyphenateRE, "-$1").toLowerCase());
  var capitalize = cacheStringFunction((str) => str.charAt(0).toUpperCase() + str.slice(1));
  var toHandlerKey = cacheStringFunction((str) => str ? `on${capitalize(str)}` : ``);
  var hasChanged = (value, oldValue) => value !== oldValue && (value === value || oldValue === oldValue);
  var targetMap = /* @__PURE__ */ new WeakMap();
  var effectStack = [];
  var activeEffect;
  var ITERATE_KEY = Symbol(true ? "iterate" : "");
  var MAP_KEY_ITERATE_KEY = Symbol(true ? "Map key iterate" : "");
  function isEffect(fn) {
    return fn && fn._isEffect === true;
  }
  function effect2(fn, options = EMPTY_OBJ) {
    if (isEffect(fn)) {
      fn = fn.raw;
    }
    const effect3 = createReactiveEffect(fn, options);
    if (!options.lazy) {
      effect3();
    }
    return effect3;
  }
  function stop(effect3) {
    if (effect3.active) {
      cleanup(effect3);
      if (effect3.options.onStop) {
        effect3.options.onStop();
      }
      effect3.active = false;
    }
  }
  var uid = 0;
  function createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
      if (!effect3.active) {
        return fn();
      }
      if (!effectStack.includes(effect3)) {
        cleanup(effect3);
        try {
          enableTracking();
          effectStack.push(effect3);
          activeEffect = effect3;
          return fn();
        } finally {
          effectStack.pop();
          resetTracking();
          activeEffect = effectStack[effectStack.length - 1];
        }
      }
    };
    effect3.id = uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
  }
  function cleanup(effect3) {
    const { deps } = effect3;
    if (deps.length) {
      for (let i4 = 0; i4 < deps.length; i4++) {
        deps[i4].delete(effect3);
      }
      deps.length = 0;
    }
  }
  var shouldTrack = true;
  var trackStack = [];
  function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
  }
  function enableTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = true;
  }
  function resetTracking() {
    const last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
  }
  function track(target, type, key) {
    if (!shouldTrack || activeEffect === void 0) {
      return;
    }
    let depsMap = targetMap.get(target);
    if (!depsMap) {
      targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    }
    let dep = depsMap.get(key);
    if (!dep) {
      depsMap.set(key, dep = /* @__PURE__ */ new Set());
    }
    if (!dep.has(activeEffect)) {
      dep.add(activeEffect);
      activeEffect.deps.push(dep);
      if (activeEffect.options.onTrack) {
        activeEffect.options.onTrack({
          effect: activeEffect,
          target,
          type,
          key
        });
      }
    }
  }
  function trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = targetMap.get(target);
    if (!depsMap) {
      return;
    }
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd) => {
      if (effectsToAdd) {
        effectsToAdd.forEach((effect3) => {
          if (effect3 !== activeEffect || effect3.allowRecurse) {
            effects.add(effect3);
          }
        });
      }
    };
    if (type === "clear") {
      depsMap.forEach(add2);
    } else if (key === "length" && isArray(target)) {
      depsMap.forEach((dep, key2) => {
        if (key2 === "length" || key2 >= newValue) {
          add2(dep);
        }
      });
    } else {
      if (key !== void 0) {
        add2(depsMap.get(key));
      }
      switch (type) {
        case "add":
          if (!isArray(target)) {
            add2(depsMap.get(ITERATE_KEY));
            if (isMap(target)) {
              add2(depsMap.get(MAP_KEY_ITERATE_KEY));
            }
          } else if (isIntegerKey(key)) {
            add2(depsMap.get("length"));
          }
          break;
        case "delete":
          if (!isArray(target)) {
            add2(depsMap.get(ITERATE_KEY));
            if (isMap(target)) {
              add2(depsMap.get(MAP_KEY_ITERATE_KEY));
            }
          }
          break;
        case "set":
          if (isMap(target)) {
            add2(depsMap.get(ITERATE_KEY));
          }
          break;
      }
    }
    const run = (effect3) => {
      if (effect3.options.onTrigger) {
        effect3.options.onTrigger({
          effect: effect3,
          target,
          key,
          type,
          newValue,
          oldValue,
          oldTarget
        });
      }
      if (effect3.options.scheduler) {
        effect3.options.scheduler(effect3);
      } else {
        effect3();
      }
    };
    effects.forEach(run);
  }
  var isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
  var builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key) => Symbol[key]).filter(isSymbol));
  var get2 = /* @__PURE__ */ createGetter();
  var shallowGet = /* @__PURE__ */ createGetter(false, true);
  var readonlyGet = /* @__PURE__ */ createGetter(true);
  var shallowReadonlyGet = /* @__PURE__ */ createGetter(true, true);
  var arrayInstrumentations = {};
  ["includes", "indexOf", "lastIndexOf"].forEach((key) => {
    const method = Array.prototype[key];
    arrayInstrumentations[key] = function(...args) {
      const arr = toRaw(this);
      for (let i4 = 0, l4 = this.length; i4 < l4; i4++) {
        track(arr, "get", i4 + "");
      }
      const res = method.apply(arr, args);
      if (res === -1 || res === false) {
        return method.apply(arr, args.map(toRaw));
      } else {
        return res;
      }
    };
  });
  ["push", "pop", "shift", "unshift", "splice"].forEach((key) => {
    const method = Array.prototype[key];
    arrayInstrumentations[key] = function(...args) {
      pauseTracking();
      const res = method.apply(this, args);
      resetTracking();
      return res;
    };
  });
  function createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
      if (key === "__v_isReactive") {
        return !isReadonly;
      } else if (key === "__v_isReadonly") {
        return isReadonly;
      } else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? shallowReadonlyMap : readonlyMap : shallow ? shallowReactiveMap : reactiveMap).get(target)) {
        return target;
      }
      const targetIsArray = isArray(target);
      if (!isReadonly && targetIsArray && hasOwn(arrayInstrumentations, key)) {
        return Reflect.get(arrayInstrumentations, key, receiver);
      }
      const res = Reflect.get(target, key, receiver);
      if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
        return res;
      }
      if (!isReadonly) {
        track(target, "get", key);
      }
      if (shallow) {
        return res;
      }
      if (isRef(res)) {
        const shouldUnwrap = !targetIsArray || !isIntegerKey(key);
        return shouldUnwrap ? res.value : res;
      }
      if (isObject(res)) {
        return isReadonly ? readonly(res) : reactive2(res);
      }
      return res;
    };
  }
  var set2 = /* @__PURE__ */ createSetter();
  var shallowSet = /* @__PURE__ */ createSetter(true);
  function createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
      let oldValue = target[key];
      if (!shallow) {
        value = toRaw(value);
        oldValue = toRaw(oldValue);
        if (!isArray(target) && isRef(oldValue) && !isRef(value)) {
          oldValue.value = value;
          return true;
        }
      }
      const hadKey = isArray(target) && isIntegerKey(key) ? Number(key) < target.length : hasOwn(target, key);
      const result = Reflect.set(target, key, value, receiver);
      if (target === toRaw(receiver)) {
        if (!hadKey) {
          trigger(target, "add", key, value);
        } else if (hasChanged(value, oldValue)) {
          trigger(target, "set", key, value, oldValue);
        }
      }
      return result;
    };
  }
  function deleteProperty(target, key) {
    const hadKey = hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) {
      trigger(target, "delete", key, void 0, oldValue);
    }
    return result;
  }
  function has(target, key) {
    const result = Reflect.has(target, key);
    if (!isSymbol(key) || !builtInSymbols.has(key)) {
      track(target, "has", key);
    }
    return result;
  }
  function ownKeys(target) {
    track(target, "iterate", isArray(target) ? "length" : ITERATE_KEY);
    return Reflect.ownKeys(target);
  }
  var mutableHandlers = {
    get: get2,
    set: set2,
    deleteProperty,
    has,
    ownKeys
  };
  var readonlyHandlers = {
    get: readonlyGet,
    set(target, key) {
      if (true) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
      }
      return true;
    },
    deleteProperty(target, key) {
      if (true) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
      }
      return true;
    }
  };
  var shallowReactiveHandlers = extend({}, mutableHandlers, {
    get: shallowGet,
    set: shallowSet
  });
  var shallowReadonlyHandlers = extend({}, readonlyHandlers, {
    get: shallowReadonlyGet
  });
  var toReactive = (value) => isObject(value) ? reactive2(value) : value;
  var toReadonly = (value) => isObject(value) ? readonly(value) : value;
  var toShallow = (value) => value;
  var getProto = (v3) => Reflect.getPrototypeOf(v3);
  function get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = toRaw(target);
    const rawKey = toRaw(key);
    if (key !== rawKey) {
      !isReadonly && track(rawTarget, "get", key);
    }
    !isReadonly && track(rawTarget, "get", rawKey);
    const { has: has2 } = getProto(rawTarget);
    const wrap2 = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
    if (has2.call(rawTarget, key)) {
      return wrap2(target.get(key));
    } else if (has2.call(rawTarget, rawKey)) {
      return wrap2(target.get(rawKey));
    } else if (target !== rawTarget) {
      target.get(key);
    }
  }
  function has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = toRaw(target);
    const rawKey = toRaw(key);
    if (key !== rawKey) {
      !isReadonly && track(rawTarget, "has", key);
    }
    !isReadonly && track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
  }
  function size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && track(toRaw(target), "iterate", ITERATE_KEY);
    return Reflect.get(target, "size", target);
  }
  function add(value) {
    value = toRaw(value);
    const target = toRaw(this);
    const proto = getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
      target.add(value);
      trigger(target, "add", value, value);
    }
    return this;
  }
  function set$1(key, value) {
    value = toRaw(value);
    const target = toRaw(this);
    const { has: has2, get: get3 } = getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
      key = toRaw(key);
      hadKey = has2.call(target, key);
    } else if (true) {
      checkIdentityKeys(target, has2, key);
    }
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) {
      trigger(target, "add", key, value);
    } else if (hasChanged(value, oldValue)) {
      trigger(target, "set", key, value, oldValue);
    }
    return this;
  }
  function deleteEntry(key) {
    const target = toRaw(this);
    const { has: has2, get: get3 } = getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
      key = toRaw(key);
      hadKey = has2.call(target, key);
    } else if (true) {
      checkIdentityKeys(target, has2, key);
    }
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) {
      trigger(target, "delete", key, void 0, oldValue);
    }
    return result;
  }
  function clear() {
    const target = toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = true ? isMap(target) ? new Map(target) : new Set(target) : void 0;
    const result = target.clear();
    if (hadItems) {
      trigger(target, "clear", void 0, void 0, oldTarget);
    }
    return result;
  }
  function createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
      const observed = this;
      const target = observed["__v_raw"];
      const rawTarget = toRaw(target);
      const wrap2 = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
      !isReadonly && track(rawTarget, "iterate", ITERATE_KEY);
      return target.forEach((value, key) => {
        return callback.call(thisArg, wrap2(value), wrap2(key), observed);
      });
    };
  }
  function createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
      const target = this["__v_raw"];
      const rawTarget = toRaw(target);
      const targetIsMap = isMap(rawTarget);
      const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
      const isKeyOnly = method === "keys" && targetIsMap;
      const innerIterator = target[method](...args);
      const wrap2 = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
      !isReadonly && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
      return {
        next() {
          const { value, done } = innerIterator.next();
          return done ? { value, done } : {
            value: isPair ? [wrap2(value[0]), wrap2(value[1])] : wrap2(value),
            done
          };
        },
        [Symbol.iterator]() {
          return this;
        }
      };
    };
  }
  function createReadonlyMethod(type) {
    return function(...args) {
      if (true) {
        const key = args[0] ? `on key "${args[0]}" ` : ``;
        console.warn(`${capitalize(type)} operation ${key}failed: target is readonly.`, toRaw(this));
      }
      return type === "delete" ? false : this;
    };
  }
  var mutableInstrumentations = {
    get(key) {
      return get$1(this, key);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, false)
  };
  var shallowInstrumentations = {
    get(key) {
      return get$1(this, key, false, true);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, true)
  };
  var readonlyInstrumentations = {
    get(key) {
      return get$1(this, key, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod("add"),
    set: createReadonlyMethod("set"),
    delete: createReadonlyMethod("delete"),
    clear: createReadonlyMethod("clear"),
    forEach: createForEach(true, false)
  };
  var shallowReadonlyInstrumentations = {
    get(key) {
      return get$1(this, key, true, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod("add"),
    set: createReadonlyMethod("set"),
    delete: createReadonlyMethod("delete"),
    clear: createReadonlyMethod("clear"),
    forEach: createForEach(true, true)
  };
  var iteratorMethods = ["keys", "values", "entries", Symbol.iterator];
  iteratorMethods.forEach((method) => {
    mutableInstrumentations[method] = createIterableMethod(method, false, false);
    readonlyInstrumentations[method] = createIterableMethod(method, true, false);
    shallowInstrumentations[method] = createIterableMethod(method, false, true);
    shallowReadonlyInstrumentations[method] = createIterableMethod(method, true, true);
  });
  function createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? shallowReadonlyInstrumentations : shallowInstrumentations : isReadonly ? readonlyInstrumentations : mutableInstrumentations;
    return (target, key, receiver) => {
      if (key === "__v_isReactive") {
        return !isReadonly;
      } else if (key === "__v_isReadonly") {
        return isReadonly;
      } else if (key === "__v_raw") {
        return target;
      }
      return Reflect.get(hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
  }
  var mutableCollectionHandlers = {
    get: createInstrumentationGetter(false, false)
  };
  var shallowCollectionHandlers = {
    get: createInstrumentationGetter(false, true)
  };
  var readonlyCollectionHandlers = {
    get: createInstrumentationGetter(true, false)
  };
  var shallowReadonlyCollectionHandlers = {
    get: createInstrumentationGetter(true, true)
  };
  function checkIdentityKeys(target, has2, key) {
    const rawKey = toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
      const type = toRawType(target);
      console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
  }
  var reactiveMap = /* @__PURE__ */ new WeakMap();
  var shallowReactiveMap = /* @__PURE__ */ new WeakMap();
  var readonlyMap = /* @__PURE__ */ new WeakMap();
  var shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
  function targetTypeMap(rawType) {
    switch (rawType) {
      case "Object":
      case "Array":
        return 1;
      case "Map":
      case "Set":
      case "WeakMap":
      case "WeakSet":
        return 2;
      default:
        return 0;
    }
  }
  function getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
  }
  function reactive2(target) {
    if (target && target["__v_isReadonly"]) {
      return target;
    }
    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
  }
  function readonly(target) {
    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
  }
  function createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!isObject(target)) {
      if (true) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
      }
      return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) {
      return target;
    }
    const existingProxy = proxyMap.get(target);
    if (existingProxy) {
      return existingProxy;
    }
    const targetType = getTargetType(target);
    if (targetType === 0) {
      return target;
    }
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
  }
  function toRaw(observed) {
    return observed && toRaw(observed["__v_raw"]) || observed;
  }
  function isRef(r4) {
    return Boolean(r4 && r4.__v_isRef === true);
  }
  magic("nextTick", () => nextTick);
  magic("dispatch", (el) => dispatch.bind(dispatch, el));
  magic("watch", (el, { evaluateLater: evaluateLater2, effect: effect3 }) => (key, callback) => {
    let evaluate2 = evaluateLater2(key);
    let firstTime = true;
    let oldValue;
    let effectReference = effect3(() => evaluate2((value) => {
      JSON.stringify(value);
      if (!firstTime) {
        queueMicrotask(() => {
          callback(value, oldValue);
          oldValue = value;
        });
      } else {
        oldValue = value;
      }
      firstTime = false;
    }));
    el._x_effects.delete(effectReference);
  });
  magic("store", getStores);
  magic("data", (el) => scope(el));
  magic("root", (el) => closestRoot(el));
  magic("refs", (el) => {
    if (el._x_refs_proxy)
      return el._x_refs_proxy;
    el._x_refs_proxy = mergeProxies(getArrayOfRefObject(el));
    return el._x_refs_proxy;
  });
  function getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while (currentEl) {
      if (currentEl._x_refs)
        refObjects.push(currentEl._x_refs);
      currentEl = currentEl.parentNode;
    }
    return refObjects;
  }
  var globalIdMemo = {};
  function findAndIncrementId(name) {
    if (!globalIdMemo[name])
      globalIdMemo[name] = 0;
    return ++globalIdMemo[name];
  }
  function closestIdRoot(el, name) {
    return findClosest(el, (element) => {
      if (element._x_ids && element._x_ids[name])
        return true;
    });
  }
  function setIdRoot(el, name) {
    if (!el._x_ids)
      el._x_ids = {};
    if (!el._x_ids[name])
      el._x_ids[name] = findAndIncrementId(name);
  }
  magic("id", (el) => (name, key = null) => {
    let root = closestIdRoot(el, name);
    let id = root ? root._x_ids[name] : findAndIncrementId(name);
    return key ? `${name}-${id}-${key}` : `${name}-${id}`;
  });
  magic("el", (el) => el);
  warnMissingPluginMagic("Focus", "focus", "focus");
  warnMissingPluginMagic("Persist", "persist", "persist");
  function warnMissingPluginMagic(name, magicName, slug) {
    magic(magicName, (el) => warn(`You can't use [$${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
  }
  directive("modelable", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2 }) => {
    let func = evaluateLater2(expression);
    let innerGet = () => {
      let result;
      func((i4) => result = i4);
      return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val) => evaluateInnerSet(() => {
    }, { scope: { __placeholder: val } });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(() => {
      if (!el._x_model)
        return;
      el._x_removeModelListeners["default"]();
      let outerGet = el._x_model.get;
      let outerSet = el._x_model.set;
      effect3(() => innerSet(outerGet()));
      effect3(() => outerSet(innerGet()));
    });
  });
  directive("teleport", (el, { expression }, { cleanup: cleanup2 }) => {
    if (el.tagName.toLowerCase() !== "template")
      warn("x-teleport can only be used on a <template> tag", el);
    let target = document.querySelector(expression);
    if (!target)
      warn(`Cannot find x-teleport element for selector: "${expression}"`);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    if (el._x_forwardEvents) {
      el._x_forwardEvents.forEach((eventName) => {
        clone2.addEventListener(eventName, (e4) => {
          e4.stopPropagation();
          el.dispatchEvent(new e4.constructor(e4.type, e4));
        });
      });
    }
    addScopeToNode(clone2, {}, el);
    mutateDom(() => {
      target.appendChild(clone2);
      initTree(clone2);
      clone2._x_ignore = true;
    });
    cleanup2(() => clone2.remove());
  });
  var handler = () => {
  };
  handler.inline = (el, { modifiers }, { cleanup: cleanup2 }) => {
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(() => {
      modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
  };
  directive("ignore", handler);
  directive("effect", (el, { expression }, { effect: effect3 }) => effect3(evaluateLater(el, expression)));
  function on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler3 = (e4) => callback(e4);
    let options = {};
    let wrapHandler = (callback2, wrapper) => (e4) => wrapper(callback2, e4);
    if (modifiers.includes("dot"))
      event = dotSyntax(event);
    if (modifiers.includes("camel"))
      event = camelCase2(event);
    if (modifiers.includes("passive"))
      options.passive = true;
    if (modifiers.includes("capture"))
      options.capture = true;
    if (modifiers.includes("window"))
      listenerTarget = window;
    if (modifiers.includes("document"))
      listenerTarget = document;
    if (modifiers.includes("prevent"))
      handler3 = wrapHandler(handler3, (next, e4) => {
        e4.preventDefault();
        next(e4);
      });
    if (modifiers.includes("stop"))
      handler3 = wrapHandler(handler3, (next, e4) => {
        e4.stopPropagation();
        next(e4);
      });
    if (modifiers.includes("self"))
      handler3 = wrapHandler(handler3, (next, e4) => {
        e4.target === el && next(e4);
      });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
      listenerTarget = document;
      handler3 = wrapHandler(handler3, (next, e4) => {
        if (el.contains(e4.target))
          return;
        if (e4.target.isConnected === false)
          return;
        if (el.offsetWidth < 1 && el.offsetHeight < 1)
          return;
        if (el._x_isShown === false)
          return;
        next(e4);
      });
    }
    if (modifiers.includes("once")) {
      handler3 = wrapHandler(handler3, (next, e4) => {
        next(e4);
        listenerTarget.removeEventListener(event, handler3, options);
      });
    }
    handler3 = wrapHandler(handler3, (next, e4) => {
      if (isKeyEvent(event)) {
        if (isListeningForASpecificKeyThatHasntBeenPressed(e4, modifiers)) {
          return;
        }
      }
      next(e4);
    });
    if (modifiers.includes("debounce")) {
      let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
      let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
      handler3 = debounce(handler3, wait);
    }
    if (modifiers.includes("throttle")) {
      let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
      let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
      handler3 = throttle(handler3, wait);
    }
    listenerTarget.addEventListener(event, handler3, options);
    return () => {
      listenerTarget.removeEventListener(event, handler3, options);
    };
  }
  function dotSyntax(subject) {
    return subject.replace(/-/g, ".");
  }
  function camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match2, char) => char.toUpperCase());
  }
  function isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
  }
  function kebabCase2(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
  }
  function isKeyEvent(event) {
    return ["keydown", "keyup"].includes(event);
  }
  function isListeningForASpecificKeyThatHasntBeenPressed(e4, modifiers) {
    let keyModifiers = modifiers.filter((i4) => {
      return !["window", "document", "prevent", "stop", "once"].includes(i4);
    });
    if (keyModifiers.includes("debounce")) {
      let debounceIndex = keyModifiers.indexOf("debounce");
      keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0)
      return false;
    if (keyModifiers.length === 1 && keyToModifiers(e4.key).includes(keyModifiers[0]))
      return false;
    const systemKeyModifiers = ["ctrl", "shift", "alt", "meta", "cmd", "super"];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier) => keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i4) => !selectedSystemKeyModifiers.includes(i4));
    if (selectedSystemKeyModifiers.length > 0) {
      const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier) => {
        if (modifier === "cmd" || modifier === "super")
          modifier = "meta";
        return e4[`${modifier}Key`];
      });
      if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
        if (keyToModifiers(e4.key).includes(keyModifiers[0]))
          return false;
      }
    }
    return true;
  }
  function keyToModifiers(key) {
    if (!key)
      return [];
    key = kebabCase2(key);
    let modifierToKeyMap = {
      ctrl: "control",
      slash: "/",
      space: "-",
      spacebar: "-",
      cmd: "meta",
      esc: "escape",
      up: "arrow-up",
      down: "arrow-down",
      left: "arrow-left",
      right: "arrow-right",
      period: ".",
      equal: "="
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier) => {
      if (modifierToKeyMap[modifier] === key)
        return modifier;
    }).filter((modifier) => modifier);
  }
  directive("model", (el, { modifiers, expression }, { effect: effect3, cleanup: cleanup2 }) => {
    let evaluate2 = evaluateLater(el, expression);
    let assignmentExpression = `${expression} = rightSideOfExpression($event, ${expression})`;
    let evaluateAssignment = evaluateLater(el, assignmentExpression);
    var event = el.tagName.toLowerCase() === "select" || ["checkbox", "radio"].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let assigmentFunction = generateAssignmentFunction(el, modifiers, expression);
    let removeListener = on(el, event, modifiers, (e4) => {
      evaluateAssignment(() => {
      }, { scope: {
        $event: e4,
        rightSideOfExpression: assigmentFunction
      } });
    });
    if (!el._x_removeModelListeners)
      el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(() => el._x_removeModelListeners["default"]());
    let evaluateSetModel = evaluateLater(el, `${expression} = __placeholder`);
    el._x_model = {
      get() {
        let result;
        evaluate2((value) => result = value);
        return result;
      },
      set(value) {
        evaluateSetModel(() => {
        }, { scope: { __placeholder: value } });
      }
    };
    el._x_forceModelUpdate = () => {
      evaluate2((value) => {
        if (value === void 0 && expression.match(/\./))
          value = "";
        window.fromModel = true;
        mutateDom(() => bind(el, "value", value));
        delete window.fromModel;
      });
    };
    effect3(() => {
      if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el))
        return;
      el._x_forceModelUpdate();
    });
  });
  function generateAssignmentFunction(el, modifiers, expression) {
    if (el.type === "radio") {
      mutateDom(() => {
        if (!el.hasAttribute("name"))
          el.setAttribute("name", expression);
      });
    }
    return (event, currentValue) => {
      return mutateDom(() => {
        if (event instanceof CustomEvent && event.detail !== void 0) {
          return event.detail || event.target.value;
        } else if (el.type === "checkbox") {
          if (Array.isArray(currentValue)) {
            let newValue = modifiers.includes("number") ? safeParseNumber(event.target.value) : event.target.value;
            return event.target.checked ? currentValue.concat([newValue]) : currentValue.filter((el2) => !checkedAttrLooseCompare2(el2, newValue));
          } else {
            return event.target.checked;
          }
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
          return modifiers.includes("number") ? Array.from(event.target.selectedOptions).map((option) => {
            let rawValue = option.value || option.text;
            return safeParseNumber(rawValue);
          }) : Array.from(event.target.selectedOptions).map((option) => {
            return option.value || option.text;
          });
        } else {
          let rawValue = event.target.value;
          return modifiers.includes("number") ? safeParseNumber(rawValue) : modifiers.includes("trim") ? rawValue.trim() : rawValue;
        }
      });
    };
  }
  function safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return isNumeric2(number) ? number : rawValue;
  }
  function checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
  }
  function isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
  }
  directive("cloak", (el) => queueMicrotask(() => mutateDom(() => el.removeAttribute(prefix("cloak")))));
  addInitSelector(() => `[${prefix("init")}]`);
  directive("init", skipDuringClone((el, { expression }, { evaluate: evaluate2 }) => {
    if (typeof expression === "string") {
      return !!expression.trim() && evaluate2(expression, {}, false);
    }
    return evaluate2(expression, {}, false);
  }));
  directive("text", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2 }) => {
    let evaluate2 = evaluateLater2(expression);
    effect3(() => {
      evaluate2((value) => {
        mutateDom(() => {
          el.textContent = value;
        });
      });
    });
  });
  directive("html", (el, { expression }, { effect: effect3, evaluateLater: evaluateLater2 }) => {
    let evaluate2 = evaluateLater2(expression);
    effect3(() => {
      evaluate2((value) => {
        mutateDom(() => {
          el.innerHTML = value;
          el._x_ignoreSelf = true;
          initTree(el);
          delete el._x_ignoreSelf;
        });
      });
    });
  });
  mapAttributes(startingWith(":", into(prefix("bind:"))));
  directive("bind", (el, { value, modifiers, expression, original }, { effect: effect3 }) => {
    if (!value) {
      let bindingProviders = {};
      injectBindingProviders(bindingProviders);
      let getBindings = evaluateLater(el, expression);
      getBindings((bindings) => {
        applyBindingsObject(el, bindings, original);
      }, { scope: bindingProviders });
      return;
    }
    if (value === "key")
      return storeKeyForXFor(el, expression);
    let evaluate2 = evaluateLater(el, expression);
    effect3(() => evaluate2((result) => {
      if (result === void 0 && typeof expression === "string" && expression.match(/\./)) {
        result = "";
      }
      mutateDom(() => bind(el, value, result, modifiers));
    }));
  });
  function storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
  }
  addRootSelector(() => `[${prefix("data")}]`);
  directive("data", skipDuringClone((el, { expression }, { cleanup: cleanup2 }) => {
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    injectMagics(magicContext, el);
    let dataProviderContext = {};
    injectDataProviders(dataProviderContext, magicContext);
    let data22 = evaluate(el, expression, { scope: dataProviderContext });
    if (data22 === void 0)
      data22 = {};
    injectMagics(data22, el);
    let reactiveData = reactive(data22);
    initInterceptors(reactiveData);
    let undo = addScopeToNode(el, reactiveData);
    reactiveData["init"] && evaluate(el, reactiveData["init"]);
    cleanup2(() => {
      reactiveData["destroy"] && evaluate(el, reactiveData["destroy"]);
      undo();
    });
  }));
  directive("show", (el, { modifiers, expression }, { effect: effect3 }) => {
    let evaluate2 = evaluateLater(el, expression);
    if (!el._x_doHide)
      el._x_doHide = () => {
        mutateDom(() => {
          el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
      };
    if (!el._x_doShow)
      el._x_doShow = () => {
        mutateDom(() => {
          if (el.style.length === 1 && el.style.display === "none") {
            el.removeAttribute("style");
          } else {
            el.style.removeProperty("display");
          }
        });
      };
    let hide = () => {
      el._x_doHide();
      el._x_isShown = false;
    };
    let show = () => {
      el._x_doShow();
      el._x_isShown = true;
    };
    let clickAwayCompatibleShow = () => setTimeout(show);
    let toggle = once((value) => value ? show() : hide(), (value) => {
      if (typeof el._x_toggleAndCascadeWithTransitions === "function") {
        el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
      } else {
        value ? clickAwayCompatibleShow() : hide();
      }
    });
    let oldValue;
    let firstTime = true;
    effect3(() => evaluate2((value) => {
      if (!firstTime && value === oldValue)
        return;
      if (modifiers.includes("immediate"))
        value ? clickAwayCompatibleShow() : hide();
      toggle(value);
      oldValue = value;
      firstTime = false;
    }));
  });
  directive("for", (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
    let iteratorNames = parseForExpression(expression);
    let evaluateItems = evaluateLater(el, iteratorNames.items);
    let evaluateKey = evaluateLater(el, el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(() => loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(() => {
      Object.values(el._x_lookup).forEach((el2) => el2.remove());
      delete el._x_prevKeys;
      delete el._x_lookup;
    });
  });
  function loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i4) => typeof i4 === "object" && !Array.isArray(i4);
    let templateEl = el;
    evaluateItems((items) => {
      if (isNumeric3(items) && items >= 0) {
        items = Array.from(Array(items).keys(), (i4) => i4 + 1);
      }
      if (items === void 0)
        items = [];
      let lookup = el._x_lookup;
      let prevKeys = el._x_prevKeys;
      let scopes = [];
      let keys = [];
      if (isObject2(items)) {
        items = Object.entries(items).map(([key, value]) => {
          let scope2 = getIterationScopeVariables(iteratorNames, value, key, items);
          evaluateKey((value2) => keys.push(value2), { scope: { index: key, ...scope2 } });
          scopes.push(scope2);
        });
      } else {
        for (let i4 = 0; i4 < items.length; i4++) {
          let scope2 = getIterationScopeVariables(iteratorNames, items[i4], i4, items);
          evaluateKey((value) => keys.push(value), { scope: { index: i4, ...scope2 } });
          scopes.push(scope2);
        }
      }
      let adds = [];
      let moves = [];
      let removes = [];
      let sames = [];
      for (let i4 = 0; i4 < prevKeys.length; i4++) {
        let key = prevKeys[i4];
        if (keys.indexOf(key) === -1)
          removes.push(key);
      }
      prevKeys = prevKeys.filter((key) => !removes.includes(key));
      let lastKey = "template";
      for (let i4 = 0; i4 < keys.length; i4++) {
        let key = keys[i4];
        let prevIndex = prevKeys.indexOf(key);
        if (prevIndex === -1) {
          prevKeys.splice(i4, 0, key);
          adds.push([lastKey, i4]);
        } else if (prevIndex !== i4) {
          let keyInSpot = prevKeys.splice(i4, 1)[0];
          let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
          prevKeys.splice(i4, 0, keyForSpot);
          prevKeys.splice(prevIndex, 0, keyInSpot);
          moves.push([keyInSpot, keyForSpot]);
        } else {
          sames.push(key);
        }
        lastKey = key;
      }
      for (let i4 = 0; i4 < removes.length; i4++) {
        let key = removes[i4];
        if (!!lookup[key]._x_effects) {
          lookup[key]._x_effects.forEach(dequeueJob);
        }
        lookup[key].remove();
        lookup[key] = null;
        delete lookup[key];
      }
      for (let i4 = 0; i4 < moves.length; i4++) {
        let [keyInSpot, keyForSpot] = moves[i4];
        let elInSpot = lookup[keyInSpot];
        let elForSpot = lookup[keyForSpot];
        let marker = document.createElement("div");
        mutateDom(() => {
          elForSpot.after(marker);
          elInSpot.after(elForSpot);
          elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
          marker.before(elInSpot);
          elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
          marker.remove();
        });
        refreshScope(elForSpot, scopes[keys.indexOf(keyForSpot)]);
      }
      for (let i4 = 0; i4 < adds.length; i4++) {
        let [lastKey2, index] = adds[i4];
        let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
        if (lastEl._x_currentIfEl)
          lastEl = lastEl._x_currentIfEl;
        let scope2 = scopes[index];
        let key = keys[index];
        let clone2 = document.importNode(templateEl.content, true).firstElementChild;
        addScopeToNode(clone2, reactive(scope2), templateEl);
        mutateDom(() => {
          lastEl.after(clone2);
          initTree(clone2);
        });
        if (typeof key === "object") {
          warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
        }
        lookup[key] = clone2;
      }
      for (let i4 = 0; i4 < sames.length; i4++) {
        refreshScope(lookup[sames[i4]], scopes[keys.indexOf(sames[i4])]);
      }
      templateEl._x_prevKeys = keys;
    });
  }
  function parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch)
      return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
      res.item = item.replace(forIteratorRE, "").trim();
      res.index = iteratorMatch[1].trim();
      if (iteratorMatch[2]) {
        res.collection = iteratorMatch[2].trim();
      }
    } else {
      res.item = item;
    }
    return res;
  }
  function getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
      let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i4) => i4.trim());
      names.forEach((name, i4) => {
        scopeVariables[name] = item[i4];
      });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
      let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i4) => i4.trim());
      names.forEach((name) => {
        scopeVariables[name] = item[name];
      });
    } else {
      scopeVariables[iteratorNames.item] = item;
    }
    if (iteratorNames.index)
      scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection)
      scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
  }
  function isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
  }
  function handler2() {
  }
  handler2.inline = (el, { expression }, { cleanup: cleanup2 }) => {
    let root = closestRoot(el);
    if (!root._x_refs)
      root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(() => delete root._x_refs[expression]);
  };
  directive("ref", handler2);
  directive("if", (el, { expression }, { effect: effect3, cleanup: cleanup2 }) => {
    let evaluate2 = evaluateLater(el, expression);
    let show = () => {
      if (el._x_currentIfEl)
        return el._x_currentIfEl;
      let clone2 = el.content.cloneNode(true).firstElementChild;
      addScopeToNode(clone2, {}, el);
      mutateDom(() => {
        el.after(clone2);
        initTree(clone2);
      });
      el._x_currentIfEl = clone2;
      el._x_undoIf = () => {
        walk(clone2, (node) => {
          if (!!node._x_effects) {
            node._x_effects.forEach(dequeueJob);
          }
        });
        clone2.remove();
        delete el._x_currentIfEl;
      };
      return clone2;
    };
    let hide = () => {
      if (!el._x_undoIf)
        return;
      el._x_undoIf();
      delete el._x_undoIf;
    };
    effect3(() => evaluate2((value) => {
      value ? show() : hide();
    }));
    cleanup2(() => el._x_undoIf && el._x_undoIf());
  });
  directive("id", (el, { expression }, { evaluate: evaluate2 }) => {
    let names = evaluate2(expression);
    names.forEach((name) => setIdRoot(el, name));
  });
  mapAttributes(startingWith("@", into(prefix("on:"))));
  directive("on", skipDuringClone((el, { value, modifiers, expression }, { cleanup: cleanup2 }) => {
    let evaluate2 = expression ? evaluateLater(el, expression) : () => {
    };
    if (el.tagName.toLowerCase() === "template") {
      if (!el._x_forwardEvents)
        el._x_forwardEvents = [];
      if (!el._x_forwardEvents.includes(value))
        el._x_forwardEvents.push(value);
    }
    let removeListener = on(el, value, modifiers, (e4) => {
      evaluate2(() => {
      }, { scope: { $event: e4 }, params: [e4] });
    });
    cleanup2(() => removeListener());
  }));
  warnMissingPluginDirective("Collapse", "collapse", "collapse");
  warnMissingPluginDirective("Intersect", "intersect", "intersect");
  warnMissingPluginDirective("Focus", "trap", "focus");
  warnMissingPluginDirective("Mask", "mask", "mask");
  function warnMissingPluginDirective(name, directiveName2, slug) {
    directive(directiveName2, (el) => warn(`You can't use [x-${directiveName2}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
  }
  alpine_default.setEvaluator(normalEvaluator);
  alpine_default.setReactivityEngine({ reactive: reactive2, effect: effect2, release: stop, raw: toRaw });
  var src_default = alpine_default;
  var module_default = src_default;

  // node_modules/delegate-it/delegate.js
  var ledger = /* @__PURE__ */ new WeakMap();
  function editLedger(wanted, baseElement, callback, setup) {
    var _a, _b;
    if (!wanted && !ledger.has(baseElement)) {
      return false;
    }
    const elementMap = (_a = ledger.get(baseElement)) != null ? _a : /* @__PURE__ */ new WeakMap();
    ledger.set(baseElement, elementMap);
    const setups = (_b = elementMap.get(callback)) != null ? _b : /* @__PURE__ */ new Set();
    elementMap.set(callback, setups);
    const existed = setups.has(setup);
    if (wanted) {
      setups.add(setup);
    } else {
      setups.delete(setup);
    }
    return existed && wanted;
  }
  function safeClosest(event, selector) {
    let target = event.target;
    if (target instanceof Text) {
      target = target.parentElement;
    }
    if (target instanceof Element && event.currentTarget instanceof Element) {
      const closest = target.closest(selector);
      if (closest && event.currentTarget.contains(closest)) {
        return closest;
      }
    }
  }
  function delegate(selector, type, callback, options = {}) {
    const { signal, base = document } = options;
    if (signal == null ? void 0 : signal.aborted) {
      return;
    }
    const { once: once2, ...nativeListenerOptions } = options;
    const baseElement = base instanceof Document ? base.documentElement : base;
    const capture = Boolean(typeof options === "object" ? options.capture : options);
    const listenerFunction = (event) => {
      const delegateTarget = safeClosest(event, selector);
      if (delegateTarget) {
        const delegateEvent = Object.assign(event, { delegateTarget });
        callback.call(baseElement, delegateEvent);
        if (once2) {
          baseElement.removeEventListener(type, listenerFunction, nativeListenerOptions);
          editLedger(false, baseElement, callback, setup);
        }
      }
    };
    const setup = JSON.stringify({ selector, type, capture });
    const isAlreadyListening = editLedger(true, baseElement, callback, setup);
    if (!isAlreadyListening) {
      baseElement.addEventListener(type, listenerFunction, nativeListenerOptions);
    }
    signal == null ? void 0 : signal.addEventListener("abort", () => {
      editLedger(false, baseElement, callback, setup);
    });
  }
  var delegate_default = delegate;

  // node_modules/path-to-regexp/dist.es2015/index.js
  function lexer(str) {
    var tokens = [];
    var i4 = 0;
    while (i4 < str.length) {
      var char = str[i4];
      if (char === "*" || char === "+" || char === "?") {
        tokens.push({ type: "MODIFIER", index: i4, value: str[i4++] });
        continue;
      }
      if (char === "\\") {
        tokens.push({ type: "ESCAPED_CHAR", index: i4++, value: str[i4++] });
        continue;
      }
      if (char === "{") {
        tokens.push({ type: "OPEN", index: i4, value: str[i4++] });
        continue;
      }
      if (char === "}") {
        tokens.push({ type: "CLOSE", index: i4, value: str[i4++] });
        continue;
      }
      if (char === ":") {
        var name = "";
        var j2 = i4 + 1;
        while (j2 < str.length) {
          var code = str.charCodeAt(j2);
          if (
            // `0-9`
            code >= 48 && code <= 57 || // `A-Z`
            code >= 65 && code <= 90 || // `a-z`
            code >= 97 && code <= 122 || // `_`
            code === 95
          ) {
            name += str[j2++];
            continue;
          }
          break;
        }
        if (!name)
          throw new TypeError("Missing parameter name at ".concat(i4));
        tokens.push({ type: "NAME", index: i4, value: name });
        i4 = j2;
        continue;
      }
      if (char === "(") {
        var count = 1;
        var pattern = "";
        var j2 = i4 + 1;
        if (str[j2] === "?") {
          throw new TypeError('Pattern cannot start with "?" at '.concat(j2));
        }
        while (j2 < str.length) {
          if (str[j2] === "\\") {
            pattern += str[j2++] + str[j2++];
            continue;
          }
          if (str[j2] === ")") {
            count--;
            if (count === 0) {
              j2++;
              break;
            }
          } else if (str[j2] === "(") {
            count++;
            if (str[j2 + 1] !== "?") {
              throw new TypeError("Capturing groups are not allowed at ".concat(j2));
            }
          }
          pattern += str[j2++];
        }
        if (count)
          throw new TypeError("Unbalanced pattern at ".concat(i4));
        if (!pattern)
          throw new TypeError("Missing pattern at ".concat(i4));
        tokens.push({ type: "PATTERN", index: i4, value: pattern });
        i4 = j2;
        continue;
      }
      tokens.push({ type: "CHAR", index: i4, value: str[i4++] });
    }
    tokens.push({ type: "END", index: i4, value: "" });
    return tokens;
  }
  function parse(str, options) {
    if (options === void 0) {
      options = {};
    }
    var tokens = lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^".concat(escapeString(options.delimiter || "/#?"), "]+?");
    var result = [];
    var key = 0;
    var i4 = 0;
    var path = "";
    var tryConsume = function(type) {
      if (i4 < tokens.length && tokens[i4].type === type)
        return tokens[i4++].value;
    };
    var mustConsume = function(type) {
      var value2 = tryConsume(type);
      if (value2 !== void 0)
        return value2;
      var _a2 = tokens[i4], nextType = _a2.type, index = _a2.index;
      throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
      var result2 = "";
      var value2;
      while (value2 = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR")) {
        result2 += value2;
      }
      return result2;
    };
    while (i4 < tokens.length) {
      var char = tryConsume("CHAR");
      var name = tryConsume("NAME");
      var pattern = tryConsume("PATTERN");
      if (name || pattern) {
        var prefix2 = char || "";
        if (prefixes.indexOf(prefix2) === -1) {
          path += prefix2;
          prefix2 = "";
        }
        if (path) {
          result.push(path);
          path = "";
        }
        result.push({
          name: name || key++,
          prefix: prefix2,
          suffix: "",
          pattern: pattern || defaultPattern,
          modifier: tryConsume("MODIFIER") || ""
        });
        continue;
      }
      var value = char || tryConsume("ESCAPED_CHAR");
      if (value) {
        path += value;
        continue;
      }
      if (path) {
        result.push(path);
        path = "";
      }
      var open = tryConsume("OPEN");
      if (open) {
        var prefix2 = consumeText();
        var name_1 = tryConsume("NAME") || "";
        var pattern_1 = tryConsume("PATTERN") || "";
        var suffix = consumeText();
        mustConsume("CLOSE");
        result.push({
          name: name_1 || (pattern_1 ? key++ : ""),
          pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
          prefix: prefix2,
          suffix,
          modifier: tryConsume("MODIFIER") || ""
        });
        continue;
      }
      mustConsume("END");
    }
    return result;
  }
  function match(str, options) {
    var keys = [];
    var re = pathToRegexp(str, keys, options);
    return regexpToFunction(re, keys, options);
  }
  function regexpToFunction(re, keys, options) {
    if (options === void 0) {
      options = {};
    }
    var _a = options.decode, decode = _a === void 0 ? function(x3) {
      return x3;
    } : _a;
    return function(pathname) {
      var m4 = re.exec(pathname);
      if (!m4)
        return false;
      var path = m4[0], index = m4.index;
      var params = /* @__PURE__ */ Object.create(null);
      var _loop_1 = function(i5) {
        if (m4[i5] === void 0)
          return "continue";
        var key = keys[i5 - 1];
        if (key.modifier === "*" || key.modifier === "+") {
          params[key.name] = m4[i5].split(key.prefix + key.suffix).map(function(value) {
            return decode(value, key);
          });
        } else {
          params[key.name] = decode(m4[i5], key);
        }
      };
      for (var i4 = 1; i4 < m4.length; i4++) {
        _loop_1(i4);
      }
      return { path, index, params };
    };
  }
  function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
  }
  function flags(options) {
    return options && options.sensitive ? "" : "i";
  }
  function regexpToRegexp(path, keys) {
    if (!keys)
      return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while (execResult) {
      keys.push({
        // Use parenthesized substring match if available, index otherwise
        name: execResult[1] || index++,
        prefix: "",
        suffix: "",
        modifier: "",
        pattern: ""
      });
      execResult = groupsRegex.exec(path.source);
    }
    return path;
  }
  function arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
      return pathToRegexp(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), flags(options));
  }
  function stringToRegexp(path, keys, options) {
    return tokensToRegexp(parse(path, options), keys, options);
  }
  function tokensToRegexp(tokens, keys, options) {
    if (options === void 0) {
      options = {};
    }
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start2 = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x3) {
      return x3;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat(escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat(escapeString(delimiter), "]");
    var route = start2 ? "^" : "";
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
      var token = tokens_1[_i];
      if (typeof token === "string") {
        route += escapeString(encode(token));
      } else {
        var prefix2 = escapeString(encode(token.prefix));
        var suffix = escapeString(encode(token.suffix));
        if (token.pattern) {
          if (keys)
            keys.push(token);
          if (prefix2 || suffix) {
            if (token.modifier === "+" || token.modifier === "*") {
              var mod = token.modifier === "*" ? "?" : "";
              route += "(?:".concat(prefix2, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix2, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
            } else {
              route += "(?:".concat(prefix2, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
            }
          } else {
            if (token.modifier === "+" || token.modifier === "*") {
              route += "((?:".concat(token.pattern, ")").concat(token.modifier, ")");
            } else {
              route += "(".concat(token.pattern, ")").concat(token.modifier);
            }
          }
        } else {
          route += "(?:".concat(prefix2).concat(suffix, ")").concat(token.modifier);
        }
      }
    }
    if (end) {
      if (!strict)
        route += "".concat(delimiterRe, "?");
      route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
      var endToken = tokens[tokens.length - 1];
      var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === void 0;
      if (!strict) {
        route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
      }
      if (!isEndDelimited) {
        route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
      }
    }
    return new RegExp(route, flags(options));
  }
  function pathToRegexp(path, keys, options) {
    if (path instanceof RegExp)
      return regexpToRegexp(path, keys);
    if (Array.isArray(path))
      return arrayToRegexp(path, keys, options);
    return stringToRegexp(path, keys, options);
  }

  // node_modules/swup/dist/Swup.modern.js
  function i() {
    return i = Object.assign ? Object.assign.bind() : function(t3) {
      for (var e4 = 1; e4 < arguments.length; e4++) {
        var i4 = arguments[e4];
        for (var s4 in i4) Object.prototype.hasOwnProperty.call(i4, s4) && (t3[s4] = i4[s4]);
      }
      return t3;
    }, i.apply(this, arguments);
  }
  var s = (t3, e4) => String(t3).toLowerCase().replace(/[\s/_.]+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+|-+$/g, "") || e4 || "";
  var n = ({ hash: t3 } = {}) => window.location.pathname + window.location.search + (t3 ? window.location.hash : "");
  var o = (t3, e4 = {}) => {
    const s4 = i({ url: t3 = t3 || n({ hash: true }), random: Math.random(), source: "swup" }, e4);
    window.history.pushState(s4, "", t3);
  };
  var r = (t3 = null, e4 = {}) => {
    t3 = t3 || n({ hash: true });
    const s4 = i({}, window.history.state || {}, { url: t3, random: Math.random(), source: "swup" }, e4);
    window.history.replaceState(s4, "", t3);
  };
  var a = (e4, s4, n4, o4) => {
    const r4 = new AbortController();
    return o4 = i({}, o4, { signal: r4.signal }), delegate_default(e4, s4, n4, o4), { destroy: () => r4.abort() };
  };
  var l = class _l extends URL {
    constructor(t3, e4 = document.baseURI) {
      super(t3.toString(), e4), Object.setPrototypeOf(this, _l.prototype);
    }
    get url() {
      return this.pathname + this.search;
    }
    static fromElement(t3) {
      const e4 = t3.getAttribute("href") || t3.getAttribute("xlink:href") || "";
      return new _l(e4);
    }
    static fromUrl(t3) {
      return new _l(t3);
    }
  };
  var h = (t3, i4) => {
    try {
      return match(t3, i4);
    } catch (e4) {
      throw new Error(`[swup] Error parsing path "${String(t3)}":
${String(e4)}`);
    }
  };
  var c = class extends Error {
    constructor(t3, e4) {
      super(t3), this.url = void 0, this.status = void 0, this.aborted = void 0, this.timedOut = void 0, this.name = "FetchError", this.url = e4.url, this.status = e4.status, this.aborted = e4.aborted || false, this.timedOut = e4.timedOut || false;
    }
  };
  async function u(t3, e4 = {}) {
    var s4;
    t3 = l.fromUrl(t3).url;
    const { visit: n4 = this.visit } = e4, o4 = i({}, this.options.requestHeaders, e4.headers), r4 = null != (s4 = e4.timeout) ? s4 : this.options.timeout, a4 = new AbortController(), { signal: h4 } = a4;
    e4 = i({}, e4, { headers: o4, signal: h4 });
    let u4, d4 = false, p4 = null;
    r4 && r4 > 0 && (p4 = setTimeout(() => {
      d4 = true, a4.abort("timeout");
    }, r4));
    try {
      u4 = await this.hooks.call("fetch:request", n4, { url: t3, options: e4 }, (t4, { url: e5, options: i4 }) => fetch(e5, i4)), p4 && clearTimeout(p4);
    } catch (e5) {
      if (d4) throw this.hooks.call("fetch:timeout", n4, { url: t3 }), new c(`Request timed out: ${t3}`, { url: t3, timedOut: d4 });
      if ("AbortError" === (null == e5 ? void 0 : e5.name) || h4.aborted) throw new c(`Request aborted: ${t3}`, { url: t3, aborted: true });
      throw e5;
    }
    const { status: m4, url: g4 } = u4, w3 = await u4.text();
    if (500 === m4) throw this.hooks.call("fetch:error", n4, { status: m4, response: u4, url: g4 }), new c(`Server error: ${g4}`, { status: m4, url: g4 });
    if (!w3) throw new c(`Empty response: ${g4}`, { status: m4, url: g4 });
    const { url: f4 } = l.fromUrl(g4), v3 = { url: f4, html: w3 };
    return !n4.cache.write || e4.method && "GET" !== e4.method || t3 !== f4 || this.cache.set(v3.url, v3), v3;
  }
  var d = class {
    constructor(t3) {
      this.swup = void 0, this.pages = /* @__PURE__ */ new Map(), this.swup = t3;
    }
    get size() {
      return this.pages.size;
    }
    get all() {
      const t3 = /* @__PURE__ */ new Map();
      return this.pages.forEach((e4, s4) => {
        t3.set(s4, i({}, e4));
      }), t3;
    }
    has(t3) {
      return this.pages.has(this.resolve(t3));
    }
    get(t3) {
      const e4 = this.pages.get(this.resolve(t3));
      return e4 ? i({}, e4) : e4;
    }
    set(t3, e4) {
      e4 = i({}, e4, { url: t3 = this.resolve(t3) }), this.pages.set(t3, e4), this.swup.hooks.callSync("cache:set", void 0, { page: e4 });
    }
    update(t3, e4) {
      t3 = this.resolve(t3);
      const s4 = i({}, this.get(t3), e4, { url: t3 });
      this.pages.set(t3, s4);
    }
    delete(t3) {
      this.pages.delete(this.resolve(t3));
    }
    clear() {
      this.pages.clear(), this.swup.hooks.callSync("cache:clear", void 0, void 0);
    }
    prune(t3) {
      this.pages.forEach((e4, i4) => {
        t3(i4, e4) && this.delete(i4);
      });
    }
    resolve(t3) {
      const { url: e4 } = l.fromUrl(t3);
      return this.swup.resolveUrl(e4);
    }
  };
  var p = (t3, e4 = document) => e4.querySelector(t3);
  var m = (t3, e4 = document) => Array.from(e4.querySelectorAll(t3));
  var g = () => new Promise((t3) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        t3();
      });
    });
  });
  function w(t3) {
    return !!t3 && ("object" == typeof t3 || "function" == typeof t3) && "function" == typeof t3.then;
  }
  function f(t3, e4 = []) {
    return new Promise((i4, s4) => {
      const n4 = t3(...e4);
      w(n4) ? n4.then(i4, s4) : i4(n4);
    });
  }
  var y = class {
    constructor(t3) {
      this.swup = void 0, this.swupClasses = ["to-", "is-changing", "is-rendering", "is-popstate", "is-animating", "is-leaving"], this.swup = t3;
    }
    get selectors() {
      const { scope: t3 } = this.swup.visit.animation;
      return "containers" === t3 ? this.swup.visit.containers : "html" === t3 ? ["html"] : Array.isArray(t3) ? t3 : [];
    }
    get selector() {
      return this.selectors.join(",");
    }
    get targets() {
      return this.selector.trim() ? m(this.selector) : [];
    }
    add(...t3) {
      this.targets.forEach((e4) => e4.classList.add(...t3));
    }
    remove(...t3) {
      this.targets.forEach((e4) => e4.classList.remove(...t3));
    }
    clear() {
      this.targets.forEach((t3) => {
        const e4 = t3.className.split(" ").filter((t4) => this.isSwupClass(t4));
        t3.classList.remove(...e4);
      });
    }
    isSwupClass(t3) {
      return this.swupClasses.some((e4) => t3.startsWith(e4));
    }
  };
  var k = class {
    constructor(t3, e4) {
      this.id = void 0, this.state = void 0, this.from = void 0, this.to = void 0, this.containers = void 0, this.animation = void 0, this.trigger = void 0, this.cache = void 0, this.history = void 0, this.scroll = void 0;
      const { to: i4, from: s4 = t3.currentPageUrl, hash: n4, el: o4, event: r4 } = e4;
      this.id = Math.random(), this.state = 1, this.from = { url: s4 }, this.to = { url: i4, hash: n4 }, this.containers = t3.options.containers, this.animation = { animate: true, wait: false, name: void 0, native: t3.options.native, scope: t3.options.animationScope, selector: t3.options.animationSelector }, this.trigger = { el: o4, event: r4 }, this.cache = { read: t3.options.cache, write: t3.options.cache }, this.history = { action: "push", popstate: false, direction: void 0 }, this.scroll = { reset: true, target: void 0 };
    }
    advance(t3) {
      this.state < t3 && (this.state = t3);
    }
    abort() {
      this.state = 8;
    }
    get done() {
      return this.state >= 7;
    }
  };
  function b(t3) {
    return new k(this, t3);
  }
  var S = class {
    constructor(t3) {
      this.swup = void 0, this.registry = /* @__PURE__ */ new Map(), this.hooks = ["animation:out:start", "animation:out:await", "animation:out:end", "animation:in:start", "animation:in:await", "animation:in:end", "animation:skip", "cache:clear", "cache:set", "content:replace", "content:scroll", "enable", "disable", "fetch:request", "fetch:error", "fetch:timeout", "history:popstate", "link:click", "link:self", "link:anchor", "link:newtab", "page:load", "page:view", "scroll:top", "scroll:anchor", "visit:start", "visit:transition", "visit:abort", "visit:end"], this.swup = t3, this.init();
    }
    init() {
      this.hooks.forEach((t3) => this.create(t3));
    }
    create(t3) {
      this.registry.has(t3) || this.registry.set(t3, /* @__PURE__ */ new Map());
    }
    exists(t3) {
      return this.registry.has(t3);
    }
    get(t3) {
      const e4 = this.registry.get(t3);
      if (e4) return e4;
      console.error(`Unknown hook '${t3}'`);
    }
    clear() {
      this.registry.forEach((t3) => t3.clear());
    }
    on(t3, e4, s4 = {}) {
      const n4 = this.get(t3);
      if (!n4) return console.warn(`Hook '${t3}' not found.`), () => {
      };
      const o4 = i({}, s4, { id: n4.size + 1, hook: t3, handler: e4 });
      return n4.set(e4, o4), () => this.off(t3, e4);
    }
    before(t3, e4, s4 = {}) {
      return this.on(t3, e4, i({}, s4, { before: true }));
    }
    replace(t3, e4, s4 = {}) {
      return this.on(t3, e4, i({}, s4, { replace: true }));
    }
    once(t3, e4, s4 = {}) {
      return this.on(t3, e4, i({}, s4, { once: true }));
    }
    off(t3, e4) {
      const i4 = this.get(t3);
      i4 && e4 ? i4.delete(e4) || console.warn(`Handler for hook '${t3}' not found.`) : i4 && i4.clear();
    }
    async call(t3, e4, i4, s4) {
      const [n4, o4, r4] = this.parseCallArgs(t3, e4, i4, s4), { before: a4, handler: l4, after: h4 } = this.getHandlers(t3, r4);
      await this.run(a4, n4, o4);
      const [c4] = await this.run(l4, n4, o4, true);
      return await this.run(h4, n4, o4), this.dispatchDomEvent(t3, n4, o4), c4;
    }
    callSync(t3, e4, i4, s4) {
      const [n4, o4, r4] = this.parseCallArgs(t3, e4, i4, s4), { before: a4, handler: l4, after: h4 } = this.getHandlers(t3, r4);
      this.runSync(a4, n4, o4);
      const [c4] = this.runSync(l4, n4, o4, true);
      return this.runSync(h4, n4, o4), this.dispatchDomEvent(t3, n4, o4), c4;
    }
    parseCallArgs(t3, e4, i4, s4) {
      return e4 instanceof k || "object" != typeof e4 && "function" != typeof i4 ? [e4, i4, s4] : [void 0, e4, i4];
    }
    async run(t3, e4 = this.swup.visit, i4, s4 = false) {
      const n4 = [];
      for (const { hook: o4, handler: r4, defaultHandler: a4, once: l4 } of t3) if (null == e4 || !e4.done) {
        l4 && this.off(o4, r4);
        try {
          const t4 = await f(r4, [e4, i4, a4]);
          n4.push(t4);
        } catch (t4) {
          if (s4) throw t4;
          console.error(`Error in hook '${o4}':`, t4);
        }
      }
      return n4;
    }
    runSync(t3, e4 = this.swup.visit, i4, s4 = false) {
      const n4 = [];
      for (const { hook: o4, handler: r4, defaultHandler: a4, once: l4 } of t3) if (null == e4 || !e4.done) {
        l4 && this.off(o4, r4);
        try {
          const t4 = r4(e4, i4, a4);
          n4.push(t4), w(t4) && console.warn(`Swup will not await Promises in handler for synchronous hook '${o4}'.`);
        } catch (t4) {
          if (s4) throw t4;
          console.error(`Error in hook '${o4}':`, t4);
        }
      }
      return n4;
    }
    getHandlers(t3, e4) {
      const i4 = this.get(t3);
      if (!i4) return { found: false, before: [], handler: [], after: [], replaced: false };
      const s4 = Array.from(i4.values()), n4 = this.sortRegistrations, o4 = s4.filter(({ before: t4, replace: e5 }) => t4 && !e5).sort(n4), r4 = s4.filter(({ replace: t4 }) => t4).filter((t4) => true).sort(n4), a4 = s4.filter(({ before: t4, replace: e5 }) => !t4 && !e5).sort(n4), l4 = r4.length > 0;
      let h4 = [];
      if (e4 && (h4 = [{ id: 0, hook: t3, handler: e4 }], l4)) {
        const i5 = r4.length - 1, s5 = (t4) => {
          const i6 = r4[t4 - 1];
          return i6 ? (e5, n5) => i6.handler(e5, n5, s5(t4 - 1)) : e4;
        };
        h4 = [{ id: 0, hook: t3, handler: r4[i5].handler, defaultHandler: s5(i5) }];
      }
      return { found: true, before: o4, handler: h4, after: a4, replaced: l4 };
    }
    sortRegistrations(t3, e4) {
      var i4, s4;
      return (null != (i4 = t3.priority) ? i4 : 0) - (null != (s4 = e4.priority) ? s4 : 0) || t3.id - e4.id || 0;
    }
    dispatchDomEvent(t3, e4, i4) {
      if (null != e4 && e4.done) return;
      const s4 = { hook: t3, args: i4, visit: e4 || this.swup.visit };
      document.dispatchEvent(new CustomEvent("swup:any", { detail: s4, bubbles: true })), document.dispatchEvent(new CustomEvent(`swup:${t3}`, { detail: s4, bubbles: true }));
    }
  };
  var E = (t3) => {
    if (t3 && "#" === t3.charAt(0) && (t3 = t3.substring(1)), !t3) return null;
    const e4 = decodeURIComponent(t3);
    let i4 = document.getElementById(t3) || document.getElementById(e4) || p(`a[name='${CSS.escape(t3)}']`) || p(`a[name='${CSS.escape(e4)}']`);
    return i4 || "top" !== t3 || (i4 = document.body), i4;
  };
  var P = "transition";
  var U = "animation";
  async function C({ elements: t3, selector: e4 }) {
    if (false === e4 && !t3) return;
    let i4 = [];
    if (t3) i4 = Array.from(t3);
    else if (e4 && (i4 = m(e4, document.body), !i4.length)) return void console.warn(`[swup] No elements found matching animationSelector \`${e4}\``);
    const s4 = i4.map((t4) => function(t5) {
      const { type: e5, timeout: i5, propCount: s5 } = function(t6) {
        const e6 = window.getComputedStyle(t6), i6 = $(e6, `${P}Delay`), s6 = $(e6, `${P}Duration`), n4 = x(i6, s6), o4 = $(e6, `${U}Delay`), r4 = $(e6, `${U}Duration`), a4 = x(o4, r4), l4 = Math.max(n4, a4), h4 = l4 > 0 ? n4 > a4 ? P : U : null;
        return { type: h4, timeout: l4, propCount: h4 ? h4 === P ? s6.length : r4.length : 0 };
      }(t5);
      return !(!e5 || !i5) && new Promise((n4) => {
        const o4 = `${e5}end`, r4 = performance.now();
        let a4 = 0;
        const l4 = () => {
          t5.removeEventListener(o4, h4), n4();
        }, h4 = (e6) => {
          if (e6.target === t5) {
            if (!function(t6) {
              return [`${P}end`, `${U}end`].includes(t6.type);
            }(e6)) throw new Error("Not a transition or animation event.");
            (performance.now() - r4) / 1e3 < e6.elapsedTime || ++a4 >= s5 && l4();
          }
        };
        setTimeout(() => {
          a4 < s5 && l4();
        }, i5 + 1), t5.addEventListener(o4, h4);
      });
    }(t4));
    s4.filter(Boolean).length > 0 ? await Promise.all(s4) : e4 && console.warn(`[swup] No CSS animation duration defined on elements matching \`${e4}\``);
  }
  function $(t3, e4) {
    return (t3[e4] || "").split(", ");
  }
  function x(t3, e4) {
    for (; t3.length < e4.length; ) t3 = t3.concat(t3);
    return Math.max(...e4.map((e5, i4) => A(e5) + A(t3[i4])));
  }
  function A(t3) {
    return 1e3 * parseFloat(t3);
  }
  function H(t3, e4 = {}, s4 = {}) {
    if ("string" != typeof t3) throw new Error("swup.navigate() requires a URL parameter");
    if (this.shouldIgnoreVisit(t3, { el: s4.el, event: s4.event })) return void window.location.assign(t3);
    const { url: n4, hash: o4 } = l.fromUrl(t3), r4 = this.createVisit(i({}, s4, { to: n4, hash: o4 }));
    this.performNavigation(r4, e4);
  }
  async function V(t3, e4 = {}) {
    if (this.navigating) {
      if (this.visit.state >= 6) return t3.state = 2, void (this.onVisitEnd = () => this.performNavigation(t3, e4));
      await this.hooks.call("visit:abort", this.visit, void 0), delete this.visit.to.document, this.visit.state = 8;
    }
    this.navigating = true, this.visit = t3;
    const { el: i4 } = t3.trigger;
    e4.referrer = e4.referrer || this.currentPageUrl, false === e4.animate && (t3.animation.animate = false), t3.animation.animate || this.classes.clear();
    const a4 = e4.history || (null == i4 ? void 0 : i4.getAttribute("data-swup-history")) || void 0;
    a4 && ["push", "replace"].includes(a4) && (t3.history.action = a4);
    const l4 = e4.animation || (null == i4 ? void 0 : i4.getAttribute("data-swup-animation")) || void 0;
    var h4, c4;
    l4 && (t3.animation.name = l4), "object" == typeof e4.cache ? (t3.cache.read = null != (h4 = e4.cache.read) ? h4 : t3.cache.read, t3.cache.write = null != (c4 = e4.cache.write) ? c4 : t3.cache.write) : void 0 !== e4.cache && (t3.cache = { read: !!e4.cache, write: !!e4.cache }), delete e4.cache;
    try {
      await this.hooks.call("visit:start", t3, void 0), t3.state = 3;
      const i5 = this.hooks.call("page:load", t3, { options: e4 }, async (t4, e5) => {
        let i6;
        return t4.cache.read && (i6 = this.cache.get(t4.to.url)), e5.page = i6 || await this.fetchPage(t4.to.url, e5.options), e5.cache = !!i6, e5.page;
      });
      if (i5.then(({ html: e5 }) => {
        t3.advance(5), t3.to.html = e5, t3.to.document = new DOMParser().parseFromString(e5, "text/html");
      }), !t3.history.popstate) {
        const e5 = t3.to.url + t3.to.hash;
        "replace" === t3.history.action || t3.to.url === this.currentPageUrl ? r(e5) : (this.currentHistoryIndex++, o(e5, { index: this.currentHistoryIndex }));
      }
      if (this.currentPageUrl = n(), t3.history.popstate && this.classes.add("is-popstate"), t3.animation.name && this.classes.add(`to-${s(t3.animation.name)}`), t3.animation.wait && await i5, t3.done) return;
      if (await this.hooks.call("visit:transition", t3, void 0, async () => {
        if (!t3.animation.animate) return await this.hooks.call("animation:skip", void 0), void await this.renderPage(t3, await i5);
        t3.advance(4), await this.animatePageOut(t3), t3.animation.native && document.startViewTransition ? await document.startViewTransition(async () => await this.renderPage(t3, await i5)).finished : await this.renderPage(t3, await i5), await this.animatePageIn(t3);
      }), t3.done) return;
      await this.hooks.call("visit:end", t3, void 0, () => this.classes.clear()), t3.state = 7, this.navigating = false, this.onVisitEnd && (this.onVisitEnd(), this.onVisitEnd = void 0);
    } catch (e5) {
      if (!e5 || null != e5 && e5.aborted) return void (t3.state = 8);
      t3.state = 9, console.error(e5), this.options.skipPopStateHandling = () => (window.location.assign(t3.to.url + t3.to.hash), true), window.history.back();
    } finally {
      delete t3.to.document;
    }
  }
  var I = async function(t3) {
    await this.hooks.call("animation:out:start", t3, void 0, () => {
      this.classes.add("is-changing", "is-animating", "is-leaving");
    }), await this.hooks.call("animation:out:await", t3, { skip: false }, (t4, { skip: e4 }) => {
      if (!e4) return this.awaitAnimations({ selector: t4.animation.selector });
    }), await this.hooks.call("animation:out:end", t3, void 0);
  };
  var L = function(t3) {
    var e4;
    const i4 = t3.to.document;
    if (!i4) return false;
    const s4 = (null == (e4 = i4.querySelector("title")) ? void 0 : e4.innerText) || "";
    document.title = s4;
    const n4 = m('[data-swup-persist]:not([data-swup-persist=""])'), o4 = t3.containers.map((t4) => {
      const e5 = document.querySelector(t4), s5 = i4.querySelector(t4);
      return e5 && s5 ? (e5.replaceWith(s5.cloneNode(true)), true) : (e5 || console.warn(`[swup] Container missing in current document: ${t4}`), s5 || console.warn(`[swup] Container missing in incoming document: ${t4}`), false);
    }).filter(Boolean);
    return n4.forEach((t4) => {
      const e5 = t4.getAttribute("data-swup-persist"), i5 = p(`[data-swup-persist="${e5}"]`);
      i5 && i5 !== t4 && i5.replaceWith(t4);
    }), o4.length === t3.containers.length;
  };
  var q = function(t3) {
    const e4 = { behavior: "auto" }, { target: s4, reset: n4 } = t3.scroll, o4 = null != s4 ? s4 : t3.to.hash;
    let r4 = false;
    return o4 && (r4 = this.hooks.callSync("scroll:anchor", t3, { hash: o4, options: e4 }, (t4, { hash: e5, options: i4 }) => {
      const s5 = this.getAnchorElement(e5);
      return s5 && s5.scrollIntoView(i4), !!s5;
    })), n4 && !r4 && (r4 = this.hooks.callSync("scroll:top", t3, { options: e4 }, (t4, { options: e5 }) => (window.scrollTo(i({ top: 0, left: 0 }, e5)), true))), r4;
  };
  var R = async function(t3) {
    if (t3.done) return;
    const e4 = this.hooks.call("animation:in:await", t3, { skip: false }, (t4, { skip: e5 }) => {
      if (!e5) return this.awaitAnimations({ selector: t4.animation.selector });
    });
    await g(), await this.hooks.call("animation:in:start", t3, void 0, () => {
      this.classes.remove("is-animating");
    }), await e4, await this.hooks.call("animation:in:end", t3, void 0);
  };
  var T = async function(t3, e4) {
    if (t3.done) return;
    t3.advance(6);
    const { url: i4 } = e4;
    this.isSameResolvedUrl(n(), i4) || (r(i4), this.currentPageUrl = n(), t3.to.url = this.currentPageUrl), await this.hooks.call("content:replace", t3, { page: e4 }, (t4, {}) => {
      if (this.classes.remove("is-leaving"), t4.animation.animate && this.classes.add("is-rendering"), !this.replaceContent(t4)) throw new Error("[swup] Container mismatch, aborting");
      t4.animation.animate && (this.classes.add("is-changing", "is-animating", "is-rendering"), t4.animation.name && this.classes.add(`to-${s(t4.animation.name)}`));
    }), await this.hooks.call("content:scroll", t3, void 0, () => this.scrollToContent(t3)), await this.hooks.call("page:view", t3, { url: this.currentPageUrl, title: document.title });
  };
  var N = function(t3) {
    var e4;
    if (e4 = t3, Boolean(null == e4 ? void 0 : e4.isSwupPlugin)) {
      if (t3.swup = this, !t3._checkRequirements || t3._checkRequirements()) return t3._beforeMount && t3._beforeMount(), t3.mount(), this.plugins.push(t3), this.plugins;
    } else console.error("Not a swup plugin instance", t3);
  };
  function O(t3) {
    const e4 = this.findPlugin(t3);
    if (e4) return e4.unmount(), e4._afterUnmount && e4._afterUnmount(), this.plugins = this.plugins.filter((t4) => t4 !== e4), this.plugins;
    console.error("No such plugin", e4);
  }
  function D(t3) {
    return this.plugins.find((e4) => e4 === t3 || e4.name === t3 || e4.name === `Swup${String(t3)}`);
  }
  function M(t3) {
    if ("function" != typeof this.options.resolveUrl) return console.warn("[swup] options.resolveUrl expects a callback function."), t3;
    const e4 = this.options.resolveUrl(t3);
    return e4 && "string" == typeof e4 ? e4.startsWith("//") || e4.startsWith("http") ? (console.warn("[swup] options.resolveUrl needs to return a relative url"), t3) : e4 : (console.warn("[swup] options.resolveUrl needs to return a url"), t3);
  }
  function W(t3, e4) {
    return this.resolveUrl(t3) === this.resolveUrl(e4);
  }
  var B = { animateHistoryBrowsing: false, animationSelector: '[class*="transition-"]', animationScope: "html", cache: true, containers: ["#swup"], ignoreVisit: (t3, { el: e4 } = {}) => !(null == e4 || !e4.closest("[data-no-swup]")), linkSelector: "a[href]", linkToSelf: "scroll", native: false, plugins: [], resolveUrl: (t3) => t3, requestHeaders: { "X-Requested-With": "swup", Accept: "text/html, application/xhtml+xml" }, skipPopStateHandling: (t3) => {
    var e4;
    return "swup" !== (null == (e4 = t3.state) ? void 0 : e4.source);
  }, timeout: 0 };
  var j = class {
    constructor(t3 = {}) {
      var e4, s4;
      this.version = "4.6.1", this.options = void 0, this.defaults = B, this.plugins = [], this.visit = void 0, this.cache = void 0, this.hooks = void 0, this.classes = void 0, this.currentPageUrl = n(), this.currentHistoryIndex = void 0, this.clickDelegate = void 0, this.navigating = false, this.onVisitEnd = void 0, this.use = N, this.unuse = O, this.findPlugin = D, this.log = () => {
      }, this.navigate = H, this.performNavigation = V, this.createVisit = b, this.delegateEvent = a, this.fetchPage = u, this.awaitAnimations = C, this.renderPage = T, this.replaceContent = L, this.animatePageIn = R, this.animatePageOut = I, this.scrollToContent = q, this.getAnchorElement = E, this.getCurrentUrl = n, this.resolveUrl = M, this.isSameResolvedUrl = W, this.options = i({}, this.defaults, t3), this.handleLinkClick = this.handleLinkClick.bind(this), this.handlePopState = this.handlePopState.bind(this), this.cache = new d(this), this.classes = new y(this), this.hooks = new S(this), this.visit = this.createVisit({ to: "" }), this.currentHistoryIndex = null != (e4 = null == (s4 = window.history.state) ? void 0 : s4.index) ? e4 : 1, this.enable();
    }
    async enable() {
      var t3;
      const { linkSelector: e4 } = this.options;
      this.clickDelegate = this.delegateEvent(e4, "click", this.handleLinkClick), window.addEventListener("popstate", this.handlePopState), this.options.animateHistoryBrowsing && (window.history.scrollRestoration = "manual"), this.options.native = this.options.native && !!document.startViewTransition, this.options.plugins.forEach((t4) => this.use(t4)), "swup" !== (null == (t3 = window.history.state) ? void 0 : t3.source) && r(null, { index: this.currentHistoryIndex }), await g(), await this.hooks.call("enable", void 0, void 0, () => {
        const t4 = document.documentElement;
        t4.classList.add("swup-enabled"), t4.classList.toggle("swup-native", this.options.native);
      });
    }
    async destroy() {
      this.clickDelegate.destroy(), window.removeEventListener("popstate", this.handlePopState), this.cache.clear(), this.options.plugins.forEach((t3) => this.unuse(t3)), await this.hooks.call("disable", void 0, void 0, () => {
        const t3 = document.documentElement;
        t3.classList.remove("swup-enabled"), t3.classList.remove("swup-native");
      }), this.hooks.clear();
    }
    shouldIgnoreVisit(t3, { el: e4, event: i4 } = {}) {
      const { origin: s4, url: n4, hash: o4 } = l.fromUrl(t3);
      return s4 !== window.location.origin || !(!e4 || !this.triggerWillOpenNewWindow(e4)) || !!this.options.ignoreVisit(n4 + o4, { el: e4, event: i4 });
    }
    handleLinkClick(t3) {
      const e4 = t3.delegateTarget, { href: i4, url: s4, hash: n4 } = l.fromElement(e4);
      if (this.shouldIgnoreVisit(i4, { el: e4, event: t3 })) return;
      if (this.navigating && s4 === this.visit.to.url) return void t3.preventDefault();
      const o4 = this.createVisit({ to: s4, hash: n4, el: e4, event: t3 });
      t3.metaKey || t3.ctrlKey || t3.shiftKey || t3.altKey ? this.hooks.callSync("link:newtab", o4, { href: i4 }) : 0 === t3.button && this.hooks.callSync("link:click", o4, { el: e4, event: t3 }, () => {
        var e5;
        const i5 = null != (e5 = o4.from.url) ? e5 : "";
        t3.preventDefault(), s4 && s4 !== i5 ? this.isSameResolvedUrl(s4, i5) || this.performNavigation(o4) : n4 ? this.hooks.callSync("link:anchor", o4, { hash: n4 }, () => {
          r(s4 + n4), this.scrollToContent(o4);
        }) : this.hooks.callSync("link:self", o4, void 0, () => {
          "navigate" === this.options.linkToSelf ? this.performNavigation(o4) : (r(s4), this.scrollToContent(o4));
        });
      });
    }
    handlePopState(t3) {
      var e4, i4, s4, o4;
      const r4 = null != (e4 = null == (i4 = t3.state) ? void 0 : i4.url) ? e4 : window.location.href;
      if (this.options.skipPopStateHandling(t3)) return;
      if (this.isSameResolvedUrl(n(), this.currentPageUrl)) return;
      const { url: a4, hash: h4 } = l.fromUrl(r4), c4 = this.createVisit({ to: a4, hash: h4, event: t3 });
      c4.history.popstate = true;
      const u4 = null != (s4 = null == (o4 = t3.state) ? void 0 : o4.index) ? s4 : 0;
      u4 && u4 !== this.currentHistoryIndex && (c4.history.direction = u4 - this.currentHistoryIndex > 0 ? "forwards" : "backwards", this.currentHistoryIndex = u4), c4.animation.animate = false, c4.scroll.reset = false, c4.scroll.target = false, this.options.animateHistoryBrowsing && (c4.animation.animate = true, c4.scroll.reset = true), this.hooks.callSync("history:popstate", c4, { event: t3 }, () => {
        this.performNavigation(c4);
      });
    }
    triggerWillOpenNewWindow(t3) {
      return !!t3.matches('[download], [target="_blank"]');
    }
  };

  // node_modules/@swup/plugin/dist/index.modern.js
  function r2() {
    return r2 = Object.assign ? Object.assign.bind() : function(r4) {
      for (var n4 = 1; n4 < arguments.length; n4++) {
        var e4 = arguments[n4];
        for (var t3 in e4) Object.prototype.hasOwnProperty.call(e4, t3) && (r4[t3] = e4[t3]);
      }
      return r4;
    }, r2.apply(this, arguments);
  }
  var n2 = (r4) => String(r4).split(".").map((r5) => String(parseInt(r5 || "0", 10))).concat(["0", "0"]).slice(0, 3).join(".");
  var e = class {
    constructor() {
      this.isSwupPlugin = true, this.swup = void 0, this.version = void 0, this.requires = {}, this.handlersToUnregister = [];
    }
    mount() {
    }
    unmount() {
      this.handlersToUnregister.forEach((r4) => r4()), this.handlersToUnregister = [];
    }
    _beforeMount() {
      if (!this.name) throw new Error("You must define a name of plugin when creating a class.");
    }
    _afterUnmount() {
    }
    _checkRequirements() {
      return "object" != typeof this.requires || Object.entries(this.requires).forEach(([r4, e4]) => {
        if (!function(r5, e5, t3) {
          const s4 = function(r6, n4) {
            var e6;
            if ("swup" === r6) return null != (e6 = n4.version) ? e6 : "";
            {
              var t4;
              const e7 = n4.findPlugin(r6);
              return null != (t4 = null == e7 ? void 0 : e7.version) ? t4 : "";
            }
          }(r5, t3);
          return !!s4 && ((r6, e6) => e6.every((e7) => {
            const [, t4, s5] = e7.match(/^([\D]+)?(.*)$/) || [];
            var o4, i4;
            return ((r7, n4) => {
              const e8 = { "": (r8) => 0 === r8, ">": (r8) => r8 > 0, ">=": (r8) => r8 >= 0, "<": (r8) => r8 < 0, "<=": (r8) => r8 <= 0 };
              return (e8[n4] || e8[""])(r7);
            })((i4 = s5, o4 = n2(o4 = r6), i4 = n2(i4), o4.localeCompare(i4, void 0, { numeric: true })), t4 || ">=");
          }))(s4, e5);
        }(r4, e4 = Array.isArray(e4) ? e4 : [e4], this.swup)) {
          const n4 = `${r4} ${e4.join(", ")}`;
          throw new Error(`Plugin version mismatch: ${this.name} requires ${n4}`);
        }
      }), true;
    }
    on(r4, n4, e4 = {}) {
      var t3;
      n4 = !(t3 = n4).name.startsWith("bound ") || t3.hasOwnProperty("prototype") ? n4.bind(this) : n4;
      const s4 = this.swup.hooks.on(r4, n4, e4);
      return this.handlersToUnregister.push(s4), s4;
    }
    once(n4, e4, t3 = {}) {
      return this.on(n4, e4, r2({}, t3, { once: true }));
    }
    before(n4, e4, t3 = {}) {
      return this.on(n4, e4, r2({}, t3, { before: true }));
    }
    replace(n4, e4, t3 = {}) {
      return this.on(n4, e4, r2({}, t3, { replace: true }));
    }
    off(r4, n4) {
      return this.swup.hooks.off(r4, n4);
    }
  };

  // node_modules/@swup/fragment-plugin/dist/index.modern.js
  function o2() {
    return o2 = Object.assign ? Object.assign.bind() : function(t3) {
      for (var r4 = 1; r4 < arguments.length; r4++) {
        var e4 = arguments[r4];
        for (var n4 in e4) Object.prototype.hasOwnProperty.call(e4, n4) && (t3[n4] = e4[n4]);
      }
      return t3;
    }, o2.apply(this, arguments);
  }
  window.process || (window.process = {}), window.process.env || (window.process.env = {});
  var s2 = ["test"].includes(String("development"));
  var i2 = ["development", "test"].includes(String("development"));
  var a2 = (t3, r4, e4) => null == t3 ? t3 : `\x1B[${r4}m${String(t3)}\x1B[${e4}m`;
  var l2 = (t3) => s2 ? t3 : `\u{1F9E9} ${((t4) => a2(t4, 1, 22))(t3)}`;
  var u2 = (t3) => s2 ? t3 : ((t4) => a2(t4, 94, 39))(t3);
  var c2 = class {
    log(...t3) {
      const r4 = t3.shift();
      console.log(l2(r4), ...t3);
    }
    warn(...t3) {
      const r4 = t3.shift();
      console.warn(l2(r4), ...t3);
    }
    error(...t3) {
      const r4 = t3.shift();
      console.error(l2(r4), ...t3);
    }
    logIf(t3, ...r4) {
      t3 && this.log(...r4);
    }
    warnIf(t3, ...r4) {
      t3 && this.warn(...r4);
    }
    errorIf(t3, ...r4) {
      t3 && this.error(...r4);
    }
  };
  var g2 = (t3) => {
    !function({ parsedRules: t4, swup: e4, logger: n4 }) {
      const o4 = e4.getCurrentUrl();
      t4.filter((t5) => t5.matchesFrom(o4) || t5.matchesTo(o4)).forEach((t5) => {
        t5.containers.forEach((t6) => {
          const s4 = y2(`${t6}:not([data-swup-fragment])`, e4);
          if (!s4) return;
          const a4 = s4.getAttribute("data-swup-fragment-url");
          a4 && i2 && (null == n4 || n4.log(`fragment url ${u2(a4)} for ${u2(t6)} provided by server`));
          const { url: l4 } = l.fromUrl(a4 || o4);
          s4.setAttribute("data-swup-fragment", ""), s4.__swupFragment = { url: l4, selector: t6 };
        });
      });
    }(t3), function({ logger: t4, swup: r4 }) {
      const e4 = "data-swup-link-to-fragment";
      document.querySelectorAll(`a[${e4}]`).forEach((n4) => {
        var o4;
        const s4 = n4.getAttribute(e4);
        if (!s4) return void (i2 && (null == t4 || t4.warn(`[${e4}] needs to contain a valid fragment selector`)));
        const a4 = y2(s4, r4);
        if (!a4) return void (i2 && (null == t4 || t4.log(`ignoring ${u2(`[${e4}="${s4}"]`)} as ${u2(s4)} is missing`)));
        const l4 = null == (o4 = a4.__swupFragment) ? void 0 : o4.url;
        l4 ? m2(l4, r4.getCurrentUrl()) ? i2 && (null == t4 || t4.warn(`The fragment URL of ${s4} is identical to the current URL. This could mean that [data-swup-fragment-url] needs to be provided by the server.`)) : n4.href = l4 : i2 && (null == t4 || t4.warn(`no fragment infos found on ${s4}`));
      });
    }(t3), function({ logger: t4 }) {
      document.querySelectorAll("dialog[data-swup-fragment]").forEach((r4) => {
        r4.__swupFragment ? r4.__swupFragment.modalShown || (r4.__swupFragment.modalShown = true, r4.removeAttribute("open"), null == r4.showModal || r4.showModal(), r4.addEventListener("keydown", (t5) => "Escape" === t5.key && t5.preventDefault())) : i2 && (null == t4 || t4.warn("fragment properties missing on element:", r4));
      });
    }(t3);
  };
  var f2 = (t3, r4) => {
    var e4;
    const n4 = null == (e4 = t3.__swupFragment) ? void 0 : e4.url;
    return !!n4 && m2(n4, r4);
  };
  var m2 = (t3, r4) => h2(t3) === h2(r4);
  var h2 = (t3) => {
    if (!t3.trim()) return t3;
    const e4 = l.fromUrl(t3);
    return e4.searchParams.sort(), e4.pathname.replace(/\/+$/g, "") + e4.search;
  };
  var p2 = (t3) => {
    const r4 = t3.from.url, e4 = t3.to.url;
    if (r4 && e4) return { from: r4, to: e4 };
  };
  var d2 = (t3, r4) => {
    if (null == t3 || !t3.name) return;
    const { name: e4, containers: n4 } = t3;
    n4.forEach((t4) => {
      var n5;
      null == (n5 = document.querySelector(t4)) || n5.classList.toggle(`to-${e4}`, r4);
    });
  };
  var w2 = (t3, r4) => r4.find((r5) => r5.matches(t3));
  function v(t3) {
    return !!t3 && t3.containers.every((t4) => {
      var r4;
      return "template" === (null == (r4 = document.querySelector(t4)) || null == (r4 = r4.tagName) ? void 0 : r4.toLowerCase());
    });
  }
  function y2(t3, r4) {
    for (const e4 of r4.options.containers) {
      const r5 = document.querySelector(e4);
      if (null != r5 && r5.matches(t3)) return r5;
      const n4 = null == r5 ? void 0 : r5.querySelector(t3);
      if (n4) return n4;
    }
  }
  function $2(t3) {
    if (!Array.isArray(t3)) throw new Error("cloneRules() expects an array of rules");
    return t3.map((t4) => o2({}, t4, { from: Array.isArray(t4.from) ? [...t4.from] : t4.from, to: Array.isArray(t4.to) ? [...t4.to] : t4.to, containers: [...t4.containers] }));
  }
  var S2 = class {
    constructor(t3) {
      var r4, o4;
      this.matchesFrom = void 0, this.matchesTo = void 0, this.swup = void 0, this.from = void 0, this.to = void 0, this.containers = void 0, this.name = void 0, this.scroll = false, this.focus = void 0, this.logger = void 0, this.swup = t3.swup, this.logger = t3.logger, this.from = t3.from || "", this.to = t3.to || "", t3.name && (this.name = s(t3.name)), void 0 !== t3.scroll && (this.scroll = t3.scroll), void 0 !== t3.focus && (this.focus = t3.focus), this.containers = this.parseContainers(t3.containers), i2 && (null == (r4 = this.logger) || r4.errorIf(!this.to, "Every fragment rule must contain a 'to' path", this), null == (o4 = this.logger) || o4.errorIf(!this.from, "Every fragment rule must contain a 'from' path", this)), this.matchesFrom = h(this.from), this.matchesTo = h(this.to);
    }
    parseContainers(t3) {
      var r4, e4;
      return Array.isArray(t3) && t3.length ? (e4 = t3.map((t4) => t4.trim()), [...new Set(e4)]).filter((t4) => {
        var r5;
        const e5 = this.validateSelector(t4);
        return null == (r5 = this.logger) || r5.errorIf(e5 instanceof Error, e5), true === e5;
      }) : (i2 && (null == (r4 = this.logger) || r4.error("Every fragment rule must contain an array of containers", this.getDebugInfo())), []);
    }
    validateSelector(t3) {
      return t3.startsWith("#") ? !t3.match(/\s|>/) || new Error(`fragment selectors must not be nested: ${t3}`) : new Error(`fragment selectors must be IDs: ${t3}`);
    }
    getDebugInfo() {
      const { from: t3, to: r4, containers: e4 } = this;
      return { from: String(t3), to: String(r4), containers: String(e4) };
    }
    matches(t3) {
      const { url: e4 } = l.fromUrl(t3.from), { url: n4 } = l.fromUrl(t3.to);
      if (!this.matchesFrom(e4) || !this.matchesTo(n4)) return false;
      for (const t4 of this.containers) {
        const r4 = this.validateFragmentSelectorForMatch(t4);
        var o4;
        if (r4 instanceof Error) return i2 && (null == (o4 = this.logger) || o4.error(r4, this.getDebugInfo())), false;
      }
      return true;
    }
    validateFragmentSelectorForMatch(t3) {
      return document.querySelector(t3) ? !!y2(t3, this.swup) || new Error(`skipping rule since ${u2(t3)} is outside of swup's default containers`) : new Error(`skipping rule since ${u2(t3)} doesn't exist in the current document`);
    }
  };
  var _ = function(t3) {
    const r4 = p2(t3);
    r4 && w2(r4, this.parsedRules) && (t3.scroll.reset = false);
  };
  var b2 = async function(t3) {
    const r4 = p2(t3);
    if (!r4) return;
    const e4 = this.getFragmentVisit(r4);
    if (!e4) return;
    var n4;
    t3.fragmentVisit = e4, i2 && (null == (n4 = this.logger) || n4.log(`fragment visit: ${u2(t3.fragmentVisit.containers.join(", "))}`)), t3.scroll = function(t4, r5) {
      return "boolean" == typeof t4.scroll ? o2({}, r5, { reset: t4.scroll }) : "string" != typeof t4.scroll || r5.target ? r5 : o2({}, r5, { target: t4.scroll });
    }(e4, t3.scroll);
    const s4 = t3.a11y;
    var a4;
    void 0 !== e4.focus && (i2 && (null == (a4 = this.logger) || a4.errorIf(!s4, "Can't set visit.a11y.focus. Is @swup/a11y-plugin installed?")), s4 && (s4.focus = e4.focus)), t3.animation.scope = t3.fragmentVisit.containers, t3.containers = t3.fragmentVisit.containers, t3.animation.selector = t3.fragmentVisit.containers.join(","), d2(e4, true);
  };
  var R2 = function(t3, r4) {
    var e4, n4;
    t3.fragmentVisit && v(t3.fragmentVisit) && (i2 && (null == (e4 = this.logger) || e4.log(`${u2("out")}-animation skipped for ${u2(null == (n4 = t3.fragmentVisit) ? void 0 : n4.containers.toString())}`)), r4.skip = true);
  };
  var E2 = function(t3, r4) {
    var e4, n4;
    t3.fragmentVisit && v(t3.fragmentVisit) && (i2 && (null == (e4 = this.logger) || e4.log(`${u2("in")}-animation skipped for ${u2(null == (n4 = t3.fragmentVisit) ? void 0 : n4.containers.toString())}`)), r4.skip = true);
  };
  var F = function(t3, r4) {
    var e4;
    if (t3.trigger.el || !t3.to.url) return;
    const n4 = this.swup.cache.get(t3.to.url);
    n4 && n4.fragmentHtml && (r4.page.html = n4.fragmentHtml, i2 && (null == (e4 = this.logger) || e4.log(`fragment cache used for ${u2(t3.to.url)}`)));
  };
  var A2 = function(t3) {
    d2(t3.fragmentVisit, true), g2(this), (({ swup: t4, logger: r4 }) => {
      const e4 = t4.getCurrentUrl(), n4 = t4.cache, s4 = n4.get(e4);
      if (!s4) return;
      const a4 = new DOMParser().parseFromString(s4.html, "text/html"), l4 = [], c4 = Array.from(document.querySelectorAll("[data-swup-fragment]")).filter((t5) => !t5.matches("template") && !f2(t5, e4));
      c4.length && (t4.options.cache ? (c4.forEach((t5) => {
        var e5, o4;
        if (null != t5.querySelector("[data-swup-fragment]")) return;
        const s5 = null == (e5 = t5.__swupFragment) ? void 0 : e5.url;
        if (!s5) return void (i2 && (null == r4 || r4.warn("no fragment url found:", t5)));
        const u4 = null == (o4 = t5.__swupFragment) ? void 0 : o4.selector;
        if (!u4) return void (i2 && (null == r4 || r4.warn("no fragment selector found:", t5)));
        const c5 = n4.get(s5);
        if (!c5) return;
        const g4 = a4.querySelector(u4);
        if (!g4) return;
        const f4 = new DOMParser().parseFromString(c5.html, "text/html").querySelector(u4);
        f4 && (f4.setAttribute("data-swup-fragment-url", s5), g4.replaceWith(f4), l4.push(t5));
      }), l4.length && (n4.update(e4, o2({}, s4, { fragmentHtml: a4.documentElement.outerHTML })), l4.forEach((t5) => {
        var e5, n5;
        const o4 = (null == (e5 = t5.__swupFragment) ? void 0 : e5.url) || "", s5 = (null == (n5 = t5.__swupFragment) ? void 0 : n5.selector) || "";
        i2 && (null == r4 || r4.log(`updated cache with ${u2(s5)} from ${u2(o4)}`));
      }))) : i2 && (null == r4 || r4.warn("can't cache foreign fragment elements without swup's cache")));
    })(this);
  };
  var V2 = function(t3) {
    d2(t3.fragmentVisit, false);
  };
  var q2 = class extends e {
    get parsedRules() {
      return this._parsedRules;
    }
    constructor(t3) {
      super(), this.name = "SwupFragmentPlugin", this.requires = { swup: ">=4" }, this._rawRules = [], this._parsedRules = [], this.options = void 0, this.defaults = { rules: [], debug: false }, this.logger = void 0, this.options = o2({}, this.defaults, t3);
    }
    mount() {
      const t3 = this.swup;
      var r4;
      this.setRules(this.options.rules), i2 && this.options.debug && (this.logger = new c2()), this.before("link:self", _), this.on("visit:start", b2), this.before("animation:out:await", R2), this.before("animation:in:await", E2), this.before("content:replace", F), this.on("content:replace", A2), this.on("visit:end", V2), i2 && (null == (r4 = this.logger) || r4.warnIf(!t3.options.cache, "fragment caching will only work with swup's cache being active")), g2(this);
    }
    unmount() {
      super.unmount(), document.querySelectorAll("[data-swup-fragment]").forEach((t3) => {
        t3.removeAttribute("data-swup-fragment-url"), delete t3.__swupFragment;
      });
    }
    setRules(t3) {
      var r4;
      this._rawRules = $2(t3), this._parsedRules = t3.map((t4) => this.parseRule(t4)), i2 && (null == (r4 = this.logger) || r4.log("Updated fragment rules", this.getRules()));
    }
    getRules() {
      return $2(this._rawRules);
    }
    prependRule(t3) {
      this.setRules([t3, ...this.getRules()]);
    }
    appendRule(t3) {
      this.setRules([...this.getRules(), t3]);
    }
    parseRule({ from: t3, to: r4, containers: e4, name: n4, scroll: o4, focus: s4 }) {
      return new S2({ from: t3, to: r4, containers: e4, name: n4, scroll: o4, focus: s4, logger: this.logger, swup: this.swup });
    }
    getFragmentVisit(t3) {
      const r4 = w2(t3, this.parsedRules);
      if (!r4) return;
      const e4 = ((t4, r5, e5, n5) => {
        const o5 = m2(t4.from, t4.to);
        return r5.filter((r6) => {
          const s5 = document.querySelector(r6);
          return s5 ? y2(r6, e5) ? !(!o5 && f2(s5, t4.to) && (i2 && (null == n5 || n5.log(`ignoring fragment ${u2(r6)} as it already matches the current URL`)), 1)) : (i2 && (null == n5 || n5.error(`${u2(r6)} is outside of swup's default containers`)), false) : (i2 && (null == n5 || n5.log(`${u2(r6)} missing in current document`)), false);
        });
      })(t3, r4.containers, this.swup, this.logger);
      if (!e4.length) return;
      const { name: n4, scroll: o4, focus: s4 } = r4;
      return { containers: e4, name: n4, scroll: o4, focus: s4 };
    }
  };

  // node_modules/@studio-freight/lenis/dist/lenis.mjs
  function t(t3, e4, i4) {
    return Math.max(t3, Math.min(e4, i4));
  }
  var Animate = class {
    advance(e4) {
      var _a;
      if (!this.isRunning) return;
      let i4 = false;
      if (this.lerp) this.value = (s4 = this.value, o4 = this.to, n4 = 60 * this.lerp, r4 = e4, function(t3, e5, i5) {
        return (1 - i5) * t3 + i5 * e5;
      }(s4, o4, 1 - Math.exp(-n4 * r4))), Math.round(this.value) === this.to && (this.value = this.to, i4 = true);
      else {
        this.currentTime += e4;
        const s5 = t(0, this.currentTime / this.duration, 1);
        i4 = s5 >= 1;
        const o5 = i4 ? 1 : this.easing(s5);
        this.value = this.from + (this.to - this.from) * o5;
      }
      var s4, o4, n4, r4;
      (_a = this.onUpdate) == null ? void 0 : _a.call(this, this.value, i4), i4 && this.stop();
    }
    stop() {
      this.isRunning = false;
    }
    fromTo(t3, e4, { lerp: i4 = 0.1, duration: s4 = 1, easing: o4 = (t4) => t4, onStart: n4, onUpdate: r4 }) {
      this.from = this.value = t3, this.to = e4, this.lerp = i4, this.duration = s4, this.easing = o4, this.currentTime = 0, this.isRunning = true, n4 == null ? void 0 : n4(), this.onUpdate = r4;
    }
  };
  var Dimensions = class {
    constructor({ wrapper: t3, content: e4, autoResize: i4 = true, debounce: s4 = 250 } = {}) {
      __publicField(this, "resize", () => {
        this.onWrapperResize(), this.onContentResize();
      });
      __publicField(this, "onWrapperResize", () => {
        this.wrapper === window ? (this.width = window.innerWidth, this.height = window.innerHeight) : (this.width = this.wrapper.clientWidth, this.height = this.wrapper.clientHeight);
      });
      __publicField(this, "onContentResize", () => {
        this.wrapper === window ? (this.scrollHeight = this.content.scrollHeight, this.scrollWidth = this.content.scrollWidth) : (this.scrollHeight = this.wrapper.scrollHeight, this.scrollWidth = this.wrapper.scrollWidth);
      });
      this.wrapper = t3, this.content = e4, i4 && (this.debouncedResize = /* @__PURE__ */ function(t4, e5) {
        let i5;
        return function() {
          let s5 = arguments, o4 = this;
          clearTimeout(i5), i5 = setTimeout(function() {
            t4.apply(o4, s5);
          }, e5);
        };
      }(this.resize, s4), this.wrapper === window ? window.addEventListener("resize", this.debouncedResize, false) : (this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize), this.wrapperResizeObserver.observe(this.wrapper)), this.contentResizeObserver = new ResizeObserver(this.debouncedResize), this.contentResizeObserver.observe(this.content)), this.resize();
    }
    destroy() {
      var _a, _b;
      (_a = this.wrapperResizeObserver) == null ? void 0 : _a.disconnect(), (_b = this.contentResizeObserver) == null ? void 0 : _b.disconnect(), window.removeEventListener("resize", this.debouncedResize, false);
    }
    get limit() {
      return { x: this.scrollWidth - this.width, y: this.scrollHeight - this.height };
    }
  };
  var Emitter = class {
    constructor() {
      this.events = {};
    }
    emit(t3, ...e4) {
      let i4 = this.events[t3] || [];
      for (let t4 = 0, s4 = i4.length; t4 < s4; t4++) i4[t4](...e4);
    }
    on(t3, e4) {
      var _a;
      return ((_a = this.events[t3]) == null ? void 0 : _a.push(e4)) || (this.events[t3] = [e4]), () => {
        var _a2;
        this.events[t3] = (_a2 = this.events[t3]) == null ? void 0 : _a2.filter((t4) => e4 !== t4);
      };
    }
    off(t3, e4) {
      var _a;
      this.events[t3] = (_a = this.events[t3]) == null ? void 0 : _a.filter((t4) => e4 !== t4);
    }
    destroy() {
      this.events = {};
    }
  };
  var e2 = 100 / 6;
  var VirtualScroll = class {
    constructor(t3, { wheelMultiplier: e4 = 1, touchMultiplier: i4 = 1 }) {
      __publicField(this, "onTouchStart", (t3) => {
        const { clientX: e4, clientY: i4 } = t3.targetTouches ? t3.targetTouches[0] : t3;
        this.touchStart.x = e4, this.touchStart.y = i4, this.lastDelta = { x: 0, y: 0 }, this.emitter.emit("scroll", { deltaX: 0, deltaY: 0, event: t3 });
      });
      __publicField(this, "onTouchMove", (t3) => {
        const { clientX: e4, clientY: i4 } = t3.targetTouches ? t3.targetTouches[0] : t3, s4 = -(e4 - this.touchStart.x) * this.touchMultiplier, o4 = -(i4 - this.touchStart.y) * this.touchMultiplier;
        this.touchStart.x = e4, this.touchStart.y = i4, this.lastDelta = { x: s4, y: o4 }, this.emitter.emit("scroll", { deltaX: s4, deltaY: o4, event: t3 });
      });
      __publicField(this, "onTouchEnd", (t3) => {
        this.emitter.emit("scroll", { deltaX: this.lastDelta.x, deltaY: this.lastDelta.y, event: t3 });
      });
      __publicField(this, "onWheel", (t3) => {
        let { deltaX: i4, deltaY: s4, deltaMode: o4 } = t3;
        i4 *= 1 === o4 ? e2 : 2 === o4 ? this.windowWidth : 1, s4 *= 1 === o4 ? e2 : 2 === o4 ? this.windowHeight : 1, i4 *= this.wheelMultiplier, s4 *= this.wheelMultiplier, this.emitter.emit("scroll", { deltaX: i4, deltaY: s4, event: t3 });
      });
      __publicField(this, "onWindowResize", () => {
        this.windowWidth = window.innerWidth, this.windowHeight = window.innerHeight;
      });
      this.element = t3, this.wheelMultiplier = e4, this.touchMultiplier = i4, this.touchStart = { x: null, y: null }, this.emitter = new Emitter(), window.addEventListener("resize", this.onWindowResize, false), this.onWindowResize(), this.element.addEventListener("wheel", this.onWheel, { passive: false }), this.element.addEventListener("touchstart", this.onTouchStart, { passive: false }), this.element.addEventListener("touchmove", this.onTouchMove, { passive: false }), this.element.addEventListener("touchend", this.onTouchEnd, { passive: false });
    }
    on(t3, e4) {
      return this.emitter.on(t3, e4);
    }
    destroy() {
      this.emitter.destroy(), window.removeEventListener("resize", this.onWindowResize, false), this.element.removeEventListener("wheel", this.onWheel, { passive: false }), this.element.removeEventListener("touchstart", this.onTouchStart, { passive: false }), this.element.removeEventListener("touchmove", this.onTouchMove, { passive: false }), this.element.removeEventListener("touchend", this.onTouchEnd, { passive: false });
    }
  };
  var Lenis = class {
    constructor({ wrapper: t3 = window, content: e4 = document.documentElement, wheelEventsTarget: i4 = t3, eventsTarget: s4 = i4, smoothWheel: o4 = true, syncTouch: n4 = false, syncTouchLerp: r4 = 0.075, touchInertiaMultiplier: l4 = 35, duration: h4, easing: a4 = (t4) => Math.min(1, 1.001 - Math.pow(2, -10 * t4)), lerp: c4 = !h4 && 0.1, infinite: d4 = false, orientation: p4 = "vertical", gestureOrientation: u4 = "vertical", touchMultiplier: m4 = 1, wheelMultiplier: v3 = 1, autoResize: g4 = true, __experimental__naiveDimensions: S3 = false } = {}) {
      this.__isSmooth = false, this.__isScrolling = false, this.__isStopped = false, this.__isLocked = false, this.onVirtualScroll = ({ deltaX: t4, deltaY: e5, event: i5 }) => {
        if (i5.ctrlKey) return;
        const s5 = i5.type.includes("touch"), o5 = i5.type.includes("wheel");
        if (this.options.syncTouch && s5 && "touchstart" === i5.type && !this.isStopped && !this.isLocked) return void this.reset();
        const n5 = 0 === t4 && 0 === e5, r5 = "vertical" === this.options.gestureOrientation && 0 === e5 || "horizontal" === this.options.gestureOrientation && 0 === t4;
        if (n5 || r5) return;
        let l5 = i5.composedPath();
        if (l5 = l5.slice(0, l5.indexOf(this.rootElement)), l5.find((t5) => {
          var e6, i6, n6, r6, l6;
          return (null === (e6 = t5.hasAttribute) || void 0 === e6 ? void 0 : e6.call(t5, "data-lenis-prevent")) || s5 && (null === (i6 = t5.hasAttribute) || void 0 === i6 ? void 0 : i6.call(t5, "data-lenis-prevent-touch")) || o5 && (null === (n6 = t5.hasAttribute) || void 0 === n6 ? void 0 : n6.call(t5, "data-lenis-prevent-wheel")) || (null === (r6 = t5.classList) || void 0 === r6 ? void 0 : r6.contains("lenis")) && !(null === (l6 = t5.classList) || void 0 === l6 ? void 0 : l6.contains("lenis-stopped"));
        })) return;
        if (this.isStopped || this.isLocked) return void i5.preventDefault();
        if (this.isSmooth = this.options.syncTouch && s5 || this.options.smoothWheel && o5, !this.isSmooth) return this.isScrolling = false, void this.animate.stop();
        i5.preventDefault();
        let h5 = e5;
        "both" === this.options.gestureOrientation ? h5 = Math.abs(e5) > Math.abs(t4) ? e5 : t4 : "horizontal" === this.options.gestureOrientation && (h5 = t4);
        const a5 = s5 && this.options.syncTouch, c5 = s5 && "touchend" === i5.type && Math.abs(h5) > 5;
        c5 && (h5 = this.velocity * this.options.touchInertiaMultiplier), this.scrollTo(this.targetScroll + h5, Object.assign({ programmatic: false }, a5 ? { lerp: c5 ? this.options.syncTouchLerp : 1 } : { lerp: this.options.lerp, duration: this.options.duration, easing: this.options.easing }));
      }, this.onNativeScroll = () => {
        if (!this.__preventNextScrollEvent && !this.isScrolling) {
          const t4 = this.animatedScroll;
          this.animatedScroll = this.targetScroll = this.actualScroll, this.velocity = 0, this.direction = Math.sign(this.animatedScroll - t4), this.emit();
        }
      }, window.lenisVersion = "1.0.42", t3 !== document.documentElement && t3 !== document.body || (t3 = window), this.options = { wrapper: t3, content: e4, wheelEventsTarget: i4, eventsTarget: s4, smoothWheel: o4, syncTouch: n4, syncTouchLerp: r4, touchInertiaMultiplier: l4, duration: h4, easing: a4, lerp: c4, infinite: d4, gestureOrientation: u4, orientation: p4, touchMultiplier: m4, wheelMultiplier: v3, autoResize: g4, __experimental__naiveDimensions: S3 }, this.animate = new Animate(), this.emitter = new Emitter(), this.dimensions = new Dimensions({ wrapper: t3, content: e4, autoResize: g4 }), this.toggleClassName("lenis", true), this.velocity = 0, this.isLocked = false, this.isStopped = false, this.isSmooth = n4 || o4, this.isScrolling = false, this.targetScroll = this.animatedScroll = this.actualScroll, this.options.wrapper.addEventListener("scroll", this.onNativeScroll, false), this.virtualScroll = new VirtualScroll(s4, { touchMultiplier: m4, wheelMultiplier: v3 }), this.virtualScroll.on("scroll", this.onVirtualScroll);
    }
    destroy() {
      this.emitter.destroy(), this.options.wrapper.removeEventListener("scroll", this.onNativeScroll, false), this.virtualScroll.destroy(), this.dimensions.destroy(), this.toggleClassName("lenis", false), this.toggleClassName("lenis-smooth", false), this.toggleClassName("lenis-scrolling", false), this.toggleClassName("lenis-stopped", false), this.toggleClassName("lenis-locked", false);
    }
    on(t3, e4) {
      return this.emitter.on(t3, e4);
    }
    off(t3, e4) {
      return this.emitter.off(t3, e4);
    }
    setScroll(t3) {
      this.isHorizontal ? this.rootElement.scrollLeft = t3 : this.rootElement.scrollTop = t3;
    }
    resize() {
      this.dimensions.resize();
    }
    emit() {
      this.emitter.emit("scroll", this);
    }
    reset() {
      this.isLocked = false, this.isScrolling = false, this.animatedScroll = this.targetScroll = this.actualScroll, this.velocity = 0, this.animate.stop();
    }
    start() {
      this.isStopped && (this.isStopped = false, this.reset());
    }
    stop() {
      this.isStopped || (this.isStopped = true, this.animate.stop(), this.reset());
    }
    raf(t3) {
      const e4 = t3 - (this.time || t3);
      this.time = t3, this.animate.advance(1e-3 * e4);
    }
    scrollTo(e4, { offset: i4 = 0, immediate: s4 = false, lock: o4 = false, duration: n4 = this.options.duration, easing: r4 = this.options.easing, lerp: l4 = !n4 && this.options.lerp, onComplete: h4, force: a4 = false, programmatic: c4 = true } = {}) {
      if (!this.isStopped && !this.isLocked || a4) {
        if (["top", "left", "start"].includes(e4)) e4 = 0;
        else if (["bottom", "right", "end"].includes(e4)) e4 = this.limit;
        else {
          let t3;
          if ("string" == typeof e4 ? t3 = document.querySelector(e4) : (null == e4 ? void 0 : e4.nodeType) && (t3 = e4), t3) {
            if (this.options.wrapper !== window) {
              const t4 = this.options.wrapper.getBoundingClientRect();
              i4 -= this.isHorizontal ? t4.left : t4.top;
            }
            const s5 = t3.getBoundingClientRect();
            e4 = (this.isHorizontal ? s5.left : s5.top) + this.animatedScroll;
          }
        }
        if ("number" == typeof e4) {
          if (e4 += i4, e4 = Math.round(e4), this.options.infinite ? c4 && (this.targetScroll = this.animatedScroll = this.scroll) : e4 = t(0, e4, this.limit), s4) return this.animatedScroll = this.targetScroll = e4, this.setScroll(this.scroll), this.reset(), void (null == h4 || h4(this));
          if (!c4) {
            if (e4 === this.targetScroll) return;
            this.targetScroll = e4;
          }
          this.animate.fromTo(this.animatedScroll, e4, { duration: n4, easing: r4, lerp: l4, onStart: () => {
            o4 && (this.isLocked = true), this.isScrolling = true;
          }, onUpdate: (t3, e5) => {
            this.isScrolling = true, this.velocity = t3 - this.animatedScroll, this.direction = Math.sign(this.velocity), this.animatedScroll = t3, this.setScroll(this.scroll), c4 && (this.targetScroll = t3), e5 || this.emit(), e5 && (this.reset(), this.emit(), null == h4 || h4(this), this.__preventNextScrollEvent = true, requestAnimationFrame(() => {
              delete this.__preventNextScrollEvent;
            }));
          } });
        }
      }
    }
    get rootElement() {
      return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
    }
    get limit() {
      return this.options.__experimental__naiveDimensions ? this.isHorizontal ? this.rootElement.scrollWidth - this.rootElement.clientWidth : this.rootElement.scrollHeight - this.rootElement.clientHeight : this.dimensions.limit[this.isHorizontal ? "x" : "y"];
    }
    get isHorizontal() {
      return "horizontal" === this.options.orientation;
    }
    get actualScroll() {
      return this.isHorizontal ? this.rootElement.scrollLeft : this.rootElement.scrollTop;
    }
    get scroll() {
      return this.options.infinite ? (t3 = this.animatedScroll, e4 = this.limit, (t3 % e4 + e4) % e4) : this.animatedScroll;
      var t3, e4;
    }
    get progress() {
      return 0 === this.limit ? 1 : this.scroll / this.limit;
    }
    get isSmooth() {
      return this.__isSmooth;
    }
    set isSmooth(t3) {
      this.__isSmooth !== t3 && (this.__isSmooth = t3, this.toggleClassName("lenis-smooth", t3));
    }
    get isScrolling() {
      return this.__isScrolling;
    }
    set isScrolling(t3) {
      this.__isScrolling !== t3 && (this.__isScrolling = t3, this.toggleClassName("lenis-scrolling", t3));
    }
    get isStopped() {
      return this.__isStopped;
    }
    set isStopped(t3) {
      this.__isStopped !== t3 && (this.__isStopped = t3, this.toggleClassName("lenis-stopped", t3));
    }
    get isLocked() {
      return this.__isLocked;
    }
    set isLocked(t3) {
      this.__isLocked !== t3 && (this.__isLocked = t3, this.toggleClassName("lenis-locked", t3));
    }
    get className() {
      let t3 = "lenis";
      return this.isStopped && (t3 += " lenis-stopped"), this.isLocked && (t3 += " lenis-locked"), this.isScrolling && (t3 += " lenis-scrolling"), this.isSmooth && (t3 += " lenis-smooth"), t3;
    }
    toggleClassName(t3, e4) {
      this.rootElement.classList.toggle(t3, e4), this.emitter.emit("className change", this);
    }
  };

  // src/theme/js/utils/dom.js
  var isReady = false;
  document.addEventListener("DOMContentLoaded", function() {
    isReady = true;
  });
  function ready(fn) {
    if (isReady) {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  // src/theme/js/utils/alpine.js
  var hasInit = false;
  document.addEventListener("alpine:init", function() {
    hasInit = true;
  });
  function init(fn) {
    if (hasInit) {
      module_default.discoverUninitializedComponents(function(el) {
        module_default.initializeComponent(el);
      });
      fn();
    } else {
      document.addEventListener("alpine:init", fn);
    }
  }

  // src/theme/js/alpine/pageData.js
  init(() => {
    module_default.store("page", {
      title: "",
      modifier: "default",
      url: window.location.pathname + window.location.hash,
      setTitle(title) {
        this.title = title;
      },
      setModifier(modifier) {
        this.modifier = modifier;
      },
      setUrl(url) {
        this.url = url;
      }
    });
    module_default.data("page", () => ({
      init(args) {
        let router2 = module_default.store("route");
        if (router2) {
          this.$watch(() => router2.href, (val) => {
            const p4 = module_default.store("page");
            p4.url = val;
          });
        }
      }
    }));
    module_default.data("pageLink", () => ({
      isActive(el) {
        const $el = el || this.$el;
        const p4 = module_default.store("page");
        const url = $el.getAttribute("href");
        let urlToMatch = p4.url;
        if (this.$el.dataset.ignoreHash) {
          urlToMatch = urlToMatch.replace(/#.*$/, "");
        }
        if (url === "/") return url === urlToMatch;
        if (!url.match("#") && this.$el.dataset.exact) {
          return url === urlToMatch;
        }
        return urlToMatch.match(url);
      },
      update() {
        if (this.isActive()) {
          this.$el.classList.add("active");
          this.$el.classList.remove("inactive");
        } else {
          this.$el.classList.remove("active");
          this.$el.classList.add("inactive");
        }
      },
      init(args) {
        this.$el.addEventListener("click", (ev) => {
          const curUrl = module_default.store("page").url;
          if (this.$el.dataset.toggle) {
            let href = this.$el.getAttribute("href");
            if (href.match("#")) {
              if (window.location.hash === href) {
                ev.preventDefault();
                module_default.store("route").removeHash();
              }
            } else {
            }
          } else {
            document.querySelectorAll('[x-data="pageLink"].active').forEach((el) => {
              if (curUrl === el.getAttribute("href") || !this.isActive(el)) {
                el.classList.remove("active");
                el.classList.add("inactive");
              }
            });
            this.$el.classList.add("active");
            this.$el.classList.remove("inactive");
          }
        });
        this.update();
        this.$watch("isActive", () => {
          this.update();
        });
      }
    }));
  });

  // src/theme/js/alpine/route.js
  init(() => {
    module_default.store("route", {
      requests: 0,
      quietUpdate: false,
      isHistoryNavigation: false,
      href: "",
      prevHref: "",
      programmaticNavigation: false,
      match(rule) {
        return this.href.match(rule);
      },
      is(rule) {
        return this.href === rule;
      },
      willMatch(rule) {
        return this.loadingHref.match(rule);
      },
      willBe(rule) {
        return this.loadingHref === rule;
      },
      query(key) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(key);
      },
      segment(key) {
        const regex = new RegExp(`/${key}/([^/]+)`);
        let match2 = this.href.match(regex);
        return match2 ? match2[1] : null;
      },
      hashSegmentsPlus(key, value = null, toggle = false) {
        let base = this.href || "";
        let parts = base.split("#/");
        let hash = parts[1] || "";
        hash = hash.replace(/\/+/g, "/").replace(/^\/|\/$/g, "");
        const segmentPattern = value === null ? new RegExp(`(?:${key})(?:\\/)?`, "g") : new RegExp(`${key}\\/${value}(?:\\/)?`, "g");
        const keyExists = segmentPattern.test(hash);
        if (toggle && keyExists) {
          hash = hash.replace(segmentPattern, "");
        } else {
          hash = hash.replace(new RegExp(`${key}(?:\\/[^\\/]*)?\\/`, "g"), "");
          const newSegment = value === null ? `${key}` : `${key}/${value}`;
          hash += `/${newSegment}`;
        }
        let final = "#/" + hash.replace(/\/+/g, "/").replace(/^\/|\/$/g, "") + "/";
        final = final.replace(/\/+/, "/");
        return final === "#/" ? "#" : final;
      },
      toggleHashSegment(key, value = null) {
        let toggle = true;
        return this.hashSegmentsPlus(key, value, toggle);
      },
      update(url, returnValue) {
        let out = url;
        out = out.replace(/^[a-zA-Z]{3,5}\:\/{2}[a-zA-Z0-9_.:-]+\//, "");
        let href = `/${out}`.replace(/\/+/, "/");
        if (returnValue) return href;
        if (href === this.href) return;
        this.prevHref = this.href;
        this.requests = this.requests + 1;
        this.href = href;
        if (!this.isHistoryNavigation) {
          document.dispatchEvent(
            new CustomEvent("router:navigate", { detail: { url: href } })
          );
        }
      },
      setVisibleUri(uri) {
        this.programmaticNavigation = true;
        window.history.pushState({}, document.title, uri);
        this.update(window.location.href);
        setTimeout(() => {
          this.programmaticNavigation = false;
        }, 0);
      },
      removeHash() {
        var uri = window.location.toString();
        if (uri.indexOf("#") > 0) {
          var clean_uri = uri.substring(0, uri.indexOf("#"));
          this.setVisibleUri(clean_uri);
        }
      },
      init() {
        this.update(window.location.href);
        let userClickedLink = false;
        document.addEventListener("click", (event) => {
          const target = event.target.closest("a");
          if (target && target.href) {
            userClickedLink = true;
            setTimeout(() => {
              userClickedLink = false;
            }, 50);
          }
        });
        window.addEventListener("popstate", (event) => {
          let newHref = this.update(window.location.href, true);
          let didClick = false;
          if (userClickedLink || this.programmaticNavigation === true)
            didClick = true;
          if (!didClick && newHref === this.prevHref) {
            document.dispatchEvent(
              new CustomEvent("router:back", {
                detail: { url: newHref }
              })
            );
            this.isHistoryNavigation = true;
            this.update(event.target.location.href);
            setTimeout(() => {
              this.isHistoryNavigation = false;
            }, 0);
          } else {
            this.update(event.target.location.href);
          }
        });
        const checkUrlChange = () => {
          let newHref = this.update(window.location.href, true);
          if (newHref !== this.href) {
            this.update(newHref);
          }
        };
        setInterval(checkUrlChange, 500);
      }
    });
  });

  // src/theme/js/alpine/lenis.js
  function getFirstElementChild(parentElement) {
    let firstElementChild = null;
    for (let i4 = 0; i4 < parentElement.childNodes.length; i4++) {
      const child = parentElement.childNodes[i4];
      if (child.nodeType === Node.ELEMENT_NODE) {
        firstElementChild = child;
        break;
      }
    }
    return firstElementChild;
  }
  init(() => {
    module_default.data("lenis", () => ({
      lenis: null,
      raf(time2) {
        this.lenis.raf(time2);
        this.updateCallback = this.raf.bind(this);
        this.loop = requestAnimationFrame(this.updateCallback);
      },
      init(args) {
        const lenis = new Lenis({
          wrapper: this.$el,
          content: getFirstElementChild(this.$el),
          wheelEventsTarget: this.$el
        });
        this.lenis = lenis;
        this.updateCallback = this.raf.bind(this);
        this.loop = requestAnimationFrame(this.updateCallback);
      },
      destroy() {
        if (this.loop) {
          cancelAnimationFrame(this.loop);
        }
        if (this.lenis) this.lenis.destroy();
        this.lenis = null;
      }
    }));
  });

  // src/theme/js/alpine/quoteReplacement.js
  init(() => {
    module_default.data("quoteReplacement", () => ({
      // Helper function to replace inch marks with proper quotes
      replaceInchMarksWithQuotes(text) {
        if (!text || typeof text !== "string") return text;
        const pattern = /"([^"]*?)"/g;
        return text.replace(pattern, (match2, content) => {
          return `\u201C${content}\u201D`;
        });
      },
      // Initialize the plugin
      init() {
        this.$nextTick(() => {
          this.processTextContent();
        });
        this.$watch("$el.textContent", () => {
          this.processTextContent();
        });
      },
      // Process text content and replace inch marks
      processTextContent() {
        if (!this.$el) return;
        this.processNode(this.$el);
      },
      // Process a node and its children recursively
      processNode(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          const originalText = node.textContent;
          const processedText = this.replaceInchMarksWithQuotes(originalText);
          if (originalText !== processedText) {
            node.textContent = processedText;
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const children = Array.from(node.childNodes);
          children.forEach((child) => this.processNode(child));
        }
      },
      // Force processing - can be called manually if needed
      forceProcess() {
        this.processTextContent();
      }
    }));
  });

  // src/theme/js/alpine/lazyload.js
  init(() => {
    module_default.directive("lazyload", (el, { value }, { evaluateLater: evaluateLater2, effect: effect3 }) => {
      let lazyLoadFn = evaluateLater2("lazyload");
      let observer2 = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting || entry.boundingClientRect.top < window.innerHeight + 500) {
              lazyLoadFn();
              observer2.disconnect();
            }
          });
        },
        {
          root: null,
          rootMargin: "500px",
          threshold: 0
        }
      );
      observer2.observe(el);
    });
  });

  // src/components/ajax/ajax.js
  init(() => {
    module_default.store("ajaxStore", {
      poppedState: false,
      requests: 0,
      init() {
        document.addEventListener("router:back", (event) => {
        });
        document.addEventListener("router:navigate", (event) => {
        });
        window.addEventListener("load", () => {
          setTimeout(() => this.fetchContent(window.location.href), 1e3);
        });
      },
      // Handle changes when navigating backward or forward in history
      onPopState(ev) {
        this.poppedState = true;
        this.updateCurrentUrl(window.location.href);
      },
      previousUrl: null,
      current: window.location.href,
      // Current URL
      cache: {},
      // Cache for storing full HTML responses
      // Fetch the full HTML content for a given URL and cache it
      fetchContent(url, selector = null) {
        const cleanedUrl = new URL(url, window.location.origin).pathname + window.location.search + window.location.hash;
        if (this.cache[cleanedUrl]) {
          if (!selector) return null;
          const parser = new DOMParser();
          const doc = parser.parseFromString(this.cache[cleanedUrl], "text/html");
          const container = doc.querySelector(selector);
          return Promise.resolve(container ? container.innerHTML : "");
        }
        return fetch(url).then((response) => response.text()).then((html) => {
          this.cache[cleanedUrl] = html;
          if (selector) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const container = doc.querySelector(selector);
            const content = container ? container.innerHTML : "";
            return content;
          }
        });
      },
      // Update the current URL
      updateCurrentUrl(url) {
        this.requests = this.requests + 1;
        this.current = url;
        module_default.store("route").setVisibleUri(url);
      }
    });
    module_default.data("ajaxContainer", () => ({
      // Watch for changes to the global store's 'current' URL and update the container
      init() {
        this.$watch(
          () => module_default.store("ajaxStore").requests,
          () => {
            this.updateContent(module_default.store("ajaxStore").current);
          }
        );
      },
      destroy() {
      },
      // Update the content based on the 'current' URL from the store
      updateContent(url) {
        const targetElement = this.$el;
        if (targetElement) {
          if (module_default.store("ajaxStore").poppedState) {
            targetElement.style.height = "9999px";
            setTimeout(
              () => document.documentElement.classList.remove("is-loading"),
              50
            );
          } else {
            document.documentElement.classList.add("is-loading");
          }
          let timer = module_default.store("ajaxStore").poppedState ? 0 : 500;
          const update = () => {
            module_default.store("ajaxStore").fetchContent(url, `#${this.$el.id}`).then((content) => {
              document.documentElement.classList.remove("is-loading");
              targetElement.innerHTML = content;
              if (!module_default.store("ajaxStore").poppedState) {
                window.scrollTo(0, 0);
              } else {
                setTimeout(() => targetElement.style.height = "", 1e3);
              }
              module_default.store("ajaxStore").poppedState = false;
            }).catch((error2) => console.error("Error loading content:", error2));
          };
          if (module_default.store("ajaxStore").poppedState) {
            update();
          } else {
            setTimeout(() => {
              update();
            }, 500);
          }
        }
      }
    }));
    module_default.data("ajax", () => ({
      init() {
        if (this.$el.tagName === "A") {
          this.$el.addEventListener(
            "click",
            (event) => this.handleClick(event, this.$el)
          );
        } else {
          this.$el.querySelectorAll("a").forEach((link) => {
            link.addEventListener(
              "click",
              (event) => this.handleClick(event, link)
            );
          });
        }
      },
      // Handle click event and update the global store
      handleClick(event, link) {
        const href = link.getAttribute("href");
        if (!href || href.startsWith("#") || new URL(href, location.origin).origin !== location.origin) {
          return;
        }
        event.stopPropagation();
        event.preventDefault();
        module_default.store("ajaxStore").updateCurrentUrl(href);
      }
    }));
  });

  // src/components/alpineColourSwatches/alpineColourSwatches.js
  init(() => {
    module_default.data("alpineColourSwatches", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/theme/js/utils/utils.js
  var shuffleArray = (array) => {
    let currentIndex = array.length;
    let randomIndex;
    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex]
      ];
    }
    return array;
  };

  // src/components/alpineFeed/alpineFeed.js
  var CACHE = [];
  init(() => {
    module_default.data("alpineFeed", () => ({
      filterCriteria: [],
      originalItems: [],
      items: [],
      debug: false,
      setup(tiles) {
        var _a;
        if (this.debug) {
        }
        if (tiles && tiles.length && this.$el.dataset.products) {
          let productOrGIDs = JSON.parse(this.$el.dataset.products);
          const shouldShuffle = this.$el.dataset.shuffle === "true" || ((_a = this.$el.closest('[data-shuffle="true"]')) == null ? void 0 : _a.dataset.shuffle) === "true";
          if (shouldShuffle && productOrGIDs && productOrGIDs.length > 0) {
            productOrGIDs = shuffleArray([...productOrGIDs]);
          }
          if (this.debug) {
          }
          if (productOrGIDs && productOrGIDs.length) {
            let products = [];
            productOrGIDs.forEach((id) => {
              let textId = `${id}`;
              let idProp = "id";
              if (textId.includes("gid://")) {
                if (textId.includes("/ProductVariant/")) {
                  idProp = "variantId";
                } else if (textId.includes("/Product/")) {
                  idProp = "id";
                }
                let match2 = textId.match(/\/(\d+)$/);
                if (match2) {
                  textId = match2[1];
                }
              }
              let foundMatch = false;
              let matchCount = 0;
              tiles.forEach((p4) => {
                var _a2, _b, _c;
                if (foundMatch && idProp === "id" && ((_a2 = p4.attributes) == null ? void 0 : _a2.create_tiles_from_skus) !== true) {
                  return;
                }
                let isMatch = ((_b = p4[idProp]) == null ? void 0 : _b.toString()) === textId;
                if (!isMatch && idProp === "variantId") {
                  isMatch = p4.variantIds.includes(textId);
                }
                if (isMatch) {
                  matchCount++;
                  let pushMatch = p4;
                  if (idProp === "variantId") {
                    let overrides = p4.variantData.find(
                      (v3) => v3.variantId.match(textId)
                    );
                    pushMatch = { ...p4, ...overrides };
                  }
                  products.push(pushMatch);
                  if (idProp === "id" && ((_c = p4.attributes) == null ? void 0 : _c.create_tiles_from_skus) !== true) {
                    foundMatch = true;
                  }
                }
              });
              return;
            });
            this.originalItems = products;
          }
        } else {
        }
        if (tiles && tiles.length && !this.$el.dataset.products) {
          this.originalItems = tiles;
        }
      },
      dataSource(products) {
        if (CACHE.length) return CACHE;
        CACHE = [...products];
        return CACHE;
      },
      init() {
        this.debug = this.$el.dataset.debug === "true";
        if (!this.$el.hasAttribute("x-lazyload")) this.ready();
      },
      lazyload() {
        this.ready();
      },
      async ready(args) {
        if (module_default.store("siteData").loaded) {
          let products = await module_default.store("siteData").getProductsAsync();
          let processedProducts = this.dataSource(products);
          this.setup(processedProducts);
        }
        this.$watch(
          () => module_default.store("siteData").loaded,
          async (newValue, oldValue) => {
            if (!this.originalItems.length) {
              let products = await module_default.store("siteData").getProductsAsync();
              let processedProducts = this.dataSource(products);
              this.setup(processedProducts);
              this.$nextTick(() => {
                this.applyFilters();
              });
            }
          }
        );
        this.$nextTick(() => {
          this.applyFilters();
        });
      },
      applyFilters() {
        if (!this.$el.dataset.filters) {
          this.items = this.originalItems;
        } else {
          let filters = {};
          try {
            filters = JSON.parse(this.$el.dataset.filters);
          } catch (err) {
          }
          let items = this.filterItems(this.originalItems, filters);
          this.items = items;
        }
      },
      filterItems(items, filters) {
        return items.filter((item) => {
          return Object.keys(filters).every((filterKey) => {
            const attribute = item.attributes[filterKey];
            if (!attribute) return false;
            let parsedValues = attribute;
            if (!Array.isArray(parsedValues)) {
              parsedValues = [parsedValues];
            }
            return parsedValues.some(
              (parsedValue) => filters[filterKey].includes(parsedValue)
            );
          });
        });
      },
      destroy() {
      }
    }));
  });

  // src/components/alpineFeedFilter/FilterController.js
  var FilterController = class {
    constructor(config2, dataset, contextual = false, filterRules = { disable: [], enable: [], visible: [] }, persistentFilters = []) {
      this.config = config2;
      this.mergedConfig = {};
      this.dataset = dataset;
      this.contextual = contextual;
      this.filterRules = filterRules;
      this.persistentFilters = persistentFilters;
      this.rulesProcessed = false;
      this.availableValues = {};
      this.indexedData = this.indexDataset();
    }
    // Process editorial filter rules to disable specific filters or options
    processFilterRules() {
      this.filterRules.disable.forEach((rule) => {
        this.applyDisableRule(rule);
      });
      this.processVisibleRulesGrouped();
    }
    /**
     * Parse filter rule path into structured object
     * @param {string} rule - The filter rule string to parse
     * @returns {Object|null} Parsed rule object with type and targeting information
     * 
     * Rule format: "filterHandle:optionHandle/metaFilter1,metaFilter2:optionHandles"
     * Examples:
     * - "categories" → targets entire filter
     * - "categories:pens-pencils" → targets specific options
     * - "categories:pens-pencils/type,lead-size" → targets metaFilters
     * - "categories:pens-pencils/type,lead-size:05mm;32mm" → targets metaFilter options
     * 
     * Returned object structure:
     * {
     *   type: 'filter' | 'options' | 'metaFilters' | 'metaFilterOptions',
     *   filterHandle: string,
     *   optionHandle: string|null,
     *   metaFilterHandles: string[]|null,
     *   optionHandles: string[]|null
     * }
     */
    parseFilterRulePath(rule) {
      const slashParts = rule.split("/");
      if (slashParts.length === 1) {
        const colonParts = rule.split(":");
        if (colonParts.length === 1) {
          return {
            type: "filter",
            filterHandle: colonParts[0],
            optionHandle: null,
            metaFilterHandles: null,
            optionHandles: null
          };
        } else {
          const filterHandle = colonParts[0];
          const optionHandles = colonParts[1].split(",").map((h4) => h4.trim());
          return {
            type: "options",
            filterHandle,
            optionHandle: null,
            metaFilterHandles: null,
            optionHandles
          };
        }
      } else if (slashParts.length === 2) {
        const parentPart = slashParts[0];
        const subOptionsPart = slashParts[1];
        const colonParts = parentPart.split(":");
        if (colonParts.length !== 2) {
          return null;
        }
        const filterHandle = colonParts[0];
        const optionHandle = colonParts[1];
        if (subOptionsPart.includes(":")) {
          const colonParts2 = subOptionsPart.split(":");
          const metaFilterString = colonParts2[0];
          const optionsString = colonParts2[1];
          const metaFilterHandles = metaFilterString.split(",").map((h4) => h4.trim());
          const optionHandles = optionsString.split(";").map((h4) => h4.trim());
          return {
            type: "metaFilterOptions",
            filterHandle,
            optionHandle,
            metaFilterHandles,
            optionHandles
          };
        } else {
          const metaFilterHandles = subOptionsPart.split(",").map((h4) => h4.trim());
          return {
            type: "metaFilters",
            filterHandle,
            optionHandle,
            metaFilterHandles,
            optionHandles: null
          };
        }
      }
      return null;
    }
    // Process visible rules grouped by option to handle multiple metaFilter rules properly
    processVisibleRulesGrouped() {
      const groupedRules = {};
      const otherRules = [];
      this.filterRules.visible.forEach((rule) => {
        const parsedRule = this.parseFilterRulePath(rule);
        if (!parsedRule) return;
        if (parsedRule.type === "metaFilters" || parsedRule.type === "metaFilterOptions") {
          const key = `${parsedRule.filterHandle}:${parsedRule.optionHandle}`;
          if (!groupedRules[key]) {
            groupedRules[key] = {
              filterHandle: parsedRule.filterHandle,
              optionHandle: parsedRule.optionHandle,
              metaFilterRules: []
            };
          }
          groupedRules[key].metaFilterRules.push(parsedRule);
        } else {
          otherRules.push(rule);
        }
      });
      otherRules.forEach((rule) => {
        this.applyVisibleRule(rule);
      });
      Object.values(groupedRules).forEach((group) => {
        this.processGroupedMetaFilterRules(group);
      });
    }
    // Process grouped metaFilter rules for a specific option
    processGroupedMetaFilterRules(group) {
      const { filterHandle, optionHandle, metaFilterRules } = group;
      const allMetaFilterHandles = /* @__PURE__ */ new Set();
      const metaFilterOptions = {};
      metaFilterRules.forEach((rule) => {
        if (rule.metaFilterHandles) {
          rule.metaFilterHandles.forEach((metaFilterHandle) => {
            allMetaFilterHandles.add(metaFilterHandle);
            if (rule.type === "metaFilterOptions" && rule.optionHandles) {
              if (!metaFilterOptions[metaFilterHandle]) {
                metaFilterOptions[metaFilterHandle] = [];
              }
              metaFilterOptions[metaFilterHandle].push(...rule.optionHandles);
            }
          });
        }
      });
      for (let key in this.mergedConfig) {
        let keyConfig = this.mergedConfig[key];
        if (keyConfig.config && keyConfig.config.handle === filterHandle) {
          if (keyConfig.config.options) {
            const targetOption = keyConfig.config.options.find((option) => option.handle === optionHandle);
            if (targetOption) {
              targetOption.silentlyActive = true;
              targetOption.visible = true;
              if (targetOption.metaFilters) {
                targetOption.metaFilters.forEach((metaFilter) => {
                  const shouldBeVisible = allMetaFilterHandles.has(metaFilter.handle);
                  metaFilter.visible = shouldBeVisible;
                  if (shouldBeVisible) {
                    if (metaFilterOptions[metaFilter.handle]) {
                      metaFilter.options.forEach((subOption) => {
                        const optionVisible = metaFilterOptions[metaFilter.handle].includes(subOption.handle);
                        subOption.visible = optionVisible;
                      });
                    }
                  } else {
                  }
                });
              }
            }
          }
          break;
        }
      }
    }
    /**
     * Apply a disable rule to hide specific filters or options
     * @param {string} rule - The disable rule string to apply
     */
    applyDisableRule(rule) {
      const parsedRule = this.parseFilterRulePath(rule);
      if (!parsedRule) {
        return;
      }
      switch (parsedRule.type) {
        case "filter":
          this.disableFilter(parsedRule.filterHandle);
          break;
        case "options":
          this.disableFilterOptions(parsedRule.filterHandle, parsedRule.optionHandles);
          break;
        case "metaFilters":
          parsedRule.metaFilterHandles.forEach((metaFilterHandle) => {
            const subfilterPath = `${parsedRule.optionHandle}/${metaFilterHandle}`;
            this.disableSubfilterOptions(parsedRule.filterHandle, subfilterPath, []);
          });
          break;
        case "metaFilterOptions":
          if (parsedRule.metaFilterHandles) {
            parsedRule.metaFilterHandles.forEach((metaFilterHandle, index) => {
              const subfilterPath = `${parsedRule.optionHandle}/${metaFilterHandle}`;
              if (index === 0) {
                this.disableSubfilterOptions(parsedRule.filterHandle, subfilterPath, []);
              } else {
                this.disableSubfilterOptions(parsedRule.filterHandle, subfilterPath, parsedRule.optionHandles);
              }
            });
          } else {
            this.disableSubfilterOptions(parsedRule.filterHandle, parsedRule.optionHandle, parsedRule.optionHandles);
          }
          break;
      }
    }
    // Process persistent filter rules to pre-activate filters
    processPersistentFilters() {
      this.persistentFilters.forEach((rule) => {
        this.applyPersistentFilterRule(rule);
      });
    }
    /**
     * Apply a persistent filter rule to pre-activate filters
     * @param {string} rule - The persistent filter rule string to apply
     */
    applyPersistentFilterRule(rule) {
      const parsedRule = this.parseFilterRulePath(rule);
      if (!parsedRule) {
        return;
      }
      if (parsedRule.type === "filter") {
        return;
      }
      switch (parsedRule.type) {
        case "options":
          this.activateFilterOptions(parsedRule.filterHandle, parsedRule.optionHandles);
          break;
        case "metaFilters":
          parsedRule.metaFilterHandles.forEach((metaFilterHandle) => {
            const subfilterPath = `${parsedRule.optionHandle}/${metaFilterHandle}`;
            this.activateSubfilterOptions(parsedRule.filterHandle, subfilterPath, []);
          });
          break;
        case "metaFilterOptions":
          if (parsedRule.metaFilterHandles) {
            parsedRule.metaFilterHandles.forEach((metaFilterHandle, index) => {
              const subfilterPath = `${parsedRule.optionHandle}/${metaFilterHandle}`;
              if (index === 0) {
                this.activateSubfilterOptions(parsedRule.filterHandle, subfilterPath, []);
              } else {
                this.activateSubfilterOptions(parsedRule.filterHandle, subfilterPath, parsedRule.optionHandles);
              }
            });
          } else {
            this.activateSubfilterOptions(parsedRule.filterHandle, parsedRule.optionHandle, parsedRule.optionHandles);
          }
          break;
      }
    }
    /**
     * Apply a visible filter rule to make specific options visible in UI
     * @param {string} rule - The visible filter rule string to apply
     */
    applyVisibleRule(rule) {
      const parsedRule = this.parseFilterRulePath(rule);
      if (!parsedRule) {
        return;
      }
      switch (parsedRule.type) {
        case "filter":
          this.makeFilterVisible(parsedRule.filterHandle);
          break;
        case "options":
          this.makeFilterOptionsVisible(parsedRule.filterHandle, parsedRule.optionHandles);
          break;
        case "metaFilters":
          parsedRule.metaFilterHandles.forEach((metaFilterHandle) => {
            const subfilterPath = `${parsedRule.optionHandle}/${metaFilterHandle}`;
            this.makeSubfilterVisible(parsedRule.filterHandle, subfilterPath);
          });
          break;
        case "metaFilterOptions":
          if (parsedRule.metaFilterHandles && parsedRule.metaFilterHandles.length > 0) {
            parsedRule.metaFilterHandles.forEach((metaFilterHandle, index) => {
              const subfilterPath = `${parsedRule.optionHandle}/${metaFilterHandle}`;
              if (parsedRule.metaFilterHandles.length === 1) {
                this.makeSubfilterOptionsVisible(parsedRule.filterHandle, subfilterPath, parsedRule.optionHandles);
              } else {
                if (index === 0) {
                  this.makeSubfilterVisible(parsedRule.filterHandle, subfilterPath);
                } else {
                  this.makeSubfilterOptionsVisible(parsedRule.filterHandle, subfilterPath, parsedRule.optionHandles);
                }
              }
            });
          } else {
            this.makeSubfilterOptionsVisible(parsedRule.filterHandle, parsedRule.optionHandle, parsedRule.optionHandles);
          }
          break;
      }
    }
    // Disable an entire filter
    disableFilter(filterHandle) {
      for (let key in this.mergedConfig) {
        let keyConfig = this.mergedConfig[key];
        if (keyConfig.config && keyConfig.config.handle === filterHandle) {
          keyConfig.config.disabled = true;
          break;
        }
      }
    }
    // Disable specific filter options
    disableFilterOptions(filterHandle, optionHandles) {
      for (let key in this.mergedConfig) {
        let keyConfig = this.mergedConfig[key];
        if (keyConfig.config && keyConfig.config.handle === filterHandle) {
          if (keyConfig.config.options) {
            keyConfig.config.options.forEach((option) => {
              if (optionHandles.includes(option.handle)) {
                option.disabled = true;
              }
            });
          }
          break;
        }
      }
    }
    // Disable specific subfilter options
    disableSubfilterOptions(filterHandle, subfilterPath, optionHandles) {
      const pathParts = subfilterPath.split("/");
      const optionHandle = pathParts[0];
      const metaFilterHandle = pathParts[1];
      for (let key in this.mergedConfig) {
        let keyConfig = this.mergedConfig[key];
        if (keyConfig.config && keyConfig.config.handle === filterHandle) {
          if (keyConfig.config.options) {
            const targetOption = keyConfig.config.options.find((option) => option.handle === optionHandle);
            if (targetOption && targetOption.metaFilters) {
              const targetMetaFilter = targetOption.metaFilters.find((metaFilter) => metaFilter.handle === metaFilterHandle);
              if (targetMetaFilter) {
                if (optionHandles.length === 0) {
                  targetMetaFilter.disabled = true;
                } else {
                  targetMetaFilter.options.forEach((subOption) => {
                    if (optionHandles.includes(subOption.handle)) {
                      subOption.disabled = true;
                    }
                  });
                }
              } else {
              }
            } else {
            }
          }
          break;
        }
      }
    }
    // Activate specific filter options (mark as persistent)
    activateFilterOptions(filterHandle, optionHandles) {
      for (let key in this.mergedConfig) {
        let keyConfig = this.mergedConfig[key];
        if (keyConfig.config && keyConfig.config.handle === filterHandle) {
          if (keyConfig.config.options) {
            keyConfig.config.options.forEach((option) => {
              if (optionHandles.includes(option.handle)) {
                option.persistent = true;
              }
            });
          }
          break;
        }
      }
    }
    // Activate specific subfilter options (mark as persistent)
    activateSubfilterOptions(filterHandle, subfilterPath, optionHandles) {
      const pathParts = subfilterPath.split("/");
      const optionHandle = pathParts[0];
      const metaFilterHandle = pathParts[1];
      for (let key in this.mergedConfig) {
        let keyConfig = this.mergedConfig[key];
        if (keyConfig.config && keyConfig.config.handle === filterHandle) {
          if (keyConfig.config.options) {
            const targetOption = keyConfig.config.options.find((option) => option.handle === optionHandle);
            if (targetOption && targetOption.metaFilters) {
              const targetMetaFilter = targetOption.metaFilters.find((metaFilter) => metaFilter.handle === metaFilterHandle);
              if (targetMetaFilter) {
                if (optionHandles.length === 0) {
                  targetMetaFilter.persistent = true;
                } else {
                  targetMetaFilter.options.forEach((subOption) => {
                    if (optionHandles.includes(subOption.handle)) {
                      subOption.persistent = true;
                    }
                  });
                }
              } else {
              }
            } else {
            }
          }
          break;
        }
      }
    }
    // Make an entire filter visible in UI
    makeFilterVisible(filterHandle) {
      for (let key in this.mergedConfig) {
        let keyConfig = this.mergedConfig[key];
        if (keyConfig.config && keyConfig.config.handle === filterHandle) {
          keyConfig.config.visible = true;
          break;
        }
      }
    }
    // Make specific filter options visible in UI
    makeFilterOptionsVisible(filterHandle, optionHandles) {
      for (let key in this.mergedConfig) {
        let keyConfig = this.mergedConfig[key];
        if (keyConfig.config && keyConfig.config.handle === filterHandle) {
          if (keyConfig.config.options) {
            keyConfig.config.options.forEach((option) => {
              if (optionHandles.includes(option.handle)) {
                option.visible = true;
                option.silentlyActive = true;
              } else {
              }
            });
          }
          break;
        }
      }
    }
    // Make a subfilter visible in UI
    makeSubfilterVisible(filterHandle, subfilterPath) {
      const pathParts = subfilterPath.split("/");
      const optionHandle = pathParts[0];
      const metaFilterHandle = pathParts[1];
      for (let key in this.mergedConfig) {
        let keyConfig = this.mergedConfig[key];
        if (keyConfig.config && keyConfig.config.handle === filterHandle) {
          if (keyConfig.config.options) {
            const targetOption = keyConfig.config.options.find((option) => option.handle === optionHandle);
            if (targetOption) {
              targetOption.silentlyActive = true;
              targetOption.visible = true;
              if (targetOption.metaFilters) {
                const targetMetaFilter = targetOption.metaFilters.find((metaFilter) => metaFilter.handle === metaFilterHandle);
                if (targetMetaFilter) {
                  targetMetaFilter.visible = true;
                } else {
                }
              } else {
              }
            } else {
            }
          }
          break;
        }
      }
    }
    // Make specific subfilter options visible in UI
    makeSubfilterOptionsVisible(filterHandle, subfilterPath, optionHandles) {
      const pathParts = subfilterPath.split("/");
      const optionHandle = pathParts[0];
      const metaFilterHandle = pathParts[1];
      for (let key in this.mergedConfig) {
        let keyConfig = this.mergedConfig[key];
        if (keyConfig.config && keyConfig.config.handle === filterHandle) {
          if (keyConfig.config.options) {
            const targetOption = keyConfig.config.options.find((option) => option.handle === optionHandle);
            if (targetOption) {
              targetOption.silentlyActive = true;
              targetOption.visible = true;
              if (targetOption.metaFilters) {
                const targetMetaFilter = targetOption.metaFilters.find((metaFilter) => metaFilter.handle === metaFilterHandle);
                if (targetMetaFilter) {
                  targetMetaFilter.visible = true;
                  targetMetaFilter.options.forEach((subOption) => {
                    if (optionHandles.includes(subOption.handle)) {
                      subOption.visible = true;
                    } else {
                      subOption.visible = false;
                    }
                  });
                } else {
                }
              } else {
              }
            } else {
            }
          }
          break;
        }
      }
    }
    // Filter out disabled items and include visible items from the config, returning a clean config
    filterDisabledItems(keyConfig) {
      if (!keyConfig.config || !keyConfig.config.options) {
        return keyConfig;
      }
      const filteredOptions = keyConfig.config.options.filter((option) => option.visible || !option.disabled).map((option) => {
        if (option.metaFilters && Array.isArray(option.metaFilters)) {
          const filteredMetaFilters = option.metaFilters.filter((metaFilter) => metaFilter.visible || !metaFilter.disabled).map((metaFilter) => {
            if (metaFilter.options && Array.isArray(metaFilter.options)) {
              const filteredMetaOptions = metaFilter.options.filter((metaOption) => metaOption.visible || !metaOption.disabled);
              return {
                ...metaFilter,
                options: filteredMetaOptions
              };
            }
            return metaFilter;
          });
          return {
            ...option,
            metaFilters: filteredMetaFilters
          };
        }
        return option;
      });
      return {
        ...keyConfig,
        config: {
          ...keyConfig.config,
          options: filteredOptions
        }
      };
    }
    getConfig() {
      let conf = {};
      for (let key in this.config.keys) {
        let keyConfig = this.getMergedConfig(key);
        if (!this.rulesProcessed) {
          this.processFilterRules();
          this.rulesProcessed = true;
        }
        if (this.persistentFilters.length > 0) {
          this.processPersistentFilters();
        }
        if (keyConfig.config && keyConfig.config.disabled) {
          continue;
        }
        if (keyConfig.config && keyConfig.config.options) {
          keyConfig = this.filterDisabledItems(keyConfig);
        }
        if (this.contextual && this.availableValues[key]) {
          keyConfig = this.filterConfigByAvailableValues(keyConfig, key);
        }
        conf[key] = keyConfig;
      }
      return conf;
    }
    filterConfigByAvailableValues(keyConfig, key) {
      const available = this.availableValues[key];
      if (!available || !keyConfig.config.options) return keyConfig;
      const availableArray = Array.isArray(available) ? available : Array.from(available);
      const filteredOptions = keyConfig.config.options.filter((option) => {
        return availableArray.includes(option.handle);
      });
      return {
        ...keyConfig,
        config: {
          ...keyConfig.config,
          options: filteredOptions
        }
      };
    }
    getMergedConfig(key) {
      if (this.mergedConfig[key]) return this.mergedConfig[key];
      const defaultConfig = this.config.default || {};
      const keyConfig = this.config.keys[key] || {};
      let conf = typeof defaultConfig.config === "function" ? defaultConfig.config(key) : { id: key, label: key, handle: key, options: [] };
      let keyConf = typeof keyConfig.config === "function" ? keyConfig.config() : {};
      let merged = {
        config: { ...conf, ...keyConf },
        index: { ...defaultConfig.index, ...keyConfig.index },
        query: { ...defaultConfig.query, ...keyConfig.query }
      };
      if (keyConf.options && Array.isArray(keyConf.options)) {
        merged.config.options = keyConf.options.map((option) => {
          return { ...option };
        });
      }
      this.mergedConfig[key] = merged;
      return this.mergedConfig[key];
    }
    indexDataset() {
      if (this.contextual) {
        for (let key in this.config.keys) {
          this.availableValues[key] = /* @__PURE__ */ new Set();
        }
      }
      const indexedData = this.dataset.map((item) => {
        let indexedItem = {};
        for (let key in this.config.keys) {
          let keyConfig = this.getMergedConfig(key);
          if (keyConfig.index && keyConfig.index.rawValue) {
            let rawValue = keyConfig.index.rawValue(item, keyConfig.config);
            let searchableValue = keyConfig.index.searchableValue ? keyConfig.index.searchableValue(rawValue) : rawValue;
            if (this.contextual) {
              this.trackAvailableValues(key, searchableValue, keyConfig);
            }
            indexedItem[key] = searchableValue;
          }
        }
        return { original: item, indexed: indexedItem };
      });
      if (this.contextual) {
        this.applyInitialMetaFilterContextualFiltering();
      }
      return indexedData;
    }
    trackAvailableValues(key, value, keyConfig) {
      if (!this.availableValues[key]) return;
      if (keyConfig.index && keyConfig.index.handle) {
        const handles = keyConfig.index.handle(value, keyConfig.config);
        if (Array.isArray(handles)) {
          handles.forEach((handle) => {
            if (handle !== null && handle !== void 0) {
              this.availableValues[key].add(handle);
            }
          });
        }
        return;
      }
      if (Array.isArray(value)) {
        value.forEach((v3) => {
          if (v3 !== null && v3 !== void 0) {
            this.availableValues[key].add(v3);
          }
        });
      } else if (value !== null && value !== void 0) {
        this.availableValues[key].add(value);
      }
    }
    // Update available values based on current result set (for contextual filtering)
    updateAvailableValues(resultSet) {
      if (!this.contextual) return;
      for (let key in this.config.keys) {
        this.availableValues[key] = /* @__PURE__ */ new Set();
      }
      resultSet.forEach((item) => {
        for (let key in this.config.keys) {
          let keyConfig = this.getMergedConfig(key);
          if (keyConfig.index && keyConfig.index.rawValue) {
            let rawValue = keyConfig.index.rawValue(item, keyConfig.config);
            let searchableValue = keyConfig.index.searchableValue ? keyConfig.index.searchableValue(rawValue) : rawValue;
            this.trackAvailableValues(key, searchableValue, keyConfig);
          }
        }
      });
    }
    // Apply initial contextual filtering for metaFilter options (based on full dataset)
    applyInitialMetaFilterContextualFiltering() {
      if (!this.contextual) return;
      const filterConfigs = this.getConfig();
      Object.keys(filterConfigs).forEach((filterKey) => {
        const filterConfig = filterConfigs[filterKey];
        const config2 = filterConfig.config;
        if (config2.options) {
          config2.options.forEach((option) => {
            if (option.metaFilters) {
              option.metaFilters.forEach((metaFilter) => {
                const availableMetaOptions = /* @__PURE__ */ new Set();
                this.dataset.forEach((item) => {
                  const keyConfig = this.getMergedConfig(filterKey);
                  if (keyConfig.index && keyConfig.index.rawValue) {
                    const rawValue = keyConfig.index.rawValue(item, keyConfig.config);
                    const searchableValue = keyConfig.index.searchableValue ? keyConfig.index.searchableValue(rawValue) : rawValue;
                    const hasParentOption = Array.isArray(searchableValue) ? searchableValue.includes(option.handle) : searchableValue === option.handle;
                    if (hasParentOption) {
                      if (item.custom_filters && item.custom_filters[metaFilter.handle]) {
                        const entries = item.custom_filters[metaFilter.handle].entries || [];
                        entries.forEach((entry) => {
                          if (entry.handle) {
                            availableMetaOptions.add(entry.handle);
                          }
                        });
                      }
                    }
                  }
                });
                if (metaFilter.options) {
                  metaFilter.options.forEach((metaOption) => {
                    if (metaOption.visible !== false) {
                      metaOption.visible = availableMetaOptions.has(metaOption.handle);
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
    // Update contextual filtering for metaFilter options (based on current result set)
    updateMetaFilterContextualFiltering(resultSet) {
      if (!this.contextual) return;
      const filterConfigs = this.getConfig();
      Object.keys(filterConfigs).forEach((filterKey) => {
        const filterConfig = filterConfigs[filterKey];
        const config2 = filterConfig.config;
        if (config2.options) {
          config2.options.forEach((option) => {
            if (option.metaFilters) {
              option.metaFilters.forEach((metaFilter) => {
                const availableMetaOptions = /* @__PURE__ */ new Set();
                resultSet.forEach((item) => {
                  const keyConfig = this.getMergedConfig(filterKey);
                  if (keyConfig.index && keyConfig.index.rawValue) {
                    const rawValue = keyConfig.index.rawValue(item, keyConfig.config);
                    const searchableValue = keyConfig.index.searchableValue ? keyConfig.index.searchableValue(rawValue) : rawValue;
                    const hasParentOption = Array.isArray(searchableValue) ? searchableValue.includes(option.handle) : searchableValue === option.handle;
                    if (hasParentOption) {
                      if (item.custom_filters && item.custom_filters[metaFilter.handle]) {
                        const entries = item.custom_filters[metaFilter.handle].entries || [];
                        entries.forEach((entry) => {
                          if (entry.handle) {
                            availableMetaOptions.add(entry.handle);
                          }
                        });
                      }
                    }
                  }
                });
                if (metaFilter.options) {
                  metaFilter.options.forEach((metaOption) => {
                    if (metaOption.visible !== false) {
                      metaOption.visible = availableMetaOptions.has(metaOption.handle);
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
    getActiveFilters() {
      let activeFilters = {};
      let selectedFilters = {};
      let silentlyActive = {};
      let metaFilters = {};
      let index = {};
      for (let key in this.config.keys) {
        selectedFilters[key] = [];
      }
      for (let key in this.config.keys) {
        let keyConfig = this.getMergedConfig(key);
        if (keyConfig.query && keyConfig.query.activeFilters) {
          let filterHandle = keyConfig.config.handle;
          let urlFilters = keyConfig.query.activeFilters(filterHandle);
          if (urlFilters && urlFilters.length > 0) {
            urlFilters = urlFilters.map((f4) => f4.toLowerCase());
            selectedFilters[key] = urlFilters;
          }
          const context = {
            silentlyActive,
            selectedFilters,
            activeFilters
          };
          let filters = keyConfig.query.activeFilters(filterHandle, context);
          if (filters && filters.length > 0) {
            filters = filters.map((f4) => f4.toLowerCase());
            activeFilters[key] = filters;
            index[filterHandle] = filters;
            filters.forEach((filter) => {
              var _a;
              const option = (_a = keyConfig.config.options) == null ? void 0 : _a.find((opt) => opt.handle === filter);
              if (option == null ? void 0 : option.silentlyActive) {
                if (!silentlyActive[key]) silentlyActive[key] = [];
                silentlyActive[key].push(filter);
              }
            });
            keyConfig.config.options.forEach((opt) => {
              if (!filters.includes(opt.handle)) return;
              if (opt.metaFilters) {
                opt.metaFilters.forEach((metaField) => {
                  let activeMetaFilters = keyConfig.query.activeFilters(
                    metaField.handle
                  );
                  if (activeMetaFilters && activeMetaFilters.length) {
                    activeMetaFilters = activeMetaFilters.map(
                      (f4) => f4.toLowerCase()
                    );
                    if (!metaFilters[key]) metaFilters[key] = {};
                    if (!metaFilters[key][opt.handle])
                      metaFilters[key][opt.handle] = [];
                    let activeMetaField = {
                      ...metaField,
                      active: metaField.options.filter(
                        (o4) => activeMetaFilters.includes(o4.handle.toLowerCase())
                      )
                    };
                    delete activeMetaField.options;
                    index[metaField.handle] = activeMetaField.active.map(
                      (a4) => a4.handle
                    );
                    metaFilters[key][opt.handle].push(activeMetaField);
                  }
                });
              }
            });
          }
        }
      }
      this.addPersistentFiltersToActive(activeFilters, metaFilters, index);
      this.addSilentlyActiveFiltersFromConfig(activeFilters, silentlyActive, index);
      this.processMetaFiltersForSilentlyActiveParents(activeFilters, metaFilters, index);
      let selectedIndex = {};
      Object.keys(index).forEach((key) => {
        if (silentlyActive[key] && silentlyActive[key].length > 0) {
          selectedIndex[key] = index[key].filter((value) => !silentlyActive[key].includes(value));
          if (selectedIndex[key].length === 0) {
            delete selectedIndex[key];
          }
        } else {
          selectedIndex[key] = [...index[key]];
        }
      });
      return {
        activeFilters,
        selectedFilters,
        silentlyActive,
        activeMetaFilters: metaFilters,
        index,
        selectedIndex
      };
    }
    // Process metaFilters for silently active parent filters
    processMetaFiltersForSilentlyActiveParents(activeFilters, metaFilters, index) {
      for (let key in this.config.keys) {
        let keyConfig = this.getMergedConfig(key);
        if (!keyConfig.config || !keyConfig.config.options) continue;
        const filterHandle = keyConfig.config.handle;
        const silentlyActiveOptions = keyConfig.config.options.filter((opt) => opt.silentlyActive);
        if (silentlyActiveOptions.length > 0) {
          silentlyActiveOptions.forEach((opt) => {
            if (opt.metaFilters) {
              opt.metaFilters.forEach((metaField) => {
                let activeMetaFilters = keyConfig.query.activeFilters(metaField.handle);
                if (activeMetaFilters && activeMetaFilters.length) {
                  activeMetaFilters = activeMetaFilters.map((f4) => f4.toLowerCase());
                  if (!metaFilters[key]) metaFilters[key] = {};
                  if (!metaFilters[key][opt.handle]) metaFilters[key][opt.handle] = [];
                  let activeMetaField = {
                    ...metaField,
                    active: metaField.options.filter(
                      (o4) => activeMetaFilters.includes(o4.handle.toLowerCase())
                    )
                  };
                  delete activeMetaField.options;
                  index[metaField.handle] = activeMetaField.active.map((a4) => a4.handle);
                  metaFilters[key][opt.handle].push(activeMetaField);
                } else {
                }
              });
            }
          });
        }
      }
    }
    // Add silently active filters from config (set at init time via visible rules)
    addSilentlyActiveFiltersFromConfig(activeFilters, silentlyActive, index) {
      for (let key in this.config.keys) {
        let keyConfig = this.getMergedConfig(key);
        if (!keyConfig.config || !keyConfig.config.options) continue;
        const filterHandle = keyConfig.config.handle;
        let silentlyActiveOptions = [];
        keyConfig.config.options.forEach((option) => {
          if (option.silentlyActive) {
            silentlyActiveOptions.push(option.handle);
            if (option.metaFilters) {
              option.metaFilters.forEach((metaFilter) => {
                if (!index[metaFilter.handle]) {
                  index[metaFilter.handle] = [];
                }
              });
            }
          }
        });
        if (silentlyActiveOptions.length > 0) {
          if (!activeFilters[key]) activeFilters[key] = [];
          if (!index[filterHandle]) index[filterHandle] = [];
          if (!silentlyActive[key]) silentlyActive[key] = [];
          silentlyActiveOptions.forEach((optionHandle) => {
            if (!activeFilters[key].includes(optionHandle)) {
              activeFilters[key].push(optionHandle);
            }
            if (!index[filterHandle].includes(optionHandle)) {
              index[filterHandle].push(optionHandle);
            }
            if (!silentlyActive[key].includes(optionHandle)) {
              silentlyActive[key].push(optionHandle);
            }
          });
        }
      }
    }
    // Add persistent filters to the active filters
    addPersistentFiltersToActive(activeFilters, metaFilters, index) {
      for (let key in this.config.keys) {
        let keyConfig = this.getMergedConfig(key);
        if (!keyConfig.config || !keyConfig.config.options) continue;
        const filterHandle = keyConfig.config.handle;
        let hasPersistentOptions = false;
        let persistentOptions = [];
        keyConfig.config.options.forEach((option) => {
          if (option.persistent) {
            hasPersistentOptions = true;
            persistentOptions.push(option.handle);
            if (option.metaFilters) {
              option.metaFilters.forEach((metaFilter) => {
                if (metaFilter.persistent) {
                  if (!metaFilters[key]) metaFilters[key] = {};
                  if (!metaFilters[key][option.handle]) metaFilters[key][option.handle] = [];
                  const metaFilterOptions = metaFilter.options || [];
                  const activeMetaOptions = metaFilterOptions.map((opt) => opt.handle);
                  const activeMetaField = {
                    ...metaFilter,
                    active: metaFilterOptions
                  };
                  delete activeMetaField.options;
                  metaFilters[key][option.handle].push(activeMetaField);
                }
              });
            }
          }
        });
        if (hasPersistentOptions) {
          if (!activeFilters[key]) activeFilters[key] = [];
          if (!index[filterHandle]) index[filterHandle] = [];
          persistentOptions.forEach((optionHandle) => {
            if (!activeFilters[key].includes(optionHandle)) {
              activeFilters[key].push(optionHandle);
            }
            if (!index[filterHandle].includes(optionHandle)) {
              index[filterHandle].push(optionHandle);
            }
          });
        }
      }
    }
    filterDataset() {
      let { activeFilters, selectedFilters, silentlyActive, activeMetaFilters, index } = this.getActiveFilters();
      let activeSorts = {};
      let filtered = this.indexedData.filter(({ original, indexed }) => {
        for (let key in activeFilters) {
          let keyConfig = this.getMergedConfig(key);
          let normalisedItemValues = Array.isArray(indexed[key]) ? indexed[key] : [indexed[key]];
          let matches = activeFilters[key].filter(
            (filter) => normalisedItemValues.some(
              (value) => (
                // If this key has no filter defined, allow it
                keyConfig.query.filter ? keyConfig.query.filter(original, value, filter) : true
              )
            )
          );
          let matchFound = matches.length;
          if (!matchFound) return false;
          if (keyConfig.query.sort) {
            if (!activeSorts[key]) activeSorts[key] = keyConfig;
          }
          if (activeMetaFilters && activeMetaFilters[key]) {
            for (let validMetaFieldKey in matches) {
              let validMetaField = matches[validMetaFieldKey];
              if (activeMetaFilters[key][validMetaField]) {
                for (let metaFieldKey in activeMetaFilters[key][validMetaField]) {
                  let metaField = activeMetaFilters[key][validMetaField][metaFieldKey];
                  let metaMatchFound = metaField.active.some(
                    (metaValue) => keyConfig.query.filterMeta ? keyConfig.query.filterMeta(original, metaField, metaValue) : true
                  );
                  if (!metaMatchFound) return false;
                }
              }
            }
          }
        }
        return true;
      });
      if (Object.keys(activeSorts).length) {
        let activeSortOptions = {};
        for (const key of Object.keys(activeSorts)) {
          const config2 = activeSorts[key];
          if (!index[key] || !Array.isArray(index[key])) continue;
          const activeOptions = config2.config.options.filter(
            (opt) => index[key].some((handle) => opt.handle === handle)
          );
          activeSortOptions[key] = activeOptions;
        }
        filtered = filtered.sort((a4, b4) => {
          var _a;
          for (const key of Object.keys(activeSorts)) {
            const config2 = activeSorts[key];
            for (const option of activeSortOptions[key]) {
              if ((_a = config2.query) == null ? void 0 : _a.sort) {
                const result = config2.query.sort(
                  option.handle,
                  a4.indexed[key],
                  b4.indexed[key]
                );
                if (result !== 0) return result;
              }
            }
          }
          return 0;
        });
      }
      return filtered.map((entry) => entry.original);
    }
  };
  var FilterController_default = FilterController;

  // src/components/alpineFeedFilter/filterConfig.js
  var config = {
    default: {
      config: (key) => {
        return {
          id: key,
          label: key,
          handle: key.toLowerCase().replace(/\s/gi, "-")
        };
      },
      index: {
        rawValue: (item, conf) => {
          let attributeKey = conf.handle;
          switch (conf.handle) {
            case "categories":
              attributeKey = "categories";
              break;
          }
          let itemValues = item.attributes[attributeKey] || [];
          return itemValues.map((id) => conf.options.find((o4) => o4.id === id)).filter((i4) => !!i4).map((v3) => v3.handle);
        },
        rawMetaValue: (item, conf) => {
        }
      },
      query: {
        activeFilters: (handle) => {
          const regex = new RegExp(`/${handle}/([^/]+)`);
          let match2 = window.location.href.match(regex);
          if (match2 && match2[1]) {
            return match2[1].split(",");
          } else {
            return false;
          }
        },
        filter: (item, fieldValue, activeFilter) => {
          return fieldValue === activeFilter;
        },
        filterMeta: (item, metaField, activeMetaFilter) => {
          let prop = metaField.handle;
          if (!item.custom_filters || !item.custom_filters[prop]) return false;
          let entries = item.custom_filters[prop].entries || [];
          if (!entries.length) return false;
          return entries.find((e4) => e4.handle === activeMetaFilter.handle);
        }
      }
    },
    keys: {
      sort: {
        config: () => {
          return {
            icon: "sort3",
            id: "sort",
            handle: "sort",
            label: "Sort",
            radio: true,
            defaultOpen: false,
            // Default closed
            options: [
              {
                id: "asc",
                handle: "price-asc",
                label: "Lowest Price"
              },
              {
                id: "new",
                handle: "new",
                label: "New"
              },
              {
                id: "desc",
                handle: "price-desc",
                label: "Highest Price"
              }
            ]
          };
        },
        index: {
          rawValue: (item) => ({
            ...item,
            price: parseFloat(item.price),
            brand: item.brand && item.brand !== "" ? item.brand : "zzzz"
          }),
          handle: (item, config2) => {
            return config2.options.map((option) => option.handle);
          }
        },
        query: {
          filter: false,
          sort: (sortHandle, a4, b4) => {
            switch (sortHandle) {
              case "new":
                return new Date(b4.updatedAt) - new Date(a4.updatedAt);
              // Newest First
              case "price-asc":
                return a4.price - b4.price;
              case "price-desc":
                return b4.price - a4.price;
              case "name-asc":
                return a4.title.localeCompare(b4.title);
              case "name-desc":
                return b4.title.localeCompare(a4.title);
              default:
                return 0;
            }
          }
        }
      },
      price: {
        config: () => {
          return {
            icon: "money",
            id: "price",
            handle: "price",
            label: "Price",
            calculateYield: false,
            radio: true,
            defaultOpen: false,
            // Default closed
            options: [
              {
                id: "0-20",
                label: "\xA30 - \xA320",
                handle: "0-20"
              },
              {
                id: "20-50",
                label: "\xA320 - \xA350",
                handle: "20-50"
              },
              {
                id: "50-100",
                label: "\xA350 - \xA3100",
                handle: "50-100"
              },
              {
                id: "100+",
                label: "\xA3100+",
                handle: "100+"
              }
            ]
          };
        },
        index: {
          rawValue: (item) => item.price,
          handle: (rawValue, config2) => {
            const price = parseFloat(rawValue);
            const availableHandles = [];
            config2.options.forEach((option) => {
              if (option.handle.includes("+")) {
                const min = parseInt(option.handle);
                if (price >= min) availableHandles.push(option.handle);
              } else {
                const [min, max] = option.handle.split("-").map(Number);
                if (price >= min && price <= max) availableHandles.push(option.handle);
              }
            });
            return availableHandles;
          }
        },
        query: {
          filter: (item, fieldValue, activeFilter) => {
            if (activeFilter.includes("+")) {
              let val = parseInt(activeFilter);
              return fieldValue >= val;
            }
            let [min, max] = activeFilter.split("-").map(Number);
            return fieldValue >= min && fieldValue <= max;
          }
        }
      },
      categories: {
        config: () => {
          let categories = module_default.store("siteData").getFilterOptions("categories");
          let subFilters = (category) => {
            let fields = category.custom_filters;
            if (fields) {
              let out = [];
              Object.keys(fields).forEach((f4) => {
                let field = fields[f4];
                out.push({
                  id: field.id,
                  handle: field.handle,
                  radio: true,
                  label: field.label,
                  options: field.entries.sort((a4, b4) => a4.value.localeCompare(b4.value)).map((v3) => ({
                    id: v3.id,
                    handle: v3.handle,
                    label: v3.value
                  }))
                });
              });
              return out;
            }
            return false;
          };
          return {
            icon: "tag",
            id: "category",
            handle: "categories",
            label: "Category",
            radio: true,
            calculateYield: true,
            defaultOpen: false,
            // Default closed
            options: categories.sort((a4, b4) => a4.attributes.label.localeCompare(b4.attributes.label)).map((c4) => ({
              id: c4.id,
              label: c4.attributes.label,
              handle: c4.handle,
              metaFilters: subFilters(c4)
            }))
          };
        },
        index: {
          //rawMetaValue: (item, metaFieldId) => item[metaFieldId] || {},
        },
        query: {}
      },
      colours: {
        config: () => {
          let options = module_default.store("siteData").getFilterOptions("colours");
          return {
            icon: "palette",
            handle: "colours",
            label: "Colour",
            id: "colour",
            calculateYield: true,
            defaultOpen: false,
            // Default closed
            options: options.map((o4) => ({
              id: o4.id,
              label: o4.attributes.value,
              slug: o4.attributes.label.toLowerCase().trim().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, ""),
              handle: o4.attributes.value.toLowerCase().replace("#", "")
            }))
          };
        },
        index: {
          //rawMetaValue: (item, metaFieldId) => item[metaFieldId] || {},
        },
        query: {}
      },
      brands: {
        config: () => {
          let brands = module_default.store("siteData").getFilterOptions("brands");
          return {
            icon: "store",
            handle: "brands",
            label: "Brands",
            calculateYield: true,
            defaultOpen: false,
            // Default closed
            options: brands.sort((a4, b4) => a4.attributes.label.localeCompare(b4.attributes.label)).map((b4) => ({
              id: b4.id,
              label: b4.attributes.label,
              handle: b4.handle
            }))
          };
        },
        index: {
          //rawMetaValue: (item, metaFieldId) => item[metaFieldId] || {},
        },
        query: {}
      },
      themes: {
        config: () => {
          let options = module_default.store("siteData").getFilterOptions("themes");
          return {
            icon: "flower",
            handle: "themes",
            label: "Theme",
            id: "theme",
            calculateYield: true,
            defaultOpen: false,
            // Default closed
            options: options.sort((a4, b4) => a4.attributes.label.localeCompare(b4.attributes.label)).map((o4) => ({
              id: o4.id,
              label: o4.attributes.label,
              handle: o4.handle
            }))
          };
        },
        index: {
          //rawMetaValue: (item, metaFieldId) => item[metaFieldId] || {},
        },
        query: {}
      },
      styles: {
        config: () => {
          let options = module_default.store("siteData").getFilterOptions("styles");
          return {
            icon: "bow-tie",
            handle: "styles",
            label: "Style",
            id: "style",
            calculateYield: true,
            defaultOpen: false,
            // Default closed
            options: options.sort((a4, b4) => a4.attributes.label.localeCompare(b4.attributes.label)).map((o4) => ({
              id: o4.id,
              label: o4.attributes.label,
              handle: o4.handle
            }))
          };
        },
        index: {
          //rawMetaValue: (item, metaFieldId) => item[metaFieldId] || {},
        },
        query: {}
      },
      eras: {
        config: () => {
          let options = module_default.store("siteData").getFilterOptions("eras");
          return {
            icon: "calendar",
            handle: "era",
            label: "Era",
            id: "era",
            calculateYield: true,
            defaultOpen: false,
            // Default closed
            options: options.sort((a4, b4) => a4.attributes.label.localeCompare(b4.attributes.label)).map((o4) => ({
              id: o4.id,
              label: o4.attributes.label,
              handle: o4.handle
            }))
          };
        },
        index: {
          //rawMetaValue: (item, metaFieldId) => item[metaFieldId] || {},
        },
        query: {}
      },
      origins: {
        config: () => {
          let options = module_default.store("siteData").getFilterOptions("origins");
          return {
            icon: "globe",
            handle: "origin",
            label: "Origin",
            id: "origin",
            calculateYield: true,
            defaultOpen: false,
            // Default closed
            options: options.sort((a4, b4) => a4.attributes.label.localeCompare(b4.attributes.label)).map((o4) => ({
              id: o4.id,
              label: o4.attributes.label,
              handle: o4.handle
            }))
          };
        },
        index: {
          //rawMetaValue: (item, metaFieldId) => item[metaFieldId] || {},
        },
        query: {}
      }
    }
  };
  var filterConfig_default = config;

  // src/components/alpineFeedFilter/alpineFeedFilter.js
  init(() => {
    module_default.data("alpineFeedFilter", (key) => ({
      $root: null,
      key,
      // String key for accessing the reactive data
      count: 0,
      working: true,
      filterController: null,
      activeFilters: {},
      availableFilters: {},
      flatFilterLookup: {},
      // New: flat lookup table for all filter options
      filterIndex: {},
      // New: pre-indexed item IDs for each filter option
      filters: {},
      dataset: [],
      performanceTime: 0,
      first100Items: [],
      filterResults: [],
      contextual: false,
      // New: contextual filtering flag
      _filterUpdateCount: 0,
      _currentlyActiveFilterType: null,
      // Track the currently active filter type being modified
      _preservedFilterOptions: null,
      // Preserve options for the currently active filter type
      accordionStates: {},
      // New: accordion open/closed states
      filterRules: { disable: [], enable: [], visible: [] },
      // New: editorial filter rules
      persistentFilters: [],
      // New: persistent filters that auto-activate
      visibleFilters: [],
      // New: visible filter rules for UI visibility
      shuffle() {
        this.filterResults = shuffleArray(this.filterResults);
      },
      get filteredItems() {
        return this.filterResults;
      },
      get filterCount() {
        if (!this.activeFilters.selectedIndex) return 0;
        return Object.keys(this.activeFilters.selectedIndex).reduce(
          (acc, k3) => {
            var _a;
            return acc + (((_a = this.activeFilters.selectedIndex[k3]) == null ? void 0 : _a.length) || 0);
          },
          0
        );
      },
      get isFiltered() {
        return this.activeFilters.activeFilters && Object.keys(this.activeFilters.activeFilters).length;
      },
      toggleValueInArray(array, value, radio = false) {
        const index = array.indexOf(value);
        if (radio) {
          return index > -1 ? [] : [value];
        }
        return index > -1 ? array.filter((v3) => v3 !== value) : [...array, value];
      },
      isFilterSelected(handle, value) {
        if (this.activeFilters.index && this.activeFilters.index[handle]) {
          const result2 = this.activeFilters.index[handle].includes(value);
          return !!result2;
        }
        const result = this.activeFilters.selectedFilters[handle] && this.activeFilters.selectedFilters[handle].includes(value);
        return !!result;
      },
      // Legacy method for backward compatibility
      isFilterActive(key2, value) {
        if (this.activeFilters.index && this.activeFilters.index[key2]) {
          return this.activeFilters.index[key2].includes(value);
        }
        return this.activeFilters.activeFilters[key2] && this.activeFilters.activeFilters[key2].includes(value);
      },
      // Check if a filter should show sub-filters (either selected or silently active)
      isFilterActiveForSubFilters(key2, value) {
        if (this.activeFilters.selectedFilters[key2] && this.activeFilters.selectedFilters[key2].includes(value)) {
          return true;
        }
        if (this.activeFilters.silentlyActive[key2] && this.activeFilters.silentlyActive[key2].includes(value)) {
          return true;
        }
        return false;
      },
      // Check if a sub-filter option is selected (requires parent to be active)
      isSubFilterSelected(parentKey, parentValue, subKey, subValue) {
        const parentActive = this.isFilterActiveForSubFilters(parentKey, parentValue);
        if (!parentActive) {
          return false;
        }
        const result = this.activeFilters.index && this.activeFilters.index[subKey] && this.activeFilters.index[subKey].includes(subValue);
        return result;
      },
      // Check if a sub-filter option is selected (handles both explicit and implicit parent activation)
      isSubFilterSelectedWithImplicitParent(parentKey, parentValue, subKey, subValue) {
        const subOptionSelected = this.activeFilters.selectedIndex && this.activeFilters.selectedIndex[subKey] && this.activeFilters.selectedIndex[subKey].includes(subValue);
        if (subOptionSelected) {
          return true;
        }
        return false;
      },
      // Check if a filter key is silently active (should be excluded from URL)
      isSilentFilter(key2) {
        return this.activeFilters.silentlyActive && this.activeFilters.silentlyActive[key2] && this.activeFilters.silentlyActive[key2].length > 0;
      },
      // Check if a filter option should be visible based on visible rules
      isFilterVisible(key2, value) {
        if (this.filterRules.visible && this.filterRules.visible.length > 0) {
          for (let rule of this.filterRules.visible) {
            const parsedRule = this.filterController.parseFilterRulePath(rule);
            if (parsedRule && parsedRule.type === "options" && parsedRule.filterHandle === key2) {
              if (parsedRule.optionHandles && parsedRule.optionHandles.includes(value)) {
                return true;
              }
            }
          }
        }
        return false;
      },
      // Check if a filter option is persistent (can't be deactivated)
      isFilterPersistent(key2, value) {
        if (!this.filterController) return false;
        const filterKey = Object.keys(this.filterController.config.keys || {}).find((key3) => {
          const keyConfig = this.filterController.config.keys[key3];
          if (keyConfig && keyConfig.config) {
            const config2 = typeof keyConfig.config === "function" ? keyConfig.config() : keyConfig.config;
            return config2.handle === key3;
          }
          return false;
        });
        if (filterKey) {
          const keyConfig = this.filterController.config.keys[filterKey];
          const config2 = typeof keyConfig.config === "function" ? keyConfig.config() : keyConfig.config;
          if (config2.options) {
            const option = config2.options.find((opt) => opt.handle === value);
            if (option && option.persistent) return true;
            if (option && option.metaFilters) {
              return option.metaFilters.some(
                (metaFilter) => {
                  var _a;
                  return metaFilter.persistent || ((_a = metaFilter.options) == null ? void 0 : _a.some((subOpt) => subOpt.persistent));
                }
              );
            }
          }
        }
        return false;
      },
      reset() {
        this._currentlyActiveFilterType = null;
        this._preservedFilterOptions = null;
        this.updateHref({});
      },
      // Accordion methods
      toggleAccordion(filterHandle) {
        this.accordionStates[filterHandle] = !this.accordionStates[filterHandle];
      },
      isAccordionOpen(filterHandle) {
        return this.accordionStates[filterHandle] !== false;
      },
      getFilterDefaultOpen(filterHandle) {
        var _a, _b;
        const filterKey = Object.keys(((_b = (_a = this.filterController) == null ? void 0 : _a.config) == null ? void 0 : _b.keys) || {}).find((key2) => {
          const keyConfig = this.filterController.config.keys[key2];
          if (keyConfig && keyConfig.config) {
            const config2 = typeof keyConfig.config === "function" ? keyConfig.config() : keyConfig.config;
            return config2.handle === filterHandle;
          }
          return false;
        });
        if (filterKey) {
          const filterConfig = this.filterController.config.keys[filterKey];
          if (filterConfig && filterConfig.config) {
            const config2 = typeof filterConfig.config === "function" ? filterConfig.config() : filterConfig.config;
            return config2.defaultOpen !== void 0 ? config2.defaultOpen : true;
          }
        }
        return true;
      },
      toggleFilter(key2, value, radio = false) {
        if (this.isFilterActive(key2, value) && this.isFilterPersistent(key2, value)) {
          return;
        }
        if (this._currentlyActiveFilterType && this._currentlyActiveFilterType !== key2) {
          this._preservedFilterOptions = null;
        }
        this._currentlyActiveFilterType = key2;
        this._preservedFilterOptions = this.availableFilters[key2] || null;
        let filters = { ...this.activeFilters.index };
        if (key2) {
          if (!filters[key2]) filters[key2] = [];
          filters[key2] = this.toggleValueInArray(filters[key2], value, radio);
          if (this._currentlyActiveFilterType === key2 && filters[key2].length === 0) {
            this._currentlyActiveFilterType = null;
            this._preservedFilterOptions = null;
          }
        }
        this.updateHref(filters);
      },
      updateHref(filters) {
        let filterSegment = window.location.hash.match("search") ? "search/all" : "filter";
        let base = this.$root.dataset["baseUrl"] || "/";
        base += "/";
        base = base.replace(/\/+/gi, "/");
        let url = `#${base}${filterSegment}/`;
        Object.keys(filters).filter((key2) => !this.isSilentFilter(key2)).forEach((k3) => {
          let query = filters[k3];
          if (query.length) {
            url += `${k3}/`;
            url += `${query.join(",")}/`;
          }
        });
        window.location.hash = url;
        this.$nextTick(() => {
          if (this.$root) {
            const currentScrollY = window.scrollY;
            const elementRect = this.$root.getBoundingClientRect();
            const elementAbsoluteTop = currentScrollY + elementRect.top;
            const scrollThreshold = 50;
            if (currentScrollY > elementAbsoluteTop + scrollThreshold) {
              window.scrollTo(0, elementAbsoluteTop);
            } else {
            }
          }
        });
      },
      init() {
        this.$root = this.$el;
        this.readFilterRules();
        this.contextual = this.$el.hasAttribute("data-contextual");
        if (module_default.store("siteData").loaded) {
          this.initializeWithData();
        } else {
          this.$watch(
            () => module_default.store("siteData").loaded,
            (loaded) => {
              if (loaded) {
                this.initializeWithData();
              }
            }
          );
        }
      },
      readFilterRules() {
        const disableRules = this.$el.getAttribute("data-disable-rules");
        if (disableRules) {
          try {
            this.filterRules.disable = JSON.parse(disableRules);
          } catch (e4) {
          }
        }
        const enableRules = this.$el.getAttribute("data-enable-rules");
        if (enableRules) {
          try {
            this.filterRules.enable = JSON.parse(enableRules);
          } catch (e4) {
          }
        }
        const visibleRules = this.$el.getAttribute("data-visible-rules");
        if (visibleRules) {
          try {
            if (typeof visibleRules === "string") {
              this.filterRules.visible = JSON.parse(visibleRules);
            } else {
              this.filterRules.visible = visibleRules;
            }
          } catch (e4) {
            this.filterRules.visible = [];
          }
        } else {
        }
        const persistentRules = this.$el.getAttribute("data-persistent-rules");
        if (persistentRules) {
          try {
            this.persistentFilters = JSON.parse(persistentRules);
          } catch (e4) {
          }
        }
      },
      async initializeWithData() {
        if (this.key) {
          let feedSource = this.$data[this.key] || [];
          if (feedSource.length) {
            this.setup(feedSource);
          }
          this.$watch(`$data.${this.key}`, (items) => {
            this.setup(items);
          });
        } else {
          if (module_default.store("siteData").getProductsCount() > 0) {
            let products = await module_default.store("siteData").getProductsAsync();
            this.setup(products);
          } else {
            this.$watch(
              () => module_default.store("siteData").productsCount,
              async (count) => {
                if (count > 0) {
                  let products = await module_default.store("siteData").getProductsAsync();
                  this.setup(products);
                }
              }
            );
          }
        }
      },
      setup(items) {
        const dataset = items;
        const filterController = new FilterController_default(filterConfig_default, dataset, this.contextual, this.filterRules, this.persistentFilters);
        this.dataset = dataset;
        this.filterController = filterController;
        this.buildFilterIndex();
        let conf = filterController.getConfig();
        let filters = [];
        Object.keys(conf).forEach((k3) => {
          filters.push(conf[k3].config);
        });
        this.filters = filters;
        this.accordionStates = {};
        this.filters.forEach((filter) => {
          if (filter.handle) {
            this.accordionStates[filter.handle] = this.getFilterDefaultOpen(filter.handle);
          }
        });
        this.activeFilters = filterController.getActiveFilters();
        this.$nextTick(() => {
          this.runFilter();
        });
        this.$watch(
          () => module_default.store("route").href,
          (newHref) => {
            this.working = true;
            this.activeFilters = this.filterController.getActiveFilters();
            this.$nextTick(() => {
              this.runFilter();
              if (this.$root) {
                const currentScrollY = window.scrollY;
                const elementRect = this.$root.getBoundingClientRect();
                const elementAbsoluteTop = currentScrollY + elementRect.top;
                const scrollThreshold = 50;
                if (currentScrollY > elementAbsoluteTop + scrollThreshold) {
                  window.scrollTo(0, elementAbsoluteTop);
                } else {
                }
              }
            });
          }
        );
      },
      runFilter() {
        const start2 = performance.now();
        let filterController = this.filterController;
        this.activeFilters = filterController.getActiveFilters();
        const filteredDataset = filterController.filterDataset();
        this.filterResults = filteredDataset;
        this.first100Items = filteredDataset.slice(0, 100);
        this.count = filteredDataset.length;
        const end = performance.now();
        this.performanceTime = (end - start2).toFixed(3);
        this.working = false;
        this.updateAvailableFilters();
      },
      updateAvailableFilters() {
        var _a;
        if (!this.filterController || !this.filterResults) {
          this.availableFilters = {};
          return;
        }
        this._filterUpdateCount++;
        const start2 = performance.now();
        const availableFilters = {};
        const resultSet = this.filterResults;
        const resultItemIds = new Set(resultSet.map((item) => item.id));
        const filterConfigs = this.filterController.getConfig();
        Object.keys(filterConfigs).forEach((filterKey) => {
          const filterConfig = filterConfigs[filterKey];
          const config2 = filterConfig.config;
          if (config2.calculateYield !== true) {
            return;
          }
          const filterHandle = config2.handle;
          if (this._currentlyActiveFilterType === filterHandle) {
            return;
          }
          const options = config2.options || [];
          const availableOptions = [];
          options.forEach((option) => {
            if (option.disabled) return;
            const parentKey = `${filterHandle}_${option.handle}`;
            const parentIds = this.filterIndex[parentKey] || /* @__PURE__ */ new Set();
            const parentCount = [...parentIds].filter((id) => resultItemIds.has(id)).length;
            let metaFiltersWithCounts = [];
            if (option.metaFilters && Array.isArray(option.metaFilters)) {
              metaFiltersWithCounts = option.metaFilters.map((metaFilter) => {
                if (metaFilter.disabled) return metaFilter;
                const metaOptionsWithCounts = metaFilter.options ? metaFilter.options.map((metaOption) => {
                  if (metaOption.disabled) return metaOption;
                  const metaKey = `${filterHandle}_${option.handle}_${metaFilter.handle}_${metaOption.handle}`;
                  const metaIds = this.filterIndex[metaKey] || /* @__PURE__ */ new Set();
                  const metaCount = [...metaIds].filter((id) => resultItemIds.has(id)).length;
                  return {
                    ...metaOption,
                    count: metaCount,
                    available: metaCount > 0
                  };
                }) : [];
                return {
                  ...metaFilter,
                  options: metaOptionsWithCounts
                };
              });
            }
            if (parentCount > 0) {
              availableOptions.push({
                handle: option.handle,
                label: option.label,
                count: parentCount,
                id: option.id,
                slug: option.slug,
                // For colour swatches
                metaFilters: metaFiltersWithCounts
              });
            } else if (metaFiltersWithCounts.length > 0) {
              availableOptions.push({
                handle: option.handle,
                label: option.label,
                count: parentCount,
                id: option.id,
                slug: option.slug,
                metaFilters: metaFiltersWithCounts
              });
            }
          });
          if (availableOptions.length > 0) {
            availableFilters[filterHandle] = availableOptions;
          }
        });
        const end = performance.now();
        const time2 = (end - start2).toFixed(3);
        const conciseFilters = {};
        Object.keys(availableFilters).forEach((filterHandle) => {
          const options = availableFilters[filterHandle];
          conciseFilters[filterHandle] = {
            count: options.length,
            handles: options.map((opt) => opt.handle),
            options: options.map((opt) => ({
              handle: opt.handle,
              count: opt.count
            }))
          };
        });
        if (this._currentlyActiveFilterType && this._preservedFilterOptions) {
          conciseFilters[this._currentlyActiveFilterType] = this._preservedFilterOptions;
        }
        this.availableFilters = {
          ...conciseFilters,
          _performance: {
            calculationTime: `${time2}ms`,
            totalItems: ((_a = this.dataset) == null ? void 0 : _a.length) || 0,
            filteredItems: resultSet.length,
            updateCount: this._filterUpdateCount
          }
        };
        if (parseFloat(time2) > 10) {
        }
      },
      // Helper method to get available options for a specific filter (for UI)
      getAvailableOptionsForFilter(filterHandle) {
        var _a;
        const conciseData = this.availableFilters[filterHandle];
        if (!conciseData || !conciseData.options) return [];
        const filterConfigs = ((_a = this.filterController) == null ? void 0 : _a.getConfig()) || {};
        const filterKey = Object.keys(filterConfigs).find((key2) => {
          const config2 = filterConfigs[key2].config;
          return config2.handle === filterHandle;
        });
        if (!filterKey) return conciseData.options;
        const originalOptions = filterConfigs[filterKey].config.options || [];
        return conciseData.options.map((opt) => {
          const originalOption = originalOptions.find((o4) => o4.handle === opt.handle);
          return {
            handle: opt.handle,
            label: (originalOption == null ? void 0 : originalOption.label) || opt.handle,
            count: opt.count,
            id: originalOption == null ? void 0 : originalOption.id,
            slug: originalOption == null ? void 0 : originalOption.slug
          };
        });
      },
      // Optimized method to get count for a specific option (avoids multiple lookups)
      getOptionCount(filterHandle, optionHandle) {
        const conciseData = this.availableFilters[filterHandle];
        if (!conciseData || !conciseData.options) return 0;
        const option = conciseData.options.find((opt) => opt.handle === optionHandle);
        return option ? option.count : 0;
      },
      // Optimized method to check if an option is available (avoids multiple lookups)
      isOptionAvailable(filterHandle, optionHandle) {
        const conciseData = this.availableFilters[filterHandle];
        if (!conciseData || !conciseData.options) return false;
        return conciseData.options.some((opt) => opt.handle === optionHandle);
      },
      // Helper method to check if a filter has any available options
      hasAvailableOptions(filterHandle) {
        const conciseData = this.availableFilters[filterHandle];
        return conciseData && conciseData.count > 0;
      },
      // Get count for a metaFilter option
      getMetaOptionCount(filterHandle, optionHandle, metaFilterHandle, metaOptionHandle) {
        const key2 = `${filterHandle}_${optionHandle}_${metaFilterHandle}_${metaOptionHandle}`;
        const metaIds = this.filterIndex[key2] || /* @__PURE__ */ new Set();
        const resultItemIds = new Set(this.filterResults.map((item) => item.id));
        return [...metaIds].filter((id) => resultItemIds.has(id)).length;
      },
      // Check if a metaFilter option is available
      isMetaOptionAvailable(filterHandle, optionHandle, metaFilterHandle, metaOptionHandle) {
        const key2 = `${filterHandle}_${optionHandle}_${metaFilterHandle}_${metaOptionHandle}`;
        const metaIds = this.filterIndex[key2] || /* @__PURE__ */ new Set();
        const resultItemIds = new Set(this.filterResults.map((item) => item.id));
        const count = [...metaIds].filter((id) => resultItemIds.has(id)).length;
        const available = count > 0;
        return available;
      },
      // Method to manually refresh available filters
      refreshAvailableFilters() {
        this.updateAvailableFilters();
      },
      // Build initial index of item IDs for each filter option
      buildFilterIndex() {
        const filterIndex = {};
        const flatLookup = {};
        const filterConfigs = this.filterController.getConfig();
        Object.keys(filterConfigs).forEach((filterKey) => {
          const filterConfig = filterConfigs[filterKey];
          const config2 = filterConfig.config;
          const options = config2.options || [];
          options.forEach((option) => {
            if (option.disabled) return;
            const parentKey = `${config2.handle}_${option.handle}`;
            const parentIds = /* @__PURE__ */ new Set();
            this.filterController.indexedData.forEach(({ original, indexed }) => {
              const indexedValue = indexed[filterKey];
              if (indexedValue) {
                const hasParentOption = Array.isArray(indexedValue) ? indexedValue.includes(option.handle) : indexedValue === option.handle;
                if (hasParentOption) {
                  parentIds.add(original.id);
                }
              }
            });
            filterIndex[parentKey] = parentIds;
            flatLookup[parentKey] = {
              type: "parent",
              filterHandle: config2.handle,
              optionHandle: option.handle,
              label: option.label
            };
            if (option.metaFilters && Array.isArray(option.metaFilters)) {
              option.metaFilters.forEach((metaFilter) => {
                if (metaFilter.disabled) return;
                if (metaFilter.options && Array.isArray(metaFilter.options)) {
                  metaFilter.options.forEach((metaOption) => {
                    if (metaOption.disabled) return;
                    const metaKey = `${config2.handle}_${option.handle}_${metaFilter.handle}_${metaOption.handle}`;
                    const metaIds = /* @__PURE__ */ new Set();
                    this.filterController.indexedData.forEach(({ original, indexed }) => {
                      const indexedValue = indexed[filterKey];
                      if (indexedValue) {
                        const hasParentOption = Array.isArray(indexedValue) ? indexedValue.includes(option.handle) : indexedValue === option.handle;
                        if (hasParentOption) {
                          if (original.custom_filters && original.custom_filters[metaFilter.handle]) {
                            const entries = original.custom_filters[metaFilter.handle].entries || [];
                            const hasMetaOption = entries.some((entry) => entry.handle === metaOption.handle);
                            if (hasMetaOption) {
                              metaIds.add(original.id);
                            }
                          }
                        }
                      }
                    });
                    filterIndex[metaKey] = metaIds;
                    flatLookup[metaKey] = {
                      type: "meta",
                      filterHandle: config2.handle,
                      optionHandle: option.handle,
                      metaFilterHandle: metaFilter.handle,
                      metaOptionHandle: metaOption.handle,
                      label: metaOption.label
                    };
                  });
                }
              });
            }
          });
        });
        this.filterIndex = filterIndex;
        this.flatFilterLookup = flatLookup;
      },
      // Method to get performance stats
      getPerformanceStats() {
        return this.availableFilters._performance || {};
      },
      // Method to test isFilterSelected
      debugIsFilterSelected() {
      },
      // Method to get active filter tags for the tray
      getActiveFilterTags() {
        const tags = [];
        if (!this.activeFilters.selectedIndex) return tags;
        Object.keys(this.activeFilters.selectedIndex).forEach((filterHandle) => {
          var _a;
          const selectedValues = this.activeFilters.selectedIndex[filterHandle];
          if (!selectedValues || selectedValues.length === 0) return;
          const filterConfigs = ((_a = this.filterController) == null ? void 0 : _a.getConfig()) || {};
          const filterKey = Object.keys(filterConfigs).find((key2) => {
            const config2 = filterConfigs[key2].config;
            return config2.handle === filterHandle;
          });
          if (!filterKey) return;
          const filterConfig = filterConfigs[filterKey].config;
          const filterOptions = filterConfig.options || [];
          selectedValues.forEach((value) => {
            const metaFilter = this.findMetaFilterForValue(filterHandle, value, filterOptions);
            if (metaFilter) {
              tags.push({
                id: `${filterHandle}-${metaFilter.parentHandle}-${value}`,
                type: "meta",
                key: metaFilter.parentLabel,
                value: metaFilter.optionLabel,
                filterHandle: metaFilter.parentHandle,
                optionHandle: value
              });
            } else if (filterHandle === "colours") {
              const option = filterOptions.find((opt) => opt.handle === value);
              tags.push({
                id: `${filterHandle}-${value}`,
                type: "colour",
                label: (option == null ? void 0 : option.label) || value,
                hex: (option == null ? void 0 : option.label) || value,
                // The hex value for the swatch
                slug: (option == null ? void 0 : option.slug) || value,
                // The slug for the swatch
                filterHandle,
                optionHandle: value
              });
            } else {
              const option = filterOptions.find((opt) => opt.handle === value);
              tags.push({
                id: `${filterHandle}-${value}`,
                type: "standard",
                label: (option == null ? void 0 : option.label) || value,
                icon: filterConfig.icon || "tag",
                filterHandle,
                optionHandle: value
              });
            }
          });
        });
        Object.keys(this.activeFilters.selectedIndex).forEach((subFilterHandle) => {
          const subValues = this.activeFilters.selectedIndex[subFilterHandle];
          if (!subValues || subValues.length === 0) return;
          const metaFilterInfo = this.findMetaFilterByHandle(subFilterHandle);
          if (metaFilterInfo) {
            subValues.forEach((value) => {
              var _a;
              const subOption = (_a = metaFilterInfo.metaFilter.options) == null ? void 0 : _a.find((opt) => opt.handle === value);
              if (subOption) {
                tags.push({
                  id: `${subFilterHandle}-${value}`,
                  type: "meta",
                  key: metaFilterInfo.metaFilter.label,
                  value: subOption.label,
                  filterHandle: subFilterHandle,
                  optionHandle: value
                });
              }
            });
          }
        });
        return tags;
      },
      // Helper method to find meta filter information
      findMetaFilterForValue(filterHandle, value, filterOptions) {
        var _a;
        for (const option of filterOptions) {
          if (option.metaFilters) {
            for (const metaFilter of option.metaFilters) {
              const metaOption = (_a = metaFilter.options) == null ? void 0 : _a.find((opt) => opt.handle === value);
              if (metaOption) {
                return {
                  parentHandle: option.handle,
                  parentLabel: option.label,
                  optionLabel: metaOption.label
                };
              }
            }
          }
        }
        return null;
      },
      // Helper method to find meta filter by handle
      findMetaFilterByHandle(subFilterHandle) {
        var _a;
        const filterConfigs = ((_a = this.filterController) == null ? void 0 : _a.getConfig()) || {};
        for (const filterKey in filterConfigs) {
          const filterConfig = filterConfigs[filterKey].config;
          const filterOptions = filterConfig.options || [];
          for (const option of filterOptions) {
            if (option.metaFilters) {
              for (const metaFilter of option.metaFilters) {
                if (metaFilter.handle === subFilterHandle) {
                  return {
                    parentHandle: option.handle,
                    parentLabel: option.label,
                    metaFilter
                  };
                }
              }
            }
          }
        }
        return null;
      },
      // Method to remove a filter tag
      removeFilterTag(tag) {
        this._currentlyActiveFilterType = null;
        this._preservedFilterOptions = null;
        this.toggleFilter(tag.filterHandle, tag.optionHandle, false);
      },
      // Method to force recalculation of a specific filter type
      recalculateFilterType(filterHandle) {
        if (!this.filterController || !this.filterResults) {
          return;
        }
        const filterConfigs = this.filterController.getConfig();
        const filterKey = Object.keys(filterConfigs).find((key2) => {
          const config3 = filterConfigs[key2].config;
          return config3.handle === filterHandle;
        });
        if (!filterKey) return;
        const filterConfig = filterConfigs[filterKey];
        const config2 = filterConfig.config;
        if (config2.calculateYield !== true) return;
        this.calculateFilterType(filterKey, filterConfig, config2);
      },
      // Helper method to calculate a specific filter type
      calculateFilterType(filterKey, filterConfig, config2) {
        const resultSet = this.filterResults;
        const options = config2.options || [];
        const availableOptions = [];
        const resultItemIds = new Set(resultSet.map((item) => item.id));
        const optionCounts = {};
        options.forEach((option) => {
          if (option.disabled) return;
          optionCounts[option.handle] = 0;
        });
        this.filterController.indexedData.forEach(({ original, indexed }) => {
          if (!resultItemIds.has(original.id)) return;
          const indexedValue = indexed[filterKey];
          if (!indexedValue) return;
          if (Array.isArray(indexedValue)) {
            indexedValue.forEach((value) => {
              if (optionCounts.hasOwnProperty(value)) {
                optionCounts[value]++;
              }
            });
          } else {
            if (optionCounts.hasOwnProperty(indexedValue)) {
              optionCounts[indexedValue]++;
            }
          }
        });
        options.forEach((option) => {
          if (option.disabled) return;
          const count = optionCounts[option.handle] || 0;
          let metaFiltersWithCounts = [];
          if (option.metaFilters && Array.isArray(option.metaFilters)) {
            metaFiltersWithCounts = option.metaFilters.map((metaFilter) => {
              if (metaFilter.disabled) return metaFilter;
              const metaOptionCounts = {};
              if (metaFilter.options && Array.isArray(metaFilter.options)) {
                metaFilter.options.forEach((metaOption) => {
                  if (metaOption.disabled) return;
                  metaOptionCounts[metaOption.handle] = 0;
                });
                this.filterController.indexedData.forEach(({ original, indexed }) => {
                  if (!resultItemIds.has(original.id)) return;
                  const indexedValue = indexed[filterKey];
                  if (indexedValue) {
                    const hasParentOption = Array.isArray(indexedValue) ? indexedValue.includes(option.handle) : indexedValue === option.handle;
                    if (hasParentOption) {
                      if (original.custom_filters && original.custom_filters[metaFilter.handle]) {
                        const entries = original.custom_filters[metaFilter.handle].entries || [];
                        entries.forEach((entry) => {
                          if (entry.handle && metaOptionCounts.hasOwnProperty(entry.handle)) {
                            metaOptionCounts[entry.handle]++;
                          }
                        });
                      }
                    }
                  }
                });
              }
              const metaOptionsWithCounts = metaFilter.options ? metaFilter.options.map((metaOption) => {
                if (metaOption.disabled) return metaOption;
                const metaCount = metaOptionCounts[metaOption.handle] || 0;
                return {
                  ...metaOption,
                  count: metaCount,
                  available: metaCount > 0
                };
              }) : [];
              return {
                ...metaFilter,
                options: metaOptionsWithCounts
              };
            });
          }
          if (count > 0) {
            availableOptions.push({
              handle: option.handle,
              label: option.label,
              count,
              id: option.id,
              slug: option.slug,
              metaFilters: metaFiltersWithCounts
            });
          } else if (metaFiltersWithCounts.length > 0) {
            availableOptions.push({
              handle: option.handle,
              label: option.label,
              count,
              id: option.id,
              slug: option.slug,
              metaFilters: metaFiltersWithCounts
            });
          }
        });
        if (availableOptions.length > 0) {
          this.availableFilters[config2.handle] = availableOptions;
        } else {
          delete this.availableFilters[config2.handle];
        }
      }
    }));
  });

  // src/components/alpinePaginate/alpinePaginate.js
  init(() => {
    module_default.data("alpinePaginate", (key, perPage) => ({
      key,
      // String key for accessing the reactive data
      paginationSource: [],
      // Initial empty array, to be populated once `key` data updates
      perPage,
      currentPage: 1,
      init() {
        const initialData = this.$data[this.key];
        if (Array.isArray(initialData)) {
          this.paginationSource = initialData;
        } else {
          this.paginationSource = [];
        }
        this.$watch(`$data.${this.key}`, (newItems) => {
          if (Array.isArray(newItems)) {
            this.paginationSource = newItems;
          } else {
            this.paginationSource = [];
          }
          this.resetPagination();
        });
      },
      get paginatedItems() {
        if (!Array.isArray(this.paginationSource)) {
          return [];
        }
        return this.paginationSource.slice(0, this.currentPage * this.perPage);
      },
      get morePages() {
        return this.currentPage * this.perPage < this.paginationSource.length;
      },
      loadMore() {
        this.currentPage += 1;
      },
      resetPagination() {
        this.currentPage = 1;
      },
      destroy() {
      }
    }));
  });

  // src/components/alpineProduct/alpineProduct.js
  init(() => {
    module_default.data("alpineProduct", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/alpineProductGrid/alpineProductGrid.js
  init(() => {
    module_default.data("alpineProductGrid", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/alpineQuickAddProduct/alpineQuickAddProduct.js
  init(() => {
    if (window.alpineQuickAddProductRegistered) {
      return;
    }
    window.alpineQuickAddProductRegistered = true;
    module_default.data("alpineQuickAddProduct", () => ({
      added: false,
      busy: false,
      error: false,
      variantId: false,
      productHandle: null,
      quantity: 1,
      // Adjust quantity as needed
      uniqueId: 0,
      init() {
        this.$nextTick(() => {
          let url = this.$el.dataset.url;
          this.productHandle = url ? url.split("/").pop() : null;
          this.variantId = this.$el.dataset.variantId;
        });
        this.uniqueId = this.generateUniqueId();
      },
      generateUniqueId() {
        const timestamp = Date.now().toString();
        const randomString = Math.random().toString(36).substring(2, 8);
        return `${timestamp}-${randomString}`;
      },
      async checkVariantAvailability() {
        if (this.productHandle) {
          try {
            const response = await fetch(`/products/${this.productHandle}.js`);
            const product = await response.json();
            const variant = product.variants.find((v3) => v3.id === parseInt(this.variantId));
            if (variant) {
              if (!variant.available) {
                this.showErrorState("This item is currently out of stock");
                return false;
              }
            }
            return true;
          } catch (error2) {
            return true;
          }
        } else {
          return true;
        }
      },
      async addToCart() {
        if (!this.variantId) {
          return;
        }
        this.busy = true;
        const isAvailable = await this.checkVariantAvailability();
        if (!isAvailable) {
          return;
        }
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: this.variantId,
            quantity: this.quantity
          })
        }).then((response) => {
          if (!response.ok) {
            this.showErrorState(`Server error: ${response.status}`);
            return;
          }
          return response.json();
        }).then((data3) => {
          if (!data3) return;
          if (data3.status === 422 || data3.status === 400) {
            this.showErrorState(data3.message || "Unable to add item to cart");
            return;
          }
          if (data3.quantity && data3.quantity === 0) {
            this.showErrorState("This item is currently out of stock");
            if (data3.key) {
              this.removeItemFromCart(data3.key);
            }
            return;
          }
          setTimeout(() => {
            this.updateCartCount();
          }, 100);
        }).catch((error2) => {
          this.showErrorState("Network error - please try again");
        });
      },
      showErrorState(message) {
        this.busy = false;
        this.error = true;
        this.added = false;
        setTimeout(() => {
          this.error = false;
        }, 2e3);
      },
      showSuccessState() {
        this.busy = false;
        this.error = false;
        this.added = true;
        setTimeout(() => {
          this.added = false;
        }, 2e3);
      },
      showError(message) {
        let errorContainer = this.$el.querySelector(".quick-add-error");
        if (!errorContainer) {
          errorContainer = document.createElement("div");
          errorContainer.className = "quick-add-error";
          errorContainer.style.cssText = "color: #e74c3c; font-size: 14px; margin-top: 8px; padding: 8px; background: #fdf2f2; border: 1px solid #fecaca; border-radius: 4px;";
          this.$el.appendChild(errorContainer);
        }
        errorContainer.textContent = message;
        errorContainer.style.display = "block";
        setTimeout(() => {
          errorContainer.style.display = "none";
        }, 5e3);
      },
      removeItemFromCart(itemKey) {
        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: 0
          })
        }).then((response) => response.json()).then((data3) => {
          document.dispatchEvent(new CustomEvent("theme:cart:change"));
          document.dispatchEvent(new CustomEvent("theme:cart:reload"));
        }).catch((error2) => {
        });
      },
      updateCartCount() {
        fetch("/cart.js", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        }).then((response) => response.json()).then((cartData) => {
          const ourItem = cartData.items.find((item) => item.variant_id === parseInt(this.variantId));
          if (ourItem) {
            if (ourItem.quantity === 0) {
              this.removeItemFromCart(ourItem.key);
              this.showErrorState("This item is currently out of stock");
              return;
            }
          } else {
            this.showErrorState("Failed to add item to cart");
            return;
          }
          this.showSuccessState();
          document.dispatchEvent(
            new CustomEvent("theme:cart:change", {
              bubbles: true,
              detail: {
                cartCount: cartData.item_count
                // Use the item_count from the cart data
              }
            })
          );
          document.dispatchEvent(
            new CustomEvent("theme:cart:reload", {
              bubbles: true,
              detail: {}
            })
          );
        }).catch((error2) => {
        });
      },
      destroy() {
      }
    }));
  });

  // src/components/alpineRelatedItems/alpineRelatedItems.js
  init(() => {
    module_default.data("alpineRelatedItems", () => ({
      //priority: ["brands", "colours", "filter_category", "price"],
      priority: ["shopifyCategory", "price", "colours"],
      relatedShuffle() {
        let swiperEl = this.$root.querySelector('[x-data="horizontalswiper"]');
        let helperEl = this.$root;
        let swiperComponent = module_default.$data(swiperEl);
        let helperComponent = module_default.$data(helperEl);
        swiperComponent.reset();
        helperComponent.shuffle();
      },
      makeRelatedCriteria(item) {
        if (!item) return null;
        let priority = this.priority;
        let criteria = {};
        priority.forEach((key) => {
          if (item.attributes[key] && Array.isArray(item.attributes[key]) && item.attributes[key].length > 0) {
            criteria[key] = item.attributes[key].map((v3) => ({
              id: v3,
              handle: v3
            }));
          } else {
            if (key === "price") criteria[key] = [item.price];
            if (key === "shopifyCategory") criteria[key] = [item[key]];
          }
        });
        return criteria;
      },
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/alpineTags/alpineTags.js
  init(() => {
    module_default.data("alpineTags", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/basicCollectionList/basicCollectionList.js
  init(() => {
    module_default.data("basicCollectionList", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/bird/bird.js
  init(() => {
    module_default.data("bird", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/collectionLoader/collectionLoader.js
  var collectionLoadQueue = [];
  var isProcessingQueue = false;
  function enqueueCollectionLoad(handle, loadFunction) {
    collectionLoadQueue.push({ handle, loadFunction });
    processLoadQueue();
  }
  function processLoadQueue() {
    if (isProcessingQueue) return;
    isProcessingQueue = true;
    function processNext() {
      if (collectionLoadQueue.length === 0) {
        isProcessingQueue = false;
        return;
      }
      const { handle, loadFunction } = collectionLoadQueue.shift();
      loadFunction(handle).finally(() => {
        requestIdleCallback(processNext, { timeout: 2e3 });
      });
    }
    requestIdleCallback(processNext, { timeout: 2e3 });
  }
  init(() => {
    module_default.data("collectionLoader", () => ({
      collectionHandle: "",
      targetFeedKey: "items",
      loading: true,
      loadedProducts: [],
      allProductIds: [],
      $asyncProducts: [],
      // Reactive property for alpineFeedFilter
      $asyncProductIds: [],
      // Reactive property for alpineFeed
      currentPage: 1,
      hasMorePages: true,
      totalProducts: 0,
      debug: false,
      init() {
        this.collectionHandle = this.$el.dataset.collectionHandle;
        this.targetFeedKey = this.$el.dataset.targetFeed || "items";
        this.debug = this.$el.dataset.debug === "true";
        if (this.debug) {
        }
        if (module_default.store("siteData").loaded) {
          this.startLoading();
        } else {
          this.$watch(
            () => module_default.store("siteData").loaded,
            (newValue) => {
              if (newValue) {
                this.startLoading();
              }
            }
          );
        }
        this.$watch(
          () => module_default.store("siteData").productsCount,
          async (newCount) => {
            if (newCount > 0 && this.allProductIds.length) {
              await this.updateAsyncProducts(!this.loading);
            }
          }
        );
      },
      async startLoading() {
        if (this.debug) {
        }
        await this.loadPage(1);
        if (this.hasMorePages) {
          enqueueCollectionLoad(this.collectionHandle, () => this.loadAllPages());
        } else {
          this.finishLoading();
        }
      },
      async loadPage(page2) {
        try {
          const response = await fetch(
            `/collections/${this.collectionHandle}/products.json?page=${page2}&limit=250`
          );
          const data3 = await response.json();
          if (this.debug) {
          }
          if (page2 === 1) {
            this.totalProducts = data3.products.length;
            this.loadedProducts = [...data3.products];
          } else {
            this.loadedProducts = [...this.loadedProducts, ...data3.products];
          }
          const pageIds = data3.products.map((p4) => p4.id);
          this.allProductIds = [...this.allProductIds, ...pageIds];
          this.hasMorePages = data3.products.length === 250;
          this.currentPage = page2;
          this.updateTargetFeed();
        } catch (error2) {
          console.error("Error loading collection page:", error2);
          this.loading = false;
        }
      },
      async loadAllPages() {
        while (this.hasMorePages) {
          await this.loadPage(this.currentPage + 1);
          await new Promise((resolve) => setTimeout(resolve, 100));
        }
        this.finishLoading();
      },
      async updateAsyncProducts(updateProductIds = false) {
        if (updateProductIds) {
          this.$asyncProductIds = [...this.allProductIds];
        }
        if (!module_default.store("siteData").getProductsCount() || !this.allProductIds.length) {
          this.$asyncProducts = [];
          return;
        }
        let products = await module_default.store("siteData").getProductsAsync();
        const mappedProducts = this.allProductIds.map((id) => {
          return products.find((product) => product.id === id);
        }).filter(Boolean);
        this.$asyncProducts = mappedProducts;
        if (this.debug) {
          if (updateProductIds) {
          }
        }
      },
      updateTargetFeed(updateProductIds = false) {
        if (this.$parent && this.$parent[this.targetFeedKey] !== void 0) {
          this.$parent[this.targetFeedKey] = [...this.allProductIds];
          if (this.debug) {
          }
        }
        this.updateAsyncProducts(updateProductIds);
      },
      finishLoading() {
        this.loading = false;
        if (this.debug) {
        }
        this.updateTargetFeed(true);
      },
      destroy() {
      }
    }));
  });

  // src/components/collectionTabs/collectionTabs.js
  var collectionQueue = [];
  var isProcessing = false;
  function enqueueCollectionLoad2(handle, loadFunction) {
    collectionQueue.push({ handle, loadFunction });
    processQueue();
  }
  function processQueue() {
    if (isProcessing) return;
    isProcessing = true;
    function processNext() {
      if (collectionQueue.length === 0) {
        isProcessing = false;
        return;
      }
      const { handle, loadFunction } = collectionQueue.shift();
      loadFunction(handle).finally(() => {
        requestIdleCallback(processNext, { timeout: 2e3 });
      });
    }
    requestIdleCallback(processNext, { timeout: 2e3 });
  }
  init(() => {
    module_default.data("collectionTabs", (defaultId) => ({
      offset: 0,
      activeTab: "",
      switchTab(tabId) {
        this.activeTab = tabId;
        const $positionRef = this.$el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
        const rect = $positionRef.getBoundingClientRect();
        const offsetTop = rect.top + window.scrollY;
        if (window.scrollY > offsetTop) {
          if (window.lenis) {
            window.lenis.scrollTo(offsetTop, { immediate: true });
          } else {
            window.scrollTo({
              top: offsetTop
            });
          }
        }
      },
      init() {
        this.offset = this.$el.getBoundingClientRect().top;
        this.activeTab = defaultId;
        collectionQueue = [];
        isProcessing = false;
      },
      destroy() {
      }
    }));
    module_default.data("collectionTabsGrid", (collectionHandle) => ({
      collectionHandle,
      loadedProducts: [],
      products: [],
      variantIds: null,
      shouldShuffle: false,
      async parseProducts() {
        if (this.collectionHandle === "all") {
          let products2 = await module_default.store("siteData").getProductsAsync();
          this.products = shuffleArray([...products2]);
          return;
        }
        if (this.variantIds && this.variantIds.length > 0) {
          await this.parseProductsFromVariants();
          return;
        }
        if (!this.loadedProducts.length || !module_default.store("siteData").getProductsCount()) {
          return;
        }
        let products = await module_default.store("siteData").getProductsAsync();
        let parsed = [];
        this.loadedProducts.forEach((p4) => {
          let matches = products.filter(
            (s4) => s4.id === `${p4.id}`
          );
          parsed = parsed.concat(matches);
        });
        if (this.shouldShuffle) {
          this.products = shuffleArray([...parsed]);
        } else {
          this.products = parsed;
        }
      },
      async parseProductsFromVariants() {
        if (!module_default.store("siteData").getProductsCount() || !this.variantIds) {
          return;
        }
        let products = await module_default.store("siteData").getProductsAsync();
        let parsed = [];
        this.variantIds.forEach((variantId) => {
          let matches = products.filter((product) => {
            if (!product.variants) {
              return false;
            }
            const hasVariant = product.variants.some((variant) => {
              return variant.id === variantId;
            });
            return hasVariant;
          });
          parsed = parsed.concat(matches);
        });
        const uniqueProducts = parsed.filter(
          (product, index, self) => index === self.findIndex((p4) => p4.id === product.id)
        );
        if (this.shouldShuffle) {
          this.products = shuffleArray([...uniqueProducts]);
        } else {
          this.products = uniqueProducts;
        }
      },
      init() {
        this.shouldShuffle = this.$el.dataset.shuffle === "true";
        const hasSkus = this.$el.dataset.debugHasSkus === "true";
        const debugIds = this.$el.dataset.debugIds;
        if (hasSkus && debugIds) {
          try {
            this.variantIds = JSON.parse(debugIds);
          } catch (e4) {
            console.error("Error parsing variant IDs:", e4);
          }
        }
        if (collectionHandle === "all") {
          if (module_default.store("siteData").loaded) {
            enqueueCollectionLoad2(
              collectionHandle,
              (handle) => this.loadCollection(handle)
            );
          } else {
            this.$watch(
              () => module_default.store("siteData").loaded,
              (newValue, oldValue) => {
                if (!this.loadedProducts.length) {
                  enqueueCollectionLoad2(
                    collectionHandle,
                    (handle) => this.loadCollection(handle)
                  );
                }
              }
            );
          }
        } else if (this.variantIds && Array.isArray(this.variantIds) && this.variantIds.length > 0) {
          if (module_default.store("siteData").loaded) {
            this.parseProducts();
          } else {
            this.$watch(
              () => module_default.store("siteData").loaded,
              (newValue, oldValue) => {
                if (newValue) {
                  this.parseProducts();
                }
              }
            );
          }
        } else {
          if (module_default.store("siteData").loaded) {
            if (!this.loadedProducts.length) {
              enqueueCollectionLoad2(
                collectionHandle,
                (handle) => this.loadCollection(handle)
              );
            }
          } else {
            this.$watch(
              () => module_default.store("siteData").loaded,
              (newValue, oldValue) => {
                if (!this.loadedProducts.length) {
                  enqueueCollectionLoad2(
                    collectionHandle,
                    (handle) => this.loadCollection(handle)
                  );
                }
              }
            );
          }
        }
        return;
        if (module_default.store("siteData").getProductsCount() > 0) {
          this.parseProducts();
        }
        this.$watch(
          () => module_default.store("siteData").productsCount,
          async (newValue, oldValue) => {
            if (newValue > 0) {
              await this.parseProducts();
            }
          }
        );
        if (collectionHandle !== "all") {
          enqueueCollectionLoad2(
            collectionHandle,
            (handle) => this.loadCollection(handle)
          );
        }
      },
      async loadCollection(collectionHandle2) {
        if (collectionHandle2 === "all") {
          this.parseProducts();
          return;
        }
        const response = await fetch(
          `/collections/${collectionHandle2}/products.json?limit=250`
        );
        const data3 = await response.json();
        this.loadedProducts = data3.products;
        this.parseProducts();
      }
    }));
  });

  // src/components/content/content.js
  init(() => {
    module_default.data("content", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/counter/counter.js
  var Counter = class extends HTMLElement {
    connectedCallback() {
      this.innerHTML = `
    <div x-data="counter">
        <h1>Component: <div x-text="count"></div></h1>
        <div>
            {{ content }}
        </div>
        <button @click="count++">Click here</button>
    </div>
    `.replace("{{ content }}", this.innerHTML);
    }
  };
  customElements.define("x-counter", Counter);
  init(() => {
    module_default.data("counter", () => ({
      count: 5,
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/dataIndex/dataIndex.js
  init(() => {
    module_default.data("dataIndex", () => ({
      showAll: false,
      indexData: null,
      globalFilters: null,
      tiles: [],
      loading: false,
      selectedFilterKey: null,
      groupedTiles: {},
      get filters() {
        return this.showAll ? this.indexData.filters : this.globalFilters;
      },
      classes() {
        return ``;
      },
      init() {
        this.fetchData();
        this.$watch("showAll", () => {
          if (this.selectedFilterKey) {
            this.applyFilter(this.selectedFilterKey);
          }
        });
      },
      fetchData() {
        this.loading = true;
        fetch(window.JSON_URL_INDEX).then((response) => response.json()).then((data3) => {
          this.indexData = data3;
          let parsedFilters = data3.filters;
          let globalFilters = {};
          Object.keys(parsedFilters).forEach((k3) => {
            let filterOptions = data3.globalFilters[k3].map(
              (id) => parsedFilters[k3].entries.find((e4) => e4.id === id)
            );
            globalFilters[k3] = {
              ...parsedFilters[k3],
              entries: filterOptions
            };
          });
          this.globalFilters = globalFilters;
          this.tiles = data3.products;
          this.loading = false;
        }).catch((error2) => {
          console.error("Error fetching SKUs:", error2);
          this.loading = false;
        });
      },
      getIndexItems({ key, id }) {
        var _a;
        const variantIds = ((_a = this.indexData.index[key]) == null ? void 0 : _a[id]) || [];
        const entryTiles = variantIds.map(
          (variantId) => this.indexData.products.find((sku) => sku.variantId === variantId)
        ).filter((sku) => sku);
        return entryTiles;
      },
      toggleFilter(currentActiveFilters, key, toggle) {
        if (!currentActiveFilters[key]) {
          currentActiveFilters[key] = [];
        }
        const index = currentActiveFilters[key].indexOf(toggle);
        if (index === -1) {
          currentActiveFilters[key].push(toggle);
        } else {
          currentActiveFilters[key].splice(index, 1);
        }
        if (currentActiveFilters[key].length === 0) {
          delete currentActiveFilters[key];
        }
      },
      filterItems(items, activeFilters) {
        if (Object.keys(activeFilters).length === 0 || Object.values(activeFilters).every((arr) => arr.length === 0)) {
          return items;
        }
        return items.filter((item) => {
          return Object.keys(activeFilters).every((key) => {
            if (!item.custom_filters[key]) {
              return false;
            }
            const entries = item.custom_filters[key].entries;
            return activeFilters[key].some(
              (filterValue) => entries.some((entry) => entry.handle === filterValue)
            );
          });
        });
      },
      applyFilter(filterKey) {
        var _a;
        this.selectedFilterKey = filterKey;
        const filterEntries = ((_a = this.filters[filterKey]) == null ? void 0 : _a.entries) || [];
        let groupedResults = {};
        filterEntries.forEach((entry) => {
          var _a2;
          const metaobjectId = entry.id;
          let entryTiles = [];
          const variantIds = ((_a2 = this.indexData.index[filterKey]) == null ? void 0 : _a2[metaobjectId]) || [];
          let d4 = { ...entry };
          delete d4.entries;
          if (variantIds.length) {
            groupedResults[entry.attributes.label] = {
              key: filterKey,
              data: d4,
              entries: entryTiles,
              variantIds
            };
          }
        });
        this.groupedTiles = groupedResults;
      },
      destroy() {
      }
    }));
  });

  // src/components/example/example.js
  init(() => {
    module_default.data("example", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/giftWrap/giftWrap.js
  init(() => {
    module_default.data("giftWrap", () => ({
      // State
      selectedVariant: null,
      giftMessage: "",
      isUpdating: false,
      hasGiftWrapInCart: false,
      lastAppliedVariant: null,
      lastAppliedMessage: null,
      init() {
        if (!this.isElementVisible()) {
          return;
        }
        try {
          this.initializeState();
          this.setupEventListeners();
          setTimeout(() => {
            this.hideGiftWrapItems();
          }, 200);
        } catch (error2) {
        }
      },
      isElementVisible() {
        const rect = this.$el.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      },
      initializeState() {
        const selectedRadio = this.$el.querySelector("[data-gift-wrap-variant-radio]:checked");
        if (selectedRadio) {
          this.selectedVariant = selectedRadio.value;
        }
        const messageField = this.$el.querySelector("[data-gift-message-attribute]");
        if (messageField) {
          this.giftMessage = messageField.value || "";
        }
        this.hasGiftWrapInCart = this.checkGiftWrapInCart();
        if (this.hasGiftWrapInCart && this.selectedVariant !== "none") {
          this.lastAppliedVariant = this.selectedVariant;
          this.lastAppliedMessage = this.giftMessage;
        }
        this.updateMessageVisibility();
        this.updateAccordionTitle();
      },
      setupEventListeners() {
        this.$el.addEventListener("change", (e4) => {
          if (e4.target.matches("[data-gift-wrap-variant-radio]")) {
            this.handleVariantChange(e4);
          }
        });
        this.$el.addEventListener("input", (e4) => {
          if (e4.target.matches("[data-gift-message-attribute]")) {
            this.giftMessage = e4.target.value;
          }
        });
        this.$el.addEventListener("blur", (e4) => {
          if (e4.target.matches("[data-gift-message-attribute]")) {
            this.handleMessageBlur(e4);
          }
        }, true);
        document.addEventListener("theme:cart:update", () => {
          this.refreshGiftWrapState();
        });
        document.addEventListener("theme:cart:reload", () => {
          this.hideGiftWrapItems();
        });
        document.addEventListener("theme:cart-drawer:open", () => {
          setTimeout(() => {
            if (this.isElementVisible()) {
              this.initializeState();
              this.hideGiftWrapItems();
            }
          }, 100);
        });
      },
      handleVariantChange(event) {
        this.selectedVariant = event.target.value;
        this.updateMessageVisibility();
        this.updateAccordionTitle();
        this.autoUpdateGiftWrap();
      },
      handleMessageBlur(event) {
        this.giftMessage = event.target.value;
        if (this.selectedVariant === "none") {
          return;
        }
        this.autoUpdateGiftWrap();
      },
      shouldApplyUpdate() {
        if (this.selectedVariant === "none") {
          return this.hasGiftWrapInCart;
        }
        return !this.hasGiftWrapInCart || this.selectedVariant !== this.lastAppliedVariant || this.giftMessage !== this.lastAppliedMessage;
      },
      updateMessageVisibility() {
        const messageContainer = this.$el.querySelector("[data-gift-wrap-message]");
        if (messageContainer) {
          if (this.selectedVariant === "none") {
            messageContainer.style.display = "none";
          } else {
            messageContainer.style.display = "block";
          }
        }
      },
      updateAccordionTitle() {
        const summaryText = this.$el.querySelector(".gift-wrap__summary-text");
        if (!summaryText) return;
        if (this.selectedVariant === "none") {
          summaryText.textContent = "Add gift wrapping";
        } else {
          const selectedRadio = this.$el.querySelector(`[data-gift-wrap-variant-radio][value="${this.selectedVariant}"]`);
          if (selectedRadio) {
            const label = selectedRadio.nextElementSibling;
            const name = label.querySelector(".gift-wrap__variant-name").textContent;
            const price = label.querySelector(".gift-wrap__variant-price").textContent;
            summaryText.textContent = `Gift wrapping: ${name} \u2014 ${price}`;
          }
        }
      },
      async autoUpdateGiftWrap() {
        if (this.isUpdating || !this.shouldApplyUpdate()) {
          return;
        }
        await this.updateGiftWrap();
      },
      async updateGiftWrap() {
        this.isUpdating = true;
        this.$el.classList.add("giftWrap--updating");
        try {
          if (this.selectedVariant === "none") {
            await this.removeGiftWrap();
            this.hasGiftWrapInCart = false;
            this.lastAppliedVariant = null;
            this.lastAppliedMessage = null;
          } else {
            await this.addGiftWrap(this.selectedVariant, this.giftMessage);
            this.hasGiftWrapInCart = true;
            this.lastAppliedVariant = this.selectedVariant;
            this.lastAppliedMessage = this.giftMessage;
          }
          await this.updateCartPrices();
          this.updateAccordionTitle();
        } catch (error2) {
        } finally {
          this.isUpdating = false;
          this.$el.classList.remove("giftWrap--updating");
        }
      },
      async addGiftWrap(variantId, giftMessage) {
        await this.removeGiftWrap();
        if (!variantId) {
          return;
        }
        await new Promise((resolve) => setTimeout(resolve, 100));
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              "Gift label message": giftMessage
            }
          })
        });
        if (!response.ok) {
          throw new Error("Failed to add gift wrap to cart");
        }
      },
      async removeGiftWrap() {
        const cartResponse = await fetch("/cart.js");
        const cart = await cartResponse.json();
        const giftWrapItems = cart.items.filter(
          (item) => item.properties && (item.properties["Gift label message"] !== void 0 || item.properties["Gift wrap message"] !== void 0)
        );
        for (const giftWrapItem of giftWrapItems) {
          const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: giftWrapItem.key,
              quantity: 0,
              properties: {}
              // Explicitly clear properties
            })
          });
          if (!response.ok) {
          }
        }
        setTimeout(async () => {
          const verifyResponse = await fetch("/cart.js");
          const verifyCart = await verifyResponse.json();
          const remainingGiftWrapItems = verifyCart.items.filter(
            (item) => item.properties && (item.properties["Gift label message"] !== void 0 || item.properties["Gift wrap message"] !== void 0)
          );
          for (const item of remainingGiftWrapItems) {
            if (item.quantity === 0) {
              await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  id: item.key,
                  quantity: 0,
                  properties: {}
                })
              });
            }
          }
        }, 200);
      },
      async updateCartPrices() {
        try {
          const cartResponse = await fetch("/cart.js");
          const cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent("theme:cart:change", {
            bubbles: true,
            detail: {
              cartCount: cart.item_count
            }
          }));
          document.dispatchEvent(new CustomEvent("theme:cart:reload", {
            bubbles: true,
            detail: {}
          }));
          setTimeout(() => {
            this.hideGiftWrapItems();
          }, 100);
        } catch (error2) {
        }
      },
      checkGiftWrapInCart() {
        try {
          const cartDrawer = document.querySelector("[data-gift-wrap-product-id]");
          if (!cartDrawer) return false;
          const giftWrapProductId = cartDrawer.getAttribute("data-gift-wrap-product-id");
          if (!giftWrapProductId) return false;
          const cartItems = cartDrawer.querySelectorAll(".cart__item[data-item-product-id]");
          for (const item of cartItems) {
            const itemProductId = item.getAttribute("data-item-product-id");
            if (itemProductId === giftWrapProductId) {
              return true;
            }
          }
          return false;
        } catch (error2) {
          return false;
        }
      },
      hideGiftWrapItems() {
        try {
          const cartDrawer = document.querySelector("[data-gift-wrap-product-id]");
          if (cartDrawer) {
            const giftWrapProductId = cartDrawer.getAttribute("data-gift-wrap-product-id");
            const cartItems = cartDrawer.querySelectorAll(".cart__item[data-item-product-id]");
            cartItems.forEach((item) => {
              const itemProductId = item.getAttribute("data-item-product-id");
              if (itemProductId === giftWrapProductId) {
                item.style.display = "none";
              }
            });
          }
        } catch (error2) {
        }
      },
      async refreshGiftWrapState() {
        setTimeout(() => {
          this.hasGiftWrapInCart = this.checkGiftWrapInCart();
          if (!this.hasGiftWrapInCart) {
            this.lastAppliedVariant = null;
            this.lastAppliedMessage = null;
          }
        }, 100);
      },
      destroy() {
      }
    }));
  });

  // src/components/headerLinks/headerLinks.js
  init(() => {
    module_default.data("headerLinks", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/helper/helper.js
  init(() => {
    module_default.data("helper", () => ({
      prefilter: null,
      ignore: [],
      query: {},
      items: [],
      results: [],
      filters: {},
      // Local storage state management
      storageKey: "helper-filter-state",
      stateTimer: null,
      stateExpiry: 5 * 60 * 1e3,
      // 5 minutes in milliseconds
      restoringState: false,
      setup(items) {
        this.$nextTick(() => {
          this.ignore = this.$el.dataset.ignore || [];
          let prefilter = this.$el.dataset.prefilter ? JSON.parse(this.$el.dataset.prefilter) : null;
          let prefilterPriority = this.$el.dataset.prefilterPriority ? JSON.parse(this.$el.dataset.prefilterPriority) : null;
          this.prefilter = prefilter;
          this.items = items;
          let finalItems = items;
          this.prefilter = prefilter;
          let currentQuery = {};
          let bestResults = [];
          let bestQuery = {};
          if (prefilter) {
            if (!prefilterPriority) prefilterPriority = Object.keys(prefilter);
            for (let i4 = 0; i4 < prefilterPriority.length; i4++) {
              const key = prefilterPriority[i4];
              if (!prefilter[key]) continue;
              currentQuery[key] = prefilter[key];
              const results2 = this.updateResults(currentQuery);
              if (results2.length) {
                bestResults = results2;
                bestQuery = { ...currentQuery };
              } else {
                delete currentQuery[key];
                break;
              }
            }
            this.prefilter = bestQuery;
            finalItems = prefilter ? bestResults : items;
            this.items = finalItems;
          }
          if (this.restoringState) {
            this.results = [];
          } else {
            if (this.$el.dataset.autosuggest) {
              this.suggest();
            } else {
              this.results = finalItems;
            }
          }
        });
      },
      shuffle() {
        this.results = shuffleArray(this.results);
      },
      updateQuery({ name, selection }, refresh = true) {
        if (name === "categories") {
          this.resetFiltersExceptCategory();
        }
        this.query[name] = selection;
        this.previousDisabledStates = { ...this.disabledStates };
        this.disabledOptionsCache.clear();
        this.disabledStates = {};
        if (refresh) this.updateResults();
        this.saveStateToLocalStorage();
      },
      // Reset all filters except category when category changes
      resetFiltersExceptCategory() {
        this.query.styles = [];
        this.query.colours = [];
        this.query.prices = [];
        this.query.specialFeatures = [];
        this.query.themes = [];
        if (this.query.categories && this.query.categories.length > 0) {
          const categoryHandle = this.query.categories[0].handle;
          const allowedFields = this.allowedCustomFields[categoryHandle] || [];
          allowedFields.forEach((field) => {
            this.query[field] = [];
          });
        }
      },
      updateResults(simulateQuery = null) {
        var _a;
        let results2 = this.items;
        let query = simulateQuery ? simulateQuery : this.query;
        if (query["categories"] && query["categories"].length) {
          results2 = results2.filter((i4) => {
            return i4.attributes.categories && i4.attributes.categories.some(
              (id) => query["categories"].some((c4) => c4.id == id)
            );
          });
        }
        if (query["filter_category"] && query["filter_category"].length) {
          results2 = results2.filter((i4) => {
            return i4.attributes.categories && i4.attributes.categories.some(
              (id) => query["filter_category"].some((c4) => c4.id == id)
            );
          });
        }
        if (query["colours"] && query["colours"].length) {
          results2 = results2.filter((i4) => {
            return i4.attributes.colours && i4.attributes.colours.some(
              (id) => query["colours"].some((c4) => c4.id == id)
            );
          });
        }
        if (query["styles"] && query["styles"].length) {
          results2 = results2.filter((i4) => {
            return i4.attributes.styles && i4.attributes.styles.some(
              (id) => query["styles"].some((c4) => c4.id == id)
            );
          });
        }
        if (query["brands"] && query["brands"].length) {
          results2 = results2.filter((i4) => {
            return i4.attributes.brands && i4.attributes.brands.some(
              (id) => query["brands"].some((b4) => b4.id == id)
            );
          });
        }
        if ((_a = query["shopifyCategory"]) == null ? void 0 : _a.length) {
          results2 = results2.filter(
            (i4) => query["shopifyCategory"].some(({ id }) => {
              let isMatch = i4.shopifyCategory.id === id;
              return isMatch;
            })
          );
        }
        if (query["prices"] && query["prices"].length) {
          results2 = results2.filter((item) => {
            const itemPrice = parseFloat(item.price);
            return query["prices"].some((priceBand) => {
              const bandKey = typeof priceBand === "object" ? priceBand.value || priceBand.id : priceBand;
              return this.isInPriceBand(itemPrice, bandKey);
            });
          });
        }
        if (query.specialFeatures && query.specialFeatures.length) {
          results2 = results2.filter((item) => {
            return query.specialFeatures.some((feature) => {
              return this.hasSpecialFeature(item, feature);
            });
          });
        }
        if (query.themes && query.themes.length) {
          const themeIds = query.themes.map((t3) => {
            if (typeof t3 === "object" && t3.id) {
              return t3.id;
            }
            return null;
          }).filter((id) => id);
          results2 = results2.filter((item) => {
            const hasTheme = item.attributes.themes && item.attributes.themes.some(
              (themeId) => themeIds.includes(themeId)
            );
            return hasTheme;
          });
        }
        if (this.query.categories && this.query.categories.length === 1) {
          const categoryHandle = this.query.categories[0].handle;
          const allowedFields = this.allowedCustomFields[categoryHandle] || [];
          allowedFields.forEach((field) => {
            if (query[field] && query[field].length) {
              results2 = results2.filter((item) => {
                return this.hasCustomFilterValue(item, field, query[field]);
              });
            }
          });
        }
        if (this.ignore.length) {
          results2 = results2.filter((item) => !this.ignore.includes(item.id));
        }
        if (simulateQuery) {
          return results2;
        } else {
          this.results = shuffleArray(results2);
        }
      },
      suggestionLimits: {
        colours: 3
        // Limit of 3 suggestions for colours
        // more limits...
      },
      resultsUrl() {
        let url = ["#/search/all"];
        if (this.query.categories && this.query.categories.length) {
          url.push(
            `categories/${this.query.categories.map((i4) => i4.handle).join(",")}`
          );
        }
        if (this.query.styles && this.query.styles.length) {
          url.push(`styles/${this.query.styles.map((i4) => i4.handle).join(",")}`);
        }
        if (this.query.colours && this.query.colours.length) {
          url.push(
            `colours/${this.query.colours.map((i4) => {
              var _a, _b;
              const hexCode = (_b = (_a = i4.value) == null ? void 0 : _a.attributes) == null ? void 0 : _b.value;
              return hexCode ? hexCode.replace("#", "") : i4.handle;
            }).join(",")}`
          );
        }
        if (this.query.prices && this.query.prices.length) {
          url.push(
            `price/${this.query.prices.map((i4) => {
              const bandKey = typeof i4 === "object" ? i4.value || i4.id : i4;
              return bandKey;
            }).join(",")}`
          );
        }
        if (this.query.specialFeatures && this.query.specialFeatures.length) {
          this.query.specialFeatures.forEach((feature) => {
            if (typeof feature === "object" && feature.filterHandle && feature.filterValue) {
              url.push(`${feature.filterHandle}/${feature.filterValue}`);
            } else {
              const featureHandle = typeof feature === "object" ? feature.value || feature.id : feature;
              url.push(featureHandle);
            }
          });
        }
        if (this.query.themes && this.query.themes.length) {
          url.push(`themes/${this.query.themes.map((i4) => i4.handle).join(",")}`);
        }
        if (this.query.categories && this.query.categories.length === 1) {
          let customFields = this.customFields();
          customFields.forEach((f4) => {
            if (this.query[f4.handle]) {
              url.push(
                `${f4.handle}/${this.query[f4.handle].map((i4) => i4.handle).join(",")}`
              );
            }
          });
        }
        return url.join("/") + "/";
      },
      suggest() {
        this.query = {};
        let suggestionTypes = [
          {
            weighting: 2,
            suggestions: ["colours"]
          },
          {
            weighting: 2,
            suggestions: ["styles"]
          },
          {
            weighting: 1,
            suggestions: ["colours", "styles"]
          },
          {
            weighting: 1,
            suggestions: ["categories", "colours"]
          },
          {
            weighting: 1,
            suggestions: ["categories", "styles"]
          }
        ];
        if (!this.hasColorOptions()) {
          suggestionTypes = suggestionTypes.filter(
            (type) => !type.suggestions.includes("colours")
          );
        }
        function getWeightedRandom(items) {
          let totalWeight = items.reduce((sum, item) => sum + item.weighting, 0);
          let randomNum = Math.random() * totalWeight;
          for (let i4 = 0; i4 < items.length; i4++) {
            if (randomNum < items[i4].weighting) {
              return items[i4].suggestions;
            }
            randomNum -= items[i4].weighting;
          }
        }
        let selectedSuggestionType = getWeightedRandom(suggestionTypes);
        let firstFilterKey = selectedSuggestionType[0];
        let simulateQuery = {};
        const maxLimit = this.suggestionLimits[firstFilterKey] || 1;
        const limit = this.getRandomNumber(1, maxLimit);
        let initialValues = this.getRandomItems(
          this.getDropdownOptions(firstFilterKey),
          1
        );
        simulateQuery[firstFilterKey] = initialValues;
        let results2 = this.updateResults(simulateQuery);
        this.updateQuery(
          {
            name: firstFilterKey,
            selection: initialValues
          },
          false
        );
        selectedSuggestionType.shift();
        let possibleValues = {};
        let filterSuggestions = selectedSuggestionType;
        results2.forEach((r4) => {
          filterSuggestions.forEach((a4) => {
            if (possibleValues[a4]) {
              possibleValues[a4] = Array.from(
                new Set(possibleValues[a4].concat(r4.attributes[a4]))
              );
            } else {
              possibleValues[a4] = Array.isArray(r4.attributes[a4]) ? Array.from(new Set(r4.attributes[a4])) : [r4.attributes[a4]];
            }
          });
        });
        Object.keys(possibleValues).forEach((key) => {
          let possibles = this.getDropdownOptions(key).filter(
            (o4) => possibleValues[key].includes(o4.id)
          );
          const maxLimit2 = this.suggestionLimits[key] || 2;
          const limit2 = this.getRandomNumber(1, maxLimit2);
          let suggestions = this.getRandomItems(possibles, limit2);
          if (suggestions.length) {
            this.updateQuery(
              {
                name: key,
                selection: suggestions
              },
              false
            );
          }
        });
        this.updateResults();
        this.saveStateToLocalStorage();
        return;
        for (const key in this.filters) {
          if (this.filters.hasOwnProperty(key)) {
            const maxLimit2 = this.suggestionLimits[key] || 1;
            const limit2 = this.getRandomNumber(1, maxLimit2);
            let suggestions = this.getRandomItems(
              this.getDropdownOptions(key),
              limit2
            );
            if (suggestions.length) {
              this.updateQuery(
                {
                  name: key,
                  selection: suggestions
                },
                false
              );
            }
          }
        }
        this.updateResults();
      },
      getRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      getRandomItems(array, limit) {
        const result = [];
        const usedIndices = /* @__PURE__ */ new Set();
        while (result.length < limit && result.length < array.length) {
          const randomIndex = Math.floor(Math.random() * array.length);
          if (!usedIndices.has(randomIndex)) {
            usedIndices.add(randomIndex);
            result.push(array[randomIndex]);
          }
        }
        return result;
      },
      hasIllustration() {
        return this.query.categories && this.query.categories.length && this.query.categories[0].value;
      },
      illustration() {
        if (this.hasIllustration) {
          return this.query.categories[0].value.attributes.illustration.url;
        } else {
          return "";
        }
      },
      hasCustomFields() {
        return this.query && this.query.categories && this.query.categories.length === 1 && this.query.categories[0].value.custom_filters;
      },
      // Check if current category should show style options
      hasStyleOptions() {
        if (!this.query.categories || this.query.categories.length === 0) {
          return true;
        }
        const categoryHandle = this.query.categories[0].handle;
        const config2 = this.categoryConfig[categoryHandle];
        return config2 ? config2.style : true;
      },
      // Check if current category should show price options
      hasPriceOptions() {
        if (!this.query.categories || this.query.categories.length === 0) {
          return false;
        }
        const categoryHandle = this.query.categories[0].handle;
        const config2 = this.categoryConfig[categoryHandle];
        return config2 ? config2.price : false;
      },
      // Check if current category should show special features
      hasSpecialFeatures() {
        if (!this.query.categories || this.query.categories.length === 0) {
          return false;
        }
        const categoryHandle = this.query.categories[0].handle;
        const config2 = this.categoryConfig[categoryHandle];
        return config2 && config2.feature && config2.feature.length > 0;
      },
      // Check if current category should show theme options
      hasThemeOptions() {
        if (!this.query.categories || this.query.categories.length === 0) {
          return false;
        }
        const categoryHandle = this.query.categories[0].handle;
        const config2 = this.categoryConfig[categoryHandle];
        return config2 ? config2.theme : false;
      },
      // Check if current category should show colour options
      hasColorOptions() {
        if (!this.query.categories || this.query.categories.length === 0) {
          return true;
        }
        const categoryHandle = this.query.categories[0].handle;
        const config2 = this.categoryConfig[categoryHandle];
        return config2 ? config2.colour !== false : true;
      },
      // Get special features options for current category
      getSpecialFeaturesOptions() {
        if (!this.query.categories || this.query.categories.length === 0) {
          return [];
        }
        const categoryHandle = this.query.categories[0].handle;
        const config2 = this.categoryConfig[categoryHandle];
        if (!config2 || !config2.feature) {
          return [];
        }
        return this.getDropdownOptionsForType("specialFeatures");
      },
      // Check if a filter option would yield results with current query
      wouldOptionYieldResults(type, option) {
        const cacheKey = `${type}-${option.id || option.handle}-${JSON.stringify(this.query)}`;
        if (this.disabledOptionsCache.has(cacheKey)) {
          return this.disabledOptionsCache.get(cacheKey);
        }
        const simulatedQuery = { ...this.query };
        if (type === "prices") {
          simulatedQuery.prices = [option];
        } else if (type === "themes") {
          simulatedQuery.themes = [option];
        } else if (type === "styles") {
          simulatedQuery.styles = [option];
        } else if (type === "colours") {
          simulatedQuery.colours = [option];
        } else if (type === "specialFeatures") {
          simulatedQuery.specialFeatures = [option];
        } else {
          simulatedQuery[type] = [option];
        }
        const results2 = this.updateResults(simulatedQuery);
        const wouldYield = results2 && results2.length > 0;
        this.disabledOptionsCache.set(cacheKey, wouldYield);
        return wouldYield;
      },
      // Get price band options
      getPriceBandOptions() {
        return this.getDropdownOptionsForType("prices");
      },
      // Check if item is in price band
      isInPriceBand(price, bandKey) {
        const band = this.priceBands[bandKey];
        if (!band) return false;
        return price >= band.min && price <= band.max;
      },
      // Check if item has special feature
      hasSpecialFeature(item, featureOption) {
        let filterHandle, filterValue;
        if (typeof featureOption === "string") {
          filterHandle = featureOption;
          filterValue = "yes";
        } else {
          filterHandle = featureOption.filterHandle || featureOption.handle;
          filterValue = featureOption.filterValue || featureOption.value;
        }
        if (!item.custom_filters || !item.custom_filters[filterHandle]) {
          return false;
        }
        const entries = item.custom_filters[filterHandle].entries || [];
        return entries.some((entry) => entry.handle === filterValue);
      },
      // Check if item has custom filter value
      hasCustomFilterValue(item, fieldHandle, selectedValues) {
        if (!item.custom_filters || !item.custom_filters[fieldHandle]) {
          return false;
        }
        const fieldEntries = item.custom_filters[fieldHandle].entries || [];
        return selectedValues.some((selectedValue) => {
          const valueHandle = typeof selectedValue === "object" ? selectedValue.handle : selectedValue;
          return fieldEntries.some((entry) => entry.handle === valueHandle);
        });
      },
      allowedCustomFields: {
        "fountain-pens": [],
        ornaments: [],
        "pens-pencils": ["type"],
        "greeting-cards": ["occasion"],
        notebooks: []
      },
      // Category configuration for style/price options and templates
      categoryConfig: {
        "fountain-pens": {
          style: true,
          price: false,
          theme: false,
          feature: [
            {
              label: "Gold Nib",
              handle: "gold-nib",
              value: "yes"
            },
            {
              label: "Vacuum/Piston Filler",
              handle: "refill",
              value: "pistonvacuum"
            },
            {
              label: "Pocket Size",
              handle: "special-characteristics",
              value: "pocket"
            }
          ],
          template: "Find me Fountain Pens in this style with this special feature in any colour"
        },
        "pens-pencils": {
          style: true,
          price: false,
          theme: false,
          // Custom style options for pens-pencils (overrides global styles)
          styles: [
            { handle: "modern", label: "Modern" },
            { handle: "traditional", label: "Traditional" },
            { handle: "luxury", label: "Luxury" }
          ],
          template: "Find me pens and pencils of this type, in this style, in any colour"
        },
        "notebooks": {
          style: true,
          price: false,
          theme: false,
          feature: [
            {
              label: "Fountain Pen Friendly",
              value: "fountain-pen-friendly",
              handle: "special-characteristics"
            },
            {
              label: "Spiral Bound",
              handle: "binding",
              value: "spiral"
            },
            {
              label: "Lay-Flat",
              handle: "special-characteristics",
              value: "lay-flat"
            }
          ],
          template: "Find me notebooks in this style with this special feature in any colour"
        },
        "greeting-cards": {
          style: true,
          price: false,
          theme: true,
          colour: false,
          // Hide colour filter for greeting cards
          // Custom theme options for greeting-cards (overrides global themes)
          themesoff: [
            { handle: "birthday", label: "Birthday" },
            { handle: "wedding", label: "Wedding" },
            { handle: "christmas", label: "Christmas" },
            { handle: "sympathy", label: "Sympathy" }
          ],
          template: "Find me greeting cards on this theme or for this occasion in this style"
        },
        "ornaments": {
          style: false,
          price: true,
          theme: true,
          // Custom theme options for ornaments (overrides global themes)
          themesoff: [
            { handle: "christmas", label: "Christmas" },
            { handle: "easter", label: "Easter" },
            { handle: "halloween", label: "Halloween" },
            { handle: "animals", label: "Animals" }
          ],
          template: "Find me ornaments on this theme, in this colour and in this price bracket"
        },
        "gifts": {
          style: true,
          price: true,
          theme: false,
          colour: false,
          // Hide colour filter for gifts
          template: "Find me gifts in this style and in this price bracket"
        }
      },
      // Default template for when no category is selected
      defaultTemplate: "Find me anything in this style, in any colour",
      // Price band configuration
      priceBands: {
        "0-20": { min: 0, max: 20, label: "\xA30-\xA320" },
        "20-50": { min: 20, max: 50, label: "\xA320-\xA350" },
        "50-100": { min: 50, max: 100, label: "\xA350-\xA3100" },
        "100+": { min: 100, max: Infinity, label: "\xA3100+" }
      },
      customFieldTemplates: {
        type: {
          before: "which are",
          after: "type"
        },
        occasion: {
          before: "for",
          after: "occasion"
        },
        material: {
          before: "made of",
          after: "material"
        },
        "ink-type": {
          before: "for",
          after: "ink"
        },
        use: {
          before: "for",
          after: "use"
        },
        size: {
          before: "in",
          after: "size"
        },
        paper: {
          before: "&",
          after: "paper"
        }
      },
      customFields() {
        let customFilters = this.query.categories[0].value.custom_filters;
        let categoryHandle = this.query.categories[0].handle;
        let rawFields = this.query.categories[0].value.attributes.shopping_helper_filters;
        let fields = Object.keys(customFilters).map((k3) => {
          let handle = customFilters[k3].handle;
          let defaultTemplate = {
            before: "with",
            after: k3
          };
          return {
            label: customFilters[k3].label,
            handle,
            values: customFilters[k3].entries.map((v3) => ({
              id: v3.handle,
              value: v3.handle,
              handle: v3.handle,
              label: v3.value
            })).sort((a4, b4) => a4.label.localeCompare(b4.label)),
            // Sort values alphabetically
            template: this.customFieldTemplates[handle] ? this.customFieldTemplates[handle] : defaultTemplate
          };
        }).filter((f4) => {
          return this.allowedCustomFields[categoryHandle] && this.allowedCustomFields[categoryHandle].includes(f4.handle);
        }).sort((a4, b4) => a4.label.localeCompare(b4.label));
        return fields;
      },
      init() {
        this.waitForSiteData();
        this.disabledOptionsCache = /* @__PURE__ */ new Map();
        this.disabledStates = {};
        this.previousDisabledStates = {};
        this.stateRestored = false;
      },
      waitForSiteData() {
        if (module_default.store("siteData") && module_default.store("siteData").getProductsCount() > 0 && module_default.store("siteData").globalFilters) {
          this.initializeWithData();
        } else {
          this.$watch(
            () => module_default.store("siteData"),
            (newValue) => {
              if (newValue && newValue.getProductsCount() > 0 && newValue.globalFilters) {
                this.initializeWithData();
              }
            },
            { immediate: true }
          );
        }
      },
      async initializeWithData() {
        let products = await module_default.store("siteData").getProductsAsync();
        let filters = { ...module_default.store("siteData").globalFilters };
        this.setup(shuffleArray(products));
        this.filters = filters;
        this.disabledStates = {};
        this.applySavedStateIfReady();
        this.$watch(
          () => module_default.store("siteData").productsCount,
          async (newValue, oldValue) => {
            if (newValue > 0) {
              let copy = await module_default.store("siteData").getProductsAsync();
              this.setup(shuffleArray(copy));
              this.applySavedStateIfReady();
            }
          }
        );
        this.$watch(
          () => module_default.store("siteData").globalFilters,
          (newValue, oldValue) => {
            let copy = { ...newValue };
            this.filters = copy;
            this.disabledStates = {};
          }
        );
      },
      applySavedStateIfReady() {
        if (this.stateRestored) {
          return;
        }
        const savedState = this.loadStateFromLocalStorage();
        if (savedState) {
          this.stateRestored = true;
          this.$nextTick(() => {
            if (this.filters && Object.keys(this.filters).length > 0) {
              this.applySavedState(savedState);
            } else {
              this.$nextTick(() => {
                this.applySavedState(savedState);
              });
            }
          });
        }
      },
      // Getter for dropdown options with progressive disabled state updates
      get dropdownOptions() {
        return {
          prices: this.getPriceBandOptions(),
          styles: this.getDropdownOptionsForType("styles"),
          colours: this.getDropdownOptionsForType("colours"),
          themes: this.getDropdownOptionsForType("themes"),
          specialFeatures: this.getSpecialFeaturesOptions()
        };
      },
      // Get dropdown options for a specific type with progressive disabled state updates
      getDropdownOptionsForType(type) {
        if (!this.disabledStates[type]) {
          const basicOptions = this.getBasicDropdownOptions(type);
          this.disabledStates[type] = basicOptions;
          if (this.previousDisabledStates && this.previousDisabledStates[type]) {
            this.disabledStates[type].forEach((option, index) => {
              const previousOption = this.previousDisabledStates[type].find(
                (prev) => prev.id === option.id || prev.handle === option.handle
              );
              if (previousOption) {
                option.disabled = previousOption.disabled;
              }
            });
          }
          this.$nextTick(() => {
            this.updateDisabledStatesForType(type);
          });
        }
        return this.disabledStates[type] || [];
      },
      // Get basic dropdown options without disabled states
      getBasicDropdownOptions(type) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (type === "prices") {
          return Object.keys(this.priceBands).map((key) => {
            const option = {
              id: key,
              handle: key,
              value: key,
              label: this.priceBands[key].label,
              disabled: false
            };
            return option;
          });
        }
        if (!this.query.categories || this.query.categories.length === 0) {
          if (type === "colours" || type === "styles" || type === "themes") {
            return this.getGlobalOptions(type);
          }
          return [];
        }
        if (type === "specialFeatures") {
          if (!this.query.categories || this.query.categories.length === 0) {
            return [];
          }
          const categoryHandle = this.query.categories[0].handle;
          const config2 = this.categoryConfig[categoryHandle];
          if (!config2 || !config2.feature) {
            return [];
          }
          return config2.feature.map((feature, index) => ({
            id: `${feature.handle}-${feature.value}`,
            // Unique ID combining handle and value
            handle: feature.handle,
            value: feature.value,
            // Use the actual value, not the handle
            label: feature.label,
            filterHandle: feature.handle,
            filterValue: feature.value,
            disabled: false
          })).sort((a4, b4) => a4.label.localeCompare(b4.label));
        }
        if (type === "colours") {
          if (!this.hasColorOptions()) {
            return [];
          }
          if (Object.keys(this.filters).length) {
            let items = ((_a = this.filters[type]) == null ? void 0 : _a.entries) || [];
            if (items) {
              const result = items.map((i4) => ({
                id: i4.id,
                value: i4,
                handle: i4.attributes.value.replace("#", ""),
                label: i4.attributes.value,
                slug: this.slugify(i4.attributes.label),
                disabled: false
              }));
              return result;
            }
          }
          return [];
        }
        if (type === "styles") {
          if (Object.keys(this.filters).length) {
            let items = ((_b = this.filters[type]) == null ? void 0 : _b.entries) || [];
            if (items) {
              const result = items.map((i4) => {
                var _a2;
                return {
                  id: i4.id,
                  handle: i4.handle,
                  value: i4,
                  label: ((_a2 = i4.attributes) == null ? void 0 : _a2.label) || i4.value,
                  disabled: false
                };
              });
              return result;
            }
          }
          return [];
        }
        if (type === "themes") {
          if (Object.keys(this.filters).length) {
            let items = ((_c = this.filters[type]) == null ? void 0 : _c.entries) || [];
            if (items) {
              return items.map((i4) => {
                var _a2;
                return {
                  id: i4.id,
                  handle: i4.handle,
                  value: i4,
                  label: ((_a2 = i4.attributes) == null ? void 0 : _a2.label) || i4.value,
                  disabled: false
                };
              });
            }
          }
          return [];
        }
        if (this.query.categories && this.query.categories.length === 1) {
          const categoryHandle = this.query.categories[0].handle;
          const config2 = this.categoryConfig[categoryHandle];
          if (config2 && config2[type] && Array.isArray(config2[type])) {
            if (type === "themes") {
              const globalThemes = ((_d = this.filters.themes) == null ? void 0 : _d.entries) || [];
              return config2[type].map((option) => {
                const globalTheme = globalThemes.find((theme) => theme.handle === option.handle);
                if (globalTheme) {
                  return {
                    id: globalTheme.id,
                    handle: globalTheme.handle,
                    value: globalTheme,
                    label: option.label,
                    disabled: false
                  };
                }
                return null;
              }).filter((option) => option !== null);
            } else {
              return config2[type].map((option) => ({
                id: option.handle,
                handle: option.handle,
                value: option.handle,
                label: option.label,
                disabled: false
              }));
            }
          }
        }
        if (Object.keys(this.filters).length) {
          let items = ((_e = this.filters[type]) == null ? void 0 : _e.entries) || [];
          if (items) {
            switch (type) {
              case "styles":
              case "themes":
                if (this.query.categories && this.query.categories.length === 1) {
                  const categoryHandle = this.query.categories[0].handle;
                  const categoryData = (_g = (_f = this.filters.categories) == null ? void 0 : _f.entries) == null ? void 0 : _g.find((cat) => cat.handle === categoryHandle);
                  if (categoryData) {
                    const categoryProducts = this.items.filter(
                      (item) => item.attributes.categories && item.attributes.categories.some((catId) => catId === categoryData.id)
                    );
                    const usedIds = /* @__PURE__ */ new Set();
                    categoryProducts.forEach((product) => {
                      if (product.attributes[type]) {
                        product.attributes[type].forEach((id) => usedIds.add(id));
                      }
                    });
                    items = items.filter((item) => usedIds.has(item.id));
                    const config2 = this.categoryConfig[categoryHandle];
                    if (config2 && config2[type] && Array.isArray(config2[type])) {
                      const customHandles = config2[type].map((option) => option.handle);
                      items = items.filter((item) => customHandles.includes(item.handle));
                    }
                  }
                }
                return items.map((i4) => {
                  var _a2;
                  return {
                    id: i4.id,
                    handle: i4.handle,
                    value: i4,
                    label: ((_a2 = i4.attributes) == null ? void 0 : _a2.label) || i4.value,
                    disabled: false
                  };
                });
              default:
                return items.map((i4) => ({
                  id: i4.id,
                  handle: i4.handle,
                  value: i4,
                  label: i4.attributes.label,
                  disabled: false
                }));
            }
          }
          return [];
        }
        return [];
      },
      // Get global options for a type
      getGlobalOptions(type) {
        var _a;
        if (type === "colours" && !this.hasColorOptions()) {
          return [];
        }
        if (Object.keys(this.filters).length) {
          let items = ((_a = this.filters[type]) == null ? void 0 : _a.entries) || [];
          if (items) {
            return items.map((i4) => {
              var _a2;
              switch (type) {
                case "colours":
                  return {
                    id: i4.id,
                    value: i4,
                    handle: i4.attributes.value.replace("#", ""),
                    label: i4.attributes.value,
                    slug: this.slugify(i4.attributes.label),
                    disabled: false
                  };
                case "styles":
                case "themes":
                  return {
                    id: i4.id,
                    handle: i4.handle,
                    value: i4,
                    label: ((_a2 = i4.attributes) == null ? void 0 : _a2.label) || i4.value,
                    disabled: false
                  };
                default:
                  return {
                    id: i4.id,
                    handle: i4.handle,
                    value: i4,
                    label: i4.attributes.label,
                    disabled: false
                  };
              }
            });
          }
        }
        return [];
      },
      // Update disabled states for a specific type
      updateDisabledStatesForType(type) {
        const options = this.disabledStates[type];
        if (!options) return;
        options.forEach((option, index) => {
          setTimeout(() => {
            const wouldYield = this.wouldOptionYieldResults(type, option);
            option.disabled = !wouldYield;
          }, index * 5);
        });
      },
      getDropdownOptions(type) {
        var _a, _b, _c, _d;
        if (type === "prices") {
          return this.getPriceBandOptions();
        }
        if (this.query.categories && this.query.categories.length === 1) {
          const categoryHandle = this.query.categories[0].handle;
          const config2 = this.categoryConfig[categoryHandle];
          if (config2 && config2[type] && Array.isArray(config2[type])) {
            if (type === "themes") {
              const globalThemes = ((_a = this.filters.themes) == null ? void 0 : _a.entries) || [];
              const options = config2[type].map((option) => {
                const globalTheme = globalThemes.find((theme) => theme.handle === option.handle);
                if (globalTheme) {
                  return {
                    id: globalTheme.id,
                    handle: globalTheme.handle,
                    value: globalTheme,
                    label: option.label,
                    disabled: false
                    // Start as enabled, update async
                  };
                }
                return null;
              }).filter((option) => option !== null);
              return options;
            } else {
              const options = config2[type].map((option) => ({
                id: option.handle,
                handle: option.handle,
                value: option.handle,
                label: option.label,
                disabled: false
                // Start as enabled, update async
              }));
              return options;
            }
          }
        }
        if (Object.keys(this.filters).length) {
          let items = ((_b = this.filters[type]) == null ? void 0 : _b.entries) || [];
          if (items) {
            switch (type) {
              case "categories":
                items = items.filter((f4) => f4.attributes.in_shopping_helper).map((i4) => ({
                  id: i4.id,
                  value: i4,
                  handle: i4.handle,
                  label: i4.attributes.label
                }));
                return items;
              case "colours":
                items = items.map((i4) => ({
                  id: i4.id,
                  value: i4,
                  handle: i4.attributes.value.replace("#", ""),
                  label: i4.attributes.value,
                  slug: this.slugify(i4.attributes.label)
                }));
                return items;
              case "styles":
              case "themes":
                if (this.query.categories && this.query.categories.length === 1) {
                  const categoryHandle = this.query.categories[0].handle;
                  const categoryData = (_d = (_c = this.filters.categories) == null ? void 0 : _c.entries) == null ? void 0 : _d.find((cat) => cat.handle === categoryHandle);
                  if (categoryData) {
                    const categoryProducts = this.items.filter(
                      (item) => item.attributes.categories && item.attributes.categories.some((catId) => catId === categoryData.id)
                    );
                    const usedIds = /* @__PURE__ */ new Set();
                    categoryProducts.forEach((product) => {
                      if (product.attributes[type]) {
                        product.attributes[type].forEach((id) => usedIds.add(id));
                      }
                    });
                    items = items.filter((item) => usedIds.has(item.id));
                    const config2 = this.categoryConfig[categoryHandle];
                    if (config2 && config2[type] && Array.isArray(config2[type])) {
                      const customHandles = config2[type].map((option) => option.handle);
                      items = items.filter((item) => customHandles.includes(item.handle));
                    }
                  }
                }
                items = items.map((i4) => {
                  var _a2;
                  return {
                    id: i4.id,
                    handle: i4.handle,
                    value: i4,
                    label: ((_a2 = i4.attributes) == null ? void 0 : _a2.label) || i4.value,
                    disabled: false
                    // Start as enabled, update async
                  };
                });
                return items;
              default:
                items = items.map((i4) => ({
                  id: i4.id,
                  handle: i4.handle,
                  value: i4,
                  label: i4.attributes.label,
                  disabled: false
                  // Start as enabled, update async
                }));
                return items;
            }
          }
          return [];
        }
        return [];
      },
      performSearch() {
      },
      slugify(text) {
        return text.toString().toLowerCase().trim().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
      },
      // Generate current phrase template
      getCurrentPhraseTemplate() {
        if (!this.query.categories || this.query.categories.length === 0) {
          return this.defaultTemplate;
        }
        const categoryHandle = this.query.categories[0].handle;
        const config2 = this.categoryConfig[categoryHandle];
        if (!config2) {
          return this.defaultTemplate;
        }
        return config2.template;
      },
      // Local storage persistence methods
      saveStateToLocalStorage() {
        if (typeof Storage === "undefined") return;
        const state = {
          query: this.query,
          results: this.results.map((item) => item.id),
          // Save only the IDs for efficiency
          timestamp: Date.now()
        };
        try {
          localStorage.setItem(this.storageKey, JSON.stringify(state));
          this.resetStateTimer();
        } catch (error2) {
          console.warn("Failed to save helper state to localStorage:", error2);
        }
      },
      loadStateFromLocalStorage() {
        if (typeof Storage === "undefined") return null;
        try {
          const savedState = localStorage.getItem(this.storageKey);
          if (!savedState) return null;
          const state = JSON.parse(savedState);
          const now = Date.now();
          if (now - state.timestamp > this.stateExpiry) {
            this.clearStateFromLocalStorage();
            return null;
          }
          return state;
        } catch (error2) {
          console.warn("Failed to load helper state from localStorage:", error2);
          this.clearStateFromLocalStorage();
          return null;
        }
      },
      clearStateFromLocalStorage() {
        if (typeof Storage === "undefined") return;
        try {
          localStorage.removeItem(this.storageKey);
        } catch (error2) {
          console.warn("Failed to clear helper state from localStorage:", error2);
        }
      },
      resetStateTimer() {
        if (this.stateTimer) {
          clearTimeout(this.stateTimer);
        }
        this.stateTimer = setTimeout(() => {
          this.clearStateFromLocalStorage();
          this.stateTimer = null;
        }, this.stateExpiry);
      },
      applySavedState(savedState) {
        if (!savedState || typeof savedState !== "object") return;
        this.restoringState = true;
        this.disabledStates = {};
        this.disabledOptionsCache.clear();
        this.previousDisabledStates = {};
        Object.keys(savedState.query).forEach((key) => {
          if (savedState.query[key] && savedState.query[key].length > 0) {
            this.updateQuery({ name: key, selection: savedState.query[key] }, false);
          }
        });
        this.$nextTick(() => {
          if (savedState.results && Array.isArray(savedState.results)) {
            this.restoreResultsOrder(savedState.results);
          } else {
            this.updateResults();
          }
          this.restoringState = false;
        });
      },
      restoreResultsOrder(savedResultIds) {
        if (!savedResultIds || !Array.isArray(savedResultIds)) return;
        const currentResults = this.updateResults(this.query);
        const currentResultsById = /* @__PURE__ */ new Map();
        currentResults.forEach((item) => {
          currentResultsById.set(item.id, item);
        });
        const restoredResults = [];
        const missingItems = [];
        savedResultIds.forEach((id) => {
          const item = currentResultsById.get(id);
          if (item) {
            restoredResults.push(item);
          } else {
            missingItems.push(id);
          }
        });
        const restoredIds = new Set(restoredResults.map((item) => item.id));
        currentResults.forEach((item) => {
          if (!restoredIds.has(item.id)) {
            restoredResults.push(item);
          }
        });
        if (missingItems.length > 0) {
        }
        this.results = restoredResults;
      },
      destroy() {
        if (this.stateTimer) {
          clearTimeout(this.stateTimer);
          this.stateTimer = null;
        }
      }
    }));
  });

  // node_modules/@motionone/utils/dist/array.es.js
  function addUniqueItem(array, item) {
    array.indexOf(item) === -1 && array.push(item);
  }

  // node_modules/@motionone/utils/dist/clamp.es.js
  var clamp = (min, max, v3) => Math.min(Math.max(v3, min), max);

  // node_modules/@motionone/utils/dist/defaults.es.js
  var defaults = {
    duration: 0.3,
    delay: 0,
    endDelay: 0,
    repeat: 0,
    easing: "ease"
  };

  // node_modules/@motionone/utils/dist/is-number.es.js
  var isNumber = (value) => typeof value === "number";

  // node_modules/@motionone/utils/dist/is-easing-list.es.js
  var isEasingList = (easing) => Array.isArray(easing) && !isNumber(easing[0]);

  // node_modules/@motionone/utils/dist/wrap.es.js
  var wrap = (min, max, v3) => {
    const rangeSize = max - min;
    return ((v3 - min) % rangeSize + rangeSize) % rangeSize + min;
  };

  // node_modules/@motionone/utils/dist/easing.es.js
  function getEasingForSegment(easing, i4) {
    return isEasingList(easing) ? easing[wrap(0, easing.length, i4)] : easing;
  }

  // node_modules/@motionone/utils/dist/mix.es.js
  var mix = (min, max, progress2) => -progress2 * min + progress2 * max + min;

  // node_modules/@motionone/utils/dist/noop.es.js
  var noop = () => {
  };
  var noopReturn = (v3) => v3;

  // node_modules/@motionone/utils/dist/progress.es.js
  var progress = (min, max, value) => max - min === 0 ? 1 : (value - min) / (max - min);

  // node_modules/@motionone/utils/dist/offset.es.js
  function fillOffset(offset, remaining) {
    const min = offset[offset.length - 1];
    for (let i4 = 1; i4 <= remaining; i4++) {
      const offsetProgress = progress(0, remaining, i4);
      offset.push(mix(min, 1, offsetProgress));
    }
  }
  function defaultOffset(length) {
    const offset = [0];
    fillOffset(offset, length - 1);
    return offset;
  }

  // node_modules/@motionone/utils/dist/interpolate.es.js
  function interpolate(output, input = defaultOffset(output.length), easing = noopReturn) {
    const length = output.length;
    const remainder = length - input.length;
    remainder > 0 && fillOffset(input, remainder);
    return (t3) => {
      let i4 = 0;
      for (; i4 < length - 2; i4++) {
        if (t3 < input[i4 + 1])
          break;
      }
      let progressInRange = clamp(0, 1, progress(input[i4], input[i4 + 1], t3));
      const segmentEasing = getEasingForSegment(easing, i4);
      progressInRange = segmentEasing(progressInRange);
      return mix(output[i4], output[i4 + 1], progressInRange);
    };
  }

  // node_modules/@motionone/utils/dist/is-cubic-bezier.es.js
  var isCubicBezier = (easing) => Array.isArray(easing) && isNumber(easing[0]);

  // node_modules/@motionone/utils/dist/is-easing-generator.es.js
  var isEasingGenerator = (easing) => typeof easing === "object" && Boolean(easing.createAnimation);

  // node_modules/@motionone/utils/dist/is-function.es.js
  var isFunction = (value) => typeof value === "function";

  // node_modules/@motionone/utils/dist/is-string.es.js
  var isString2 = (value) => typeof value === "string";

  // node_modules/@motionone/utils/dist/time.es.js
  var time = {
    ms: (seconds) => seconds * 1e3,
    s: (milliseconds) => milliseconds / 1e3
  };

  // node_modules/@motionone/easing/dist/cubic-bezier.es.js
  var calcBezier = (t3, a1, a22) => (((1 - 3 * a22 + 3 * a1) * t3 + (3 * a22 - 6 * a1)) * t3 + 3 * a1) * t3;
  var subdivisionPrecision = 1e-7;
  var subdivisionMaxIterations = 12;
  function binarySubdivide(x3, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i4 = 0;
    do {
      currentT = lowerBound + (upperBound - lowerBound) / 2;
      currentX = calcBezier(currentT, mX1, mX2) - x3;
      if (currentX > 0) {
        upperBound = currentT;
      } else {
        lowerBound = currentT;
      }
    } while (Math.abs(currentX) > subdivisionPrecision && ++i4 < subdivisionMaxIterations);
    return currentT;
  }
  function cubicBezier(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2)
      return noopReturn;
    const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
    return (t3) => t3 === 0 || t3 === 1 ? t3 : calcBezier(getTForX(t3), mY1, mY2);
  }

  // node_modules/@motionone/easing/dist/steps.es.js
  var steps = (steps2, direction = "end") => (progress2) => {
    progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
    const expanded = progress2 * steps2;
    const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
    return clamp(0, 1, rounded / steps2);
  };

  // node_modules/@motionone/animation/dist/utils/easing.es.js
  var namedEasings = {
    ease: cubicBezier(0.25, 0.1, 0.25, 1),
    "ease-in": cubicBezier(0.42, 0, 1, 1),
    "ease-in-out": cubicBezier(0.42, 0, 0.58, 1),
    "ease-out": cubicBezier(0, 0, 0.58, 1)
  };
  var functionArgsRegex = /\((.*?)\)/;
  function getEasingFunction(definition) {
    if (isFunction(definition))
      return definition;
    if (isCubicBezier(definition))
      return cubicBezier(...definition);
    const namedEasing = namedEasings[definition];
    if (namedEasing)
      return namedEasing;
    if (definition.startsWith("steps")) {
      const args = functionArgsRegex.exec(definition);
      if (args) {
        const argsArray = args[1].split(",");
        return steps(parseFloat(argsArray[0]), argsArray[1].trim());
      }
    }
    return noopReturn;
  }

  // node_modules/@motionone/animation/dist/Animation.es.js
  var Animation = class {
    constructor(output, keyframes = [0, 1], { easing, duration: initialDuration = defaults.duration, delay = defaults.delay, endDelay = defaults.endDelay, repeat = defaults.repeat, offset, direction = "normal", autoplay = true } = {}) {
      this.startTime = null;
      this.rate = 1;
      this.t = 0;
      this.cancelTimestamp = null;
      this.easing = noopReturn;
      this.duration = 0;
      this.totalDuration = 0;
      this.repeat = 0;
      this.playState = "idle";
      this.finished = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
      easing = easing || defaults.easing;
      if (isEasingGenerator(easing)) {
        const custom = easing.createAnimation(keyframes);
        easing = custom.easing;
        keyframes = custom.keyframes || keyframes;
        initialDuration = custom.duration || initialDuration;
      }
      this.repeat = repeat;
      this.easing = isEasingList(easing) ? noopReturn : getEasingFunction(easing);
      this.updateDuration(initialDuration);
      const interpolate$1 = interpolate(keyframes, offset, isEasingList(easing) ? easing.map(getEasingFunction) : noopReturn);
      this.tick = (timestamp) => {
        var _a;
        delay = delay;
        let t3 = 0;
        if (this.pauseTime !== void 0) {
          t3 = this.pauseTime;
        } else {
          t3 = (timestamp - this.startTime) * this.rate;
        }
        this.t = t3;
        t3 /= 1e3;
        t3 = Math.max(t3 - delay, 0);
        if (this.playState === "finished" && this.pauseTime === void 0) {
          t3 = this.totalDuration;
        }
        const progress2 = t3 / this.duration;
        let currentIteration = Math.floor(progress2);
        let iterationProgress = progress2 % 1;
        if (!iterationProgress && progress2 >= 1) {
          iterationProgress = 1;
        }
        iterationProgress === 1 && currentIteration--;
        const iterationIsOdd = currentIteration % 2;
        if (direction === "reverse" || direction === "alternate" && iterationIsOdd || direction === "alternate-reverse" && !iterationIsOdd) {
          iterationProgress = 1 - iterationProgress;
        }
        const p4 = t3 >= this.totalDuration ? 1 : Math.min(iterationProgress, 1);
        const latest = interpolate$1(this.easing(p4));
        output(latest);
        const isAnimationFinished = this.pauseTime === void 0 && (this.playState === "finished" || t3 >= this.totalDuration + endDelay);
        if (isAnimationFinished) {
          this.playState = "finished";
          (_a = this.resolve) === null || _a === void 0 ? void 0 : _a.call(this, latest);
        } else if (this.playState !== "idle") {
          this.frameRequestId = requestAnimationFrame(this.tick);
        }
      };
      if (autoplay)
        this.play();
    }
    play() {
      const now = performance.now();
      this.playState = "running";
      if (this.pauseTime !== void 0) {
        this.startTime = now - this.pauseTime;
      } else if (!this.startTime) {
        this.startTime = now;
      }
      this.cancelTimestamp = this.startTime;
      this.pauseTime = void 0;
      this.frameRequestId = requestAnimationFrame(this.tick);
    }
    pause() {
      this.playState = "paused";
      this.pauseTime = this.t;
    }
    finish() {
      this.playState = "finished";
      this.tick(0);
    }
    stop() {
      var _a;
      this.playState = "idle";
      if (this.frameRequestId !== void 0) {
        cancelAnimationFrame(this.frameRequestId);
      }
      (_a = this.reject) === null || _a === void 0 ? void 0 : _a.call(this, false);
    }
    cancel() {
      this.stop();
      this.tick(this.cancelTimestamp);
    }
    reverse() {
      this.rate *= -1;
    }
    commitStyles() {
    }
    updateDuration(duration) {
      this.duration = duration;
      this.totalDuration = duration * (this.repeat + 1);
    }
    get currentTime() {
      return this.t;
    }
    set currentTime(t3) {
      if (this.pauseTime !== void 0 || this.rate === 0) {
        this.pauseTime = t3;
      } else {
        this.startTime = performance.now() - t3 / this.rate;
      }
    }
    get playbackRate() {
      return this.rate;
    }
    set playbackRate(rate) {
      this.rate = rate;
    }
  };

  // node_modules/hey-listen/dist/hey-listen.es.js
  var warning = function() {
  };
  var invariant = function() {
  };
  if (true) {
    warning = function(check, message) {
      if (!check && typeof console !== "undefined") {
        console.warn(message);
      }
    };
    invariant = function(check, message) {
      if (!check) {
        throw new Error(message);
      }
    };
  }

  // node_modules/@motionone/types/dist/MotionValue.es.js
  var MotionValue = class {
    setAnimation(animation) {
      this.animation = animation;
      animation === null || animation === void 0 ? void 0 : animation.finished.then(() => this.clearAnimation()).catch(() => {
      });
    }
    clearAnimation() {
      this.animation = this.generator = void 0;
    }
  };

  // node_modules/@motionone/dom/dist/animate/data.es.js
  var data2 = /* @__PURE__ */ new WeakMap();
  function getAnimationData(element) {
    if (!data2.has(element)) {
      data2.set(element, {
        transforms: [],
        values: /* @__PURE__ */ new Map()
      });
    }
    return data2.get(element);
  }
  function getMotionValue(motionValues, name) {
    if (!motionValues.has(name)) {
      motionValues.set(name, new MotionValue());
    }
    return motionValues.get(name);
  }

  // node_modules/@motionone/dom/dist/animate/utils/transforms.es.js
  var axes = ["", "X", "Y", "Z"];
  var order = ["translate", "scale", "rotate", "skew"];
  var transformAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ"
  };
  var rotation = {
    syntax: "<angle>",
    initialValue: "0deg",
    toDefaultUnit: (v3) => v3 + "deg"
  };
  var baseTransformProperties = {
    translate: {
      syntax: "<length-percentage>",
      initialValue: "0px",
      toDefaultUnit: (v3) => v3 + "px"
    },
    rotate: rotation,
    scale: {
      syntax: "<number>",
      initialValue: 1,
      toDefaultUnit: noopReturn
    },
    skew: rotation
  };
  var transformDefinitions = /* @__PURE__ */ new Map();
  var asTransformCssVar = (name) => `--motion-${name}`;
  var transforms = ["x", "y", "z"];
  order.forEach((name) => {
    axes.forEach((axis) => {
      transforms.push(name + axis);
      transformDefinitions.set(asTransformCssVar(name + axis), baseTransformProperties[name]);
    });
  });
  var compareTransformOrder = (a4, b4) => transforms.indexOf(a4) - transforms.indexOf(b4);
  var transformLookup = new Set(transforms);
  var isTransform = (name) => transformLookup.has(name);
  var addTransformToElement = (element, name) => {
    if (transformAlias[name])
      name = transformAlias[name];
    const { transforms: transforms2 } = getAnimationData(element);
    addUniqueItem(transforms2, name);
    element.style.transform = buildTransformTemplate(transforms2);
  };
  var buildTransformTemplate = (transforms2) => transforms2.sort(compareTransformOrder).reduce(transformListToString, "").trim();
  var transformListToString = (template, name) => `${template} ${name}(var(${asTransformCssVar(name)}))`;

  // node_modules/@motionone/dom/dist/animate/utils/css-var.es.js
  var isCssVar = (name) => name.startsWith("--");
  var registeredProperties = /* @__PURE__ */ new Set();
  function registerCssVariable(name) {
    if (registeredProperties.has(name))
      return;
    registeredProperties.add(name);
    try {
      const { syntax, initialValue } = transformDefinitions.has(name) ? transformDefinitions.get(name) : {};
      CSS.registerProperty({
        name,
        inherits: false,
        syntax,
        initialValue
      });
    } catch (e4) {
    }
  }

  // node_modules/@motionone/dom/dist/animate/utils/feature-detection.es.js
  var testAnimation = (keyframes, options) => document.createElement("div").animate(keyframes, options);
  var featureTests = {
    cssRegisterProperty: () => typeof CSS !== "undefined" && Object.hasOwnProperty.call(CSS, "registerProperty"),
    waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
    partialKeyframes: () => {
      try {
        testAnimation({ opacity: [1] });
      } catch (e4) {
        return false;
      }
      return true;
    },
    finished: () => Boolean(testAnimation({ opacity: [0, 1] }, { duration: 1e-3 }).finished),
    linearEasing: () => {
      try {
        testAnimation({ opacity: 0 }, { easing: "linear(0, 1)" });
      } catch (e4) {
        return false;
      }
      return true;
    }
  };
  var results = {};
  var supports = {};
  for (const key in featureTests) {
    supports[key] = () => {
      if (results[key] === void 0)
        results[key] = featureTests[key]();
      return results[key];
    };
  }

  // node_modules/@motionone/dom/dist/animate/utils/easing.es.js
  var resolution = 0.015;
  var generateLinearEasingPoints = (easing, duration) => {
    let points = "";
    const numPoints = Math.round(duration / resolution);
    for (let i4 = 0; i4 < numPoints; i4++) {
      points += easing(progress(0, numPoints - 1, i4)) + ", ";
    }
    return points.substring(0, points.length - 2);
  };
  var convertEasing = (easing, duration) => {
    if (isFunction(easing)) {
      return supports.linearEasing() ? `linear(${generateLinearEasingPoints(easing, duration)})` : defaults.easing;
    } else {
      return isCubicBezier(easing) ? cubicBezierAsString(easing) : easing;
    }
  };
  var cubicBezierAsString = ([a4, b4, c4, d4]) => `cubic-bezier(${a4}, ${b4}, ${c4}, ${d4})`;

  // node_modules/@motionone/dom/dist/animate/utils/keyframes.es.js
  function hydrateKeyframes(keyframes, readInitialValue) {
    for (let i4 = 0; i4 < keyframes.length; i4++) {
      if (keyframes[i4] === null) {
        keyframes[i4] = i4 ? keyframes[i4 - 1] : readInitialValue();
      }
    }
    return keyframes;
  }
  var keyframesList = (keyframes) => Array.isArray(keyframes) ? keyframes : [keyframes];

  // node_modules/@motionone/dom/dist/animate/utils/get-style-name.es.js
  function getStyleName(key) {
    if (transformAlias[key])
      key = transformAlias[key];
    return isTransform(key) ? asTransformCssVar(key) : key;
  }

  // node_modules/@motionone/dom/dist/animate/style.es.js
  var style = {
    get: (element, name) => {
      name = getStyleName(name);
      let value = isCssVar(name) ? element.style.getPropertyValue(name) : getComputedStyle(element)[name];
      if (!value && value !== 0) {
        const definition = transformDefinitions.get(name);
        if (definition)
          value = definition.initialValue;
      }
      return value;
    },
    set: (element, name, value) => {
      name = getStyleName(name);
      if (isCssVar(name)) {
        element.style.setProperty(name, value);
      } else {
        element.style[name] = value;
      }
    }
  };

  // node_modules/@motionone/dom/dist/animate/utils/stop-animation.es.js
  function stopAnimation(animation, needsCommit = true) {
    if (!animation || animation.playState === "finished")
      return;
    try {
      if (animation.stop) {
        animation.stop();
      } else {
        needsCommit && animation.commitStyles();
        animation.cancel();
      }
    } catch (e4) {
    }
  }

  // node_modules/@motionone/dom/dist/animate/utils/get-unit.es.js
  function getUnitConverter(keyframes, definition) {
    var _a;
    let toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || noopReturn;
    const finalKeyframe = keyframes[keyframes.length - 1];
    if (isString2(finalKeyframe)) {
      const unit = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
      if (unit)
        toUnit = (value) => value + unit;
    }
    return toUnit;
  }

  // node_modules/@motionone/dom/dist/animate/animate-style.es.js
  function getDevToolsRecord() {
    return window.__MOTION_DEV_TOOLS_RECORD;
  }
  function animateStyle(element, key, keyframesDefinition, options = {}, AnimationPolyfill) {
    const record = getDevToolsRecord();
    const isRecording = options.record !== false && record;
    let animation;
    let { duration = defaults.duration, delay = defaults.delay, endDelay = defaults.endDelay, repeat = defaults.repeat, easing = defaults.easing, persist = false, direction, offset, allowWebkitAcceleration = false, autoplay = true } = options;
    const data3 = getAnimationData(element);
    const valueIsTransform = isTransform(key);
    let canAnimateNatively = supports.waapi();
    valueIsTransform && addTransformToElement(element, key);
    const name = getStyleName(key);
    const motionValue = getMotionValue(data3.values, name);
    const definition = transformDefinitions.get(name);
    stopAnimation(motionValue.animation, !(isEasingGenerator(easing) && motionValue.generator) && options.record !== false);
    return () => {
      const readInitialValue = () => {
        var _a, _b;
        return (_b = (_a = style.get(element, name)) !== null && _a !== void 0 ? _a : definition === null || definition === void 0 ? void 0 : definition.initialValue) !== null && _b !== void 0 ? _b : 0;
      };
      let keyframes = hydrateKeyframes(keyframesList(keyframesDefinition), readInitialValue);
      const toUnit = getUnitConverter(keyframes, definition);
      if (isEasingGenerator(easing)) {
        const custom = easing.createAnimation(keyframes, key !== "opacity", readInitialValue, name, motionValue);
        easing = custom.easing;
        keyframes = custom.keyframes || keyframes;
        duration = custom.duration || duration;
      }
      if (isCssVar(name)) {
        if (supports.cssRegisterProperty()) {
          registerCssVariable(name);
        } else {
          canAnimateNatively = false;
        }
      }
      if (valueIsTransform && !supports.linearEasing() && (isFunction(easing) || isEasingList(easing) && easing.some(isFunction))) {
        canAnimateNatively = false;
      }
      if (canAnimateNatively) {
        if (definition) {
          keyframes = keyframes.map((value) => isNumber(value) ? definition.toDefaultUnit(value) : value);
        }
        if (keyframes.length === 1 && (!supports.partialKeyframes() || isRecording)) {
          keyframes.unshift(readInitialValue());
        }
        const animationOptions = {
          delay: time.ms(delay),
          duration: time.ms(duration),
          endDelay: time.ms(endDelay),
          easing: !isEasingList(easing) ? convertEasing(easing, duration) : void 0,
          direction,
          iterations: repeat + 1,
          fill: "both"
        };
        animation = element.animate({
          [name]: keyframes,
          offset,
          easing: isEasingList(easing) ? easing.map((thisEasing) => convertEasing(thisEasing, duration)) : void 0
        }, animationOptions);
        if (!animation.finished) {
          animation.finished = new Promise((resolve, reject) => {
            animation.onfinish = resolve;
            animation.oncancel = reject;
          });
        }
        const target = keyframes[keyframes.length - 1];
        animation.finished.then(() => {
          if (persist)
            return;
          style.set(element, name, target);
          animation.cancel();
        }).catch(noop);
        if (!allowWebkitAcceleration)
          animation.playbackRate = 1.000001;
      } else if (AnimationPolyfill && valueIsTransform) {
        keyframes = keyframes.map((value) => typeof value === "string" ? parseFloat(value) : value);
        if (keyframes.length === 1) {
          keyframes.unshift(parseFloat(readInitialValue()));
        }
        animation = new AnimationPolyfill((latest) => {
          style.set(element, name, toUnit ? toUnit(latest) : latest);
        }, keyframes, Object.assign(Object.assign({}, options), {
          duration,
          easing
        }));
      } else {
        const target = keyframes[keyframes.length - 1];
        style.set(element, name, definition && isNumber(target) ? definition.toDefaultUnit(target) : target);
      }
      if (isRecording) {
        record(element, key, keyframes, {
          duration,
          delay,
          easing,
          repeat,
          offset
        }, "motion-one");
      }
      motionValue.setAnimation(animation);
      if (animation && !autoplay)
        animation.pause();
      return animation;
    };
  }

  // node_modules/@motionone/dom/dist/animate/utils/options.es.js
  var getOptions = (options, key) => (
    /**
     * TODO: Make test for this
     * Always return a new object otherwise delay is overwritten by results of stagger
     * and this results in no stagger
     */
    options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options)
  );

  // node_modules/@motionone/dom/dist/utils/resolve-elements.es.js
  function resolveElements(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
      if (selectorCache) {
        (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = document.querySelectorAll(elements);
        elements = selectorCache[elements];
      } else {
        elements = document.querySelectorAll(elements);
      }
    } else if (elements instanceof Element) {
      elements = [elements];
    }
    return Array.from(elements || []);
  }

  // node_modules/@motionone/dom/dist/animate/utils/controls.es.js
  var createAnimation = (factory) => factory();
  var withControls = (animationFactory, options, duration = defaults.duration) => {
    return new Proxy({
      animations: animationFactory.map(createAnimation).filter(Boolean),
      duration,
      options
    }, controls);
  };
  var getActiveAnimation = (state) => state.animations[0];
  var controls = {
    get: (target, key) => {
      const activeAnimation = getActiveAnimation(target);
      switch (key) {
        case "duration":
          return target.duration;
        case "currentTime":
          return time.s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
        case "playbackRate":
        case "playState":
          return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
        case "finished":
          if (!target.finished) {
            target.finished = Promise.all(target.animations.map(selectFinished)).catch(noop);
          }
          return target.finished;
        case "stop":
          return () => {
            target.animations.forEach((animation) => stopAnimation(animation));
          };
        case "forEachNative":
          return (callback) => {
            target.animations.forEach((animation) => callback(animation, target));
          };
        default:
          return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined" ? void 0 : () => target.animations.forEach((animation) => animation[key]());
      }
    },
    set: (target, key, value) => {
      switch (key) {
        case "currentTime":
          value = time.ms(value);
        // Fall-through
        case "playbackRate":
          for (let i4 = 0; i4 < target.animations.length; i4++) {
            target.animations[i4][key] = value;
          }
          return true;
      }
      return false;
    }
  };
  var selectFinished = (animation) => animation.finished;

  // node_modules/@motionone/dom/dist/utils/stagger.es.js
  function resolveOption(option, i4, total) {
    return isFunction(option) ? option(i4, total) : option;
  }

  // node_modules/@motionone/dom/dist/animate/create-animate.es.js
  function createAnimate(AnimatePolyfill) {
    return function animate3(elements, keyframes, options = {}) {
      elements = resolveElements(elements);
      const numElements = elements.length;
      invariant(Boolean(numElements), "No valid element provided.");
      invariant(Boolean(keyframes), "No keyframes defined.");
      const animationFactories = [];
      for (let i4 = 0; i4 < numElements; i4++) {
        const element = elements[i4];
        for (const key in keyframes) {
          const valueOptions = getOptions(options, key);
          valueOptions.delay = resolveOption(valueOptions.delay, i4, numElements);
          const animation = animateStyle(element, key, keyframes[key], valueOptions, AnimatePolyfill);
          animationFactories.push(animation);
        }
      }
      return withControls(
        animationFactories,
        options,
        /**
         * TODO:
         * If easing is set to spring or glide, duration will be dynamically
         * generated. Ideally we would dynamically generate this from
         * animation.effect.getComputedTiming().duration but this isn't
         * supported in iOS13 or our number polyfill. Perhaps it's possible
         * to Proxy animations returned from animateStyle that has duration
         * as a getter.
         */
        options.duration
      );
    };
  }

  // node_modules/@motionone/dom/dist/animate/index.es.js
  var animate = createAnimate(Animation);

  // node_modules/motion/dist/animate.es.js
  function animateProgress(target, options = {}) {
    return withControls([
      () => {
        const animation = new Animation(target, [0, 1], options);
        animation.finished.catch(() => {
        });
        return animation;
      }
    ], options, options.duration);
  }
  function animate2(target, keyframesOrOptions, options) {
    const factory = isFunction(target) ? animateProgress : animate;
    return factory(target, keyframesOrOptions, options);
  }

  // node_modules/keen-slider/keen-slider.es.js
  var n3 = function() {
    return n3 = Object.assign || function(n4) {
      for (var t3, i4 = 1, e4 = arguments.length; i4 < e4; i4++) for (var r4 in t3 = arguments[i4]) Object.prototype.hasOwnProperty.call(t3, r4) && (n4[r4] = t3[r4]);
      return n4;
    }, n3.apply(this, arguments);
  };
  function t2(n4, t3, i4) {
    if (i4 || 2 === arguments.length) for (var e4, r4 = 0, a4 = t3.length; r4 < a4; r4++) !e4 && r4 in t3 || (e4 || (e4 = Array.prototype.slice.call(t3, 0, r4)), e4[r4] = t3[r4]);
    return n4.concat(e4 || Array.prototype.slice.call(t3));
  }
  function i3(n4) {
    return Array.prototype.slice.call(n4);
  }
  function e3(n4, t3) {
    var i4 = Math.floor(n4);
    return i4 === t3 || i4 + 1 === t3 ? n4 : t3;
  }
  function r3() {
    return Date.now();
  }
  function a3(n4, t3, i4) {
    if (t3 = "data-keen-slider-" + t3, null === i4) return n4.removeAttribute(t3);
    n4.setAttribute(t3, i4 || "");
  }
  function o3(n4, t3) {
    return t3 = t3 || document, "function" == typeof n4 && (n4 = n4(t3)), Array.isArray(n4) ? n4 : "string" == typeof n4 ? i3(t3.querySelectorAll(n4)) : n4 instanceof HTMLElement ? [n4] : n4 instanceof NodeList ? i3(n4) : [];
  }
  function u3(n4) {
    n4.raw && (n4 = n4.raw), n4.cancelable && !n4.defaultPrevented && n4.preventDefault();
  }
  function s3(n4) {
    n4.raw && (n4 = n4.raw), n4.stopPropagation && n4.stopPropagation();
  }
  function c3() {
    var n4 = [];
    return { add: function(t3, i4, e4, r4) {
      t3.addListener ? t3.addListener(e4) : t3.addEventListener(i4, e4, r4), n4.push([t3, i4, e4, r4]);
    }, input: function(n5, t3, i4, e4) {
      this.add(n5, t3, /* @__PURE__ */ function(n6) {
        return function(t4) {
          t4.nativeEvent && (t4 = t4.nativeEvent);
          var i5 = t4.changedTouches || [], e5 = t4.targetTouches || [], r4 = t4.detail && t4.detail.x ? t4.detail : null;
          return n6({ id: r4 ? r4.identifier ? r4.identifier : "i" : e5[0] ? e5[0] ? e5[0].identifier : "e" : "d", idChanged: r4 ? r4.identifier ? r4.identifier : "i" : i5[0] ? i5[0] ? i5[0].identifier : "e" : "d", raw: t4, x: r4 && r4.x ? r4.x : e5[0] ? e5[0].screenX : r4 ? r4.x : t4.pageX, y: r4 && r4.y ? r4.y : e5[0] ? e5[0].screenY : r4 ? r4.y : t4.pageY });
        };
      }(i4), e4);
    }, purge: function() {
      n4.forEach(function(n5) {
        n5[0].removeListener ? n5[0].removeListener(n5[2]) : n5[0].removeEventListener(n5[1], n5[2], n5[3]);
      }), n4 = [];
    } };
  }
  function d3(n4, t3, i4) {
    return Math.min(Math.max(n4, t3), i4);
  }
  function l3(n4) {
    return (n4 > 0 ? 1 : 0) - (n4 < 0 ? 1 : 0) || +n4;
  }
  function f3(n4) {
    var t3 = n4.getBoundingClientRect();
    return { height: e3(t3.height, n4.offsetHeight), width: e3(t3.width, n4.offsetWidth) };
  }
  function p3(n4, t3, i4, e4) {
    var r4 = n4 && n4[t3];
    return null == r4 ? i4 : e4 && "function" == typeof r4 ? r4() : r4;
  }
  function v2(n4) {
    return Math.round(1e6 * n4) / 1e6;
  }
  function h3(n4) {
    var t3, i4, e4, r4, a4, o4;
    function u4(t4) {
      o4 || (o4 = t4), s4(true);
      var a5 = t4 - o4;
      a5 > e4 && (a5 = e4);
      var l5 = r4[i4];
      if (l5[3] < a5) return i4++, u4(t4);
      var f4 = l5[2], p4 = l5[4], v3 = l5[0], h4 = l5[1] * (0, l5[5])(0 === p4 ? 1 : (a5 - f4) / p4);
      if (h4 && n4.track.to(v3 + h4), a5 < e4) return d4();
      o4 = null, s4(false), c4(null), n4.emit("animationEnded");
    }
    function s4(n5) {
      t3.active = n5;
    }
    function c4(n5) {
      t3.targetIdx = n5;
    }
    function d4() {
      var n5;
      n5 = u4, a4 = window.requestAnimationFrame(n5);
    }
    function l4() {
      var t4;
      t4 = a4, window.cancelAnimationFrame(t4), s4(false), c4(null), o4 && n4.emit("animationStopped"), o4 = null;
    }
    return t3 = { active: false, start: function(t4) {
      if (l4(), n4.track.details) {
        var a5 = 0, o5 = n4.track.details.position;
        i4 = 0, e4 = 0, r4 = t4.map(function(n5) {
          var t5, i5 = Number(o5), r5 = null !== (t5 = n5.earlyExit) && void 0 !== t5 ? t5 : n5.duration, u5 = n5.easing, s5 = n5.distance * u5(r5 / n5.duration) || 0;
          o5 += s5;
          var c5 = e4;
          return e4 += r5, a5 += s5, [i5, n5.distance, c5, e4, n5.duration, u5];
        }), c4(n4.track.distToIdx(a5)), d4(), n4.emit("animationStarted");
      }
    }, stop: l4, targetIdx: null };
  }
  function m3(n4) {
    var i4, e4, a4, o4, u4, s4, c4, f4, h4, m4, g4, b4, x3, k3, y4 = 1 / 0, w3 = [], M2 = null, T2 = 0;
    function C2(n5) {
      _2(T2 + n5);
    }
    function E3(n5) {
      var t3 = z(T2 + n5).abs;
      return D2(t3) ? t3 : null;
    }
    function z(n5) {
      var i5 = Math.floor(Math.abs(v2(n5 / e4))), r4 = v2((n5 % e4 + e4) % e4);
      r4 === e4 && (r4 = 0);
      var a5 = l3(n5), o5 = c4.indexOf(t2([], c4, true).reduce(function(n6, t3) {
        return Math.abs(t3 - r4) < Math.abs(n6 - r4) ? t3 : n6;
      })), u5 = o5;
      return a5 < 0 && i5++, o5 === s4 && (u5 = 0, i5 += a5 > 0 ? 1 : -1), { abs: u5 + i5 * s4 * a5, origin: o5, rel: u5 };
    }
    function I2(n5, t3, i5) {
      var e5;
      if (t3 || !S3()) return A3(n5, i5);
      if (!D2(n5)) return null;
      var r4 = z(null != i5 ? i5 : T2), a5 = r4.abs, o5 = n5 - r4.rel, u5 = a5 + o5;
      e5 = A3(u5);
      var c5 = A3(u5 - s4 * l3(o5));
      return (null !== c5 && Math.abs(c5) < Math.abs(e5) || null === e5) && (e5 = c5), v2(e5);
    }
    function A3(n5, t3) {
      if (null == t3 && (t3 = v2(T2)), !D2(n5) || null === n5) return null;
      n5 = Math.round(n5);
      var i5 = z(t3), r4 = i5.abs, a5 = i5.rel, o5 = i5.origin, u5 = O2(n5), d4 = (t3 % e4 + e4) % e4, l4 = c4[o5], f5 = Math.floor((n5 - (r4 - a5)) / s4) * e4;
      return v2(l4 - d4 - l4 + c4[u5] + f5 + (o5 === s4 ? e4 : 0));
    }
    function D2(n5) {
      return L2(n5) === n5;
    }
    function L2(n5) {
      return d3(n5, h4, m4);
    }
    function S3() {
      return o4.loop;
    }
    function O2(n5) {
      return (n5 % s4 + s4) % s4;
    }
    function _2(t3) {
      var i5;
      i5 = t3 - T2, w3.push({ distance: i5, timestamp: r3() }), w3.length > 6 && (w3 = w3.slice(-6)), T2 = v2(t3);
      var e5 = H2().abs;
      if (e5 !== M2) {
        var a5 = null !== M2;
        M2 = e5, a5 && n4.emit("slideChanged");
      }
    }
    function H2(t3) {
      var r4 = t3 ? null : function() {
        if (s4) {
          var n5 = S3(), t4 = n5 ? (T2 % e4 + e4) % e4 : T2, i5 = (n5 ? T2 % e4 : T2) - u4[0][2], r5 = 0 - (i5 < 0 && n5 ? e4 - Math.abs(i5) : i5), c5 = 0, d4 = z(T2), f5 = d4.abs, p4 = d4.rel, v3 = u4[p4][2], y5 = u4.map(function(t5, i6) {
            var a5 = r5 + c5;
            (a5 < 0 - t5[0] || a5 > 1) && (a5 += (Math.abs(a5) > e4 - 1 && n5 ? e4 : 0) * l3(-a5));
            var u5 = i6 - p4, d5 = l3(u5), h5 = u5 + f5;
            n5 && (-1 === d5 && a5 > v3 && (h5 += s4), 1 === d5 && a5 < v3 && (h5 -= s4), null !== g4 && h5 < g4 && (a5 += e4), null !== b4 && h5 > b4 && (a5 -= e4));
            var m5 = a5 + t5[0] + t5[1], x4 = Math.max(a5 >= 0 && m5 <= 1 ? 1 : m5 < 0 || a5 > 1 ? 0 : a5 < 0 ? Math.min(1, (t5[0] + a5) / t5[0]) : (1 - a5) / t5[0], 0);
            return c5 += t5[0] + t5[1], { abs: h5, distance: o4.rtl ? -1 * a5 + 1 - t5[0] : a5, portion: x4, size: t5[0] };
          });
          return f5 = L2(f5), p4 = O2(f5), { abs: L2(f5), length: a4, max: k3, maxIdx: m4, min: x3, minIdx: h4, position: T2, progress: n5 ? t4 / e4 : T2 / a4, rel: p4, slides: y5, slidesLength: e4 };
        }
      }();
      return i4.details = r4, n4.emit("detailsChanged"), r4;
    }
    return i4 = { absToRel: O2, add: C2, details: null, distToIdx: E3, idxToDist: I2, init: function(t3) {
      if (function() {
        if (o4 = n4.options, u4 = (o4.trackConfig || []).map(function(n5) {
          return [p3(n5, "size", 1), p3(n5, "spacing", 0), p3(n5, "origin", 0)];
        }), s4 = u4.length) {
          e4 = v2(u4.reduce(function(n5, t5) {
            return n5 + t5[0] + t5[1];
          }, 0));
          var t4, i6 = s4 - 1;
          a4 = v2(e4 + u4[0][2] - u4[i6][0] - u4[i6][2] - u4[i6][1]), c4 = u4.reduce(function(n5, i7) {
            if (!n5) return [0];
            var e5 = u4[n5.length - 1], r4 = n5[n5.length - 1] + (e5[0] + e5[2]) + e5[1];
            return r4 -= i7[2], n5[n5.length - 1] > r4 && (r4 = n5[n5.length - 1]), r4 = v2(r4), n5.push(r4), (!t4 || t4 < r4) && (f4 = n5.length - 1), t4 = r4, n5;
          }, null), 0 === a4 && (f4 = 0), c4.push(v2(e4));
        }
      }(), !s4) return H2(true);
      var i5;
      !function() {
        var t4 = n4.options.range, i6 = n4.options.loop;
        g4 = h4 = i6 ? p3(i6, "min", -1 / 0) : 0, b4 = m4 = i6 ? p3(i6, "max", y4) : f4;
        var e5 = p3(t4, "min", null), r4 = p3(t4, "max", null);
        null !== e5 && (h4 = e5), null !== r4 && (m4 = r4), x3 = h4 === -1 / 0 ? h4 : n4.track.idxToDist(h4 || 0, true, 0), k3 = m4 === y4 ? m4 : I2(m4, true, 0), null === r4 && (b4 = m4), p3(t4, "align", false) && m4 !== y4 && 0 === u4[O2(m4)][2] && (k3 -= 1 - u4[O2(m4)][0], m4 = E3(k3 - T2)), x3 = v2(x3), k3 = v2(k3);
      }(), i5 = t3, Number(i5) === i5 ? C2(A3(L2(t3))) : H2();
    }, to: _2, velocity: function() {
      var n5 = r3(), t3 = w3.reduce(function(t4, i5) {
        var e5 = i5.distance, r4 = i5.timestamp;
        return n5 - r4 > 200 || (l3(e5) !== l3(t4.distance) && t4.distance && (t4 = { distance: 0, lastTimestamp: 0, time: 0 }), t4.time && (t4.distance += e5), t4.lastTimestamp && (t4.time += r4 - t4.lastTimestamp), t4.lastTimestamp = r4), t4;
      }, { distance: 0, lastTimestamp: 0, time: 0 });
      return t3.distance / t3.time || 0;
    } };
  }
  function g3(n4) {
    var t3, i4, e4, r4, a4, o4, u4, s4;
    function c4(n5) {
      return 2 * n5;
    }
    function f4(n5) {
      return d3(n5, u4, s4);
    }
    function p4(n5) {
      return 1 - Math.pow(1 - n5, 3);
    }
    function v3() {
      return e4 ? n4.track.velocity() : 0;
    }
    function h4() {
      b4();
      var t4 = "free-snap" === n4.options.mode, i5 = n4.track, e5 = v3();
      r4 = l3(e5);
      var u5 = n4.track.details, s5 = [];
      if (e5 || !t4) {
        var d4 = m4(e5), h5 = d4.dist, g5 = d4.dur;
        if (g5 = c4(g5), h5 *= r4, t4) {
          var x3 = i5.idxToDist(i5.distToIdx(h5), true);
          x3 && (h5 = x3);
        }
        s5.push({ distance: h5, duration: g5, easing: p4 });
        var k3 = u5.position, y4 = k3 + h5;
        if (y4 < a4 || y4 > o4) {
          var w3 = y4 < a4 ? a4 - k3 : o4 - k3, M2 = 0, T2 = e5;
          if (l3(w3) === r4) {
            var C2 = Math.min(Math.abs(w3) / Math.abs(h5), 1), E3 = function(n5) {
              return 1 - Math.pow(1 - n5, 1 / 3);
            }(C2) * g5;
            s5[0].earlyExit = E3, T2 = e5 * (1 - C2);
          } else s5[0].earlyExit = 0, M2 += w3;
          var z = m4(T2, 100), I2 = z.dist * r4;
          n4.options.rubberband && (s5.push({ distance: I2, duration: c4(z.dur), easing: p4 }), s5.push({ distance: -I2 + M2, duration: 500, easing: p4 }));
        }
        n4.animator.start(s5);
      } else n4.moveToIdx(f4(u5.abs), true, { duration: 500, easing: function(n5) {
        return 1 + --n5 * n5 * n5 * n5 * n5;
      } });
    }
    function m4(n5, t4) {
      void 0 === t4 && (t4 = 1e3);
      var i5 = 147e-9 + (n5 = Math.abs(n5)) / t4;
      return { dist: Math.pow(n5, 2) / i5, dur: n5 / i5 };
    }
    function g4() {
      var t4 = n4.track.details;
      t4 && (a4 = t4.min, o4 = t4.max, u4 = t4.minIdx, s4 = t4.maxIdx);
    }
    function b4() {
      n4.animator.stop();
    }
    n4.on("updated", g4), n4.on("optionsChanged", g4), n4.on("created", g4), n4.on("dragStarted", function() {
      e4 = false, b4(), t3 = i4 = n4.track.details.abs;
    }), n4.on("dragChecked", function() {
      e4 = true;
    }), n4.on("dragEnded", function() {
      var e5 = n4.options.mode;
      "snap" === e5 && function() {
        var e6 = n4.track, r5 = n4.track.details, u5 = r5.position, s5 = l3(v3());
        (u5 > o4 || u5 < a4) && (s5 = 0);
        var c5 = t3 + s5;
        0 === r5.slides[e6.absToRel(c5)].portion && (c5 -= s5), t3 !== i4 && (c5 = i4), l3(e6.idxToDist(c5, true)) !== s5 && (c5 += s5), c5 = f4(c5);
        var d4 = e6.idxToDist(c5, true);
        n4.animator.start([{ distance: d4, duration: 500, easing: function(n5) {
          return 1 + --n5 * n5 * n5 * n5 * n5;
        } }]);
      }(), "free" !== e5 && "free-snap" !== e5 || h4();
    }), n4.on("dragged", function() {
      i4 = n4.track.details.abs;
    });
  }
  function b3(n4) {
    var t3, i4, e4, r4, a4, f4, p4, v3, h4, m4, g4, b4, x3, k3, y4, w3, M2, T2, C2 = c3();
    function E3(t4) {
      if (f4 && v3 === t4.id) {
        var o4 = D2(t4);
        if (h4) {
          if (!A3(t4)) return I2(t4);
          m4 = o4, h4 = false, n4.emit("dragChecked");
        }
        if (w3) return m4 = o4;
        u3(t4);
        var c4 = function(t5) {
          if (M2 === -1 / 0 && T2 === 1 / 0) return t5;
          var e5 = n4.track.details, o5 = e5.length, u4 = e5.position, s4 = d3(t5, M2 - u4, T2 - u4);
          if (0 === o5) return 0;
          if (!n4.options.rubberband) return s4;
          if (u4 <= T2 && u4 >= M2) return t5;
          if (u4 < M2 && i4 > 0 || u4 > T2 && i4 < 0) return t5;
          var c5 = (u4 < M2 ? u4 - M2 : u4 - T2) / o5, l4 = r4 * o5, f5 = Math.abs(c5 * l4), p5 = Math.max(0, 1 - f5 / a4 * 2);
          return p5 * p5 * t5;
        }(p4(m4 - o4) / r4 * e4);
        i4 = l3(c4);
        var x4 = n4.track.details.position;
        (x4 > M2 && x4 < T2 || x4 === M2 && i4 > 0 || x4 === T2 && i4 < 0) && s3(t4), g4 += c4, !b4 && Math.abs(g4 * r4) > 5 && (b4 = true), n4.track.add(c4), m4 = o4, n4.emit("dragged");
      }
    }
    function z(t4) {
      !f4 && n4.track.details && n4.track.details.length && (g4 = 0, f4 = true, b4 = false, h4 = true, v3 = t4.id, A3(t4), m4 = D2(t4), n4.emit("dragStarted"));
    }
    function I2(t4) {
      f4 && v3 === t4.idChanged && (f4 = false, n4.emit("dragEnded"));
    }
    function A3(n5) {
      var t4 = L2(), i5 = t4 ? n5.y : n5.x, e5 = t4 ? n5.x : n5.y, r5 = void 0 !== x3 && void 0 !== k3 && Math.abs(k3 - e5) <= Math.abs(x3 - i5);
      return x3 = i5, k3 = e5, r5;
    }
    function D2(n5) {
      return L2() ? n5.y : n5.x;
    }
    function L2() {
      return n4.options.vertical;
    }
    function S3() {
      r4 = n4.size, a4 = L2() ? window.innerHeight : window.innerWidth;
      var t4 = n4.track.details;
      t4 && (M2 = t4.min, T2 = t4.max);
    }
    function O2(n5) {
      b4 && (s3(n5), u3(n5));
    }
    function _2() {
      if (C2.purge(), n4.options.drag && !n4.options.disabled) {
        var i5;
        i5 = n4.options.dragSpeed || 1, p4 = "function" == typeof i5 ? i5 : function(n5) {
          return n5 * i5;
        }, e4 = n4.options.rtl ? -1 : 1, S3(), t3 = n4.container, function() {
          var n5 = "data-keen-slider-clickable";
          o3("[".concat(n5, "]:not([").concat(n5, "=false])"), t3).map(function(n6) {
            C2.add(n6, "dragstart", s3), C2.add(n6, "mousedown", s3), C2.add(n6, "touchstart", s3);
          });
        }(), C2.add(t3, "dragstart", function(n5) {
          u3(n5);
        }), C2.add(t3, "click", O2, { capture: true }), C2.input(t3, "ksDragStart", z), C2.input(t3, "ksDrag", E3), C2.input(t3, "ksDragEnd", I2), C2.input(t3, "mousedown", z), C2.input(t3, "mousemove", E3), C2.input(t3, "mouseleave", I2), C2.input(t3, "mouseup", I2), C2.input(t3, "touchstart", z, { passive: true }), C2.input(t3, "touchmove", E3, { passive: false }), C2.input(t3, "touchend", I2), C2.input(t3, "touchcancel", I2), C2.add(window, "wheel", function(n5) {
          f4 && u3(n5);
        });
        var r5 = "data-keen-slider-scrollable";
        o3("[".concat(r5, "]:not([").concat(r5, "=false])"), n4.container).map(function(n5) {
          return function(n6) {
            var t4;
            C2.input(n6, "touchstart", function(n7) {
              t4 = D2(n7), w3 = true, y4 = true;
            }, { passive: true }), C2.input(n6, "touchmove", function(i6) {
              var e5 = L2(), r6 = e5 ? n6.scrollHeight - n6.clientHeight : n6.scrollWidth - n6.clientWidth, a5 = t4 - D2(i6), o4 = e5 ? n6.scrollTop : n6.scrollLeft, s4 = e5 && "scroll" === n6.style.overflowY || !e5 && "scroll" === n6.style.overflowX;
              if (t4 = D2(i6), (a5 < 0 && o4 > 0 || a5 > 0 && o4 < r6) && y4 && s4) return w3 = true;
              y4 = false, u3(i6), w3 = false;
            }), C2.input(n6, "touchend", function() {
              w3 = false;
            });
          }(n5);
        });
      }
    }
    n4.on("updated", S3), n4.on("optionsChanged", _2), n4.on("created", _2), n4.on("destroyed", C2.purge);
  }
  function x2(n4) {
    var t3, i4, e4 = null;
    function r4(t4, i5, e5) {
      n4.animator.active ? o4(t4, i5, e5) : requestAnimationFrame(function() {
        return o4(t4, i5, e5);
      });
    }
    function a4() {
      r4(false, false, i4);
    }
    function o4(i5, r5, a5) {
      var o5 = 0, u5 = n4.size, d5 = n4.track.details;
      if (d5 && t3) {
        var l5 = d5.slides;
        t3.forEach(function(n5, t4) {
          if (i5) !e4 && r5 && s4(n5, null, a5), c4(n5, null, a5);
          else {
            if (!l5[t4]) return;
            var d6 = l5[t4].size * u5;
            !e4 && r5 && s4(n5, d6, a5), c4(n5, l5[t4].distance * u5 - o5, a5), o5 += d6;
          }
        });
      }
    }
    function u4(t4) {
      return "performance" === n4.options.renderMode ? Math.round(t4) : t4;
    }
    function s4(n5, t4, i5) {
      var e5 = i5 ? "height" : "width";
      null !== t4 && (t4 = u4(t4) + "px"), n5.style["min-" + e5] = t4, n5.style["max-" + e5] = t4;
    }
    function c4(n5, t4, i5) {
      if (null !== t4) {
        t4 = u4(t4);
        var e5 = i5 ? t4 : 0;
        t4 = "translate3d(".concat(i5 ? 0 : t4, "px, ").concat(e5, "px, 0)");
      }
      n5.style.transform = t4, n5.style["-webkit-transform"] = t4;
    }
    function d4() {
      t3 && (o4(true, true, i4), t3 = null), n4.on("detailsChanged", a4, true);
    }
    function l4() {
      r4(false, true, i4);
    }
    function f4() {
      d4(), i4 = n4.options.vertical, n4.options.disabled || "custom" === n4.options.renderMode || (e4 = "auto" === p3(n4.options.slides, "perView", null), n4.on("detailsChanged", a4), (t3 = n4.slides).length && l4());
    }
    n4.on("created", f4), n4.on("optionsChanged", f4), n4.on("beforeOptionsChanged", function() {
      d4();
    }), n4.on("updated", l4), n4.on("destroyed", d4);
  }
  function k2(t3, i4) {
    return function(e4) {
      var r4, u4, s4, d4, l4, v3, h4 = c3();
      function m4(n4) {
        var t4;
        a3(e4.container, "reverse", "rtl" !== (t4 = e4.container, window.getComputedStyle(t4, null).getPropertyValue("direction")) || n4 ? null : ""), a3(e4.container, "v", e4.options.vertical && !n4 ? "" : null), a3(e4.container, "disabled", e4.options.disabled && !n4 ? "" : null);
      }
      function g4() {
        b4() && M2();
      }
      function b4() {
        var t4 = null;
        if (d4.forEach(function(n4) {
          n4.matches && (t4 = n4.__media);
        }), t4 === r4) return false;
        r4 || e4.emit("beforeOptionsChanged"), r4 = t4;
        var i5 = t4 ? s4.breakpoints[t4] : s4;
        return e4.options = n3(n3({}, s4), i5), m4(), I2(), A3(), C2(), true;
      }
      function x3(n4) {
        var t4 = f3(n4);
        return (e4.options.vertical ? t4.height : t4.width) / e4.size || 1;
      }
      function k3() {
        return e4.options.trackConfig.length;
      }
      function y4(t4) {
        for (var a4 in r4 = false, s4 = n3(n3({}, i4), t4), h4.purge(), u4 = e4.size, d4 = [], s4.breakpoints || []) {
          var o4 = window.matchMedia(a4);
          o4.__media = a4, d4.push(o4), h4.add(o4, "change", g4);
        }
        h4.add(window, "orientationchange", z), h4.add(window, "resize", E3), b4();
      }
      function w3(n4) {
        e4.animator.stop();
        var t4 = e4.track.details;
        e4.track.init(null != n4 ? n4 : t4 ? t4.abs : 0);
      }
      function M2(n4) {
        w3(n4), e4.emit("optionsChanged");
      }
      function T2(n4, t4) {
        if (n4) return y4(n4), void M2(t4);
        I2(), A3();
        var i5 = k3();
        C2(), k3() !== i5 ? M2(t4) : w3(t4), e4.emit("updated");
      }
      function C2() {
        var n4 = e4.options.slides;
        if ("function" == typeof n4) return e4.options.trackConfig = n4(e4.size, e4.slides);
        for (var t4 = e4.slides, i5 = t4.length, r5 = "number" == typeof n4 ? n4 : p3(n4, "number", i5, true), a4 = [], o4 = p3(n4, "perView", 1, true), u5 = p3(n4, "spacing", 0, true) / e4.size || 0, s5 = "auto" === o4 ? u5 : u5 / o4, c4 = p3(n4, "origin", "auto"), d5 = 0, l5 = 0; l5 < r5; l5++) {
          var f4 = "auto" === o4 ? x3(t4[l5]) : 1 / o4 - u5 + s5, v4 = "center" === c4 ? 0.5 - f4 / 2 : "auto" === c4 ? 0 : c4;
          a4.push({ origin: v4, size: f4, spacing: u5 }), d5 += f4;
        }
        if (d5 += u5 * (r5 - 1), "auto" === c4 && !e4.options.loop && 1 !== o4) {
          var h5 = 0;
          a4.map(function(n5) {
            var t5 = d5 - h5;
            return h5 += n5.size + u5, t5 >= 1 || (n5.origin = 1 - t5 - (d5 > 1 ? 0 : 1 - d5)), n5;
          });
        }
        e4.options.trackConfig = a4;
      }
      function E3() {
        I2();
        var n4 = e4.size;
        e4.options.disabled || n4 === u4 || (u4 = n4, T2());
      }
      function z() {
        E3(), setTimeout(E3, 500), setTimeout(E3, 2e3);
      }
      function I2() {
        var n4 = f3(e4.container);
        e4.size = (e4.options.vertical ? n4.height : n4.width) || 1;
      }
      function A3() {
        e4.slides = o3(e4.options.selector, e4.container);
      }
      e4.container = (v3 = o3(t3, l4 || document)).length ? v3[0] : null, e4.destroy = function() {
        h4.purge(), e4.emit("destroyed"), m4(true);
      }, e4.prev = function() {
        e4.moveToIdx(e4.track.details.abs - 1, true);
      }, e4.next = function() {
        e4.moveToIdx(e4.track.details.abs + 1, true);
      }, e4.update = T2, y4(e4.options);
    };
  }
  var y3 = function(n4, i4, e4) {
    try {
      return function(n5, t3) {
        var i5, e5 = {};
        return i5 = { emit: function(n6) {
          e5[n6] && e5[n6].forEach(function(n7) {
            n7(i5);
          });
          var t4 = i5.options && i5.options[n6];
          t4 && t4(i5);
        }, moveToIdx: function(n6, t4, e6) {
          var r4 = i5.track.idxToDist(n6, t4);
          if (r4) {
            var a4 = i5.options.defaultAnimation;
            i5.animator.start([{ distance: r4, duration: p3(e6 || a4, "duration", 500), easing: p3(e6 || a4, "easing", function(n7) {
              return 1 + --n7 * n7 * n7 * n7 * n7;
            }) }]);
          }
        }, on: function(n6, t4, i6) {
          void 0 === i6 && (i6 = false), e5[n6] || (e5[n6] = []);
          var r4 = e5[n6].indexOf(t4);
          r4 > -1 ? i6 && delete e5[n6][r4] : i6 || e5[n6].push(t4);
        }, options: n5 }, function() {
          if (i5.track = m3(i5), i5.animator = h3(i5), t3) for (var n6 = 0, e6 = t3; n6 < e6.length; n6++) (0, e6[n6])(i5);
          i5.track.init(i5.options.initial || 0), i5.emit("created");
        }(), i5;
      }(i4, t2([k2(n4, { drag: true, mode: "snap", renderMode: "precision", rubberband: true, selector: ".keen-slider__slide" }), x2, b3, g3], e4 || [], true));
    } catch (n5) {
      console.error(n5);
    }
  };

  // src/theme/js/alpine/keen-slider.js
  function WheelControls(slider) {
    var touchTimeout;
    var position;
    var wheelActive;
    function dispatch2(e4, name) {
      position.x -= e4.deltaX;
      position.y -= e4.deltaY;
      slider.container.dispatchEvent(
        new CustomEvent(name, {
          detail: {
            x: position.x,
            y: position.y
          }
        })
      );
    }
    function wheelStart(e4) {
      position = {
        x: e4.pageX,
        y: e4.pageY
      };
      dispatch2(e4, "ksDragStart");
    }
    function wheel(e4) {
      dispatch2(e4, "ksDrag");
    }
    function wheelEnd(e4) {
      dispatch2(e4, "ksDragEnd");
    }
    function eventWheel(e4) {
      if (!wheelActive) {
        wheelStart(e4);
        wheelActive = true;
      }
      wheel(e4);
      clearTimeout(touchTimeout);
      touchTimeout = setTimeout(() => {
        wheelActive = false;
        wheelEnd(e4);
      }, 50);
    }
    slider.on("created", () => {
      slider.container.addEventListener("wheel", eventWheel, {
        passive: false
      });
    });
  }
  var MutationPlugin = (slider) => {
    const observer2 = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        console.log("KS keen slider mutation...", mutation);
        slider.update();
      });
    });
    const config2 = { childList: true };
    slider.on("created", () => {
      observer2.observe(slider.container, config2);
    });
    slider.on("destroyed", () => {
      observer2.disconnect();
    });
  };
  var navigationPlugin = (slider) => {
    let wrapper, dots, arrowLeft, arrowRight;
    function markup(remove) {
      wrapperMarkup(remove);
      dotMarkup(remove);
      arrowMarkup(remove);
    }
    function removeElement(elment) {
      elment.parentNode.removeChild(elment);
    }
    function createDiv(className) {
      var div = document.createElement("div");
      var classNames = className.split(" ");
      classNames.forEach((name) => div.classList.add(name));
      return div;
    }
    function arrowMarkup(remove) {
      if (remove) {
        removeElement(arrowLeft);
        removeElement(arrowRight);
        return;
      }
      arrowLeft = createDiv("arrow arrow--left");
      arrowLeft.addEventListener("click", () => slider.prev());
      arrowRight = createDiv("arrow arrow--right");
      arrowRight.addEventListener("click", () => slider.next());
      wrapper.appendChild(arrowLeft);
      wrapper.appendChild(arrowRight);
    }
    function wrapperMarkup(remove) {
      wrapper = slider.container.parentNode;
    }
    function dotMarkup(remove) {
      if (remove) {
        removeElement(dots);
        return;
      }
      dots = createDiv("dots");
      slider.track.details.slides.forEach((_e, idx) => {
        var dot = createDiv("dot");
        dot.addEventListener("click", () => slider.moveToIdx(idx));
        dots.appendChild(dot);
      });
      wrapper.appendChild(dots);
    }
    function updateClasses() {
      var slide = slider.track.details.rel;
      slide === 0 ? arrowLeft.classList.add("arrow--disabled") : arrowLeft.classList.remove("arrow--disabled");
      slide === slider.track.details.slides.length - 1 ? arrowRight.classList.add("arrow--disabled") : arrowRight.classList.remove("arrow--disabled");
      Array.from(dots.children).forEach(function(dot, idx) {
        idx === slide ? dot.classList.add("dot--active") : dot.classList.remove("dot--active");
      });
    }
    slider.on("created", () => {
      markup();
      updateClasses();
    });
    slider.on("optionsChanged", () => {
      markup(true);
      markup();
      updateClasses();
    });
    slider.on("slideChanged", () => {
      updateClasses();
    });
    slider.on("destroyed", () => {
      markup(true);
    });
  };
  init(() => {
    module_default.data("keenslider", () => ({
      currentIndex: 0,
      slider: null,
      init(args) {
        let $ref = this.$el;
        let settings = this.$el.dataset.settings && this.$el.dataset.settings !== "" ? JSON.parse(this.$el.dataset.settings) : {};
        let defaults2 = {
          loop: true
        };
        let opts = { ...defaults2, ...settings };
        if (settings.fade) {
          opts.renderMode = "custom";
          opts.detailsChanged = (s4) => {
            s4.slides.forEach((element, idx) => {
              element.style.opacity = s4.track.details.slides[idx].portion;
            });
          };
          this.$el.classList.add("fade-slider");
          Array.from(this.$el.children).forEach((c4) => {
            c4.classList.add("fader__slide");
          });
        } else {
          this.$el.classList.add("keen-slider");
          Array.from(this.$el.children).forEach((child) => {
            child.classList.add("keen-slider__slide");
          });
        }
        let plugins = [];
        plugins.push(MutationPlugin);
        if (settings.autoplay) {
          plugins.push(autoplayPlugin);
        }
        if (settings.navigation) {
          plugins.push(navigationPlugin);
        }
        if (settings.wheel) {
          plugins.push(WheelControls);
        }
        this.$nextTick(() => {
          const keenslider = new y3($ref, opts, plugins);
          console.log("KS Keen Slider", plugins);
          keenslider.on("slideChanged", (s4) => {
            this.currentIndex = s4.track.details.rel;
            this.$dispatch("slide-change", s4.track.details.rel);
          });
          this.slider = keenslider;
          this.$dispatch("keenslider", keenslider);
        });
      },
      destroy() {
        if (this.slider) this.slider.destroy();
      }
    }));
  });

  // src/components/horizontalswiper/horizontalswiper.js
  init(() => {
    module_default.data("horizontalswiper", () => ({
      mutationObserver: null,
      hasInit: 0,
      isDragging: false,
      willScroll: false,
      scrollEnded: false,
      hasScrolled: false,
      startX: 0,
      startLeft: 0,
      scrollLeft: 0,
      targetScrollLeft: 0,
      animationFrameId: null,
      motionTween: null,
      listeners: [],
      init() {
        this.$nextTick(() => {
          this.refreshScrollState();
        });
        const scrollContainer = this.$refs.scrollContainer;
        const startDragHandler = (e4) => this.startDrag(e4);
        const stopDragHandler = (e4) => this.stopDrag(e4);
        const onDragHandler = (e4) => this.onDrag(e4);
        const wheelHandler = () => {
          this.isDragging = false;
          this.refreshScrollState();
        };
        const touchStartHandler = (e4) => this.refreshScrollState();
        const touchMoveHandler = (e4) => this.refreshScrollState();
        const touchEndHandler = () => this.refreshScrollState();
        const resizeHandler = this.debounce(() => this.refreshScrollState(), 200);
        scrollContainer.addEventListener("mousedown", startDragHandler);
        scrollContainer.addEventListener("mouseup", stopDragHandler);
        scrollContainer.addEventListener("mouseleave", stopDragHandler);
        scrollContainer.addEventListener("mousemove", onDragHandler);
        scrollContainer.addEventListener("wheel", wheelHandler);
        scrollContainer.addEventListener("touchstart", touchStartHandler);
        scrollContainer.addEventListener("touchmove", touchMoveHandler);
        scrollContainer.addEventListener("touchend", touchEndHandler);
        window.addEventListener("resize", resizeHandler);
        this.listeners.push(
          { el: scrollContainer, event: "mousedown", handler: startDragHandler },
          { el: scrollContainer, event: "mouseup", handler: stopDragHandler },
          { el: scrollContainer, event: "mouseleave", handler: stopDragHandler },
          { el: scrollContainer, event: "mousemove", handler: onDragHandler },
          { el: scrollContainer, event: "wheel", handler: wheelHandler },
          {
            el: scrollContainer,
            event: "touchstart",
            handler: touchStartHandler
          },
          { el: scrollContainer, event: "touchmove", handler: touchMoveHandler },
          { el: scrollContainer, event: "touchend", handler: touchEndHandler },
          { el: window, event: "resize", handler: resizeHandler }
        );
        this.mutationObserver = new MutationObserver(() => {
          this.refreshScrollState();
        });
        this.mutationObserver.observe(this.$refs.scrollContainer, {
          childList: true,
          // Detect direct children added/removed
          subtree: true
          // Set to true if changes deeper inside children matter
        });
        this.hasInit = 1;
      },
      classes() {
        return [
          "is-ready",
          this.isDragging && "is-dragging",
          this.hasScrolled && "has-scrolled",
          this.willScroll && "will-scroll",
          this.scrollEnded && "scroll-ended"
        ].filter(Boolean).join(" ");
      },
      startDrag(event) {
        this.cancelTween();
        this.isDragging = true;
        this.startX = event.pageX - this.$refs.scrollContainer.offsetLeft;
        this.startLeft = this.$refs.scrollContainer.scrollLeft;
        this.scrollLeft = this.$refs.scrollContainer.scrollLeft;
        this.$refs.scrollContainer.style.cursor = "grabbing";
        this.startAnimation();
      },
      stopDrag(mouseEvent) {
        if (mouseEvent) {
          mouseEvent.stopPropagation();
          mouseEvent.preventDefault();
        }
        this.isDragging = false;
        this.$refs.scrollContainer.style.cursor = "grab";
        setTimeout(() => this.stopAnimation(), 200);
      },
      onDrag(event) {
        if (!this.isDragging) return;
        event.preventDefault();
        const x3 = event.pageX - this.$refs.scrollContainer.offsetLeft;
        const walk2 = x3 - this.startX;
        this.targetScrollLeft = this.startLeft - walk2 * 2;
      },
      startAnimation() {
        const lerp = (start2, end, t3) => start2 + (end - start2) * t3;
        const animate3 = () => {
          if (this.isDragging || this.isAnimating) {
            const current = this.$refs.scrollContainer.scrollLeft;
            const newScroll = lerp(current, this.targetScrollLeft, 0.1);
            this.$refs.scrollContainer.scrollLeft = newScroll;
            this.refreshScrollState();
            this.animationFrameId = requestAnimationFrame(animate3);
          }
        };
        animate3();
      },
      stopAnimation() {
        if (this.animationFrameId) {
          cancelAnimationFrame(this.animationFrameId);
          this.animationFrameId = null;
        }
        this.refreshScrollState();
      },
      cancelTween() {
        if (this.motionTween && typeof this.motionTween.cancel === "function") {
          this.motionTween.cancel();
          this.motionTween = null;
        }
      },
      refreshScrollState() {
        const el = this.$refs.scrollContainer;
        this.scrollLeft = el.scrollLeft;
        this.targetScrollLeft = this.scrollLeft;
        this.hasScrolled = this.scrollLeft > 0;
        this.willScroll = el.scrollWidth > el.clientWidth;
        this.scrollEnded = Math.ceil(el.scrollLeft + el.clientWidth) >= el.scrollWidth;
      },
      reset() {
        const el = this.$refs.scrollContainer;
        el.scrollLeft = 0;
        this.refreshScrollState();
      },
      go(direction = "next") {
        const el = this.$refs.scrollContainer;
        const step = el.clientWidth;
        const start2 = el.scrollLeft;
        const max = el.scrollWidth - el.clientWidth;
        let target = direction === "next" ? Math.min(start2 + step, max) : Math.max(start2 - step, 0);
        this.cancelTween();
        this.motionTween = animate2(
          (progress2) => {
            el.scrollLeft = start2 + (target - start2) * progress2;
            this.refreshScrollState();
          },
          {
            duration: 0.5,
            ease: "cubic-bezier(0.33, 1, 0.68, 1)"
          }
        );
        this.motionTween.finished.then(() => {
          this.scrollLeft = el.scrollLeft;
          this.targetScrollLeft = this.scrollLeft;
          this.refreshScrollState();
          this.motionTween = null;
        });
      },
      next() {
        this.go("next");
      },
      prev() {
        this.go("prev");
      },
      debounce(func, wait) {
        let timeout;
        return (...args) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(this, args), wait);
        };
      },
      destroy() {
        this.cancelTween();
        this.stopAnimation();
        this.listeners.forEach(
          ({ el, event, handler: handler3 }) => el.removeEventListener(event, handler3)
        );
        this.listeners = [];
        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
          this.mutationObserver = null;
        }
      }
    }));
  });

  // src/components/interface/interface.js
  init(() => {
    module_default.data("interface", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/logo/logo.js
  init(() => {
    module_default.data("logo", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // node_modules/@alpinejs/intersect/dist/module.esm.js
  function src_default2(Alpine3) {
    Alpine3.directive("intersect", Alpine3.skipDuringClone((el, { value, expression, modifiers }, { evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
      let evaluate2 = evaluateLater2(expression);
      let options = {
        rootMargin: getRootMargin(modifiers),
        threshold: getThreshold(modifiers)
      };
      let observer2 = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting === (value === "leave"))
            return;
          evaluate2();
          modifiers.includes("once") && observer2.disconnect();
        });
      }, options);
      observer2.observe(el);
      cleanup2(() => {
        observer2.disconnect();
      });
    }));
  }
  function getThreshold(modifiers) {
    if (modifiers.includes("full"))
      return 0.99;
    if (modifiers.includes("half"))
      return 0.5;
    if (!modifiers.includes("threshold"))
      return 0;
    let threshold = modifiers[modifiers.indexOf("threshold") + 1];
    if (threshold === "100")
      return 1;
    if (threshold === "0")
      return 0;
    return Number(`.${threshold}`);
  }
  function getLengthValue(rawValue) {
    let match2 = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
    return match2 ? match2[1] + (match2[2] || "px") : void 0;
  }
  function getRootMargin(modifiers) {
    const key = "margin";
    const fallback = "0px 0px 0px 0px";
    const index = modifiers.indexOf(key);
    if (index === -1)
      return fallback;
    let values = [];
    for (let i4 = 1; i4 < 5; i4++) {
      values.push(getLengthValue(modifiers[index + i4] || ""));
    }
    values = values.filter((v3) => v3 !== void 0);
    return values.length ? values.join(" ").trim() : fallback;
  }
  var module_default2 = src_default2;

  // src/theme/js/alpine/image.js
  module_default.plugin(module_default2);
  init(() => {
    module_default.data("image", () => ({
      isLoading: false,
      loaded: false,
      state() {
        if (this.loaded) return "loaded";
        if (this.isLoading) return "loading";
        return "passive";
      },
      init(args) {
        if (!this.$el.getAttribute("x-bind")) {
          this.$nextTick(() => {
            this.load();
            this.$el.classList.add("loaded");
          });
        }
      },
      setImage() {
        let src = this.$el.dataset.src;
        let fit = this.$el.dataset.fit || "natural";
        let alt = this.$el.dataset.alt || `Image from ${window.location.hostname}`;
        if (src) {
          this.$el.innerHTML = `<img src="${src}" alt="${alt}" class="block w-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${fit === "natural" ? "object-none" : ""} ${fit === "cover" ? "h-full object-cover" : ""} ${fit === "contain" ? "h-full object-contain" : ""}" />`;
        }
      },
      load() {
        let src = this.$el.getAttribute("data-src");
        if (src) {
          this.isLoading = true;
          let i4 = new Image();
          i4.onload = () => {
            this.setImage();
            setTimeout(() => {
              this.isLoading = false;
              this.loaded = true;
            }, 0);
          };
          i4.src = src;
        }
      },
      lazy: {
        [":class"]() {
          return `${this.state()}`;
        },
        ["x-intersect.once"]() {
          setTimeout(() => {
            this.load();
          }, 0);
        }
      }
    }));
  });

  // src/theme/js/alpine/video.js
  module_default.plugin(module_default2);
  init(() => {
    module_default.data("video", () => ({
      isLoading: false,
      isVisible: false,
      loaded: false,
      state() {
        if (this.loaded) return "loaded";
        if (this.isLoading) return "loading";
        return "passive";
      },
      init(args) {
        if (!this.$el.getAttribute("x-bind")) this.load();
        else this.load();
      },
      setVideo() {
        let src = this.$el.dataset.src;
        let poster = this.$el.dataset.poster;
        let fit = this.$el.dataset.fit || "natural";
        let srcTemplate = this.$refs.src;
        if (src || srcTemplate) {
          this.$el.innerHTML = `<video preload ${!this.$el.getAttribute("x-bind") ? "autoplay" : ""} loop muted playsinline ${src ? `src="${src}"` : ""} ${poster ? `poster="${poster}"` : ""} class="block w-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${fit === "natural" ? "object-none" : ""} ${fit === "cover" ? "h-full object-cover" : ""} ${fit === "contain" ? "h-full object-contain" : ""}">
				${srcTemplate ? `${srcTemplate.innerHTML}` : ""}
				</video>`;
        }
      },
      play() {
        if (!this.loaded) return;
        let $video = this.$el.querySelector("video");
        $video.setAttribute("autoplay", "");
        $video.play();
      },
      load() {
        let src = this.$el.getAttribute("data-src");
        let srcTemplate = this.$refs.src;
        if (src || srcTemplate) {
          this.isLoading = true;
          setTimeout(() => {
            this.isLoading = false;
            this.loaded = true;
            this.setVideo();
            let $video = this.$el.querySelector("video");
            setTimeout(() => {
              $video.load();
              if (this.isVisible) {
                this.play();
              }
            }, 0);
          }, 0);
        }
      },
      lazy: {
        [":class"]() {
          return `${this.state()}`;
        },
        ["x-intersect.once"]() {
          this.isVisible = true;
          this.play();
        }
      }
    }));
  });

  // src/components/media/media.js
  init(() => {
    module_default.data("media", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/megaMenu/megaMenu.js
  init(() => {
    module_default.data("megaMenu", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/minimumOrderCheckoutButton/minimumOrderCheckoutButton.js
  document.addEventListener("alpine:init", () => {
    Alpine.data("minimumOrderCheckoutButton", () => ({
      showMessage: false,
      disabled: false,
      minimumOrderValue: 0,
      minimumOrderMessage: "",
      init() {
        var _a, _b;
        this.minimumOrderValue = ((_a = window.minimumOrderConfig) == null ? void 0 : _a.value) || 0;
        this.minimumOrderMessage = ((_b = window.minimumOrderConfig) == null ? void 0 : _b.message) || "";
        this.setupEventListeners();
        this.validateMinimumOrder();
      },
      setupEventListeners() {
        document.addEventListener("theme:cart:change", () => {
          setTimeout(() => this.validateMinimumOrder(), 100);
        });
        document.addEventListener("theme:cart:reload", () => {
          setTimeout(() => this.validateMinimumOrder(), 200);
        });
        document.addEventListener("theme:cart-drawer:show", () => {
          setTimeout(() => this.validateMinimumOrder(), 100);
        });
        document.addEventListener("theme:product:added", () => {
          setTimeout(() => this.validateMinimumOrder(), 150);
        });
        document.addEventListener("change", (event) => {
          const quantityInput = event.target;
          if (quantityInput.matches("[data-cart-quantity-input]") || quantityInput.closest("[data-cart-item]")) {
            clearTimeout(this.quantityChangeTimeout);
            this.quantityChangeTimeout = setTimeout(() => {
              this.validateMinimumOrder();
            }, 300);
          }
        });
      },
      async validateMinimumOrder() {
        var _a;
        try {
          const response = await fetch("/cart.js");
          if (!response.ok) {
            throw new Error("Failed to fetch cart data");
          }
          const cart = await response.json();
          const cartTotal = cart.total_price / 100;
          const minimumOrderValue = ((_a = window.minimumOrderConfig) == null ? void 0 : _a.value) || 0;
          const remainingAmount = minimumOrderValue - cartTotal;
          this.updateState(remainingAmount > 0);
          document.dispatchEvent(new CustomEvent("theme:minimum-order:updated", {
            detail: {
              cartTotal,
              minimumOrderValue,
              remainingAmount,
              isMinimumReached: remainingAmount <= 0
            }
          }));
        } catch (error2) {
        }
      },
      updateState(shouldShow) {
        this.showMessage = shouldShow;
        this.disabled = shouldShow && this.minimumOrderValue > 0;
        const button = this.$el;
        const buttonContainer = button.closest("[data-cart-checkout-buttons]") || button.closest(".cart__buttons");
        if (this.disabled) {
          button.classList.add("btn--disabled");
          buttonContainer == null ? void 0 : buttonContainer.classList.add("cart__buttons--disabled", "cart__buttons--minimum-order-disabled");
        } else {
          button.classList.remove("btn--disabled");
          buttonContainer == null ? void 0 : buttonContainer.classList.remove("cart__buttons--disabled", "cart__buttons--minimum-order-disabled");
        }
      }
    }));
  });

  // src/components/modalDropdown/modalDropdown.js
  init(() => {
    module_default.data("modalDropdown", () => ({
      isOpen: false,
      selectedItems: [],
      name: "",
      mode: "multi",
      // "multi" or "radio"
      autoClose: false,
      // "true" or "false"
      updateProps(props) {
        if (props) this.selectedItems = props || [];
        else this.selectedItems = [];
      },
      toggle() {
        this.isOpen = !this.isOpen;
      },
      close() {
        this.isOpen = false;
      },
      reset() {
        this.selectedItems = [];
        this.$dispatch("dropdown-updated", {
          name: this.name,
          selection: this.selectedItems
        });
      },
      toggleItem(item) {
        if (this.mode === "radio") {
          const isCurrentlySelected = this.selectedItems.some((i4) => i4.id === item.id);
          if (isCurrentlySelected) {
            this.selectedItems = [];
          } else {
            this.selectedItems = [item];
          }
        } else {
          const index = this.selectedItems.findIndex((i4) => i4.id === item.id);
          if (index === -1) {
            this.selectedItems.push(item);
          } else {
            this.selectedItems.splice(index, 1);
          }
        }
        this.$dispatch("dropdown-updated", {
          name: this.name,
          selection: this.selectedItems
        });
        if (this.autoClose) {
          this.close();
        }
      },
      isSelected(item) {
        return this.selectedItems.some((i4) => i4.id === item.id);
      },
      selection() {
        if (!this.selectedItems.length) return false;
        return this.selectedItems.map((i4) => i4.label);
      },
      label() {
        if (this.selectedItems.length <= 2) return this.selection().join(" & ");
        else
          return `${this.selection()[0]} & ${this.selection().length - 1} other`;
      },
      init(args) {
        this.name = this.$el.dataset.name;
        this.mode = this.$el.dataset.mode || "multi";
        this.autoClose = this.$el.dataset.autoClose === "true";
        this.$nextTick(() => {
          this.name = this.$el.dataset.name;
          this.mode = this.$el.dataset.mode || "multi";
          this.autoClose = this.$el.dataset.autoClose === "true";
        });
      },
      destroy() {
      }
    }));
  });

  // src/components/pageLoadIndicator/pageLoadIndicator.js
  init(() => {
    module_default.data("pageLoadIndicator", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/pdfSaver/pdfSaver.js
  init(() => {
    module_default.data("pdfSaver", () => ({
      destroy() {
      },
      busy: false,
      html2pdfReady: false,
      jsPdfReady: false,
      init() {
        this.ensurejsPdfLoaded();
      },
      async ensurejsPdfLoaded() {
        if (this.jsPdfReady || window.jspdf) return;
        return new Promise((resolve, reject) => {
          const scriptId = "jspdf-lib";
          if (document.getElementById(scriptId)) {
            this.jsPdfReady = true;
            resolve();
            return;
          }
          const script = document.createElement("script");
          script.id = scriptId;
          script.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/3.0.1/jspdf.umd.min.js";
          script.onload = () => {
            this.jsPdfReady = true;
            resolve();
          };
          script.onerror = reject;
          document.head.appendChild(script);
        });
      },
      async ensureHtml2PdfLoaded() {
        if (this.html2pdfReady || window.html2pdf) return;
        return new Promise((resolve, reject) => {
          const scriptId = "html2pdf-lib";
          if (document.getElementById(scriptId)) {
            this.html2pdfReady = true;
            resolve();
            return;
          }
          const script = document.createElement("script");
          script.id = scriptId;
          script.src = "https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js";
          script.onload = () => {
            this.html2pdfReady = true;
            resolve();
          };
          script.onerror = reject;
          document.head.appendChild(script);
        });
      },
      async saveRasterPdf(ev) {
        this.busy = true;
        try {
          ev.stopPropagation();
          ev.preventDefault();
          if (!this.html2pdfReady) {
            await this.ensureHtml2PdfLoaded();
          }
          const target = this.$refs.pdf;
          if (!target) {
            console.warn('Missing x-ref="pdf" element');
            return;
          }
          const filename = ev.target.dataset.filename || "download.pdf";
          const opt = {
            margin: 0.5,
            filename,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "in", format: "letter", orientation: "portrait" }
          };
          await window.html2pdf().set(opt).from(target).save();
          this.busy = false;
        } catch (err) {
        }
        return;
      },
      async savePdf(ev) {
        const target = this.$refs.pdf;
        if (!target) {
          console.warn('Missing x-ref="pdf" element');
          return;
        }
        const filename = ev.target.dataset.filename || "download.pdf";
        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "none";
        document.body.appendChild(iframe);
        const doc = iframe.contentWindow.document;
        let styles = "";
        for (let sheet of document.styleSheets) {
          try {
            for (let rule of sheet.cssRules) {
              styles += rule.cssText;
            }
          } catch (e4) {
          }
        }
        let printDoc = `
        <html>
          <head>
            <title>${filename}</title>
            <style>${styles}</style>
          </head>
          <body>
            <div class="PDF">
            ${target.outerHTML}
            </div>
          </body>
        </html>
      `;
        doc.open();
        doc.write(printDoc);
        doc.close();
        iframe.onload = () => {
          setTimeout(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
          }, 300);
        };
        return;
      }
    }));
  });

  // src/components/randomIllustration/randomIllustration.js
  init(() => {
    module_default.data("randomIllustration", () => ({
      blocks: [],
      selectedIndex: null,
      init() {
        this.blocks = JSON.parse(this.$el.getAttribute("data-blocks"));
        this.selectedIndex = Math.floor(Math.random() * this.blocks.length);
      },
      destroy() {
      }
    }));
  });

  // src/components/recents/recents.js
  init(() => {
    module_default.store("recents", {
      items: JSON.parse(localStorage.getItem("recentItems")) || [],
      saveToLocalStorage() {
        localStorage.setItem("recentItems", JSON.stringify(this.items));
      },
      addItem(type, data3) {
        const newItem = { type, data: { ...data3 } };
        let hash = JSON.stringify(newItem);
        let newSet = this.items.filter((i4) => JSON.stringify(i4) !== hash);
        newSet.unshift(newItem);
        this.items = newSet;
        this.saveToLocalStorage();
        return newItem;
      },
      async getProducts() {
        let all = await module_default.store("siteData").getProductsAsync();
        let filtered = this.items.filter((i4) => i4.type === "product").map((i4) => {
          let found = all.filter((p4) => `${p4.id}` === `${i4.data.productId}`);
          if (found.length >= 1) {
            let product = found[0];
            if (!product.hasOnlyDefaultVariant && i4.data.variantId) {
              let v3 = found.filter(
                (p4) => p4.variantIds && p4.variantIds.includes(i4.data.variantId)
              );
              if (v3.length) {
                let variant = v3[0];
                let overrides = variant.variantData ? variant.variantData.find(
                  (v4) => `${v4.variantId}` === `${i4.data.variantId}`
                ) : null;
                return { ...variant, ...overrides };
              }
            }
            return {
              ...product,
              variantId: product.variantId || i4.data.variantId
            };
          }
          return null;
        }).filter(Boolean);
        return filtered;
      }
    });
    module_default.data("saveRecent", () => ({
      init(args) {
        let type = this.$el.dataset.type;
        let data3 = this.$el.dataset.data;
        if (data3) this.$store.recents.addItem(type, JSON.parse(data3));
      },
      destroy() {
      }
    }));
    module_default.data("recents", () => ({
      recents: [],
      // Store the loaded products here
      loading: false,
      async init(args) {
        await this.loadProducts();
        this.$watch("$store.recents.items", () => {
          this.loadProducts();
        });
        this.$watch("$store.siteData.productsCount", (newCount) => {
          if (newCount > 0 && this.recents.length === 0) {
            this.loadProducts();
          }
        });
      },
      async loadProducts() {
        if (this.loading) return;
        this.loading = true;
        try {
          this.recents = await this.$store.recents.getProducts();
        } catch (error2) {
          console.error("Error loading recents:", error2);
          this.recents = [];
        } finally {
          this.loading = false;
        }
      },
      destroy() {
      }
    }));
  });

  // src/components/saved/saved.js
  init(() => {
    module_default.store("saved", {
      folders: JSON.parse(localStorage.getItem("savedFolders")) || [],
      pendingSave: null,
      // Store the item that is pending save
      get total() {
        return this.folders.reduce((acc, folder) => acc + folder.items.length, 0);
      },
      saveToLocalStorage() {
        localStorage.setItem("savedFolders", JSON.stringify(this.folders));
      },
      generateUniqueId() {
        const timestamp = Date.now().toString();
        const randomString = Math.random().toString(36).substring(2, 8);
        return `${timestamp}-${randomString}`;
      },
      addFolder(name) {
        const newFolder = {
          id: this.generateUniqueId(),
          name,
          items: [],
          updated: Date.now()
        };
        this.folders.unshift(newFolder);
        this.saveToLocalStorage();
        return newFolder;
      },
      /*addFolder(name) {
              this.folders.unshift({ name: name, items: [] });
              this.folders = [...this.folders]; // Force reactive update
              this.saveToLocalStorage();
          },*/
      addItemToFolder(folderId, item) {
        const folder = this.folders.find((f4) => f4.id === folderId);
        if (folder) {
          const itemExists = folder.items.some((i4) => i4.id === item.id);
          if (itemExists) {
            alert("This item already exists in that collection.");
            return;
          }
          folder.items.unshift(item);
          folder.updated = Date.now();
          this.saveToLocalStorage();
        }
      },
      removeItemFromFolder(itemId, folderId) {
        const folder = this.folders.find((f4) => f4.id === folderId);
        if (folder) {
          folder.items = folder.items.filter((i4) => i4.id !== itemId);
          this.saveToLocalStorage();
        }
      },
      removeFolder(folderId) {
        this.folders = this.folders.filter((f4) => f4.id !== folderId);
        this.saveToLocalStorage();
      },
      get sortedFolders() {
        return this.folders.slice().sort((a4, b4) => b4.updated - a4.updated);
      },
      // Handle the pending save
      setPendingSave(item) {
        this.pendingSave = item;
      },
      async setPendingSaveById(id) {
        let item = await module_default.store("siteData").getProductByIdAsync(id);
        if (!item) {
          const products = await module_default.store("siteData").getProductsAsync();
          item = products.find(
            (product) => {
              var _a;
              return product.id === id || product.gid === id || product.gid === `gid://shopify/Product/${id}` || ((_a = product.variantIds) == null ? void 0 : _a.includes(id));
            }
          );
        }
        if (item) {
          this.pendingSave = item;
        }
      },
      // Clear the pending save
      clearPendingSave() {
        this.pendingSave = null;
      }
    });
    module_default.data("saved", () => ({
      newFolderName: "",
      selectedFolder: "",
      showFolderForm: false,
      init() {
        this.selectedFolder = this.$store.saved.folders.length > 0 ? this.$store.saved.folders[0] : "";
      },
      toggleFolderForm() {
        this.showFolderForm = !this.showFolderForm;
        this.newFolderName = "";
      },
      createFolder() {
        if (this.newFolderName.trim() !== "") {
          let f4 = this.$store.saved.addFolder(this.newFolderName.trim());
          this.newFolderName = "";
          this.showFolderForm = false;
        }
      },
      createFolderAndAddItem() {
        if (this.newFolderName.trim() !== "" && this.$store.saved.pendingSave) {
          let f4 = this.$store.saved.addFolder(this.newFolderName.trim());
          this.$store.saved.addItemToFolder(f4.id, this.$store.saved.pendingSave);
          this.newFolderName = "";
          this.showFolderForm = false;
        }
      },
      addFolder() {
        if (this.newFolderName.trim() !== "") {
          this.$store.saved.addFolder(this.newFolderName.trim());
          this.newFolderName = "";
          this.selectedFolder = this.$store.saved.folders.length > 0 ? this.$store.saved.folders[0].name : "";
        }
      },
      confirmRemoveFolder(id) {
        let folderContents = this.$store.saved.folders.find((f4) => f4.id === id);
        if (!folderContents || folderContents && !folderContents.items.length) {
          this.$store.saved.removeFolder(id);
        } else if (confirm(
          "Are you sure you want to remove the entire collection and all items within?"
        )) {
          this.$store.saved.removeFolder(id);
        }
      },
      confirmRemoveItem(itemId, folderId) {
        if (confirm(
          `Are you sure you want to remove this item from the collection?`
        )) {
          this.$store.saved.removeItemFromFolder(itemId, folderId);
        }
      },
      removeItem(itemId, folderId) {
        this.$store.saved.removeItemFromFolder(itemId, folderId);
      },
      savePendingItem() {
        if (this.selectedFolder !== "") {
          this.$store.saved.addItemToFolder(
            this.selectedFolder.id,
            this.$store.saved.pendingSave
          );
          this.$store.saved.clearPendingSave();
        }
      },
      savePendingItemToFolder(folder) {
        if (folder && this.$store.saved.pendingSave) {
          this.$store.saved.addItemToFolder(
            folder.id,
            this.$store.saved.pendingSave
          );
        }
      },
      togglePendingItemToFolder(folder) {
        if (folder && this.$store.saved.pendingSave) {
          let alreadyIn = folder.items.find(
            (i4) => i4.id === this.$store.saved.pendingSave.id
          );
          let saved = alreadyIn ? this.$store.saved.removeItemFromFolder(
            this.$store.saved.pendingSave.id,
            folder.id
          ) : this.$store.saved.addItemToFolder(
            folder.id,
            this.$store.saved.pendingSave
          );
        }
      },
      cancelSave() {
        this.$store.saved.clearPendingSave();
      },
      get sortedFolders() {
        return this.$store.saved.sortedFolders;
      },
      get hasFolders() {
        let folders = this.$store.saved.folders;
        if (!folders) return false;
        return this.$store.saved.folders.length;
      }
    }));
  });

  // src/components/scrollReset/scrollReset.js
  init(() => {
    module_default.data("scrollReset", () => ({
      init(args) {
        if (window.lenis) {
          window.lenis.scrollTo(0, { immediate: true });
        } else {
          window.scrollTo(0, 0);
        }
      },
      destroy() {
      }
    }));
  });

  // src/components/search/search.js
  init(() => {
    module_default.data("search", () => ({
      query: "",
      fuse: null,
      items: [],
      results: [],
      setup(items) {
        this.items = items;
        this.results = items;
      },
      async init() {
        let products = await module_default.store("siteData").getProductsAsync();
        this.setup(shuffleArray(products));
        this.$watch(
          () => module_default.store("siteData").productsCount,
          async (newValue, oldValue) => {
            if (newValue > 0) {
              let copy = await module_default.store("siteData").getProductsAsync();
              this.setup(shuffleArray(copy));
            }
          }
        );
      },
      performSearch() {
        if (this.query.trim() === "") {
          this.results = this.items;
          return;
        }
        let matchedCategoryIds = this.getMatchedCategoryIds(this.query);
        let results2 = this.items.filter((item) => {
          if (item.skus.includes(this.query)) {
            return true;
          }
          let tokens = this.query.toLowerCase().split(/\s+/);
          let title = item.title.toLowerCase();
          if (tokens.every((token) => new RegExp(token, "i").test(title))) {
            return true;
          }
          if (this.productBelongsToMatchedCategories(item, matchedCategoryIds)) {
            return true;
          }
          return false;
        });
        this.$nextTick(() => this.results = results2);
      },
      clearSearch() {
        this.query = "";
        this.results = this.items;
      },
      getMatchedCategoryIds(query) {
        var _a, _b;
        let categories = ((_b = (_a = module_default.store("siteData").filters) == null ? void 0 : _a.categories) == null ? void 0 : _b.entries) || [];
        let matchedCategoryIds = [];
        categories.forEach((category) => {
          var _a2, _b2;
          let categoryTitle = ((_b2 = (_a2 = category.attributes) == null ? void 0 : _a2.label) == null ? void 0 : _b2.toLowerCase()) || "";
          let queryLower = query.toLowerCase();
          if (categoryTitle.includes(queryLower) || queryLower.includes(categoryTitle)) {
            matchedCategoryIds.push(category.id);
          }
        });
        return matchedCategoryIds;
      },
      productBelongsToMatchedCategories(product, matchedCategoryIds) {
        if (matchedCategoryIds.length === 0) {
          return false;
        }
        if (product.attributes && product.attributes.filter_category) {
          let categoryIds = product.attributes.filter_category;
          if (Array.isArray(categoryIds)) {
            return categoryIds.some((categoryId) => matchedCategoryIds.includes(categoryId));
          }
        }
        return false;
      },
      destroy() {
      }
    }));
  });

  // src/components/shopTheLook/shopTheLook.js
  init(() => {
    module_default.data("shopTheLook", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/components/siteData/siteData.js
  var JSON_INDEX = window.JSON_URL_INDEX;
  var SITE_WORKER_URL = window.WORKER_URL;
  var INDEXES = {};
  var FRESHNESS_THRESHOLD = 36e5;
  function getCachedData(key) {
    const cached = localStorage.getItem(key);
    if (cached) {
      const { timestamp, data: data3 } = JSON.parse(cached);
      const isFresh = Date.now() - timestamp < FRESHNESS_THRESHOLD;
      return isFresh ? data3 : null;
    }
    return null;
  }
  function setCachedData(key, data3) {
    const cached = {
      timestamp: Date.now(),
      data: data3
    };
    localStorage.setItem(key, JSON.stringify(cached));
  }
  var GLOBAL_DATA = {};
  var requestQueue = [];
  var isProcessingQueue2 = false;
  var frameId = null;
  init(() => {
    module_default.store("siteData", {
      loaded: false,
      indexData: null,
      productsCount: 0,
      // Store count instead of full array
      filters: [],
      globalFilters: null,
      // Old props
      RETURN_ALL: false,
      hasIndex: false,
      indexes() {
        return INDEXES;
      },
      skus: [],
      // New methods for accessing data without reactivity overhead
      getProducts() {
        return GLOBAL_DATA.products || [];
      },
      // Async version that processes on animation frame
      async getProductsAsync() {
        return new Promise((resolve) => {
          requestQueue.push({
            type: "getProducts",
            resolve,
            timestamp: Date.now()
          });
          this.processQueue();
        });
      },
      getProductsCount() {
        return this.productsCount;
      },
      // Method to get products with optional filtering
      getFilteredProducts(filterFn = null) {
        const products = this.getProducts();
        return filterFn ? products.filter(filterFn) : products;
      },
      // Async version with animation frame processing
      async getFilteredProductsAsync(filterFn = null) {
        return new Promise((resolve) => {
          requestQueue.push({
            type: "getFilteredProducts",
            resolve,
            filterFn,
            timestamp: Date.now()
          });
          this.processQueue();
        });
      },
      // Method to get a specific product by ID
      getProductById(id) {
        return this.getProducts().find((product) => product.id === id);
      },
      // Async version
      async getProductByIdAsync(id) {
        return new Promise((resolve) => {
          requestQueue.push({
            type: "getProductById",
            resolve,
            id,
            timestamp: Date.now()
          });
          this.processQueue();
        });
      },
      // Method to get a product by variant ID
      getProductByVariantId(variantId) {
        return this.getProducts().find(
          (product) => product.variants && product.variants.some((variant) => variant.id === variantId)
        );
      },
      // Async version
      async getProductByVariantIdAsync(variantId) {
        return new Promise((resolve) => {
          requestQueue.push({
            type: "getProductByVariantId",
            resolve,
            variantId,
            timestamp: Date.now()
          });
          this.processQueue();
        });
      },
      // Method to get products with pagination for better performance
      getProductsPage(page2 = 0, pageSize = 50) {
        const products = this.getProducts();
        const start2 = page2 * pageSize;
        const end = start2 + pageSize;
        return products.slice(start2, end);
      },
      // Async version
      async getProductsPageAsync(page2 = 0, pageSize = 50) {
        return new Promise((resolve) => {
          requestQueue.push({
            type: "getProductsPage",
            resolve,
            page: page2,
            pageSize,
            timestamp: Date.now()
          });
          this.processQueue();
        });
      },
      // Method to search products efficiently
      searchProducts(query, limit = 100) {
        const products = this.getProducts();
        if (!query) return products.slice(0, limit);
        const lowerQuery = query.toLowerCase();
        return products.filter(
          (product) => product.title.toLowerCase().includes(lowerQuery) || product.vendor.toLowerCase().includes(lowerQuery) || product.tags && product.tags.some((tag) => tag.toLowerCase().includes(lowerQuery))
        ).slice(0, limit);
      },
      // Async version
      async searchProductsAsync(query, limit = 100) {
        return new Promise((resolve) => {
          requestQueue.push({
            type: "searchProducts",
            resolve,
            query,
            limit,
            timestamp: Date.now()
          });
          this.processQueue();
        });
      },
      // Queue processing system
      processQueue() {
        if (isProcessingQueue2 || requestQueue.length === 0) {
          return;
        }
        isProcessingQueue2 = true;
        const processNextBatch = () => {
          if (requestQueue.length === 0) {
            isProcessingQueue2 = false;
            return;
          }
          const batchSize = Math.min(10, requestQueue.length);
          const batch = requestQueue.splice(0, batchSize);
          batch.forEach((request) => {
            try {
              let result;
              const products = GLOBAL_DATA.products || [];
              switch (request.type) {
                case "getProducts":
                  result = products;
                  break;
                case "getFilteredProducts":
                  result = request.filterFn ? products.filter(request.filterFn) : products;
                  break;
                case "getProductById":
                  result = products.find((product) => product.id === request.id);
                  break;
                case "getProductByVariantId":
                  result = products.find(
                    (product) => product.variants && product.variants.some((variant) => variant.id === request.variantId)
                  );
                  break;
                case "getProductsPage":
                  const start2 = request.page * request.pageSize;
                  const end = start2 + request.pageSize;
                  result = products.slice(start2, end);
                  break;
                case "searchProducts":
                  if (!request.query) {
                    result = products.slice(0, request.limit);
                  } else {
                    const lowerQuery = request.query.toLowerCase();
                    result = products.filter(
                      (product) => product.title.toLowerCase().includes(lowerQuery) || product.vendor.toLowerCase().includes(lowerQuery) || product.tags && product.tags.some((tag) => tag.toLowerCase().includes(lowerQuery))
                    ).slice(0, request.limit);
                  }
                  break;
                default:
                  result = null;
              }
              request.resolve(result);
            } catch (error2) {
              console.error("Error processing request:", error2);
              request.resolve(null);
            }
          });
          if (requestQueue.length > 0) {
            frameId = requestAnimationFrame(processNextBatch);
          } else {
            isProcessingQueue2 = false;
          }
        };
        frameId = requestAnimationFrame(processNextBatch);
      },
      init() {
        let timeoutTriggered = false;
        let maxWait = 500;
        const loadTimeout = setTimeout(() => {
          timeoutTriggered = true;
          this.ready();
        }, maxWait);
        window.addEventListener("load", () => {
          if (!timeoutTriggered) {
            clearTimeout(loadTimeout);
            this.ready();
          }
        });
      },
      ready() {
        this.fetchData();
      },
      fetchData() {
        const cachedProducts = getCachedData("products");
        const cachedFilters = getCachedData("filters");
        const cachedGlobalFilters = getCachedData("globalFilters");
        if (cachedProducts) {
          GLOBAL_DATA.products = cachedProducts;
          this.productsCount = cachedProducts.length;
          this.filters = cachedFilters;
          this.globalFilters = cachedGlobalFilters;
          this.loaded = true;
          return;
        }
        fetch(JSON_INDEX).then((response) => response.json()).then((data3) => {
          let parsedFilters = data3.filters;
          let globalFilters = {};
          Object.keys(parsedFilters).forEach((k3) => {
            let filterOptions = data3.globalFilters[k3].filter((id) => data3.index[k3][id] && data3.index[k3][id].length).map((id) => parsedFilters[k3].entries.find((e4) => e4.id === id));
            globalFilters[k3] = {
              ...parsedFilters[k3],
              entries: filterOptions
            };
          });
          this.filters = data3.filters;
          this.globalFilters = globalFilters;
          GLOBAL_DATA.products = data3.products;
          this.productsCount = data3.products.length;
          this.loaded = true;
          setCachedData("products", data3.products);
          setCachedData("filters", data3.filters);
          setCachedData("globalFilters", globalFilters);
        }).catch((error2) => {
          console.error("Error fetching data:", error2);
          this.loading = false;
        });
      },
      distinctAttributes(keyFilters, items, settings) {
        const seen = /* @__PURE__ */ new Set();
        const uniqueAttributes = [];
        let mapped = [];
        keyFilters.split(",").forEach((keyFilter) => {
          items.forEach((item) => {
            Object.keys(item.attributes).forEach((key) => {
              if (key === keyFilter) {
                let values = item.attributes[key] || [];
                values.forEach((value) => {
                  const uniqueKey = `${key}-${value}`;
                  if (!seen.has(uniqueKey)) {
                    seen.add(uniqueKey);
                    uniqueAttributes.push(value);
                  }
                });
              }
            });
          });
          let mappedValues = uniqueAttributes.map((gid) => {
            let item = this.filters[keyFilter].entries.find(
              (f4) => f4.id === gid
            );
            return { ...item };
          }).filter((value) => value && Object.keys(value).length);
          mapped = mapped.concat(mappedValues);
        });
        if (settings && settings.limit) {
          mapped = mapped.slice(0, settings.limit);
        }
        return mapped;
      },
      /* This restricts what is returned by what has been designted in the Global Filters metaobject */
      getFilterOptions(type) {
        var _a;
        return ((_a = this.globalFilters[type]) == null ? void 0 : _a.entries) || [];
      },
      getUnrestrictedFilterOptions(type) {
        var _a;
        return ((_a = this.globalFilters[type]) == null ? void 0 : _a.entries) || [];
      }
    });
    module_default.data("siteDataProduct", () => ({
      item: null,
      init() {
        this.$nextTick(() => {
          this.lazyLoad();
        });
      },
      lazyLoad() {
        let observer2 = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.boundingClientRect.top < window.innerHeight + 500) {
                this.load();
              }
            });
          },
          {
            root: null,
            rootMargin: "500px",
            // Extend the viewport by 500px
            threshold: 0
          }
        );
        observer2.observe(this.$el);
      },
      load() {
        let productsCount = module_default.store("siteData").getProductsCount();
        if (productsCount > 0) {
          this.getItem();
        } else {
          this.$watch(
            () => module_default.store("siteData").productsCount,
            (newValue, oldValue) => {
              if (newValue > 0) this.getItem();
            }
          );
        }
      },
      getItem() {
        if (this.item) return;
        let id = this.$el.dataset.id;
        this.item = GLOBAL_DATA.products.find((p4) => p4.variantId === id);
      },
      destroy() {
      }
    }));
    module_default.data("siteData", () => ({
      visible: false,
      count: 0,
      hasInit: false,
      products: [],
      filters: {},
      useWorker: false,
      worker: null,
      get log() {
        return this.hasInit ? `init ${this.count}` : "";
      },
      init() {
        if (!this.$el.getAttribute("x-lazyload")) this.ready();
      },
      lazyload() {
        this.ready();
      },
      ready() {
        this.hasInit = true;
        if (this.useWorker && window.Worker) {
          try {
            this.worker = new Worker(SITE_WORKER_URL);
            this.worker.onmessage = (event) => {
              this.count = event.data.length;
              this.products = event.data;
            };
            this.worker.onerror = (error2) => {
              console.error("Worker error:", error2);
            };
          } catch (err) {
            console.error("Failed to create web worker:", err);
          }
        } else {
          console.warn("Web Workers are not supported in this browser.");
        }
        if (module_default.store("siteData").loaded) {
          this.load();
        } else {
          this.$watch(
            () => module_default.store("siteData").loaded,
            (newValue, oldValue) => {
              this.load();
            }
          );
        }
      },
      load() {
        if (this.worker) {
          this.worker.postMessage(GLOBAL_DATA.products);
        }
      },
      destroy() {
        if (this.worker) {
          this.worker.terminate();
        }
      }
    }));
  });

  // src/components/siteLoading/siteLoading.js
  init(() => {
    module_default.data("siteLoading", () => ({
      siteLoaded: false,
      init() {
        if (module_default.store("siteData") && module_default.store("siteData").loaded) {
          this.siteLoaded = true;
        } else {
          this.$watch(
            () => {
              var _a;
              return (_a = module_default.store("siteData")) == null ? void 0 : _a.loaded;
            },
            (loaded) => {
              if (loaded) {
                this.siteLoaded = true;
              }
            },
            { immediate: true }
          );
        }
      },
      destroy() {
      }
    }));
  });

  // src/components/toolbar/toolbar.js
  init(() => {
    module_default.data("toolbar", () => ({
      init(args) {
      },
      destroy() {
      }
    }));
  });

  // src/js/main.js
  ready(() => {
    let t3, e4, n4, o4, i4, a4 = null, s4 = 65, c4 = /* @__PURE__ */ new Set();
    const r4 = 1111;
    function d4(t4) {
      o4 = performance.now();
      const e5 = t4.target.closest("a");
      m4(e5) && p4(e5.href, "high");
    }
    function u4(t4) {
      if (performance.now() - o4 < r4) return;
      if (!("closest" in t4.target)) return;
      const e5 = t4.target.closest("a");
      m4(e5) && (e5.addEventListener("mouseout", f4, { passive: true }), i4 = setTimeout(() => {
        p4(e5.href, "high"), i4 = void 0;
      }, s4));
    }
    function l4(t4) {
      const e5 = t4.target.closest("a");
      m4(e5) && p4(e5.href, "high");
    }
    function f4(t4) {
      t4.relatedTarget && t4.target.closest("a") == t4.relatedTarget.closest("a") || i4 && (clearTimeout(i4), i4 = void 0);
    }
    function h4(t4) {
      if (performance.now() - o4 < r4) return;
      const e5 = t4.target.closest("a");
      if (t4.which > 1 || t4.metaKey || t4.ctrlKey) return;
      if (!e5) return;
      e5.addEventListener(
        "click",
        function(t5) {
          1337 != t5.detail && t5.preventDefault();
        },
        { capture: true, passive: false, once: true }
      );
      const n5 = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
        detail: 1337
      });
      e5.dispatchEvent(n5);
    }
    function m4(o5) {
      if (o5 && o5.href && (!n4 || "instant" in o5.dataset)) {
        if (o5.origin != location.origin) {
          if (!(e4 || "instant" in o5.dataset) || !a4) return;
        }
        if (["http:", "https:"].includes(o5.protocol) && ("http:" != o5.protocol || "https:" != location.protocol) && (t3 || !o5.search || "instant" in o5.dataset) && !(o5.hash && o5.pathname + o5.search == location.pathname + location.search || "noInstant" in o5.dataset))
          return true;
      }
    }
    function p4(t4, e5 = "auto") {
      if (c4.has(t4)) return;
      const n5 = document.createElement("link");
      n5.rel = "prefetch", n5.href = t4, n5.fetchPriority = e5, n5.as = "document", document.head.appendChild(n5), c4.add(t4);
    }
    !function() {
      if (!document.createElement("link").relList.supports("prefetch")) return;
      const o5 = "instantVaryAccept" in document.body.dataset || "Shopify" in window, i5 = navigator.userAgent.indexOf("Chrome/");
      i5 > -1 && (a4 = parseInt(navigator.userAgent.substring(i5 + "Chrome/".length)));
      if (o5 && a4 && a4 < 110) return;
      const c5 = "instantMousedownShortcut" in document.body.dataset;
      t3 = "instantAllowQueryString" in document.body.dataset, e4 = "instantAllowExternalLinks" in document.body.dataset, n4 = "instantWhitelist" in document.body.dataset;
      const r5 = { capture: true, passive: true };
      let f5 = false, v3 = false, g4 = false;
      if ("instantIntensity" in document.body.dataset) {
        const t4 = document.body.dataset.instantIntensity;
        if (t4.startsWith("mousedown"))
          f5 = true, "mousedown-only" == t4 && (v3 = true);
        else if (t4.startsWith("viewport")) {
          const e5 = navigator.connection && navigator.connection.saveData, n5 = navigator.connection && navigator.connection.effectiveType && navigator.connection.effectiveType.includes("2g");
          e5 || n5 || ("viewport" == t4 ? document.documentElement.clientWidth * document.documentElement.clientHeight < 45e4 && (g4 = true) : "viewport-all" == t4 && (g4 = true));
        } else {
          const e5 = parseInt(t4);
          isNaN(e5) || (s4 = e5);
        }
      }
      v3 || document.addEventListener("touchstart", d4, r5);
      f5 ? c5 || document.addEventListener("mousedown", l4, r5) : document.addEventListener("mouseover", u4, r5);
      c5 && document.addEventListener("mousedown", h4, r5);
      if (g4) {
        let t4 = window.requestIdleCallback;
        t4 || (t4 = (t5) => {
          t5();
        }), t4(
          function() {
            const t5 = new IntersectionObserver((e5) => {
              e5.forEach((e6) => {
                if (e6.isIntersecting) {
                  const n5 = e6.target;
                  t5.unobserve(n5), p4(n5.href);
                }
              });
            });
            document.querySelectorAll("a").forEach((e5) => {
              m4(e5) && t5.observe(e5);
            });
          },
          { timeout: 1500 }
        );
      }
    }();
    const hostname = window.location.hostname;
    function isInternalLink(link) {
      if (!link) return false;
      if (link.match("#")) return false;
      if (link.match("/cart")) return false;
      const url = new URL(link, window.location.origin);
      return url.hostname === hostname && // Same hostname
      !url.hash && // No hash in the URL
      (link.startsWith("/") || url.origin === window.location.origin);
    }
    function attachListenersToInternalLinks(root = document) {
      const links = Array.from(root.querySelectorAll("a[href]")).filter(
        (el) => !el.closest("[data-load-ignore]")
      );
      links.forEach((link) => {
        if (isInternalLink(link.getAttribute("href")) && !link.dataset.isProcessed) {
          link.addEventListener("click", () => {
            document.documentElement.classList.add("is-loading");
          });
          link.dataset.isProcessed = "true";
        }
      });
    }
    attachListenersToInternalLinks();
    const observer2 = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              attachListenersToInternalLinks(node);
            }
          });
        }
      });
    });
    observer2.observe(document.body, { childList: true, subtree: true });
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        document.documentElement.classList.remove("is-loading");
      }
    });
  });

  // src/theme/js/main.js
  window.global = window;
  ready(() => {
    const scrollWrapper = document.getElementById("page");
    let isScrolled = false;
    let lastScroll = 0;
    const lenis = new Lenis({
      wrapper: document.body,
      wheelEventsTarget: scrollWrapper
    });
    window.lenis = lenis;
    function raf(time2) {
      lenis.raf(time2);
      requestAnimationFrame(raf);
    }
    lenis.on("scroll", (props) => {
      if (props.animatedScroll >= 50 && lastScroll < props.animatedScroll) {
        if (!isScrolled) document.documentElement.classList.add("scrolled");
        isScrolled = true;
      } else {
        if (isScrolled) document.documentElement.classList.remove("scrolled");
        isScrolled = false;
      }
      lastScroll = props.animatedScroll;
    });
    requestAnimationFrame(raf);
    document.addEventListener("alpine:init", () => {
      module_default.directive(
        "destroy",
        (el, { expression }, { evaluateLater: evaluateLater2, cleanup: cleanup2 }) => {
          const onDestroy = evaluateLater2(expression);
          cleanup2(onDestroy);
        }
      );
    });
    window.processQuoteReplacement = (container = document) => {
      const elements = container.querySelectorAll('[x-data="quoteReplacement"]');
      elements.forEach((element) => {
        if (window.Alpine && element._x_dataStack) {
          const component = element._x_dataStack[0];
          if (component && component.forceProcess) {
            component.forceProcess();
          }
        } else if (window.Alpine) {
          window.Alpine.initTree(element);
        }
      });
    };
    module_default.start();
    const USE_SWUP = false;
    if (USE_SWUP) {
      const swup = new j({
        ignoreVisit: (url, { el } = {}) => {
          let isHash = el ? el.getAttribute("href")[0] === "#" : false;
          if (isHash) return true;
          let isNoSwup = (el == null ? void 0 : el.getAttribute("data-no-swup")) || (el == null ? void 0 : el.closest("[data-no-swup]"));
          if (isNoSwup) return true;
          return false;
        },
        containers: ["#swup"],
        plugins: [
          new q2({
            rules: [
              {
                from: "/pages/locations/:id?",
                to: "/pages/locations/:id?",
                containers: ["#locations"],
                debug: true
              }
            ]
          })
        ]
      });
      swup.hooks.on("page:view", (visit) => {
        document.documentElement.classList.remove("is-loading");
      });
      swup.hooks.on("link:click", (visit) => {
        router = module_default.store("route");
        page = module_default.store("page");
        setTimeout(() => lenis.scrollTo(0), 250);
        if (router) {
          let p4 = visit.trigger.el.getAttribute("href");
          if (p4 === window.location.pathname) {
            if (!visit.trigger.el.getAttribute("href").match("#")) {
              if (window.location.hash) {
                router.removeHash();
              }
            }
          }
          router.update(p4);
          page.setUrl(p4);
        }
      });
    }
    document.getElementsByTagName("html")[0].style.setProperty("--initialViewportHeight", window.innerHeight + "px");
    document.getElementsByTagName("html")[0].classList.add("js-ready");
  });
  window.Alpine = module_default;
})();
